import React from 'react';
import PropTypes from 'prop-types';
import styles from './Icon.module.scss';

const paths = {
  ascSort: () => (
    <svg width="7.071" height="9.071">
      <g fill="#000000">
        <path d="M0 3.535L3.536 0l3.536 3.535z" />
        <path d="M7.072 5.536L3.536 9.07 0 5.536z" opacity=".3" />
      </g>
    </svg>
  ),
  descSort: () => (
    <svg width="7.071" height="9.071">
      <g fill="#000000">
        <path d="M0 3.535L3.536 0l3.536 3.535z" opacity=".3" />
        <path d="M7.072 5.536L3.536 9.07 0 5.536z" />
      </g>
    </svg>
  ),
  filter: () => (
    <svg width="7.071" height="7.071">
      <path d="M7.072 3.536L3.536 7.07 0 3.536z" />
    </svg>
  ),
  advancedFilter: () => (
    <svg data-name="Layer 1" viewBox="0 0 16 16" width="14" height="14" className="filter_icon">
      <g fill="">
        <path d="M7.25.75v7.52a3.19 3.19 0 0 1 1.51 0V.75a.75.75 0 1 0-1.51 0zM8.75 15.25v-1.42a3.19 3.19 0 0 1-1.51 0v1.42a.75.75 0 0 0 1.51 0zM13.28 15.25a.75.75 0 0 0 1.51 0V7.79a3.19 3.19 0 0 1-1.51 0zM13.28.75v1.48a3.19 3.19 0 0 1 1.51 0V.75a.75.75 0 1 0-1.51 0zM2.72.75a.75.75 0 1 0-1.51 0v1.48A3 3 0 0 1 2 2.14a3 3 0 0 1 .75.09zM2.72 15.25V7.79a3 3 0 0 1-.72.09 3 3 0 0 1-.75-.09v7.46a.75.75 0 0 0 1.51 0z" />
        <circle cx="8" cy="11.05" r="1.96" />
        <circle cx="14.04" cy="5.01" r="1.96" />
        <circle cx="1.96" cy="5.01" r="1.96" />
      </g>
    </svg>
  ),
  rearrangeColumns: () => (
    <svg width="19" height="19">
      <g
        data-name="ArrangeColumn"
        transform="translate(-857.5 -16.5)"
        fill="none"
        stroke=""
        strokeMiterlimit="10"
      >
        <circle cx="9" cy="9" r="9" transform="translate(858 17)" />
        <path data-name="Line 7" d="M863 26.5h8M867 22.5v8" strokeLinecap="round" />
      </g>
    </svg>
  ),
  remove: () => (
    <svg width="7.779" height="7.778">
      <g fill="none" stroke="" strokeLinecap="round" strokeMiterlimit="10">
        <path dataName="CANCEL ICON2" d="M.708.707l6.364 6.364" />
        <path dataName="CANCEL ICON1" d="M7.072.707L.708 7.071" />
      </g>
    </svg>
  ),
  trashDel: () => (
    <svg width="18" height="17" viewBox="0 0 17 16">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              fillRule="nonzero"
              d="M13.333 6v6.333c0 .92-.746 1.667-1.666 1.667H4.333c-.92 0-1.666-.746-1.666-1.667V6h10.666zm-.666.667H3.333v5.666c0 .52.397.947.904.996l.096.004h7.334c.52 0 .947-.396.995-.903l.005-.097V6.667z"
              transform="translate(-430 -341) translate(430.5 341)"
            />
            <path
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              d="M4.67 8.032v3.936c0 .183.15.332.333.332.184 0 .333-.149.333-.332V8.032c0-.183-.15-.332-.333-.332-.183 0-.332.149-.332.332zM6.67 8.032v3.936c0 .183.15.332.333.332.184 0 .333-.149.333-.332V8.032c0-.183-.15-.332-.333-.332-.183 0-.332.149-.332.332zM8.67 8.032v3.936c0 .183.15.332.333.332.184 0 .333-.149.333-.332V8.032c0-.183-.15-.332-.333-.332-.183 0-.332.149-.332.332zM10.67 8.032v3.936c0 .183.15.332.333.332.184 0 .333-.149.333-.332V8.032c0-.183-.15-.332-.333-.332-.183 0-.332.149-.332.332z"
              transform="translate(-430 -341) translate(430.5 341)"
            />
            <path
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              fillRule="nonzero"
              d="M12 3.333c.736 0 1.333.597 1.333 1.334v.666H2.667v-.666c0-.737.597-1.334 1.333-1.334h8zM12 4H4c-.342 0-.624.257-.662.589l-.005.078h9.334c0-.342-.258-.624-.59-.663L12 4z"
              transform="translate(-430 -341) translate(430.5 341)"
            />
            <path
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              fillRule="nonzero"
              d="M8.333 2.333c.553 0 1 .448 1 1 0 .184-.149.334-.333.334-.164 0-.3-.118-.328-.274l-.005-.06c0-.163-.118-.3-.274-.328L8.333 3h-.666c-.164 0-.3.118-.328.273l-.006.06c0 .184-.149.334-.333.334-.184 0-.333-.15-.333-.334 0-.52.396-.947.903-.995l.097-.005h.666z"
              transform="translate(-430 -341) translate(430.5 341)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  editIcon: ({ intl, color, variant }) => (
    <svg width="22px" height="22px" viewBox="0 0 24 24">
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-308.000000, -720.000000)"
          fill={
            color ? getComputedStyle(document.body).getPropertyValue('--primary-main') : '#000000'
          }
        >
          <g id="edit" transform="translate(308.000000, 720.000000)">
            <g
              id="Group-15"
              transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(9.000000, 3.000000)"
            >
              <path
                d="M5,4.5 C5.27614237,4.5 5.5,4.72385763 5.5,5 L5.5,5 L5.5,14 C5.5,14.0987125 5.47078099,14.1952163 5.41602515,14.2773501 L5.41602515,14.2773501 L3.41602515,17.2773501 C3.21811412,17.5742166 2.78188588,17.5742166 2.58397485,17.2773501 L2.58397485,17.2773501 L0.583974853,14.2773501 C0.529219014,14.1952163 0.5,14.0987125 0.5,14 L0.5,14 L0.5,5 C0.5,4.72385763 0.723857625,4.5 1,4.5 L1,4.5 Z M4.5,5.5 L1.5,5.5 L1.5,13.848 L3,16.097 L4.5,13.847 L4.5,5.5 Z M5,0.5 C5.27614237,0.5 5.5,0.723857625 5.5,1 L5.5,1 L5.5,3 C5.5,3.27614237 5.27614237,3.5 5,3.5 L5,3.5 L1,3.5 C0.723857625,3.5 0.5,3.27614237 0.5,3 L0.5,3 L0.5,1 C0.5,0.723857625 0.723857625,0.5 1,0.5 L1,0.5 Z M4.5,1.5 L1.5,1.5 L1.5,2.5 L4.5,2.5 L4.5,1.5 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  edit: ({ intl, color, variant }) => (
    <svg width="22px" height="22px" viewBox="0 0 24 24">
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-308.000000, -720.000000)"
          fill={
            color ? getComputedStyle(document.body).getPropertyValue('--primary-main') : '#000000'
          }
        >
          <g id="edit" transform="translate(308.000000, 720.000000)">
            <g
              id="Group-15"
              transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(9.000000, 3.000000)"
            >
              <path
                d="M5,4.5 C5.27614237,4.5 5.5,4.72385763 5.5,5 L5.5,5 L5.5,14 C5.5,14.0987125 5.47078099,14.1952163 5.41602515,14.2773501 L5.41602515,14.2773501 L3.41602515,17.2773501 C3.21811412,17.5742166 2.78188588,17.5742166 2.58397485,17.2773501 L2.58397485,17.2773501 L0.583974853,14.2773501 C0.529219014,14.1952163 0.5,14.0987125 0.5,14 L0.5,14 L0.5,5 C0.5,4.72385763 0.723857625,4.5 1,4.5 L1,4.5 Z M4.5,5.5 L1.5,5.5 L1.5,13.848 L3,16.097 L4.5,13.847 L4.5,5.5 Z M5,0.5 C5.27614237,0.5 5.5,0.723857625 5.5,1 L5.5,1 L5.5,3 C5.5,3.27614237 5.27614237,3.5 5,3.5 L5,3.5 L1,3.5 C0.723857625,3.5 0.5,3.27614237 0.5,3 L0.5,3 L0.5,1 C0.5,0.723857625 0.723857625,0.5 1,0.5 L1,0.5 Z M4.5,1.5 L1.5,1.5 L1.5,2.5 L4.5,2.5 L4.5,1.5 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  Edit: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <title>{intl.formatMessage({ id: 'ApplicationCart.icon.Edit' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-308.000000, -720.000000)" fill="#000000">
          <g id="edit" transform="translate(308.000000, 720.000000)">
            <g
              id="Group-15"
              transform="translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) translate(9.000000, 3.000000)"
            >
              <path
                d="M5,4.5 C5.27614237,4.5 5.5,4.72385763 5.5,5 L5.5,5 L5.5,14 C5.5,14.0987125 5.47078099,14.1952163 5.41602515,14.2773501 L5.41602515,14.2773501 L3.41602515,17.2773501 C3.21811412,17.5742166 2.78188588,17.5742166 2.58397485,17.2773501 L2.58397485,17.2773501 L0.583974853,14.2773501 C0.529219014,14.1952163 0.5,14.0987125 0.5,14 L0.5,14 L0.5,5 C0.5,4.72385763 0.723857625,4.5 1,4.5 L1,4.5 Z M4.5,5.5 L1.5,5.5 L1.5,13.848 L3,16.097 L4.5,13.847 L4.5,5.5 Z M5,0.5 C5.27614237,0.5 5.5,0.723857625 5.5,1 L5.5,1 L5.5,3 C5.5,3.27614237 5.27614237,3.5 5,3.5 L5,3.5 L1,3.5 C0.723857625,3.5 0.5,3.27614237 0.5,3 L0.5,3 L0.5,1 C0.5,0.723857625 0.723857625,0.5 1,0.5 L1,0.5 Z M4.5,1.5 L1.5,1.5 L1.5,2.5 L4.5,2.5 L4.5,1.5 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  customTick: ({ intl, tooltip, variant }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      {variant !== 'hideTooltip' && (
        <title>
          {tooltip === 'Save'
            ? intl.formatMessage({ id: 'ApplicationCart.Save' })
            : intl.formatMessage({ id: 'ApplicationCart.icon.Edit' })}
        </title>
      )}
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-354.000000, -720.000000)">
          <g id="tick" transform="translate(354.000000, 720.000000)">
            <rect
              id="Rectangle-Copy-279"
              fillOpacity="0"
              fill="#D8D8D8"
              fillRule="evenodd"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-278"
              fillOpacity="0"
              fill="#FFF5F5"
              fillRule="evenodd"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M17.6465955,7.64629775 C17.8419399,7.45111785 18.1585224,7.45125117 18.3537023,7.64659553 C18.5271955,7.82023497 18.5463672,8.08966746 18.4112891,8.28447874 L18.3534045,8.35370225 L10.3466635,16.3537023 C10.1727472,16.5274721 9.90279827,16.5463918 9.70796721,16.4107264 L9.63876099,16.3526062 L6.64550197,13.3432876 C6.45076293,13.1475038 6.45160993,12.8309224 6.64739378,12.6361834 C6.82142388,12.463082 7.09089891,12.4445178 7.28540518,12.5800347 L7.35449803,12.6380752 L9.994,15.292 L17.6465955,7.64629775 Z"
              id="Path-18-Copy-3"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  customClose: ({ intl, variant }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      {variant !== 'hideTooltip' && (
        <title>{intl.formatMessage({ id: 'CloseButton.ariaLabel' })}</title>
      )}
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-67.000000, -676.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="close" transform="translate(67.000000, 676.000000)">
            <path
              d="M17.179825,6.21966991 C17.4483105,6.48815536 17.4706843,6.909555 17.2469464,7.20352615 L17.179825,7.28033009 L12.76,11.699 L17.179825,16.1191649 C17.4727182,16.4120581 17.4727182,16.8869318 17.179825,17.179825 C16.9113396,17.4483105 16.4899399,17.4706843 16.1959688,17.2469464 L16.1191649,17.179825 L11.699,12.76 L7.28033009,17.179825 C6.98743687,17.4727182 6.51256313,17.4727182 6.21966991,17.179825 C5.95118446,16.9113396 5.92881068,16.4899399 6.15254855,16.1959688 L6.21966991,16.1191649 L10.639,11.699 L6.21966991,7.28033009 C5.9267767,6.98743687 5.9267767,6.51256313 6.21966991,6.21966991 C6.48815536,5.95118446 6.909555,5.92881068 7.20352615,6.15254855 L7.28033009,6.21966991 L11.699,10.639 L16.1191649,6.21966991 C16.4120581,5.9267767 16.8869318,5.9267767 17.179825,6.21966991 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  success: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <filter
          id="prefix__a"
          width="104.1%"
          height="159.1%"
          x="-2%"
          y="-29.5%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0.639215686 0 0 0 0 0.639215686 0 0 0 0 0.639215686 0 0 0 0.5 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g fill="#31B793" filter="url(#prefix__a)" transform="translate(-16 -13)">
        <path d="M27.795 16.27c.186.091.263.315.172.502-.09.186-.315.263-.501.172-2.792-1.362-6.16-.202-7.522 2.59s-.202 6.16 2.59 7.522 6.16.202 7.522-2.59c.26-.534.432-1.097.514-1.673.107-.75.06-1.513-.135-2.244-.054-.2.065-.406.265-.46.2-.053.406.066.46.266.22.828.274 1.693.153 2.544-.093.653-.288 1.291-.583 1.896-1.544 3.164-5.36 4.478-8.525 2.935-3.164-1.544-4.478-5.36-2.935-8.525 1.544-3.164 5.36-4.478 8.525-2.935zm1.97 1.715c.13.13.145.332.044.478l-.044.052-6 6c-.13.13-.332.145-.478.044l-.052-.044-2.25-2.25c-.147-.146-.147-.384 0-.53.13-.13.332-.145.478-.044l.052.044L23.5 23.72l5.735-5.735c.146-.147.384-.147.53 0z" />
      </g>
    </svg>
  ),
  addInstance: () => (
    <svg width="10" height="10" className="add_icon">
      <circle
        cx="5"
        cy="5"
        r="5"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
      />
      <path
        data-name="CANCEL ICON2"
        d="M5 2.5v5"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
      <path
        data-name="CANCEL ICON1"
        d="M7.5 5h-5"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  close: () => (
    <svg width="9.193" height="9.191">
      <g fill="none" stroke="#969696" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1.5">
        <path data-name="CANCEL ICON2" d="M1.06 1.061l7.072 7.071" />
        <path data-name="CANCEL ICON1" d="M8.132 1.061L1.061 8.132" />
      </g>
    </svg>
  ),
  cartRemove: () => (
    <svg width="5.657" height="5.657">
      <g data-name="CANCEL ICON" fill="none" stroke="" strokeLinecap="round" strokeMiterlimit="10">
        <path data-name="CANCEL ICON2" d="M.707.707L4.949 4.95" />
        <path data-name="CANCEL ICON1" d="M4.95.707L.706 4.95" />
      </g>
    </svg>
  ),
  request: () => (
    <svg width="23" height="23">
      <g
        data-name="apps icon"
        transform="translate(.5 .5)"
        fill="none"
        stroke=""
        strokeMiterlimit="10"
      >
        <g data-name="apps icon5" transform="translate(7.009 7.091)">
          <rect width="2.955" height="2.955" rx=".6" stroke="none" />
          <rect x=".5" y=".5" width="1.955" height="1.955" rx=".1" />
        </g>
        <g data-name="apps icon4" transform="translate(2.872 7.091)">
          <rect width="2.955" height="2.955" rx=".6" stroke="none" />
          <rect x=".5" y=".5" width="1.955" height="1.955" rx=".1" />
        </g>
        <g data-name="apps icon3" transform="rotate(45 1.357 11.555)">
          <rect width="2.955" height="2.955" rx=".6" stroke="none" />
          <rect x=".5" y=".5" width="1.955" height="1.955" rx=".1" />
        </g>
        <g data-name="apps icon2" transform="translate(2.872 2.955)">
          <rect width="2.955" height="2.955" rx=".6" stroke="none" />
          <rect x=".5" y=".5" width="1.955" height="1.955" rx=".1" />
        </g>
        <circle data-name="apps icon1" cx="6.5" cy="6.5" r="6.5" />
      </g>
    </svg>
  ),
  admin: () => (
    <svg width="23" height="23" viewBox="0 0 22 22">
      <g transform="translate(1 1)" stroke="" fill="none">
        <path
          d="M11.727 12c0-3.314-2.564-6-5.727-6C2.837 6 .273 8.686.273 12"
          strokeLinecap="round"
        />
        <circle cx="6" cy="3" r="3" />
      </g>
    </svg>
  ),
  analytics: () => (
    <svg width="14" height="13">
      <g fill="none" fillRule="nonzero">
        <path d="M13.996 0L9.791.008l.002.795 2.823-.006L7.64 5.891 3.866 3.262 0 7.461.586 8l3.396-3.687 3.756 2.618L13.2 1.34l.002 2.862L14 4.2zM13 6h1v7h-1zM9 8h1v5H9zM5 10h1v3H5zM1 9h1v4H1z" />
      </g>
    </svg>
  ),
  switcherIcon: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      className="switcher"
    >
      <g fill fillRule="evenodd">
        <rect width="4" height="4" y="15" rx="1" />
        <rect width="4" height="4" x="7.5" y="15" rx="1" />
        <rect width="4" height="4" x="15" y="15" rx="1" />
        <rect width="4" height="4" y="7.5" rx="1" />
        <rect width="4" height="4" x="7.5" y="7.5" rx="1" />
        <rect width="4" height="4" x="15" y="7.5" rx="1" />
        <rect width="4" height="4" rx="1" />
        <rect width="4" height="4" x="7.5" rx="1" />
        <rect width="4" height="4" x="15" rx="1" />
      </g>
    </svg>
  ),
  search: () => (
    <svg width="14" height="14" className="searchIcon">
      <g data-name="search icon" fill="none" stroke="" strokeMiterlimit="10">
        <path
          data-name="search icon2"
          d="M9.9 5.4A4.5 4.5 0 1 1 5.4.9a4.5 4.5 0 0 1 4.5 4.5z"
          strokeWidth="1.8"
        />
        <path
          data-name="search icon1"
          d="M9.4 9.4l1.941 1.941"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  ),
  notification: () => (
    <svg width="18.284" height="20.277" className="notificationIcon">
      <g data-name="update icon">
        <path
          data-name="update icon3"
          d="M11.681 17.181a2.448 2.448 0 0 1-2.539 2.345 2.448 2.448 0 0 1-2.54-2.345 2.448 2.448 0 0 1 2.54-2.345 2.448 2.448 0 0 1 2.539 2.345z"
          fill="none"
          stroke
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          data-name="update icon2"
          d="M15.85 11.575a1.8 1.8 0 0 1-.676-1.582C15.397 7.361 15.35.75 9.142.75S2.887 7.361 3.114 9.993a1.8 1.8 0 0 1-.676 1.582A4.1 4.1 0 0 0 .75 14.956a1.562 1.562 0 0 0 1.5 1.609h13.783a1.562 1.562 0 0 0 1.5-1.609 4.1 4.1 0 0 0-1.683-3.381"
          fill
        />
        <path
          data-name="update icon1"
          d="M15.85 11.575a1.8 1.8 0 0 1-.676-1.582C15.397 7.361 15.35.75 9.142.75S2.887 7.361 3.114 9.993a1.8 1.8 0 0 1-.676 1.582A4.1 4.1 0 0 0 .75 14.956a1.562 1.562 0 0 0 1.5 1.609h13.783a1.562 1.562 0 0 0 1.5-1.609 4.1 4.1 0 0 0-1.683-3.381z"
          fill="none"
          stroke
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  ),
  accounts: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="46" viewBox="0 0 47 46">
      <g fill="none" stroke="#9FA2B4" transform="translate(1)">
        <path
          strokeLinecap="round"
          d="M32.0650329,30.2987673 C28.7341704,25.8362804 23.7402121,23 18.1578947,23 C8.12956639,23 0,32.1532896 0,43.4444444"
        />
        <ellipse cx="18.158" cy="11.5" rx="9.684" ry="10.222" />
        <ellipse cx="37.526" cy="37.056" rx="7.263" ry="7.667" />
        <path strokeLinecap="round" d="M35.1052632,37.0555556 L39.9473684,37.0555556" />
        <path
          strokeLinecap="round"
          d="M42.2363636,31.7818182 L42.2363636,31.7818182"
          transform="rotate(90 42.236 31.782)"
        />
      </g>
    </svg>
  ),
  dashboard: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      viewBox="0 0 48 48"
      className="dashboardSVG"
    >
      <g fill="none" stroke transform="translate(1 -1)">
        <ellipse cx="21.467" cy="9.288" rx="3.067" ry="3.096" />
        <ellipse cx="10.733" cy="15.481" rx="3.067" ry="3.096" />
        <ellipse cx="7.667" cy="27.865" rx="3.067" ry="3.096" />
        <ellipse cx="15.333" cy="40.25" rx="3.067" ry="3.096" />
        <ellipse cx="30.667" cy="40.25" rx="3.067" ry="3.096" />
        <ellipse cx="36.8" cy="27.865" rx="3.067" ry="3.096" />
        <path strokeLinecap="round" d="M21.4666667,26.3173077 L32.2,15.4807692" />
        <ellipse cx="23" cy="24.769" rx="23" ry="23.221" />
      </g>
    </svg>
  ),

  filtering: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <g fill="none" stroke="#9FA2B4" transform="translate(1 -1)">
        <ellipse cx="21.467" cy="9.288" rx="3.067" ry="3.096" />
        <ellipse cx="10.733" cy="15.481" rx="3.067" ry="3.096" />
        <ellipse cx="7.667" cy="27.865" rx="3.067" ry="3.096" />
        <ellipse cx="15.333" cy="40.25" rx="3.067" ry="3.096" />
        <ellipse cx="30.667" cy="40.25" rx="3.067" ry="3.096" />
        <ellipse cx="36.8" cy="27.865" rx="3.067" ry="3.096" />
        <path strokeLinecap="round" d="M21.4666667,26.3173077 L32.2,15.4807692" />
        <ellipse cx="23" cy="24.769" rx="23" ry="23.221" />
      </g>
    </svg>
  ),

  gridViewIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11">
      <path
        fill="none"
        stroke="#B4B4B4"
        strokeLinecap="round"
        strokeWidth="2"
        d="M.3125 9.16666667L9.6875 9.16666667M.3125 5L9.6875 5M.3125.833333333L9.6875.833333333"
        transform="translate(1 .51)"
      />
    </svg>
  ),
  hamburger: () => (
    <svg
      className="hamburgerIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="13"
      viewBox="0 0 15 13"
    >
      <path
        fill="none"
        stroke
        strokeLinecap="round"
        strokeWidth="2"
        d="M0 .5L13 .5M0 5.5L13 5.5M0 10.5L13 10.5"
        transform="translate(1 1)"
      />
    </svg>
  ),
  identity: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 48 59">
      <g fill="none" stroke transform="translate(1 1)">
        <path
          strokeLinecap="round"
          d="M.244958733 11.5C-1.50075747 34.5455624 6.08425629 49.8788958 23 57.5M0 11.5L23 0"
        />
        <path
          strokeLinecap="round"
          d="M23 11.5L46 0M23.4125877 11.5C21.0838585 34.547401 28.6129959 49.8807344 46 57.5"
          transform="matrix(-1 0 0 1 69 0)"
        />
        <circle cx="23" cy="19.55" r="5.75" />
        <path
          strokeLinecap="round"
          d="M34.5,39.1 C34.5,32.7487254 29.3512746,27.6 23,27.6 C16.6487254,27.6 11.5,32.7487254 11.5,39.1"
        />
      </g>
    </svg>
  ),
  listViewIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12">
      <g
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        transform="translate(0 .51)"
      >
        <rect width="4.321" height="4.321" x="6.679" y="6.679" rx=".8" />
        <rect width="4.321" height="4.321" x=".393" y="6.679" rx=".8" />
        <rect width="4.321" height="4.321" x="6.679" y=".393" rx=".8" />
        <rect width="4.321" height="4.321" x=".393" y=".393" rx=".8" />
      </g>
    </svg>
  ),
  roles: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 46 41">
      <g fill="none" stroke>
        <rect width="17.121" height="11.172" x=".5" y="28.578" rx=".48" />
        <rect width="17.121" height="11.172" x="27.682" y="28.578" rx=".48" />
        <path
          strokeLinecap="round"
          d="M26.5194547,22.0332576 L33.7637138,22.0332576 C34.0288105,22.0332576 34.2437138,22.2481609 34.2437138,22.5132576 L34.2437138,28.1757363"
        />
        <path
          strokeLinecap="round"
          d="M11.8484848,21.9914315 L19.092744,21.9914315 C19.3578407,21.9914315 19.572744,22.2063348 19.572744,22.4714315 L19.572744,28.1339101"
          transform="matrix(-1 0 0 1 31.421 0)"
        />
        <ellipse cx="23" cy="21.315" rx="3.485" ry="3.381" />
        <path strokeLinecap="round" d="M23,12.578125 L23,17.9339718" />
        <rect width="17.121" height="11.172" x="14.439" y="1.339" rx=".48" />
      </g>
    </svg>
  ),
  searchIcon: ({ size, primaryColor }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '20'}
      height={size || '20'}
      viewBox="0 0 20 20"
      stroke={
        primaryColor
          ? getComputedStyle(document.body).getPropertyValue('--primary-main')
          : '#dddddd'
      }
    >
      <g fill="none" fillRule="evenodd" stroke strokeWidth="1.5" transform="translate(1 1)">
        <path d="M14.725,7.3625 C14.725,11.4286036 11.4286036,14.725 7.3625,14.725 C3.29601402,14.725 0,11.4286036 0,7.3625 C0,3.29601402 3.29601402,0 7.3625,0 C11.4286036,0 14.725,3.29601402 14.725,7.3625 Z" />
        <path strokeLinecap="round" d="M12.5755544,13.0755544 L17.4865196,17.9865196" />
      </g>
    </svg>
  ),
  sort: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-640.000000, -280.000000)"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(640.000000, 280.000000)">
            <g
              id="sync"
              transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
            >
              <path
                d="M18.0009882,12.4999816 C18.2771306,12.4999816 18.5009882,12.7238392 18.5009882,12.9999816 C18.5009882,13.2454415 18.3241131,13.44959 18.0908639,13.4919259 L18.0009882,13.4999816 L7.42698822,13.4999816 L11.3133357,16.6095472 C11.5050077,16.7628848 11.5539279,17.0285316 11.4412771,17.2371157 L11.3914226,17.3123291 C11.238085,17.5040011 10.9724382,17.5529212 10.7638541,17.4402704 L10.6886407,17.390416 L5.6886407,13.390416 C5.34263859,13.1136143 5.50450941,12.5732074 5.91553722,12.5067378 L6.00098822,12.4999816 L18.0009882,12.4999816 Z M13.2371341,5.55971115 L13.3123475,5.6095656 L18.3123475,9.6095656 C18.6583496,9.88636728 18.4964788,10.4267742 18.085451,10.4932438 L18,10.5 L6,10.5 C5.72385763,10.5 5.5,10.2761424 5.5,10 C5.5,9.75454011 5.67687516,9.55039163 5.91012437,9.50805567 L6,9.5 L16.574,9.5 L12.6876525,6.3904344 C12.4959805,6.23709683 12.4470604,5.97144999 12.5597112,5.76286589 L12.6095656,5.68765248 C12.7629032,5.49598051 13.02855,5.44706036 13.2371341,5.55971115 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  swicther: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
      <g fillRule="evenodd">
        <rect width="4" height="4" y="15" rx="1" />
        <rect width="4" height="4" x="7.5" y="15" rx="1" />
        <rect width="4" height="4" x="15" y="15" rx="1" />
        <rect width="4" height="4" y="7.5" rx="1" />
        <rect width="4" height="4" x="7.5" y="7.5" rx="1" />
        <rect width="4" height="4" x="15" y="7.5" rx="1" />
        <rect width="4" height="4" rx="1" />
        <rect width="4" height="4" x="7.5" rx="1" />
        <rect width="4" height="4" x="15" rx="1" />
      </g>
    </svg>
  ),
  update: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21">
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <path
          stroke="#787878"
          strokeWidth="1.5"
          d="M11.0396211,16.5314457 C11.0396211,17.826337 9.90241053,18.8762935 8.49991053,18.8762935 C7.09696316,18.8762935 5.9602,17.826337 5.9602,16.5314457 C5.9602,15.2361413 7.09696316,14.1861848 8.49991053,14.1861848 C9.90241053,14.1861848 11.0396211,15.2361413 11.0396211,16.5314457 Z"
        />
        <path
          fill="#FEFEFE"
          d="M15.2031,10.9246696 C14.7329158,10.5632565 14.4738895,9.96393043 14.5271263,9.34312609 C14.7548368,6.7108 14.7078632,0.099626087 8.49973158,0.099626087 C2.2916,0.099626087 2.24507368,6.7108 2.47233684,9.34312609 C2.52602105,9.96393043 2.26654737,10.5632565 1.79681053,10.9246696 C0.426968421,11.9779304 0.103968421,13.2909957 0.107994737,14.3058435 C0.112021053,15.1971913 0.784415789,15.9150609 1.60891579,15.9150609 L8.49973158,15.9150609 L15.3909947,15.9150609 C16.2150474,15.9150609 16.8874421,15.1971913 16.8914684,14.3058435 C16.8959421,13.2909957 16.5729421,11.9779304 15.2031,10.9246696"
        />
        <path
          stroke="#787878"
          strokeWidth="1.5"
          d="M15.2031,10.9246696 C14.7329158,10.5632565 14.4738895,9.96393043 14.5271263,9.34312609 C14.7548368,6.7108 14.7078632,0.099626087 8.49973158,0.099626087 C2.2916,0.099626087 2.24507368,6.7108 2.47233684,9.34312609 C2.52602105,9.96393043 2.26654737,10.5632565 1.79681053,10.9246696 C0.426968421,11.9779304 0.103968421,13.2909957 0.107994737,14.3058435 C0.112021053,15.1971913 0.784415789,15.9150609 1.60891579,15.9150609 L8.49973158,15.9150609 L15.3909947,15.9150609 C16.2150474,15.9150609 16.8874421,15.1971913 16.8914684,14.3058435 C16.8959421,13.2909957 16.5729421,11.9779304 15.2031,10.9246696 Z"
        />
      </g>
    </svg>
  ),
  apps: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 48 48">
      <g fill="none" stroke transform="translate(1 1)">
        <rect width="9.455" height="9.455" x="25.3" y="25.591" rx=".6" />
        <rect width="9.455" height="9.455" x="10.664" y="25.591" rx=".6" />
        <path
          d="M25.6909091,11.2453643 C25.6356806,11.2453643 25.5909091,11.2901359 25.5909091,11.3453643 L25.5909091,20.5999098 C25.5909091,20.6551383 25.6356806,20.6999098 25.6909091,20.6999098 L34.9454545,20.6999098 C35.000683,20.6999098 35.0454545,20.6551383 35.0454545,20.5999098 L35.0454545,11.3453643 C35.0454545,11.2901359 35.000683,11.2453643 34.9454545,11.2453643 L25.6909091,11.2453643 Z"
          transform="rotate(45 30.318 15.973)"
        />
        <rect width="9.455" height="9.455" x="10.664" y="10.955" rx=".6" />
        <circle cx="23" cy="23" r="23" />
      </g>
    </svg>
  ),
  cancelIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17">
      <g
        fill="none"
        stroke="#B4B4B4"
        strokeLinecap="round"
        strokeWidth="3"
        transform="rotate(45 9.707 7.793)"
      >
        <path d="M0,9.5 L18,9.5" />
        <path d="M0,9.5 L18,9.5" transform="rotate(90 9 9.5)" />
      </g>
    </svg>
  ),
  controls: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 46 46">
      <g fill="none" stroke>
        <rect width="45" height="45" x=".5" y=".5" rx="1.2" />
        <path strokeLinecap="square" d="M1.76923077,13.5909091 L44.2307692,13.5909091" />
        <path
          strokeLinecap="square"
          d="M13.4300699,29.4335664 L43.0244755,29.4335664"
          transform="rotate(90 28.227 29.434)"
        />
        <path
          strokeLinecap="square"
          d="M2.01048951,32.4090909 L28.4685315,32.4090909"
          transform="rotate(-180 15.119 31.364)"
        />
      </g>
    </svg>
  ),
  calendar: () => (
    <svg width="16.714" height="18.4" className="calender-icon">
      <g data-name="Calendar" transform="translate(0 .4)">
        <rect
          width="2.615"
          height="2.615"
          rx=".5"
          transform="translate(4.486 7.051)"
          fill="#1e1e1e"
        />
        <rect
          data-name="Rectangle Copy 2"
          width="2.615"
          height="2.615"
          rx=".5"
          transform="translate(4.486 10.897)"
          fill="#1e1e1e"
        />
        <rect
          data-name="Rectangle Copy"
          width="2.615"
          height="2.615"
          rx=".5"
          transform="translate(9.613 7.051)"
          fill="#1e1e1e"
        />
        <rect
          data-name="Rectangle Copy 3"
          width="2.615"
          height="2.615"
          rx=".5"
          transform="translate(9.613 10.897)"
          fill="#1e1e1e"
        />
        <g
          data-name="Rectangle"
          transform="translate(0 1.308)"
          fill="none"
          stroke="#1e1e1e"
          strokeMiterlimit="10"
          strokeWidth=".8"
        >
          <rect width="16.714" height="16.692" rx="1" stroke="none" />
          <rect x=".4" y=".4" width="15.914" height="15.892" rx=".6" />
        </g>
        <path
          data-name="Line 3"
          d="M4.5 0v3.923"
          fill="none"
          stroke="#1e1e1e"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth=".8"
        />
        <path
          data-name="Line 3 Copy 2"
          d="M12.214 0v3.923"
          fill="none"
          stroke="#1e1e1e"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth=".8"
        />
        <path
          data-name="Line 3 Copy"
          d="M8.357 0v3.923"
          fill="none"
          stroke="#1e1e1e"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth=".8"
        />
      </g>
    </svg>
  ),
  filetype: ({ filetext, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.714" height="18.4">
      <title>svg-file-flat</title>
      <path
        d="M269.59,88.2l-.05-.05H145.7a9.59,9.59,0,0,0-9.59,9.59V414.26a9.6,9.6,0,0,0,9.59,9.59H366.31a9.59,9.59,0,0,0,9.59-9.59V194.5H269.59Z"
        fill={color}
      />
      <polygon points="269.59 194.49 375.89 194.49 269.59 88.2 269.59 194.49" fill={color} />
      <polygon
        xmlns="http://www.w3.org/2000/svg"
        points="375.9 300.79 375.9 194.5 375.89 194.49 269.59 194.49 269.59 194.49 375.9 300.79"
        fill="#333"
        opacity="0.1"
      />
      <text
        xmlns="http://www.w3.org/2000/svg"
        x="50%"
        y="60%"
        dominantBaseline="middle"
        style={{ fontSize: '5px' }}
        textAnchor="middle"
      >
        {filetext}
      </text>
      <path
        d="M328.58,372.41q-8.37,4.82-20.8,4.82-13.78,0-21.74-7.63t-7.95-21q0-13.47,8.69-22t23.11-8.48a46.94,46.94,0,0,1,16,2.51v12.07q-6.61-3.82-16.18-3.82a17.37,17.37,0,0,0-13,5.2q-5,5.2-5,13.89t4.52,13.63q4.53,4.82,12.21,4.82a17,17,0,0,0,7.33-1.32V354H304.28V343.68h24.3Z"
        fill="#eff0f0"
      />
    </svg>
  ),
  gridError: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="15"
      height="15"
      viewBox="0 0 225.000000 225.000000"
    >
      <g
        transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          style={{ fill: '#ec9a9a' }}
          d="M1066 2035 c-22 -8 -56 -31 -77 -52 -36 -37 -917 -1472 -946 -1542 -10 -23 -14 -56 -11 -95 4 -52 8 -63 40 -92 20 -18 53 -37 75 -43 26 -7 344 -11 983 -11 l945 0 53 25 c44 21 56 32 73 71 25 55 20 110 -15 176 -13 24 -222 369 -465 768 -301 495 -453 735 -478 756 -34 30 -92 55 -124 54 -8 -1 -32 -7 -53 -15z m165 -494 l29 -29 0 -321 0 -320 -24 -28 c-21 -24 -32 -28 -95 -31 -44 -3 -83 1 -102 9 -55 22 -59 46 -59 369 0 380 -1 378 148 379 68 1 76 -1 103 -28z m-53 -875 c105 -55 110 -202 8 -250 -97 -46 -200 17 -200 123 0 101 106 171 192 127z"
        />
      </g>
    </svg>
  ),
  arrow: ({ angle }) => (
    <svg width="10" height="6" transform={`rotate(${angle})`} className="mt-1">
      <path
        d="M9.8 1.231L5.339 5.854a.467.467 0 0 1-.679 0L.2 1.231a.741.741 0 0 1 0-1.02.679.679 0 0 1 .983 0L5 4.165 8.813.211a.679.679 0 0 1 .984 0 .741.741 0 0 1 0 1.02"
        fill="#fff"
      />
    </svg>
  ),

  thumb: ({ up }) => (
    <div
      className="d-flex"
      style={{
        width: '20px',
        height: '19px',
        backgroundColor: up ? 'green' : 'red',
        borderRadius: '3px',
        paddingLeft: '5px',
        paddingTop: '5px',
      }}
    >
      <svg
        style={{ transform: up ? "rotate('0deg')" : 'rotate(180deg)' }}
        width="10px"
        height="10px"
        viewBox="0 0 16 15"
        version="1.1"
      >
        <title>thumb</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
          <g id="Icons-2" fill="#FFFFFF" transform="translate(-259.000000, -235.000000)">
            <g id="thumb" transform="translate(255.000000, 231.000000)">
              <rect
                id="Rectangle-Copy-81"
                fill="#FFFFFF"
                x="4"
                y="10"
                width="5"
                height="9"
                rx="1"
              />
              <rect id="Rectangle-Copy-82" fill="#FFFFFF" x="6" y="11" width="1" height="4" />
              <path
                d="M9,11 L10.5098039,9.2 L10.5098039,5.4120009 C10.5097583,4.85969093 10.957494,4.41195524 11.5098039,4.41195524 C11.6838603,4.41195524 11.8549027,4.45738383 12.0060205,4.54374955 C12.5550984,4.85755448 12.9910001,5.27630463 13.3137255,5.8 C13.8888889,6.73333333 14.1045752,7.86666667 13.9607843,9.2 L18,9.2 C19.1045695,9.2 20,10.0954305 20,11.2 L20,17 C20,18.1045695 19.1045695,19 18,19 L10.8623913,19 C10.4908948,19 10.1267401,18.8965302 9.81074714,18.7011891 L9,18.2 L9,18.2 L9,11 Z"
                id="Path-25-Copy"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  ),
  attachedFile: ({ fileType }) => (
    <svg x="0px" y="0px" viewBox="0 0 317.001 317.001" className="attached-icon">
      <path d="M270.825,70.55L212.17,3.66C210.13,1.334,207.187,0,204.093,0H55.941C49.076,0,43.51,5.566,43.51,12.431V304.57  c0,6.866,5.566,12.431,12.431,12.431h205.118c6.866,0,12.432-5.566,12.432-12.432V77.633  C273.491,75.027,272.544,72.51,270.825,70.55z M55.941,305.073V12.432H199.94v63.601c0,3.431,2.78,6.216,6.216,6.216h54.903  l0.006,222.824H55.941z" />
      <text
        x="50%"
        y="60%"
        dominantBaseline="middle"
        textAnchor="middle"
        style={{ fontSize: '100px' }}
      >
        {fileType}
      </text>
    </svg>
  ),
  userAccount: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75px"
      height="70px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <title>User</title>
      <desc>Created with Sketch.</desc>
      <g id="User" stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          d="M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M16,16 C16,13.790861 14.209139,12 12,12 C9.790861,12 8,13.790861 8,16"
          id="Combined-Shape"
          fill="#001498"
        />
      </g>
    </svg>
  ),
  assigneSelected: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <title />
      <desc>Created with Sketch.</desc>
      <g id="User" stroke="none" strokeWidth="1" fillRule="evenodd">
        <path
          d="M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M16,16 C16,13.790861 14.209139,12 12,12 C9.790861,12 8,13.790861 8,16"
          id="Combined-Shape"
          fill="#001498"
        />
      </g>
    </svg>
  ),
  acceptOld: ({ selected, disabled, tooltip, intl }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      className="mr-1"
    >
      <title>{intl.formatMessage({ id: `Icon.${tooltip || 'Approve'}` })}</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M7.53033009,11.4696699 C7.23743687,11.1767767 6.76256313,11.1767767 6.46966991,11.4696699 C6.1767767,11.7625631 6.1767767,12.2374369 6.46966991,12.5303301 L9.46966991,15.5303301 C9.76256313,15.8232233 10.2374369,15.8232233 10.5303301,15.5303301 L16.5303301,9.53033009 C16.8232233,9.23743687 16.8232233,8.76256313 16.5303301,8.46966991 C16.2374369,8.1767767 15.7625631,8.1767767 15.4696699,8.46966991 L10,13.9393398 L7.53033009,11.4696699 Z"
          id="path-1"
        />
      </defs>
      <g
        className={`${styles.selectIcon} ${disabled ? styles.disabled : ''}`}
        id="right"
        stroke="none"
        strokeWidth="1"
        fill={
          selected ? '#00a472' : getComputedStyle(document.body).getPropertyValue('--primary-bg')
        }
        fillRule="evenodd"
      >
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Combined-Shape" xlinkHref="#path-1" />
      </g>
    </svg>
  ),
  commentsaccept: ({ selected, intl }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="mr-1"
    >
      <title>{intl.formatMessage({ id: 'Icon.Right' })}</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M7.53033009,11.4696699 C7.23743687,11.1767767 6.76256313,11.1767767 6.46966991,11.4696699 C6.1767767,11.7625631 6.1767767,12.2374369 6.46966991,12.5303301 L9.46966991,15.5303301 C9.76256313,15.8232233 10.2374369,15.8232233 10.5303301,15.5303301 L16.5303301,9.53033009 C16.8232233,9.23743687 16.8232233,8.76256313 16.5303301,8.46966991 C16.2374369,8.1767767 15.7625631,8.1767767 15.4696699,8.46966991 L10,13.9393398 L7.53033009,11.4696699 Z"
          id="path-1"
        />
      </defs>
      <g
        className={`${styles.selectIcon}`}
        id="right"
        stroke="none"
        strokeWidth="1"
        fill={
          selected ? '#00a472' : getComputedStyle(document.body).getPropertyValue('--primary-bg')
        }
        fillRule="evenodd"
      >
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Combined-Shape" xlinkHref="#path-1" />
      </g>
    </svg>
  ),

  rejectOld: ({ selected, width, style, tooltip, intl }) => (
    <svg
      className={`ml-1 ${styles.rejectIcon}`}
      width={width || '20px'}
      height={width || '20px'}
      viewBox="0 0 16 16"
      version="1.1"
      style={style}
    >
      <title>{intl.formatMessage({ id: `Icon.${tooltip || 'Reject'}` })}</title>
      <desc>Created with Sketch.</desc>
      <g
        id="V2"
        stroke="none"
        strokeWidth="1"
        fill={selected ? 'red' : getComputedStyle(document.body).getPropertyValue('--primary-bg')}
        fillRule="evenodd"
      >
        <g id="Icon" transform="translate(-194.000000, -396.000000)">
          <g id="cancel" transform="translate(190.000000, 392.000000)">
            <rect
              id="Rectangle-Copy-96"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-95"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <g id="Mask" strokeWidth="1" transform="translate(3.389087, 3.889087)">
              <path
                d="M8.6109127,16.1109127 C13.0291907,16.1109127 16.6109127,12.5291907 16.6109127,8.1109127 C16.6109127,3.69263471 13.0291907,0.110912703 8.6109127,0.110912703 C4.19263471,0.110912703 0.610912703,3.69263471 0.610912703,8.1109127 C0.610912703,12.5291907 4.19263471,16.1109127 8.6109127,16.1109127 Z"
                id="Oval"
                className={styles.rejectCirle}
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(45.000000) translate(-8.500000, -8.000000) "
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29-Copy"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(135.000000) translate(-8.500000, -8.000000) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  commentsremove: () => (
    <svg
      className={`ml-1 ${styles.removeIcon}`}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
    >
      <title>cancel</title>
      <desc>Created with Sketch.</desc>
      <g id="V2" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="Icon" transform="translate(-194.000000, -396.000000)">
          <g id="cancel" transform="translate(190.000000, 392.000000)">
            <rect id="Rectangle-Copy-96" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle-Copy-95" opacity="0" x="2" y="2" width="20" height="20" />
            <g id="Mask" strokeWidth="1" transform="translate(3.389087, 3.889087)">
              <path
                d="M8.6109127,16.1109127 C13.0291907,16.1109127 16.6109127,12.5291907 16.6109127,8.1109127 C16.6109127,3.69263471 13.0291907,0.110912703 8.6109127,0.110912703 C4.19263471,0.110912703 0.610912703,3.69263471 0.610912703,8.1109127 C0.610912703,12.5291907 4.19263471,16.1109127 8.6109127,16.1109127 Z"
                id="Oval"
                className={styles.rejectCirle}
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(45.000000) translate(-8.500000, -8.000000) "
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29-Copy"
                stroke="#FFFFFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(135.000000) translate(-8.500000, -8.000000) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  removeFilled: () => (
    <svg
      className={`ml-1 ${styles.removeFilled}`}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
    >
      <title>Remove</title>
      <g id="V2" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="Icon" transform="translate(-194.000000, -396.000000)">
          <g id="cancel" transform="translate(190.000000, 392.000000)">
            <rect id="Rectangle-Copy-96" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle-Copy-95" opacity="0" x="2" y="2" width="20" height="20" />
            <g id="Mask" strokeWidth="1" transform="translate(3.389087, 3.889087)">
              <path
                d="M8.6109127,16.1109127 C13.0291907,16.1109127 16.6109127,12.5291907 16.6109127,8.1109127 C16.6109127,3.69263471 13.0291907,0.110912703 8.6109127,0.110912703 C4.19263471,0.110912703 0.610912703,3.69263471 0.610912703,8.1109127 C0.610912703,12.5291907 4.19263471,16.1109127 8.6109127,16.1109127 Z"
                id="Oval"
                className={styles.rejectCirle}
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29"
                stroke="#3751ff"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(45.000000) translate(-8.500000, -8.000000) "
                className={styles.rejectCirlePath}
              />
              <path
                d="M8.5,13 L8.5,3 L8.5,13 Z"
                id="Path-29-Copy"
                stroke="#3751ff"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(8.500000, 8.000000) rotate(135.000000) translate(-8.500000, -8.000000) "
                className={styles.rejectCirlePath}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  comments: ({ size, active }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className={size === 'large' ? styles.largeComments : styles.smallComments}
    >
      <title>Role Copy</title>
      <g id="Role-Copy" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="chat"
          transform="translate(4.000000, 4.000000)"
          fill={
            active ? getComputedStyle(document.body).getPropertyValue('--primary-main') : 'grey'
          }
        >
          <g id="Combined-Shape">
            <path
              d="M11.752,3.86206897 C12.624,3.86206897 13.3333333,4.59586207 13.3333333,5.49793103 L13.3333333,5.49793103 L13.3333333,11.329931 C13.3333333,12.2317241 12.624,12.9655172 11.752,12.9655172 L11.752,12.9655172 L6.2512,12.9655172 L3.664,15.9097931 C3.61253333,15.9682759 3.54026667,16 3.46666667,16 C3.4344,16 3.40186667,15.993931 3.37066667,15.9815172 C3.26773333,15.9404138 3.2,15.838069 3.2,15.7241379 L3.2,15.7241379 L3.2,12.9655172 L1.58133333,12.9655172 C0.709333333,12.9655172 0,12.2317241 0,11.3296552 L0,11.3296552 L0,5.49765517 C0,4.59586207 0.709333333,3.86206897 1.58133333,3.86206897 L1.58133333,3.86206897 Z M14.4186667,0 C15.292,0 16,0.732413793 16,1.63586207 L16,1.63586207 L16,8.29517241 C16,8.74151724 15.6501333,9.10344828 15.2186667,9.10344828 L15.2186667,9.10344828 L14.1333333,9.10344828 C13.9861333,9.10344828 13.8666667,8.97986207 13.8666667,8.82758621 L13.8666667,8.82758621 L13.8666667,5.33572414 C13.8666667,4.21710345 12.9901333,3.31034483 11.9088,3.31034483 L11.9088,3.31034483 L2.93333333,3.31034483 C2.78613333,3.31034483 2.66666667,3.18675862 2.66666667,3.03448276 L2.66666667,3.03448276 L2.66666667,1.63586207 C2.66666667,0.732413793 3.37466667,0 4.248,0 L4.248,0 Z"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  passwordview: () => (
    <svg width="13px" height="8px" viewBox="0 0 16 8">
      <title>view</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Icon"
          transform="translate(-95.000000, -499.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="view" transform="translate(91.000000, 491.000000)">
            <path
              d="M5.46210286,8.80905249 C6.45610181,11.2145814 8.83175445,12.5 12,12.5 C15.166554,12.5 17.5426768,11.2177298 18.5381447,8.81745204 C18.6439323,8.56237637 18.9364697,8.44135449 19.1915454,8.54714209 C19.4466211,8.65292969 19.5676429,8.94546717 19.4618553,9.20054284 C19.0171887,10.2727256 18.3415722,11.1522757 17.4795886,11.830242 L18.5261655,13.3829978 C18.6805824,13.6119302 18.6201756,13.9226962 18.3912432,14.077113 C18.1877477,14.2143724 17.9195936,14.1818947 17.7540642,14.0121963 L17.697128,13.9421907 L16.6489793,12.389013 C15.4883798,13.053235 14.0804895,13.4252838 12.5015631,13.4898495 L12.5,15 C12.5,15.2761424 12.2761424,15.5 12,15.5 C11.7238576,15.5 11.5,15.2761424 11.5,15 L11.4994771,13.4898782 C9.95302462,13.4266896 8.57087728,13.0681595 7.42449111,12.4288287 L6.41602515,13.9414507 C6.26284892,14.171215 5.95241425,14.233302 5.7226499,14.0801257 C5.51841493,13.9439691 5.44666581,13.6835589 5.54082354,13.466 L5.58397485,13.3867505 L6.58837257,11.8803711 C5.69328116,11.1937954 4.99371482,10.2940499 4.53789714,9.19094751 C4.43243975,8.93573515 4.55384013,8.64335454 4.80905249,8.53789714 C5.06426485,8.43243975 5.35664546,8.55384013 5.46210286,8.80905249 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  arrowLeft: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="17"
      viewBox="0 0 10 17"
      style={{ margin: 'auto' }}
    >
      <path
        id="Chevron"
        d="M7.948,16.654.243,9.077a.805.805,0,0,1,0-1.154L7.948.346a1.217,1.217,0,0,1,1.7,0,1.17,1.17,0,0,1,0,1.672L3.058,8.5l6.59,6.481a1.171,1.171,0,0,1,0,1.673,1.217,1.217,0,0,1-1.7,0"
        fill="#ffffff"
      />
    </svg>
  ),
  cicleArrowLeft: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
      <g fill="none" fillRule="evenodd" transform="translate(1 .811)">
        <circle cx="13" cy="13" r="13" fill="#FFF" stroke="#DDD" />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M12,6.35 C12.1450445,6.35 12.2789929,6.39750779 12.3871335,6.47781155 L12.39,6.48 L16.39,9.48 C16.6771881,9.69539105 16.7353911,10.1028119 16.52,10.39 C16.3261481,10.6484693 15.9767519,10.7214606 15.6994511,10.5764541 L15.61,10.52 L12.6499617,8.299 L12.65,17 C12.65,17.3589851 12.3589851,17.65 12,17.65 C11.6736499,17.65 11.4034735,17.4094918 11.3570477,17.0960522 L11.35,17 L11.3499617,8.299 L8.39,10.52 C8.13153074,10.7138519 7.7756729,10.6860927 7.55006595,10.4692423 L7.48,10.39 C7.28614805,10.1315307 7.31390727,9.7756729 7.53075774,9.55006595 L7.61,9.48 L11.61,6.48 L11.6254231,6.4687167 C11.6433575,6.45604905 11.6619618,6.4442666 11.6811722,6.43343294 L11.61,6.48 C11.6421991,6.45585069 11.6760804,6.43506594 11.7111753,6.41764574 C11.7295989,6.408352 11.7492566,6.39973751 11.7693927,6.39209475 C11.781655,6.38759243 11.7931465,6.38361865 11.8047176,6.37997672 C11.8285065,6.37233136 11.853639,6.36600387 11.8793034,6.36118475 C11.8859826,6.36001779 11.8926853,6.35886227 11.8994009,6.35781253 C11.9324732,6.35262116 11.9659305,6.35 12,6.35 Z"
          opacity=".5"
          transform="rotate(270 13 12)"
        />
      </g>
    </svg>
  ),
  circleArrowRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <filter id="5hqyqamoua">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.640597 0 0 0 0 0.640597 0 0 0 0 0.640597 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g filter="url(#5hqyqamoua)" transform="translate(-692 -723) translate(415 602)">
            <g>
              <path
                fill="#000"
                fillRule="nonzero"
                d="M12 6.35c.145 0 .279.048.387.128l.003.002 4 3c.287.215.345.623.13.91-.194.258-.543.331-.82.186l-.09-.056-2.96-2.221V17c0 .359-.291.65-.65.65-.326 0-.597-.24-.643-.554L11.35 17V8.299L8.39 10.52c-.258.194-.614.166-.84-.05l-.07-.08c-.194-.258-.166-.614.05-.84l.08-.07 4-3 .015-.011c.018-.013.037-.025.056-.036l-.071.047c.032-.024.066-.045.101-.062.019-.01.038-.018.058-.026l.036-.012c.024-.008.049-.014.074-.019l.02-.003c.033-.005.067-.008.101-.008z"
                transform="rotate(90 90 211)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  arrowLeftAlt: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <path
        fill="#999"
        d="M8.467 16v-.022c0-.02.002-.038.003-.057L8.467 16c0-.049.004-.096.011-.143l.01-.046c.004-.022.01-.045.017-.067l.015-.043c.027-.076.065-.146.112-.21l.008-.011 4-5.333c.287-.383.83-.46 1.213-.174.345.259.442.725.249 1.094l-.075.12-2.961 3.947h11.6c.48 0 .867.387.867.866 0 .435-.32.795-.738.857l-.128.01H11.066l2.96 3.946c.26.345.222.82-.067 1.12l-.106.094c-.344.258-.819.221-1.12-.068l-.093-.106-4-5.333c-.051-.069-.09-.138-.117-.213l-.012-.033c-.008-.025-.016-.05-.022-.076l-.007-.037c-.005-.024-.008-.048-.01-.073-.003-.02-.004-.038-.005-.057V16z"
      />
    </svg>
  ),
  arrowRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17">
      <path
        id="right_arrow"
        d="M7.948,16.654.243,9.077a.805.805,0,0,1,0-1.154L7.948.346a1.217,1.217,0,0,1,1.7,0,1.17,1.17,0,0,1,0,1.672L3.058,8.5l6.59,6.481a1.171,1.171,0,0,1,0,1.673,1.217,1.217,0,0,1-1.7,0"
        transform="translate(10 17) rotate(-180)"
        fill="#ffffff"
      />
    </svg>
  ),
  arrowDownForInput: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24">
      <path
        d="M7.902 9.47c.29-.267.742-.29 1.061-.073l.092.073 4.858 4.469 4.858-4.47c.29-.266.743-.29 1.062-.072l.091.073c.29.266.316.683.08.976l-.08.084-5.435 5c-.289.267-.742.29-1.061.073l-.091-.073-5.435-5c-.319-.293-.319-.767 0-1.06z"
        opacity=".3"
      />
    </svg>
  ),
  fullscreen: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>fullscreen</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-385.000000, -126.000000)" fill="#000000">
          <g id="fullscreen" transform="translate(387.343811, 127.889968)">
            <g
              id="Group-Copy"
              transform="translate(10.242641, 9.853116) scale(1, -1) rotate(-45.000000) translate(-10.242641, -9.853116) translate(5.742641, 1.353116)"
            >
              <path
                d="M4.30425876,9.23999862 L4.39413439,9.23194295 C4.63959428,9.23194295 4.84374276,9.40881811 4.88607872,9.64206732 L4.89413439,9.73194295 L4.894,14.973 L7.5851677,12.288892 C7.78063167,12.0938319 8.09721399,12.0941593 8.29227411,12.2896233 C8.46566088,12.463369 8.4846674,12.7328132 8.3494699,12.9275417 L8.29154287,12.9967297 L4.82197765,16.4591264 C4.64848595,16.6322596 4.3795152,16.6514967 4.18480593,16.5168375 L4.11560248,16.4591264 L0.646037268,12.9967297 C0.4505733,12.8016696 0.450245914,12.4850873 0.64530603,12.2896233 C0.8186928,12.1158775 1.08809711,12.0963138 1.28310475,12.2311082 L1.35241243,12.288892 L3.894,14.825 L3.89413439,9.73194295 C3.89413439,9.48648306 4.07100955,9.28233458 4.30425876,9.23999862 Z M0.744762237,3.3536738 L4.21432745,-0.108722889 C4.38781916,-0.281856139 4.65678991,-0.301093167 4.85149918,-0.166433973 L4.92070262,-0.108722889 L8.39026784,3.3536738 C8.5857318,3.54873392 8.58605919,3.86531624 8.39099907,4.06078021 C8.2176123,4.23452596 7.94820799,4.25408972 7.75320035,4.11929525 L7.68389267,4.06151145 L5.067,1.45 L5.06751504,7.14155322 C5.06751504,7.4176956 4.84365741,7.64155322 4.56751504,7.64155322 C4.32205515,7.64155322 4.11790667,7.46467806 4.07557071,7.23142886 L4.06751504,7.14155322 L4.067,1.45 L1.4511374,4.06151145 C1.27739165,4.23489821 1.00794745,4.25390474 0.81321902,4.11870724 L0.744030999,4.06078021 C0.57064423,3.88703446 0.551637709,3.61759026 0.686835206,3.42286183 L0.744762237,3.3536738 L4.21432745,-0.108722889 L0.744762237,3.3536738 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),

  requestnewaccess: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestNewAccess' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -644.000000)">
          <g id="request-new-access" transform="translate(560.000000, 644.000000)">
            <g id="Group-5">
              <rect
                id="Rectangle-Copy-47"
                // fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-46"
                // fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M10,13 C10.5522847,13 11,13.4477153 11,14 L11,19 C11,19.5522847 10.5522847,20 10,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,14 C4,13.4477153 4.44771525,13 5,13 L10,13 Z M16.5,13 C16.7454599,13 16.9496084,13.1768752 16.9919443,13.4101244 L17,13.5 L17,16 L19.5,16 C19.7454599,16 19.9496084,16.1768752 19.9919443,16.4101244 L20,16.5 C20,16.7761424 19.7761424,17 19.5,17 L19.5,17 L17,17 L17,19.5 C17,19.7761424 16.7761424,20 16.5,20 C16.2545401,20 16.0503916,19.8231248 16.0080557,19.5898756 L16,19.5 L16,17 L13.5,17 C13.2545401,17 13.0503916,16.8231248 13.0080557,16.5898756 L13,16.5 C13,16.2238576 13.2238576,16 13.5,16 L13.5,16 L16,16 L16,13.5 C16,13.2238576 16.2238576,13 16.5,13 Z M10,14 L5,14 L5,19 L10,19 L10,14 Z M10,4 C10.5522847,4 11,4.44771525 11,5 L11,10 C11,10.5522847 10.5522847,11 10,11 L5,11 C4.44771525,11 4,10.5522847 4,10 L4,5 C4,4.44771525 4.44771525,4 5,4 L10,4 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,10 C20,10.5522847 19.5522847,11 19,11 L14,11 C13.4477153,11 13,10.5522847 13,10 L13,5 C13,4.44771525 13.4477153,4 14,4 L19,4 Z M10,5 L5,5 L5,10 L10,10 L10,5 Z M19,5 L14,5 L14,10 L19,10 L19,5 Z"
                id="Combined-Shape"
                // fill="#999"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  myapplications: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.MyApplications' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -711.000000)">
          <g id="My-Applications" transform="translate(560.000000, 711.000000)">
            <g id="Group-6">
              <rect
                id="Rectangle-Copy-14"
                // fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                // fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <g
                id="Group-9"
                transform="translate(4.000000, 4.000000)"
                // fill="#999"
                fillRule="nonzero"
              >
                <path
                  d="M14,4 C15.1045695,4 16,4.82081129 16,5.83333333 L16,13.1666667 C16,14.1791887 15.1045695,15 14,15 L2,15 C0.8954305,15 0,14.1791887 0,13.1666667 L0,5.83333333 C0,4.82081129 0.8954305,4 2,4 L14,4 Z M14,5 L2,5 C1.44771525,5 1,5.40294373 1,5.9 L1,13.1 C1,13.5970563 1.44771525,14 2,14 L14,14 C14.5522847,14 15,13.5970563 15,13.1 L15,5.9 C15,5.40294373 14.5522847,5 14,5 Z M2.5,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.74545989 13.8231248,2.94960837 13.5898756,2.99194433 L13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.25454011 2.17687516,2.05039163 2.41012437,2.00805567 L2.5,2 L13.5,2 Z M11.4285714,0 C11.7441627,0 12,0.223857625 12,0.5 C12,0.776142375 11.7441627,1 11.4285714,1 L11.4285714,1 L4.57142857,1 C4.25583729,1 4,0.776142375 4,0.5 C4,0.223857625 4.25583729,0 4.57142857,0 L4.57142857,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  requestnewaccessLarge: ({ intl }) => (
    <svg
      width="37px"
      height="37px"
      viewBox="0 0 26 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestNewAccess' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="#a5abb4" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -644.000000)">
          <g id="request-new-access" transform="translate(560.000000, 644.000000)">
            <g id="Group-5">
              <rect
                id="Rectangle-Copy-47"
                // fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-46"
                // fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M10,13 C10.5522847,13 11,13.4477153 11,14 L11,19 C11,19.5522847 10.5522847,20 10,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,14 C4,13.4477153 4.44771525,13 5,13 L10,13 Z M16.5,13 C16.7454599,13 16.9496084,13.1768752 16.9919443,13.4101244 L17,13.5 L17,16 L19.5,16 C19.7454599,16 19.9496084,16.1768752 19.9919443,16.4101244 L20,16.5 C20,16.7761424 19.7761424,17 19.5,17 L19.5,17 L17,17 L17,19.5 C17,19.7761424 16.7761424,20 16.5,20 C16.2545401,20 16.0503916,19.8231248 16.0080557,19.5898756 L16,19.5 L16,17 L13.5,17 C13.2545401,17 13.0503916,16.8231248 13.0080557,16.5898756 L13,16.5 C13,16.2238576 13.2238576,16 13.5,16 L13.5,16 L16,16 L16,13.5 C16,13.2238576 16.2238576,13 16.5,13 Z M10,14 L5,14 L5,19 L10,19 L10,14 Z M10,4 C10.5522847,4 11,4.44771525 11,5 L11,10 C11,10.5522847 10.5522847,11 10,11 L5,11 C4.44771525,11 4,10.5522847 4,10 L4,5 C4,4.44771525 4.44771525,4 5,4 L10,4 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,10 C20,10.5522847 19.5522847,11 19,11 L14,11 C13.4477153,11 13,10.5522847 13,10 L13,5 C13,4.44771525 13.4477153,4 14,4 L19,4 Z M10,5 L5,5 L5,10 L10,10 L10,5 Z M19,5 L14,5 L14,10 L19,10 L19,5 Z"
                id="Combined-Shape"
                // fill="#999"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  newpriviligedaccess: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.NewPrivilegedAccess' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -570.000000)">
          <g id="New-Privileged-Access" transform="translate(560.000000, 570.000000)">
            <g>
              <rect
                id="Rectangle-Copy-13"
                // fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                // fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M6.5,20 L17.5,20 C17.7761424,20 18,19.7761424 18,19.5 C18,19.2238576 17.7761424,19 17.5,19 L6.5,19 C6.22385763,19 6,19.2238576 6,19.5 C6,19.7761424 6.22385763,20 6.5,20 Z M14.5,19 C14.7761424,19 15,19.2238576 15,19.5 C15,19.7761424 14.7761424,20 14.5,20 C14.2238576,20 14,19.7761424 14,19.5 C14,19.2238576 14.2238576,19 14.5,19 Z M16.5,19 C16.7761424,19 17,19.2238576 17,19.5 C17,19.7761424 16.7761424,20 16.5,20 C16.2238576,20 16,19.7761424 16,19.5 C16,19.2238576 16.2238576,19 16.5,19 Z M12.5,19 C12.7761424,19 13,19.2238576 13,19.5 C13,19.7761424 12.7761424,20 12.5,20 C12.2238576,20 12,19.7761424 12,19.5 C12,19.2238576 12.2238576,19 12.5,19 Z M15.7941623,11.3321038 L12.4571691,3.79752419 C12.2740399,3.38403774 11.6797372,3.40675547 11.528708,3.83301542 L8.86638307,11.3470772 L4.33025031,7.35664467 C3.96462286,7.03500248 3.40171538,7.37262363 3.5133046,7.8466331 L5.69512278,17.1145757 C5.74828687,17.3404065 5.94981395,17.5 6.18181818,17.5 L17.8181818,17.5 C18.0501861,17.5 18.2517131,17.3404065 18.3048772,17.1145757 L20.4866954,7.8466331 C20.6028533,7.35321683 19.995636,7.02006498 19.6418852,7.38312505 L15.7941623,11.3321038 Z M4.84554822,9.14181925 L8.76065878,12.5859391 C9.026325,12.8196454 9.44403206,12.7110274 9.56220109,12.3775109 L12.0516565,5.35135045 L15.1791946,12.4130021 C15.3225214,12.736619 15.7474792,12.8129579 15.9944784,12.5594587 L19.1002816,9.37192389 L17.4222213,16.5 L6.57777869,16.5 L4.84554822,9.14181925 Z"
                id="Combined-Shape"
                // fill="#999"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  violation: ({ size }) => (
    <svg
      width={size || '24px'}
      height={size || '24px'}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Violation</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-346.000000, -126.000000)">
          <g id="Violation" transform="translate(346.000000, 126.000000)">
            <rect
              id="Rectangle-Copy-101"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-100"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <g
              id="Group-5"
              strokeWidth="1"
              fillRule="evenodd"
              transform="translate(6.000000, 4.000000)"
              fill="#000000"
            >
              <path
                d="M10,15 C10.2761424,15 10.5,15.2238576 10.5,15.5 C10.5,15.7761424 10.2761424,16 10,16 L10,16 L2,16 C1.72385763,16 1.5,15.7761424 1.5,15.5 C1.5,15.2238576 1.72385763,15 2,15 L2,15 Z M6,0 C9.3137085,0 12,2.6862915 12,6 L12,13 C12,13.5522847 11.5522847,14 11,14 L1,14 C0.44771525,14 0,13.5522847 0,13 L0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,1 C3.23857625,1 1,3.23857625 1,6 L1,13 L11,13 L11,6 C11,3.23857625 8.76142375,1 6,1 Z M6.03804033,3.54340764 C6.53785116,3.54340764 6.94302789,3.94858438 6.94302789,4.44839521 C6.94302789,4.47846773 6.94152894,4.50852156 6.93853661,4.53844483 L6.53804033,8.54340764 C6.51042609,8.81955002 6.2641827,9.02102188 5.98804033,8.99340764 C5.75006474,8.96961009 5.56183789,8.78138323 5.53804033,8.54340764 L5.13754405,4.53844483 C5.08781101,4.04111447 5.45066034,3.59763196 5.9479907,3.54789893 C5.97791398,3.5449066 6.00796781,3.54340764 6.03804033,3.54340764 Z M6.03804033,4.54340764 L6.04749442,4.54293612 C6.09970792,4.53771477 6.13780259,4.49115462 6.13258124,4.43894112 L6.53307752,8.44390393 C6.50951617,8.2082904 6.32315758,8.02193181 6.08754405,7.99837045 C5.81414256,7.97103031 5.57034329,8.17050243 5.54300314,8.44390393 L5.94349942,4.43894112 L5.94302789,4.44839521 C5.94302789,4.50086913 5.98556641,4.54340764 6.03804033,4.54340764 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
            <path
              d="M12.0209687,14.7250108 C12.2971111,14.7250108 12.5209687,14.5011532 12.5209687,14.2250108 C12.5209687,13.9488685 12.2971111,13.7250108 12.0209687,13.7250108 C11.7448263,13.7250108 11.5209687,13.9488685 11.5209687,14.2250108 C11.5209687,14.5011532 11.7448263,14.7250108 12.0209687,14.7250108 Z"
              id="Oval"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  priviligedsession: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.PrivilegedSessions' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -501.000000)">
          <g id="Privileged-sessions" transform="translate(560.000000, 501.000000)">
            <rect
              id="Rectangle-Copy-19"
              // fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-18"
              // fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15.5,17 C15.7761424,17 16,17.2238576 16,17.5 C16,17.7761424 15.7761424,18 15.5,18 L15.5,18 L8.5,18 C8.22385763,18 8,17.7761424 8,17.5 C8,17.2238576 8.22385763,17 8.5,17 L8.5,17 Z M18,6 C18.5522847,6 19,6.44771525 19,7 L19,15 C19,15.5522847 18.5522847,16 18,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,7 C5,6.44771525 5.44771525,6 6,6 L18,6 Z M18,7 L6,7 L6,15 L18,15 L18,7 Z M10,10.5 C10.2454599,10.5 10.4496084,10.6768752 10.4919443,10.9101244 L10.5,11 L10.5,13 C10.5,13.2761424 10.2761424,13.5 10,13.5 C9.75454011,13.5 9.55039163,13.3231248 9.50805567,13.0898756 L9.5,13 L9.5,11 C9.5,10.7238576 9.72385763,10.5 10,10.5 Z M12,9.5 C12.2454599,9.5 12.4496084,9.67687516 12.4919443,9.91012437 L12.5,10 L12.5,13 C12.5,13.2761424 12.2761424,13.5 12,13.5 C11.7545401,13.5 11.5503916,13.3231248 11.5080557,13.0898756 L11.5,13 L11.5,10 C11.5,9.72385763 11.7238576,9.5 12,9.5 Z M14,8.5 C14.2454599,8.5 14.4496084,8.67687516 14.4919443,8.91012437 L14.5,9 L14.5,13 C14.5,13.2761424 14.2761424,13.5 14,13.5 C13.7545401,13.5 13.5503916,13.3231248 13.5080557,13.0898756 L13.5,13 L13.5,9 C13.5,8.72385763 13.7238576,8.5 14,8.5 Z"
              id="Combined-Shape"
              // fill="#999"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  pastsessions: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.PastSessions' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -779.000000)">
          <g id="Rectangle" transform="translate(560.000000, 779.000000)">
            <rect fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24" />
            <g id="Group-10" strokeWidth="1" transform="translate(3.000000, 5.000000)">
              {/* fill="#999" */}
              <path
                d="M16.7350005,8.57600085 C16.9691688,8.42964568 17.277644,8.50083226 17.4239992,8.73500053 C17.5703543,8.9691688 17.4991677,9.27764399 17.2649995,9.42399915 L17.2649995,9.42399915 L9.26499947,14.4239992 C9.10286433,14.5253336 8.89713567,14.5253336 8.73500053,14.4239992 L8.73500053,14.4239992 L0.73500053,9.42399915 C0.500832264,9.27764399 0.429645682,8.9691688 0.576000848,8.73500053 C0.722356014,8.50083226 1.0308312,8.42964568 1.26499947,8.57600085 L1.26499947,8.57600085 L9,13.4103762 Z M8.73500053,0.576000848 C8.89713567,0.474666384 9.10286433,0.474666384 9.26499947,0.576000848 L9.26499947,0.576000848 L17.2649995,5.57600085 C17.5783335,5.77183462 17.5783335,6.22816538 17.2649995,6.42399915 L17.2649995,6.42399915 L9.26499947,11.4239992 C9.10286433,11.5253336 8.89713567,11.5253336 8.73500053,11.4239992 L8.73500053,11.4239992 L0.73500053,6.42399915 C0.42166649,6.22816538 0.42166649,5.77183462 0.73500053,5.57600085 L0.73500053,5.57600085 Z M9,1.58962382 L1.94339811,6 L9,10.4103762 L16.0566019,6 L9,1.58962382 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  requesthistory: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestHistory' })}</title>
      <desc>Created with Sketch.</desc>
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        fillRule="evenodd"
      >
        <g id="Desktop" transform="translate(-560.000000, -847.000000)">
          <g id="Request-history" transform="translate(560.000000, 847.000000)">
            <g id="Group-3">
              <rect
                id="Rectangle-Copy-29"
                // fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-28"
                // fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M17,3.5 C18.3807119,3.5 19.5,4.61928813 19.5,6 L19.5,18 C19.5,19.3807119 18.3807119,20.5 17,20.5 L7,20.5 C5.61928813,20.5 4.5,19.3807119 4.5,18 L4.5,3.5 L17,3.5 Z M17,4.5 L5.5,4.5 L5.5,18 C5.5,18.8284271 6.17157288,19.5 7,19.5 L17,19.5 C17.8284271,19.5 18.5,18.8284271 18.5,18 L18.5,6 C18.5,5.17157288 17.8284271,4.5 17,4.5 Z M14.5315683,15.6776347 C14.8077107,15.6776347 15.0315683,15.9014923 15.0315683,16.1776347 C15.0315683,16.4537771 14.8077107,16.6776347 14.5315683,16.6776347 L14.5315683,16.6776347 L9.53156833,16.6776347 C9.25542595,16.6776347 9.03156833,16.4537771 9.03156833,16.1776347 C9.03156833,15.9014923 9.25542595,15.6776347 9.53156833,15.6776347 L9.53156833,15.6776347 Z M12.0230146,6.40137283 C14.2321536,6.40137283 16.0230146,8.19223383 16.0230146,10.4013728 C16.0230146,12.6105118 14.2321536,14.4013728 12.0230146,14.4013728 C10.6427096,14.4013728 9.42569822,13.70223 8.70678744,12.6387516 C8.27510186,12.0001628 8.02301455,11.2302069 8.02301455,10.4013728 C8.02301455,9.6721237 8.21816414,8.9884542 8.55908943,8.3997382 C9.25094063,7.20503697 10.5431247,6.40137283 12.0230146,6.40137283 Z M12.0230146,7.40137283 C10.9395541,7.40137283 9.95790801,7.97970297 9.42445853,8.90087324 C9.16266519,9.35294274 9.02301455,9.86578722 9.02301455,10.4013728 C9.02301455,11.0089525 9.20293476,11.587116 9.53525199,12.07871 C10.0905314,12.9001301 11.0135495,13.4013728 12.0230146,13.4013728 C13.6798688,13.4013728 15.0230146,12.0582271 15.0230146,10.4013728 C15.0230146,8.74451858 13.6798688,7.40137283 12.0230146,7.40137283 Z M11.9625547,8.25380649 C12.2080146,8.25380649 12.4121631,8.43068165 12.454499,8.66393086 L12.4625547,8.75380649 L12.4625547,10.5466997 L13.3161081,11.4002531 C13.5113702,11.5955152 13.5113702,11.9120977 13.3161081,12.1073599 C13.1425417,12.2809262 12.8731173,12.3002114 12.6782492,12.1652153 L12.6090013,12.1073599 L11.6090013,11.1073599 C11.5339868,11.0323453 11.4852697,10.9359492 11.4687834,10.8324959 L11.4625547,10.7538065 L11.4625547,8.75380649 C11.4625547,8.47766412 11.6864123,8.25380649 11.9625547,8.25380649 Z"
                id="Combined-Shape"
                // fill="#999"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  approvalsafe: ({ intl }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55px"
      height="16px"
      viewBox="0 0 55 16"
      version="1.1"
    >
      <title>{intl.formatMessage({ id: 'Icon.Safe.Label' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="safe-label" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-29">
          <rect id="Rectangle" fill="#00a472" x="0" y="0" width="55" height="16" rx="7.5" />
          <g id="Group-13" transform="translate(5.188679, 3.000000)">
            <path
              d="M1,1.42108547e-14 L7.56132075,1.42108547e-14 C8.1136055,1.41094017e-14 8.56132075,0.44771525 8.56132075,1 C8.56132075,2.33582475 8.56132075,3.6716495 8.56132075,5.00747425 C8.56132075,6.67105551 7.34515241,8.39045109 4.91281573,10.165661 L4.912806,10.1656477 C4.56501607,10.4194777 4.09379647,10.4221892 3.74310848,10.1723783 C1.24770283,8.39478844 0,6.67315374 0,5.00747425 C0,3.6716495 0,2.33582475 0,1 C-6.76353751e-17,0.44771525 0.44771525,1.43123078e-14 1,1.42108547e-14 Z"
              id="Rectangle"
              fill="#FFFFFF"
            />
            <polygon
              id="Star"
              fill="#00a472"
              points="4.28066038 5.61458333 2.74303819 6.39356367 3.03669789 4.74365684 1.79273541 3.57518633 3.51184928 3.33446816 4.28066038 1.83333333 5.04947147 3.33446816 6.76858534 3.57518633 5.52462286 4.74365684 5.81828257 6.39356367"
            />
          </g>
          <text
            id="Safe"
            fontFamily="Rubik-Bold, Rubik"
            fontSize="10"
            fontWeight="bold"
            line-spacing="10"
            fill="#FFFFFF"
            fontStyle="normal"
          >
            <tspan x="20.754717" y="12">
              Safe
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  ),
  approvalrisk: ({ intl }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55px"
      height="16px"
      viewBox="0 0 55 16"
      version="1.1"
    >
      <title>{intl.formatMessage({ id: 'Icon.Risky.Label' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="risky-lable" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-28">
          <rect id="Rectangle" fill="#FFA936" x="0" y="0" width="55" height="16" rx="7.5" />
          <text
            id="Risky"
            fontFamily="Rubik-Bold, Rubik"
            fontSize="10"
            fontWeight="bold"
            line-spacing="10"
            fill="#FFFFFF"
            fontStyle="normal"
          >
            <tspan x="20" y="12">
              Risky
            </tspan>
          </text>
          <g id="Group-27" transform="translate(4.000000, 2.500000)">
            <circle id="Oval" fill="#FFFFFF" cx="5.5" cy="5.5" r="5.5" />
            <g id="mark" transform="translate(4.125000, 1.833333)" fillRule="nonzero">
              <ellipse id="Oval" fill="#FFA936" cx="1.37605765" cy="6.86856918" rx="1" ry="1" />
              <path
                d="M2.27509608,4.39783387 C2.27509608,4.8383671 1.87211533,5.1945429 1.37605765,5.1945429 L1.37605765,5.1945429 C0.87894228,5.1945429 0.477019216,4.83742979 0.477019216,4.39783387 L0.096249997,0.531451791 C0.096249997,0.0909185604 0.879999973,0.0159341807 1.37711534,0.0159341807 L1.37711534,0.0159341807 C1.87423071,0.0159341807 2.66221146,0.0909185604 2.66221146,0.531451791 L2.52471146,1.9158509"
                id="Path"
                fill="#FFA936"
              />
              <path d="M2.60403838,2.45386382 L2.32903839,3.85888364" id="Path" fill="#FFFFFF" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  riskyIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="14" viewBox="0 0 68 14">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g transform="translate(-778 -632) translate(144 232) translate(634 400) translate(0 .038)">
                <circle cx="7" cy="7" r="6.5" fill="#FF9200" stroke="#FF9200" />
                <g fill="#FFF" fillRule="nonzero" transform="translate(6 2.562)">
                  <circle cx="1" cy="8" r="1" />
                  <path d="M1.698 5.077c0 .51-.314.923-.7.923-.388 0-.701-.414-.701-.923L0 .597C0 .087.61 0 .998 0S2 .087 2 .597l-.107 1.604" />
                </g>
              </g>
              <text
                fill="#FF9200"
                fontFamily="Rubik"
                fontSize="13"
                fontWeight="500"
                transform="translate(-778 -632) translate(144 232) translate(634 400)"
              >
                <tspan x="20" y="12">
                  Risky
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  listRiskIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="14" viewBox="0 0 68 14">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#FF9200"
                fillRule="nonzero"
                d="M58.191 4.203c.232-.246.594-.268.85-.067l.072.067L63 8.328l3.887-4.125c.231-.246.594-.268.849-.067l.073.067c.232.246.253.63.063.901l-.063.078-4.348 4.615c-.231.246-.594.268-.849.067l-.073-.067-4.348-4.615c-.255-.27-.255-.709 0-.98z"
                transform="translate(-778 -632) translate(144 232) translate(634 400) rotate(-90 63 7)"
              />
              <g transform="translate(-778 -632) translate(144 232) translate(634 400) translate(0 .038)">
                <circle cx="7" cy="7" r="6.5" fill="#FF9200" stroke="#FF9200" />
                <g fill="#FFF" fillRule="nonzero" transform="translate(6 2.562)">
                  <circle cx="1" cy="8" r="1" />
                  <path d="M1.698 5.077c0 .51-.314.923-.7.923-.388 0-.701-.414-.701-.923L0 .597C0 .087.61 0 .998 0S2 .087 2 .597l-.107 1.604" />
                </g>
              </g>
              <text
                fill="#FF9200"
                fontFamily="Rubik-Medium, Rubik"
                fontSize="13"
                fontWeight="500"
                transform="translate(-778 -632) translate(144 232) translate(634 400)"
              >
                <tspan x="20" y="12" fontStyle="normal">
                  Risky
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  listSafeIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="14" viewBox="0 0 68 14">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#31B793"
                fillRule="nonzero"
                d="M58.191 4.203c.232-.246.594-.268.85-.067l.072.067L63 8.328l3.887-4.125c.231-.246.594-.268.849-.067l.073.067c.232.246.253.63.063.901l-.063.078-4.348 4.615c-.231.246-.594.268-.849.067l-.073-.067-4.348-4.615c-.255-.27-.255-.709 0-.98z"
                transform="translate(-807 -738) translate(128 232) translate(679 506) rotate(-90 63 7)"
              />
              <text
                fill="#31B793"
                fontFamily="Rubik-Medium, Rubik"
                fontSize="13"
                fontWeight="500"
                transform="translate(-807 -738) translate(128 232) translate(679 506)"
              >
                <tspan x="21" y="12" fontStyle="normal">
                  Safe
                </tspan>
              </text>
              <path
                fill="#31B793"
                stroke="#31B793"
                d="M13 .5l.5 6.129c0 2.11-2.029 4.233-5.816 6.453-.4.23-.65.324-.852.212-2.14-1.192-3.748-2.36-4.818-3.514C1.023 8.71.5 7.667.5 6.629h0V1L13 .5z"
                transform="translate(-807 -738) translate(128 232) translate(679 506)"
              />
              <path
                fill="#FFF"
                d="M7 7.75L4.943 8.832 5.336 6.541 3.671 4.918 5.971 4.584 7 2.5 8.029 4.584 10.329 4.918 8.664 6.541 9.057 8.832z"
                transform="translate(-807 -738) translate(128 232) translate(679 506)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  advFilter: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 225.000000 225.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
        fill="#bcc0c8"
        stroke="none"
      >
        <path d="M662 2080 c-98 -20 -192 -96 -229 -185 l-18 -43 -161 -4 c-172 -3 -187 -7 -205 -57 -13 -33 7 -80 38 -92 13 -5 93 -9 177 -9 l153 0 12 -41 c19 -62 111 -151 186 -179 156 -57 343 25 401 176 l17 44 558 0 c306 0 565 3 574 6 23 9 46 60 39 88 -3 14 -15 33 -26 43 -19 17 -54 18 -582 21 l-561 3 -24 50 c-59 129 -211 207 -349 179z m137 -170 c130 -66 107 -260 -36 -299 -95 -26 -203 55 -203 153 0 126 127 204 239 146z" />
        <path d="M1416 1423 c-67 -23 -147 -98 -177 -168 l-24 -55 -561 0 c-534 0 -563 -1 -585 -19 -32 -26 -32 -86 0 -112 22 -18 51 -19 585 -19 l561 0 19 -47 c28 -67 90 -131 161 -164 157 -75 348 -4 421 156 l25 55 159 0 c139 0 160 2 181 19 17 13 23 29 23 56 0 27 -6 43 -23 56 -20 17 -42 19 -181 19 l-157 0 -32 65 c-71 144 -236 210 -395 158z m184 -156 c50 -26 90 -90 90 -142 0 -52 -40 -116 -90 -142 -71 -38 -141 -25 -193 36 -54 65 -55 147 0 212 52 61 121 74 193 36z" />
        <path d="M640 791 c-92 -30 -190 -119 -211 -192 l-12 -39 -161 0 c-111 -1 -166 -4 -177 -13 -43 -33 -46 -89 -7 -124 17 -15 42 -18 182 -21 l161 -4 18 -43 c54 -130 203 -210 344 -184 108 20 191 83 234 178 l24 50 561 3 c607 3 584 1 605 57 13 33 -5 75 -37 90 -18 8 -188 11 -578 11 l-553 0 -17 44 c-24 63 -87 130 -152 162 -59 29 -174 42 -224 25z m170 -174 c75 -49 97 -151 50 -221 -74 -107 -223 -98 -281 17 -54 105 24 227 146 227 37 0 61 -6 85 -23z" />
      </g>
    </svg>
  ),
  discontinueRequest: () => (
    <svg
      width="57px"
      height="51px"
      className="pt-1"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Role Copy 2</title>
      <desc>Created with Sketch.</desc>
      <g id="Role-Copy-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,7 C12.5142429,7 12.9311192,7.41687627 12.9311192,7.9311192 C12.9311192,7.95325346 12.93033,7.97538069 12.928753,7.9974587 L12.5356235,13.5012707 C12.5155515,13.7822795 12.2817248,14 12,14 C11.7182752,14 11.4844485,13.7822795 11.4643765,13.5012707 L11.071247,7.9974587 C11.0346088,7.48452261 11.4207244,7.03900455 11.9336605,7.00236625 C11.9557385,7.00078925 11.9778657,7 12,7 Z M11.9933637,14.5377166 C12.2695061,14.5377166 12.4933637,14.7615743 12.4933637,15.0377166 C12.4933637,15.2831765 12.3164885,15.487325 12.0832393,15.529661 L11.9933637,15.5377166 C11.7172213,15.5377166 11.4933637,15.313859 11.4933637,15.0377166 C11.4933637,14.7615743 11.7172213,14.5377166 11.9933637,14.5377166 L11.9933637,14.5377166 Z"
          id="Combined-Shape"
          fill="#ee5357"
        />
      </g>
    </svg>
  ),
  appswitcheronboard: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.AppOnboard' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-568.000000, -564.000000)">
          <g id="Group" transform="translate(568.000000, 564.000000)">
            <rect
              id="Rectangle-Copy-319"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-318"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M16,4 C17.1045695,4 18,4.8954305 18,6 L18,7.5 L19,7.5 C19.7626523,7.5 20.4184435,8.00910779 20.4929565,8.70145121 L20.5,8.83333333 L20.5,17.1666667 C20.5,17.8806416 19.8890707,18.4317479 19.1416292,18.4941135 L19,18.5 L17.9367279,18.5010222 C17.7143512,19.3631171 16.9315516,20 16,20 L8,20 C7.06844842,20 6.28564881,19.3631171 6.06327212,18.5010222 L4.5,18.5 L4.3583708,18.4941135 C3.61092935,18.4317479 3,17.8806416 3,17.1666667 L3,17.1666667 L3,8.83333333 L3.0070435,8.70145121 C3.08155648,8.00910779 3.73734773,7.5 4.5,7.5 L4.5,7.5 L6,7.5 L6,6 C6,4.8954305 6.8954305,4 8,4 L16,4 Z M16,5 L8,5 C7.48716416,5 7.06449284,5.38604019 7.00672773,5.88337887 L7,6 L7,18 C7,18.5128358 7.38604019,18.9355072 7.88337887,18.9932723 L8,19 L16,19 C16.5128358,19 16.9355072,18.6139598 16.9932723,18.1166211 L17,18 L17,6 C17,5.48716416 16.6139598,5.06449284 16.1166211,5.00672773 L16,5 Z M6,8.5 L4.5,8.5 L4.4053549,8.50610193 C4.16256675,8.5379833 4,8.68944336 4,8.83333333 L4,8.83333333 L4,17.1666667 L4.00745949,17.2207319 C4.04681453,17.3645277 4.23844315,17.5 4.5,17.5 L4.5,17.5 L6,17.5 L6,8.5 Z M19,8.5 L18,8.5 L18,17.5 L19,17.5 C19.2615569,17.5 19.4531855,17.3645277 19.4925405,17.2207319 L19.5,17.1666667 L19.5,8.83333333 C19.5,8.68944336 19.3374333,8.5379833 19.0946451,8.50610193 L19,8.5 Z M11,16 C11.2761424,16 11.5,16.2238576 11.5,16.5 C11.5,16.7454599 11.3231248,16.9496084 11.0898756,16.9919443 L11,17 L9,17 C8.72385763,17 8.5,16.7761424 8.5,16.5 C8.5,16.2545401 8.67687516,16.0503916 8.91012437,16.0080557 L9,16 L11,16 Z M13,14 C13.2761424,14 13.5,14.2238576 13.5,14.5 C13.5,14.7454599 13.3231248,14.9496084 13.0898756,14.9919443 L13,15 L9,15 C8.72385763,15 8.5,14.7761424 8.5,14.5 C8.5,14.2545401 8.67687516,14.0503916 8.91012437,14.0080557 L9,14 L13,14 Z M15,12 C15.2761424,12 15.5,12.2238576 15.5,12.5 C15.5,12.7454599 15.3231248,12.9496084 15.0898756,12.9919443 L15,13 L9,13 C8.72385763,13 8.5,12.7761424 8.5,12.5 C8.5,12.2545401 8.67687516,12.0503916 8.91012437,12.0080557 L9,12 L15,12 Z M14.3448276,6.63793103 C14.5225744,6.80721372 14.5484232,7.07608779 14.4182187,7.2741896 L14.362069,7.34482759 L11.5049261,10.3448276 C11.3297756,10.5287356 11.0495348,10.5491699 10.8510308,10.4061303 L10.7807882,10.3448276 L9.63793103,9.14482759 C9.44748802,8.94486242 9.45520725,8.62837405 9.65517241,8.43793103 C9.83291923,8.26864835 10.1027338,8.25593831 10.2942524,8.39564569 L10.362069,8.45517241 L11.142,9.275 L13.637931,6.65517241 C13.8283741,6.45520725 14.1448624,6.44748802 14.3448276,6.63793103 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcheradmin: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Admin' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-210.000000, -332.000000)" fill="#000000">
          <g id="Admin" transform="translate(210.000000, 332.000000)">
            <g transform="translate(6.000000, 5.000000)" id="Combined-Shape">
              <path
                d="M10.204087,7.06556984 C10.9875505,7.06556984 11.5374203,7.85738243 11.5374203,8.76556984 L11.5374203,13.5655698 C11.5374203,13.8417122 11.3135627,14.0655698 11.0374203,14.0655698 C10.761278,14.0655698 10.5374203,13.8417122 10.5374203,13.5655698 L10.5374203,8.76556984 C10.5374203,8.34827385 10.3410981,8.06556984 10.204087,8.06556984 L1.87075367,8.06556984 C1.73374256,8.06556984 1.53742033,8.34827385 1.53742033,8.76556984 L1.53742033,13.5655698 C1.53742033,13.8417122 1.31356271,14.0655698 1.03742033,14.0655698 C0.761277957,14.0655698 0.537420332,13.8417122 0.537420332,13.5655698 L0.537420332,8.76556984 C0.537420332,7.85738243 1.08729019,7.06556984 1.87075367,7.06556984 L10.204087,7.06556984 Z M6.11110045,0.92140829 C7.49181232,0.92140829 8.61110045,2.04069642 8.61110045,3.42140829 C8.61110045,4.80212016 7.49181232,5.92140829 6.11110045,5.92140829 C4.73038857,5.92140829 3.61110045,4.80212016 3.61110045,3.42140829 C3.61110045,2.04069642 4.73038857,0.92140829 6.11110045,0.92140829 Z M6.11110045,1.92140829 C5.28267332,1.92140829 4.61110045,2.59298117 4.61110045,3.42140829 C4.61110045,4.24983542 5.28267332,4.92140829 6.11110045,4.92140829 C6.93952757,4.92140829 7.61110045,4.24983542 7.61110045,3.42140829 C7.61110045,2.59298117 6.93952757,1.92140829 6.11110045,1.92140829 Z"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherreview: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Review</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-67.000000, -332.000000)"
          fill="#a9a9a9"
          fillRule="nonzero"
        >
          <g id="Review" transform="translate(67.000000, 332.000000)">
            <path
              d="M17,4 C18.1045695,4 19,4.8954305 19,6 L19,18 C19,19.1045695 18.1045695,20 17,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 L17,4 Z M17,5 L6,5 L6,18 C6,18.5522847 6.44771525,19 7,19 L17,19 C17.5522847,19 18,18.5522847 18,18 L18,6 C18,5.44771525 17.5522847,5 17,5 Z M14,15.5 C14.2761424,15.5 14.5,15.7238576 14.5,16 C14.5,16.2761424 14.2761424,16.5 14,16.5 L14,16.5 L10,16.5 C9.72385763,16.5 9.5,16.2761424 9.5,16 C9.5,15.7238576 9.72385763,15.5 10,15.5 L10,15.5 Z M12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 C10.6196951,14 9.40268367,13.3008572 8.68377289,12.2373787 C8.2520873,11.59879 8,10.8288341 8,10 C8,9.27075087 8.19514959,8.58708137 8.53607488,7.99836537 C9.22792608,6.80366414 10.5201101,6 12,6 Z M12,7 C10.9165395,7 9.93489346,7.57833014 9.40144397,8.49950041 C9.13965064,8.95156991 9,9.46441439 9,10 C9,10.6075796 9.17992021,11.1857432 9.51223744,11.6773372 C10.0675169,12.4987573 10.9905349,13 12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 Z M13.084335,8.64644661 C13.2795971,8.45118446 13.5961796,8.45118446 13.7914418,8.64644661 C13.9867039,8.84170876 13.9867039,9.15829124 13.7914418,9.35355339 L13.7914418,9.35355339 L11.7914418,11.3535534 C11.5961796,11.5488155 11.2795971,11.5488155 11.084335,11.3535534 L11.084335,11.3535534 L10.084335,10.3535534 C9.88907284,10.1582912 9.88907284,9.84170876 10.084335,9.64644661 C10.2795971,9.45118446 10.5961796,9.45118446 10.7914418,9.64644661 L10.7914418,9.64644661 L11.4378884,10.2928932 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherrequest: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Home' })}</title>

      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-712.000000, -564.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(712.000000, 564.000000)">
            <path d="M7,19.5 C6.17157288,19.5 5.5,18.8284271 5.5,18 L5.5,18 L5.5,10.4683749 C5.5,10.0232052 5.69773451,9.60103376 6.0397234,9.31604303 L6.0397234,9.31604303 L11.0397234,5.14937636 C11.5959923,4.68581892 12.4040077,4.68581892 12.9602766,5.14937636 L12.9602766,5.14937636 L17.9602766,9.31604303 C18.3022655,9.60103376 18.5,10.0232052 18.5,10.4683749 L18.5,10.4683749 L18.5,18 C18.5,18.8284271 17.8284271,19.5 17,19.5 L17,19.5 Z M12.3200922,5.91759764 C12.1346692,5.76307849 11.8653308,5.76307849 11.6799078,5.91759764 L11.6799078,5.91759764 L6.6799078,10.0842643 C6.5659115,10.1792612 6.5,10.319985 6.5,10.4683749 L6.5,10.4683749 L6.5,18 C6.5,18.2761424 6.72385763,18.5 7,18.5 L7,18.5 L11.5,18.4997083 L11.5,15 L11.5060026,14.9385262 C10.6403449,14.7185995 10,13.93408 10,13 C10,11.8954305 10.8954305,11 12,11 C13.1045695,11 14,11.8954305 14,13 C14,13.9337188 13.3601502,14.7179927 12.4950016,14.9382708 L12.5,15 L12.5,18.4997083 L17,18.5 C17.2454599,18.5 17.4496084,18.3231248 17.4919443,18.0898756 L17.5,18 L17.5,10.4683749 C17.5,10.319985 17.4340885,10.1792612 17.3200922,10.0842643 L17.3200922,10.0842643 Z M12,12 C11.4477153,12 11,12.4477153 11,13 C11,13.5522847 11.4477153,14 12,14 C12.5522847,14 13,13.5522847 13,13 C13,12.4477153 12.5522847,12 12,12 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherintelligence: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'intelligenceMiniApp' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-259.000000, -332.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="intelligence" transform="translate(259.000000, 332.000000)">
            <path
              d="M6.79006222,7.6049515 C6.98870242,7.41312689 7.30523669,7.41865201 7.49706131,7.61729221 C7.68888592,7.81593241 7.68336079,8.13246669 7.48472059,8.3242913 C4.90239798,10.8180113 4.83057134,14.9329568 7.3242913,17.5152794 C9.81801126,20.097602 13.9329568,20.1694287 16.5152794,17.6757087 C19.097602,15.1819887 19.1694287,11.0670432 16.6757087,8.48472059 C16.4838841,8.28608039 16.4894092,7.96954612 16.6880494,7.77772151 C16.8866896,7.58589689 17.2032239,7.59142202 17.3950485,7.79006222 C20.2724177,10.7696652 20.1895408,15.5176793 17.2099378,18.3950485 C14.2303348,21.2724177 9.48232068,21.1895408 6.6049515,18.2099378 C3.72758232,15.2303348 3.81045921,10.4823207 6.79006222,7.6049515 Z M10.7226499,13.5839749 C10.8905996,13.4720084 11.1094004,13.4720084 11.2773501,13.5839749 L11.2773501,13.5839749 L14.0359213,15.4230223 L15.7763932,14.5527864 C16.0233825,14.4292918 16.323719,14.529404 16.4472136,14.7763932 C16.5707082,15.0233825 16.470596,15.323719 16.2236068,15.4472136 L16.2236068,15.4472136 L14.2236068,16.4472136 C14.0631211,16.5274564 13.8719434,16.5155541 13.7226499,16.4160251 L13.7226499,16.4160251 L11,14.6009252 L8.2773501,16.4160251 C8.04758575,16.5692014 7.73715108,16.5071144 7.58397485,16.2773501 C7.43079862,16.0475858 7.49288556,15.7371511 7.7226499,15.5839749 L7.7226499,15.5839749 Z M10.7226499,10.5839749 C10.8905996,10.4720084 11.1094004,10.4720084 11.2773501,10.5839749 L11.2773501,10.5839749 L14.0359213,12.4230223 L15.7763932,11.5527864 C16.0233825,11.4292918 16.323719,11.529404 16.4472136,11.7763932 C16.5707082,12.0233825 16.470596,12.323719 16.2236068,12.4472136 L16.2236068,12.4472136 L14.2236068,13.4472136 C14.0631211,13.5274564 13.8719434,13.5155541 13.7226499,13.4160251 L13.7226499,13.4160251 L11,11.6009252 L8.2773501,13.4160251 C8.04758575,13.5692014 7.73715108,13.5071144 7.58397485,13.2773501 C7.43079862,13.0475858 7.49288556,12.7371511 7.7226499,12.5839749 L7.7226499,12.5839749 Z M12,4 C13.1045695,4 14,4.8954305 14,6 C14,7.1045695 13.1045695,8 12,8 C10.8954305,8 10,7.1045695 10,6 C10,4.8954305 10.8954305,4 12,4 Z M12,5 C11.4477153,5 11,5.44771525 11,6 C11,6.55228475 11.4477153,7 12,7 C12.5522847,7 13,6.55228475 13,6 C13,5.44771525 12.5522847,5 12,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherRoles: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>User</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-259.000000, -250.000000)"
          fill="#a9a9a9"
          fillRule="nonzero"
        >
          <g id="Role" transform="translate(259.000000, 250.000000)">
            <path
              d="M15.3333333,10.5 C16.0305346,10.5 16.5,11.2041982 16.5,12 L16.5,17 C16.5,17.2761424 16.2761424,17.5 16,17.5 C15.7238576,17.5 15.5,17.2761424 15.5,17 L15.5,12 C15.5,11.6912323 15.3725118,11.5 15.3333333,11.5 L8.66666667,11.5 C8.62748823,11.5 8.5,11.6912323 8.5,12 L8.5,17 C8.5,17.2761424 8.27614237,17.5 8,17.5 C7.72385763,17.5 7.5,17.2761424 7.5,17 L7.5,12 C7.5,11.2041982 7.96946544,10.5 8.66666667,10.5 L15.3333333,10.5 Z M18.1666667,11.5 C18.8638679,11.5 19.3333333,12.2041982 19.3333333,13 L19.3333333,17 C19.3333333,17.2761424 19.1094757,17.5 18.8333333,17.5 C18.557191,17.5 18.3333333,17.2761424 18.3333333,17 L18.3333333,13 C18.3333333,12.6912323 18.2058451,12.5 18.1666667,12.5 C17.8905243,12.5 17.6666667,12.2761424 17.6666667,12 C17.6666667,11.7238576 17.8905243,11.5 18.1666667,11.5 Z M5.83333333,11.5 C6.10947571,11.5 6.33333333,11.7238576 6.33333333,12 C6.33333333,12.2761424 6.10947571,12.5 5.83333333,12.5 C5.79415489,12.5 5.66666667,12.6912323 5.66666667,13 L5.66666667,13 L5.66666667,17 C5.66666667,17.2761424 5.44280904,17.5 5.16666667,17.5 C4.89052429,17.5 4.66666667,17.2761424 4.66666667,17 L4.66666667,17 L4.66666667,13 C4.66666667,12.2041982 5.13613211,11.5 5.83333333,11.5 Z M17,8 C17.5522847,8 18,8.44771525 18,9 C18,9.55228475 17.5522847,10 17,10 C16.4477153,10 16,9.55228475 16,9 C16,8.44771525 16.4477153,8 17,8 Z M7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z M12,6 C11.4477153,6 11,6.44771525 11,7 C11,7.55228475 11.4477153,8 12,8 C12.5522847,8 13,7.55228475 13,7 C13,6.44771525 12.5522847,6 12,6 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherAnalytics: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Analytics</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-346.000000, -250.000000)"
          fill="#a9a9a9"
          fillRule="nonzero"
        >
          <g id="Analytics" transform="translate(346.000000, 250.000000)">
            <path
              d="M9.71485579,14.5580659 L9.79319877,14.6095656 L14.444,18.329 L16.1272979,16.6464466 C16.257738,16.5160065 16.4471781,16.4696542 16.6198627,16.5196832 L16.704458,16.5527864 L18.704458,17.5527864 C18.9514473,17.676281 19.0515595,17.9766175 18.9280648,18.2236068 C18.8182918,18.4431528 18.5687919,18.5466478 18.3412343,18.480202 L18.2572444,18.4472136 L16.579,17.608 L14.8344046,19.3535534 C14.6767709,19.5111871 14.4374835,19.543053 14.2468467,19.4419341 L14.1685037,19.3904344 L9.517,15.67 L5.83440464,19.3535534 C5.66083828,19.5271197 5.39141388,19.5464049 5.19654574,19.4114088 L5.12729786,19.3535534 C4.9537315,19.179987 4.93444635,18.9105626 5.0694424,18.7156945 L5.12729786,18.6464466 L9.12729786,14.6464466 C9.2849316,14.4888129 9.524219,14.456947 9.71485579,14.5580659 Z M8.48085125,7.5 C8.72631113,7.5 8.93045962,7.67687516 8.97279558,7.91012437 L8.98085125,8 L8.98085125,14 C8.98085125,14.2761424 8.75699362,14.5 8.48085125,14.5 C8.23539136,14.5 8.03124288,14.3231248 7.98890692,14.0898756 L7.98085125,14 L7.98,8.5 L5.98,8.5 L5.98085125,17 C5.98085125,17.2454599 5.80397609,17.4496084 5.57072688,17.4919443 L5.48085125,17.5 C5.23539136,17.5 5.03124288,17.3231248 4.98890692,17.0898756 L4.98085125,17 L4.98085125,8 C4.98085125,7.75454011 5.15772641,7.55039163 5.39097561,7.50805567 L5.48085125,7.5 L8.48085125,7.5 Z M13.4808512,5.5 C13.7263111,5.5 13.9304596,5.67687516 13.9727956,5.91012437 L13.9808512,6 L13.9808512,16 C13.9808512,16.2761424 13.7569936,16.5 13.4808512,16.5 C13.2353914,16.5 13.0312429,16.3231248 12.9889069,16.0898756 L12.9808512,16 L12.98,6.5 L10.98,6.5 L10.9808512,14 C10.9808512,14.2454599 10.8039761,14.4496084 10.5707269,14.4919443 L10.4808512,14.5 C10.2353914,14.5 10.0312429,14.3231248 9.98890692,14.0898756 L9.98085125,14 L9.98085125,6 C9.98085125,5.75454011 10.1577264,5.55039163 10.3909756,5.50805567 L10.4808512,5.5 L13.4808512,5.5 Z M18.4808512,9.5 C18.7263111,9.5 18.9304596,9.67687516 18.9727956,9.91012437 L18.9808512,10 L18.9808512,16 C18.9808512,16.2761424 18.7569936,16.5 18.4808512,16.5 C18.2353914,16.5 18.0312429,16.3231248 17.9889069,16.0898756 L17.9808512,16 L17.98,10.5 L15.98,10.5 L15.9808512,16 C15.9808512,16.2454599 15.8039761,16.4496084 15.5707269,16.4919443 L15.4808512,16.5 C15.2353914,16.5 15.0312429,16.3231248 14.9889069,16.0898756 L14.9808512,16 L14.9808512,10 C14.9808512,9.75454011 15.1577264,9.55039163 15.3909756,9.50805567 L15.4808512,9.5 L18.4808512,9.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherSOD: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.SOD' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-496.000000, -64.000000)">
          <g id="Group" transform="translate(496.000000, 64.000000)">
            <rect
              id="Rectangle-Copy-101"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-100"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <g
              id="Group-5"
              transform="translate(6.000000, 4.000000)"
              fill="#000000"
              fillRule="nonzero"
            >
              <path
                d="M10,15 C10.2761424,15 10.5,15.2238576 10.5,15.5 C10.5,15.7761424 10.2761424,16 10,16 L10,16 L2,16 C1.72385763,16 1.5,15.7761424 1.5,15.5 C1.5,15.2238576 1.72385763,15 2,15 L2,15 Z M6,0 C9.3137085,0 12,2.6862915 12,6 L12,13 C12,13.5522847 11.5522847,14 11,14 L1,14 C0.44771525,14 0,13.5522847 0,13 L0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,1 C3.23857625,1 1,3.23857625 1,6 L1,13 L11,13 L11,6 C11,3.23857625 8.76142375,1 6,1 Z M6.03804033,3.54340764 C6.53785116,3.54340764 6.94302789,3.94858438 6.94302789,4.44839521 C6.94302789,4.47846773 6.94152894,4.50852156 6.93853661,4.53844483 L6.53804033,8.54340764 C6.51042609,8.81955002 6.2641827,9.02102188 5.98804033,8.99340764 C5.75006474,8.96961009 5.56183789,8.78138323 5.53804033,8.54340764 L5.13754405,4.53844483 C5.08781101,4.04111447 5.45066034,3.59763196 5.9479907,3.54789893 C5.97791398,3.5449066 6.00796781,3.54340764 6.03804033,3.54340764 Z M6.03804033,4.54340764 L6.04749442,4.54293612 C6.09970792,4.53771477 6.13780259,4.49115462 6.13258124,4.43894112 L6.53307752,8.44390393 C6.50951617,8.2082904 6.32315758,8.02193181 6.08754405,7.99837045 C5.81414256,7.97103031 5.57034329,8.17050243 5.54300314,8.44390393 L5.94349942,4.43894112 L5.94302789,4.44839521 C5.94302789,4.50086913 5.98556641,4.54340764 6.03804033,4.54340764 Z"
                id="Combined-Shape"
              />
            </g>
            <path
              d="M12.0209687,14.7250108 C12.2971111,14.7250108 12.5209687,14.5011532 12.5209687,14.2250108 C12.5209687,13.9488685 12.2971111,13.7250108 12.0209687,13.7250108 C11.7448263,13.7250108 11.5209687,13.9488685 11.5209687,14.2250108 C11.5209687,14.5011532 11.7448263,14.7250108 12.0209687,14.7250108 Z"
              id="Oval"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherdesign: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Design' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-307.000000, -332.000000)" fill="#000000">
          <g id="Design" transform="translate(307.000000, 332.000000)">
            <g id="Group-2" transform="translate(4.000000, 4.000000)">
              <path
                d="M13.3535534,2.64644661 C13.5488155,2.84170876 13.5488155,3.15829124 13.3535534,3.35355339 C13.1582912,3.54881554 12.8417088,3.54881554 12.6464466,3.35355339 L11.6464466,2.35355339 C11.4511845,2.15829124 11.4511845,1.84170876 11.6464466,1.64644661 L12.6464466,0.646446609 C12.8417088,0.451184464 13.1582912,0.451184464 13.3535534,0.646446609 C13.5488155,0.841708755 13.5488155,1.15829124 13.3535534,1.35355339 L13.206,1.5 L15,1.5 C15.2454599,1.5 15.4496084,1.67687516 15.4919443,1.91012437 L15.5,2 L15.5,14 C15.5,14.2761424 15.2761424,14.5 15,14.5 L15,14.5 L11,14.5 L11,14.5 L11,15 C11,15.5522847 10.5522847,16 10,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,13 C5,12.4477153 5.44771525,12 6,12 L10,12 C10.5522847,12 11,12.4477153 11,13 L11,13.5 L14.5,13.5 L14.5,2.5 L13.207,2.5 L13.3535534,2.64644661 Z M10,0 C10.5522847,0 11,0.44771525 11,1 L11,3 C11,3.55228475 10.5522847,4 10,4 L6,4 C5.44771525,4 5,3.55228475 5,3 L5,2.5 L1.5,2.5 L1.5,13.5 L2.793,13.5 L2.64644661,13.3535534 C2.47288026,13.179987 2.45359511,12.9105626 2.58859116,12.7156945 L2.64644661,12.6464466 C2.84170876,12.4511845 3.15829124,12.4511845 3.35355339,12.6464466 L3.35355339,12.6464466 L4.35355339,13.6464466 C4.54881554,13.8417088 4.54881554,14.1582912 4.35355339,14.3535534 L4.35355339,14.3535534 L3.35355339,15.3535534 C3.15829124,15.5488155 2.84170876,15.5488155 2.64644661,15.3535534 C2.45118446,15.1582912 2.45118446,14.8417088 2.64644661,14.6464466 L2.64644661,14.6464466 L2.792,14.5 L1,14.5 C0.754540111,14.5 0.55039163,14.3231248 0.508055669,14.0898756 L0.5,14 L0.5,2 C0.5,1.72385763 0.723857625,1.5 1,1.5 L1,1.5 L5,1.5 L5,1.5 L5,1 C5,0.44771525 5.44771525,0 6,0 L10,0 Z M10,13 L6,13 L6,15 L10,15 L10,13 Z M10,6 C10.5522847,6 11,6.44771525 11,7 L11,9 C11,9.55228475 10.5522847,10 10,10 L6,10 C5.44771525,10 5,9.55228475 5,9 L5,7 C5,6.44771525 5.44771525,6 6,6 L10,6 Z M10,7 L6,7 L6,9 L10,9 L10,7 Z M10,1 L6,1 L6,3 L10,3 L10,1 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitchercontrol: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Control.Center' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-113.000000, -332.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Control-center" transform="translate(113.000000, 332.000000)">
            <path
              d="M18,4 C18.5522847,4 19,4.44771525 19,5 L19,14.2590324 C19,15.3356029 18.4231418,16.3296333 17.4884168,16.8637618 L12.4961389,19.716492 C12.1887063,19.8921678 11.8112937,19.8921678 11.5038611,19.716492 L6.51158318,16.8637618 C5.57685819,16.3296333 5,15.3356029 5,14.2590324 L5,5 C5,4.44771525 5.44771525,4 6,4 L18,4 Z M18,5 L6,5 L6,14.2590324 C6,14.9767461 6.38457213,15.639433 7.00772212,15.9955187 L12,18.8482489 L16.9922779,15.9955187 C17.6154279,15.639433 18,14.9767461 18,14.2590324 L18,5 Z M14.0055346,9.98750631 C14.281677,9.98750631 14.5055346,10.2113639 14.5055346,10.4875063 L14.5055346,10.4875063 L14.5055346,14.4875063 C14.5055346,14.7636487 14.281677,14.9875063 14.0055346,14.9875063 C13.7293922,14.9875063 13.5055346,14.7636487 13.5055346,14.4875063 L13.5055346,14.4875063 L13.5055346,10.4875063 C13.5055346,10.2113639 13.7293922,9.98750631 14.0055346,9.98750631 Z M12.0055346,9.98750631 C12.281677,9.98750631 12.5055346,10.2113639 12.5055346,10.4875063 L12.5055346,10.4875063 L12.5055346,13.4875063 C12.5055346,13.7636487 12.281677,13.9875063 12.0055346,13.9875063 C11.7293922,13.9875063 11.5055346,13.7636487 11.5055346,13.4875063 L11.5055346,13.4875063 L11.5055346,10.4875063 C11.5055346,10.2113639 11.7293922,9.98750631 12.0055346,9.98750631 Z M10.0055346,9.92739986 C10.281677,9.92739986 10.5055346,10.1512575 10.5055346,10.4273999 L10.5055346,10.4273999 L10.5055346,12.4273999 C10.5055346,12.7035422 10.281677,12.9273999 10.0055346,12.9273999 C9.72939224,12.9273999 9.50553462,12.7035422 9.50553462,12.4273999 L9.50553462,12.4273999 L9.50553462,10.4273999 C9.50553462,10.1512575 9.72939224,9.92739986 10.0055346,9.92739986 Z M12.0055346,7.48638751 C12.5578194,7.48638751 13.0055346,7.93410276 13.0055346,8.48638751 C13.0055346,9.03867226 12.5578194,9.48638751 12.0055346,9.48638751 C11.4532499,9.48638751 11.0055346,9.03867226 11.0055346,8.48638751 C11.0055346,7.93410276 11.4532499,7.48638751 12.0055346,7.48638751 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  erpRole: ({ intl }) => (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Enterprise.Role' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-307.000000, -239.000000)"
          fill="#ffffff"
          fillRule="nonzero"
        >
          <g id="Enterprise-Role" transform="translate(307.000000, 239.000000)">
            <path
              d="M6,10 C6.27614237,10 6.5,10.2238576 6.5,10.5 C6.5,10.7761424 6.27614237,11 6,11 C5.17157288,11 4.5,11.6715729 4.5,12.5 L4.5,18.5 C4.5,18.7761424 4.27614237,19 4,19 C3.72385763,19 3.5,18.7761424 3.5,18.5 L3.5,12.5 C3.5,11.1192881 4.61928813,10 6,10 Z M18,13 C19.3807119,13 20.5,14.1192881 20.5,15.5 L20.5,15.5 L20.5,18.5 C20.5,18.7761424 20.2761424,19 20,19 C19.7238576,19 19.5,18.7761424 19.5,18.5 L19.5,18.5 L19.5,15.5 C19.5,14.6715729 18.8284271,14 18,14 C17.7238576,14 17.5,13.7761424 17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z M14,5 C15.3807119,5 16.5,6.11928813 16.5,7.5 L16.5,18.5 C16.5,18.7761424 16.2761424,19 16,19 C15.7238576,19 15.5,18.7761424 15.5,18.5 L15.5,7.5 C15.5,6.67157288 14.8284271,6 14,6 L10,6 C9.17157288,6 8.5,6.67157288 8.5,7.5 L8.5,18.5 C8.5,18.7761424 8.27614237,19 8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 L7.5,7.5 C7.5,6.11928813 8.61928813,5 10,5 L14,5 Z M13.3333333,15.9770387 C14.0305346,15.9770387 14.5,16.6812368 14.5,17.4770387 L14.5,18.4770387 C14.5,18.7531811 14.2761424,18.9770387 14,18.9770387 C13.7238576,18.9770387 13.5,18.7531811 13.5,18.4770387 L13.5,17.4770387 C13.5,17.168271 13.3725118,16.9770387 13.3333333,16.9770387 L10.6666667,16.9770387 C10.6274882,16.9770387 10.5,17.168271 10.5,17.4770387 L10.5,18.4770387 C10.5,18.7531811 10.2761424,18.9770387 10,18.9770387 C9.72385763,18.9770387 9.5,18.7531811 9.5,18.4770387 L9.5,17.4770387 C9.5,16.6812368 9.96946544,15.9770387 10.6666667,15.9770387 L13.3333333,15.9770387 Z M12,13.5 C12.5522847,13.5 13,13.9477153 13,14.5 C13,15.0522847 12.5522847,15.5 12,15.5 C11.4477153,15.5 11,15.0522847 11,14.5 C11,13.9477153 11.4477153,13.5 12,13.5 Z M10.5,10.5 C10.7761424,10.5 11,10.7238576 11,11 L11,11 L11,12 C11,12.2761424 10.7761424,12.5 10.5,12.5 C10.2238576,12.5 10,12.2761424 10,12 L10,12 L10,11 C10,10.7238576 10.2238576,10.5 10.5,10.5 Z M13.5,10.5 C13.7761424,10.5 14,10.7238576 14,11 L14,11 L14,12 C14,12.2761424 13.7761424,12.5 13.5,12.5 C13.2238576,12.5 13,12.2761424 13,12 L13,12 L13,11 C13,10.7238576 13.2238576,10.5 13.5,10.5 Z M10.5,7.5 C10.7761424,7.5 11,7.72385763 11,8 L11,8 L11,9 C11,9.27614237 10.7761424,9.5 10.5,9.5 C10.2238576,9.5 10,9.27614237 10,9 L10,9 L10,8 C10,7.72385763 10.2238576,7.5 10.5,7.5 Z M13.5,7.5 C13.7761424,7.5 14,7.72385763 14,8 L14,8 L14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 C13.2238576,9.5 13,9.27614237 13,9 L13,9 L13,8 C13,7.72385763 13.2238576,7.5 13.5,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  erpRolebadge: ({ fillColor, title }) => (
    <svg
      width="13px"
      height="16px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title || 'Enterprise Role'}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-307.000000, -239.000000)"
          fill={fillColor || '#ffffff'}
          fillRule="nonzero"
        >
          <g id="Enterprise-Role" transform="translate(307.000000, 239.000000)">
            <path
              d="M6,10 C6.27614237,10 6.5,10.2238576 6.5,10.5 C6.5,10.7761424 6.27614237,11 6,11 C5.17157288,11 4.5,11.6715729 4.5,12.5 L4.5,18.5 C4.5,18.7761424 4.27614237,19 4,19 C3.72385763,19 3.5,18.7761424 3.5,18.5 L3.5,12.5 C3.5,11.1192881 4.61928813,10 6,10 Z M18,13 C19.3807119,13 20.5,14.1192881 20.5,15.5 L20.5,15.5 L20.5,18.5 C20.5,18.7761424 20.2761424,19 20,19 C19.7238576,19 19.5,18.7761424 19.5,18.5 L19.5,18.5 L19.5,15.5 C19.5,14.6715729 18.8284271,14 18,14 C17.7238576,14 17.5,13.7761424 17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z M14,5 C15.3807119,5 16.5,6.11928813 16.5,7.5 L16.5,18.5 C16.5,18.7761424 16.2761424,19 16,19 C15.7238576,19 15.5,18.7761424 15.5,18.5 L15.5,7.5 C15.5,6.67157288 14.8284271,6 14,6 L10,6 C9.17157288,6 8.5,6.67157288 8.5,7.5 L8.5,18.5 C8.5,18.7761424 8.27614237,19 8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 L7.5,7.5 C7.5,6.11928813 8.61928813,5 10,5 L14,5 Z M13.3333333,15.9770387 C14.0305346,15.9770387 14.5,16.6812368 14.5,17.4770387 L14.5,18.4770387 C14.5,18.7531811 14.2761424,18.9770387 14,18.9770387 C13.7238576,18.9770387 13.5,18.7531811 13.5,18.4770387 L13.5,17.4770387 C13.5,17.168271 13.3725118,16.9770387 13.3333333,16.9770387 L10.6666667,16.9770387 C10.6274882,16.9770387 10.5,17.168271 10.5,17.4770387 L10.5,18.4770387 C10.5,18.7531811 10.2761424,18.9770387 10,18.9770387 C9.72385763,18.9770387 9.5,18.7531811 9.5,18.4770387 L9.5,17.4770387 C9.5,16.6812368 9.96946544,15.9770387 10.6666667,15.9770387 L13.3333333,15.9770387 Z M12,13.5 C12.5522847,13.5 13,13.9477153 13,14.5 C13,15.0522847 12.5522847,15.5 12,15.5 C11.4477153,15.5 11,15.0522847 11,14.5 C11,13.9477153 11.4477153,13.5 12,13.5 Z M10.5,10.5 C10.7761424,10.5 11,10.7238576 11,11 L11,11 L11,12 C11,12.2761424 10.7761424,12.5 10.5,12.5 C10.2238576,12.5 10,12.2761424 10,12 L10,12 L10,11 C10,10.7238576 10.2238576,10.5 10.5,10.5 Z M13.5,10.5 C13.7761424,10.5 14,10.7238576 14,11 L14,11 L14,12 C14,12.2761424 13.7761424,12.5 13.5,12.5 C13.2238576,12.5 13,12.2761424 13,12 L13,12 L13,11 C13,10.7238576 13.2238576,10.5 13.5,10.5 Z M10.5,7.5 C10.7761424,7.5 11,7.72385763 11,8 L11,8 L11,9 C11,9.27614237 10.7761424,9.5 10.5,9.5 C10.2238576,9.5 10,9.27614237 10,9 L10,9 L10,8 C10,7.72385763 10.2238576,7.5 10.5,7.5 Z M13.5,7.5 C13.7761424,7.5 14,7.72385763 14,8 L14,8 L14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 C13.2238576,9.5 13,9.27614237 13,9 L13,9 L13,8 C13,7.72385763 13.2238576,7.5 13.5,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  expansionIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Expand</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-67.000000, -720.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Expand" transform="translate(67.000000, 720.000000)">
            <path
              d="M7.3411666,13.5063094 L7.42426407,13.5757359 L12,18.151 L16.5757359,13.5757359 C16.7840156,13.3674563 17.1073248,13.3443141 17.3411666,13.5063094 L17.4242641,13.5757359 C17.6325437,13.7840156 17.6556859,14.1073248 17.4936906,14.3411666 L17.4242641,14.4242641 L12.4242641,19.4242641 C12.2159844,19.6325437 11.8926752,19.6556859 11.6588334,19.4936906 L11.5757359,19.4242641 L6.57573593,14.4242641 C6.34142136,14.1899495 6.34142136,13.8100505 6.57573593,13.5757359 C6.78401555,13.3674563 7.10732483,13.3443141 7.3411666,13.5063094 Z M11.6588334,4.50630939 C11.8926752,4.34431413 12.2159844,4.36745631 12.4242641,4.57573593 L12.4242641,4.57573593 L17.4242641,9.57573593 L17.4936906,9.6588334 C17.6556859,9.89267517 17.6325437,10.2159844 17.4242641,10.4242641 L17.4242641,10.4242641 L17.3411666,10.4936906 C17.1073248,10.6556859 16.7840156,10.6325437 16.5757359,10.4242641 L16.5757359,10.4242641 L12,5.849 L7.42426407,10.4242641 L7.3411666,10.4936906 C7.10732483,10.6556859 6.78401555,10.6325437 6.57573593,10.4242641 C6.34142136,10.1899495 6.34142136,9.81005051 6.57573593,9.57573593 L6.57573593,9.57573593 L11.5757359,4.57573593 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  expansionIconAlt: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <g id="Icons/Fullscreen" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M11.3822524,13.4398246 L11.4621418,13.432664 C11.6803284,13.432664 11.8617937,13.5898864 11.8994257,13.797219 L11.9065863,13.8771085 L11.9064668,18.5358258 L14.2986159,16.1499521 C14.4723616,15.9765653 14.7537681,15.9768563 14.9271549,16.1506021 C15.0812765,16.3050428 15.0981712,16.5445487 14.9779956,16.7176407 L14.9265049,16.7791411 L11.8424469,19.8568271 C11.6882321,20.0107233 11.449147,20.0278229 11.2760721,19.9081258 L11.2145579,19.8568271 L8.13049993,16.7791411 C7.95675418,16.6057543 7.95646317,16.3243478 8.12984994,16.1506021 C8.28397151,15.9961614 8.52344201,15.9787714 8.69678214,16.0985887 L8.75838896,16.1499521 L11.0175779,18.4042703 L11.0176974,13.8771085 C11.0176974,13.6589219 11.1749197,13.4774566 11.3822524,13.4398246 Z M8.21825546,8.20753589 L11.3023134,5.12984994 C11.4565283,4.97595372 11.6956134,4.95885413 11.8686883,5.0785512 L11.9302025,5.12984994 L15.0142604,8.20753589 C15.1880062,8.38092266 15.1882972,8.66232916 15.0149104,8.83607491 C14.8607888,8.99051558 14.6213183,9.00790559 14.4479782,8.88808829 L14.3863714,8.8367249 L12.0602446,6.51538139 L12.0607024,11.5745398 C12.0607024,11.8199997 11.8617178,12.0189843 11.6162579,12.0189843 C11.3980714,12.0189843 11.2166061,11.8617619 11.1789741,11.6544293 L11.1718135,11.5745398 L11.1713557,6.51538139 L8.84614449,8.8367249 C8.69170383,8.99084647 8.45219787,9.00774116 8.27910593,8.88756561 L8.21760547,8.83607491 C8.06348389,8.68163425 8.04658921,8.44212829 8.16676476,8.26903635 L8.21825546,8.20753589 L11.3023134,5.12984994 L8.21825546,8.20753589 Z"
          id="Combined-Shape"
          fill="#000000"
          fillRule="nonzero"
          transform="translate(11.572380, 12.493339) rotate(45.000000) translate(-11.572380, -12.493339) "
        />
      </g>
    </svg>
  ),
  collapseIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Collapse</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-113.000000, -720.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Collapse" transform="translate(113.000000, 720.000000)">
            <path
              d="M11.6588334,13.5063094 C11.8926752,13.3443141 12.2159844,13.3674563 12.4242641,13.5757359 L12.4242641,13.5757359 L17.4242641,18.5757359 L17.4936906,18.6588334 C17.6556859,18.8926752 17.6325437,19.2159844 17.4242641,19.4242641 L17.4242641,19.4242641 L17.3411666,19.4936906 C17.1073248,19.6556859 16.7840156,19.6325437 16.5757359,19.4242641 L16.5757359,19.4242641 L12,14.849 L7.42426407,19.4242641 L7.3411666,19.4936906 C7.10732483,19.6556859 6.78401555,19.6325437 6.57573593,19.4242641 C6.34142136,19.1899495 6.34142136,18.8100505 6.57573593,18.5757359 L6.57573593,18.5757359 L11.5757359,13.5757359 Z M7.3411666,4.50630939 L7.42426407,4.57573593 L12,9.151 L16.5757359,4.57573593 C16.7840156,4.36745631 17.1073248,4.34431413 17.3411666,4.50630939 L17.4242641,4.57573593 C17.6325437,4.78401555 17.6556859,5.10732483 17.4936906,5.3411666 L17.4242641,5.42426407 L12.4242641,10.4242641 C12.2159844,10.6325437 11.8926752,10.6556859 11.6588334,10.4936906 L11.5757359,10.4242641 L6.57573593,5.42426407 C6.34142136,5.18994949 6.34142136,4.81005051 6.57573593,4.57573593 C6.78401555,4.36745631 7.10732483,4.34431413 7.3411666,4.50630939 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  enterpriseLogo: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-307.000000, -250.000000)"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <g id="Enterprise-Role" transform="translate(307.000000, 250.000000)">
            <path
              d="M6,10 C6.27614237,10 6.5,10.2238576 6.5,10.5 C6.5,10.7761424 6.27614237,11 6,11 C5.17157288,11 4.5,11.6715729 4.5,12.5 L4.5,18.5 C4.5,18.7761424 4.27614237,19 4,19 C3.72385763,19 3.5,18.7761424 3.5,18.5 L3.5,12.5 C3.5,11.1192881 4.61928813,10 6,10 Z M18,13 C19.3807119,13 20.5,14.1192881 20.5,15.5 L20.5,15.5 L20.5,18.5 C20.5,18.7761424 20.2761424,19 20,19 C19.7238576,19 19.5,18.7761424 19.5,18.5 L19.5,18.5 L19.5,15.5 C19.5,14.6715729 18.8284271,14 18,14 C17.7238576,14 17.5,13.7761424 17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z M14,5 C15.3807119,5 16.5,6.11928813 16.5,7.5 L16.5,18.5 C16.5,18.7761424 16.2761424,19 16,19 C15.7238576,19 15.5,18.7761424 15.5,18.5 L15.5,7.5 C15.5,6.67157288 14.8284271,6 14,6 L10,6 C9.17157288,6 8.5,6.67157288 8.5,7.5 L8.5,18.5 C8.5,18.7761424 8.27614237,19 8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 L7.5,7.5 C7.5,6.11928813 8.61928813,5 10,5 L14,5 Z M13.3333333,15.9770387 C14.0305346,15.9770387 14.5,16.6812368 14.5,17.4770387 L14.5,18.4770387 C14.5,18.7531811 14.2761424,18.9770387 14,18.9770387 C13.7238576,18.9770387 13.5,18.7531811 13.5,18.4770387 L13.5,17.4770387 C13.5,17.168271 13.3725118,16.9770387 13.3333333,16.9770387 L10.6666667,16.9770387 C10.6274882,16.9770387 10.5,17.168271 10.5,17.4770387 L10.5,18.4770387 C10.5,18.7531811 10.2761424,18.9770387 10,18.9770387 C9.72385763,18.9770387 9.5,18.7531811 9.5,18.4770387 L9.5,17.4770387 C9.5,16.6812368 9.96946544,15.9770387 10.6666667,15.9770387 L13.3333333,15.9770387 Z M12,13.5 C12.5522847,13.5 13,13.9477153 13,14.5 C13,15.0522847 12.5522847,15.5 12,15.5 C11.4477153,15.5 11,15.0522847 11,14.5 C11,13.9477153 11.4477153,13.5 12,13.5 Z M10.5,10.5 C10.7761424,10.5 11,10.7238576 11,11 L11,11 L11,12 C11,12.2761424 10.7761424,12.5 10.5,12.5 C10.2238576,12.5 10,12.2761424 10,12 L10,12 L10,11 C10,10.7238576 10.2238576,10.5 10.5,10.5 Z M13.5,10.5 C13.7761424,10.5 14,10.7238576 14,11 L14,11 L14,12 C14,12.2761424 13.7761424,12.5 13.5,12.5 C13.2238576,12.5 13,12.2761424 13,12 L13,12 L13,11 C13,10.7238576 13.2238576,10.5 13.5,10.5 Z M10.5,7.5 C10.7761424,7.5 11,7.72385763 11,8 L11,8 L11,9 C11,9.27614237 10.7761424,9.5 10.5,9.5 C10.2238576,9.5 10,9.27614237 10,9 L10,9 L10,8 C10,7.72385763 10.2238576,7.5 10.5,7.5 Z M13.5,7.5 C13.7761424,7.5 14,7.72385763 14,8 L14,8 L14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 C13.2238576,9.5 13,9.27614237 13,9 L13,9 L13,8 C13,7.72385763 13.2238576,7.5 13.5,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  enterpriseLogoRedesign: () => (
    <svg
      width="35px"
      height="35px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-640.000000, -136.000000)"
          fill="#ffffff"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(640.000000, 136.000000)">
            <path d="M6,10 C6.27614237,10 6.5,10.2238576 6.5,10.5 C6.5,10.7761424 6.27614237,11 6,11 C5.17157288,11 4.5,11.6715729 4.5,12.5 L4.5,18.5 C4.5,18.7761424 4.27614237,19 4,19 C3.72385763,19 3.5,18.7761424 3.5,18.5 L3.5,12.5 C3.5,11.1192881 4.61928813,10 6,10 Z M18,13 C19.3807119,13 20.5,14.1192881 20.5,15.5 L20.5,15.5 L20.5,18.5 C20.5,18.7761424 20.2761424,19 20,19 C19.7238576,19 19.5,18.7761424 19.5,18.5 L19.5,18.5 L19.5,15.5 C19.5,14.6715729 18.8284271,14 18,14 C17.7238576,14 17.5,13.7761424 17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z M14,5 C15.3807119,5 16.5,6.11928813 16.5,7.5 L16.5,18.5 C16.5,18.7761424 16.2761424,19 16,19 C15.7238576,19 15.5,18.7761424 15.5,18.5 L15.5,7.5 C15.5,6.67157288 14.8284271,6 14,6 L10,6 C9.17157288,6 8.5,6.67157288 8.5,7.5 L8.5,18.5 C8.5,18.7761424 8.27614237,19 8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 L7.5,7.5 C7.5,6.11928813 8.61928813,5 10,5 L14,5 Z M13.3333333,15.9770387 C14.0305346,15.9770387 14.5,16.6812368 14.5,17.4770387 L14.5,18.4770387 C14.5,18.7531811 14.2761424,18.9770387 14,18.9770387 C13.7238576,18.9770387 13.5,18.7531811 13.5,18.4770387 L13.5,17.4770387 C13.5,17.168271 13.3725118,16.9770387 13.3333333,16.9770387 L10.6666667,16.9770387 C10.6274882,16.9770387 10.5,17.168271 10.5,17.4770387 L10.5,18.4770387 C10.5,18.7531811 10.2761424,18.9770387 10,18.9770387 C9.72385763,18.9770387 9.5,18.7531811 9.5,18.4770387 L9.5,17.4770387 C9.5,16.6812368 9.96946544,15.9770387 10.6666667,15.9770387 L13.3333333,15.9770387 Z M12,13.5 C12.5522847,13.5 13,13.9477153 13,14.5 C13,15.0522847 12.5522847,15.5 12,15.5 C11.4477153,15.5 11,15.0522847 11,14.5 C11,13.9477153 11.4477153,13.5 12,13.5 Z M10.5,10.5 C10.7761424,10.5 11,10.7238576 11,11 L11,11 L11,12 C11,12.2761424 10.7761424,12.5 10.5,12.5 C10.2238576,12.5 10,12.2761424 10,12 L10,12 L10,11 C10,10.7238576 10.2238576,10.5 10.5,10.5 Z M13.5,10.5 C13.7761424,10.5 14,10.7238576 14,11 L14,11 L14,12 C14,12.2761424 13.7761424,12.5 13.5,12.5 C13.2238576,12.5 13,12.2761424 13,12 L13,12 L13,11 C13,10.7238576 13.2238576,10.5 13.5,10.5 Z M10.5,7.5 C10.7761424,7.5 11,7.72385763 11,8 L11,8 L11,9 C11,9.27614237 10.7761424,9.5 10.5,9.5 C10.2238576,9.5 10,9.27614237 10,9 L10,9 L10,8 C10,7.72385763 10.2238576,7.5 10.5,7.5 Z M13.5,7.5 C13.7761424,7.5 14,7.72385763 14,8 L14,8 L14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 C13.2238576,9.5 13,9.27614237 13,9 L13,9 L13,8 C13,7.72385763 13.2238576,7.5 13.5,7.5 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  appColLogo: () => (
    <svg
      width="35px"
      height="35px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-640.000000, -352.000000)">
          <g id="Group" transform="translate(640.000000, 352.000000)">
            <rect
              id="Rectangle-Copy-295"
              fill="#ffffff"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-294"
              fill="#ffffff"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15,6 C15.4418278,6 15.8,6.36631248 15.8,6.81818182 L15.8,16.6363636 C15.8,17.088233 15.4418278,17.4545455 15,17.4545455 L8.6,17.4545455 C8.1581722,17.4545455 7.8,17.088233 7.8,16.6363636 L7.8,6.81818182 C7.8,6.36631248 8.1581722,6 8.6,6 L15,6 Z M15,6.81818182 L8.6,6.81818182 L8.6,16.6363636 L15,16.6363636 L15,6.81818182 Z M17.0643905,7.22727273 C17.6881474,7.22727273 18.2007495,7.71399934 18.2588973,8.3363509 L18.2643905,8.45454545 L18.2643905,15 C18.2643905,15.6379332 17.7884801,16.1621853 17.1799585,16.2216546 L17.0643905,16.2272727 L16.2643905,16.2272727 L16.2643905,15.4090909 L17.0643905,15.4090909 C17.2607584,15.4090909 17.4240772,15.2643749 17.457946,15.0735346 L17.4643905,15 L17.4643905,8.45454545 C17.4643905,8.25371464 17.3228904,8.08668406 17.136291,8.05204555 L17.0643905,8.04545455 L16.2643905,8.04545455 L16.2643905,7.22727273 L17.0643905,7.22727273 Z M7.4,7.22727273 L7.4,8.04545455 L6.6,8.04545455 C6.40363209,8.04545455 6.2403133,8.19017059 6.20644454,8.38101085 L6.2,8.45454545 L6.2,15 C6.2,15.2008308 6.34150013,15.3678614 6.52809949,15.4024999 L6.6,15.4090909 L7.4,15.4090909 L7.4,16.2272727 L6.6,16.2272727 C5.97624311,16.2272727 5.46364106,15.7405461 5.40549326,15.1181946 L5.4,15 L5.4,8.45454545 C5.4,7.81661227 5.87591047,7.29236017 6.48443199,7.23289084 L6.6,7.22727273 L7.4,7.22727273 Z M19.4643905,8.86363636 C20.0881474,8.86363636 20.6007495,9.35036298 20.6588973,9.97271454 L20.6643905,10.0909091 L20.6643905,13.3636364 C20.6643905,14.0015696 20.1884801,14.5258216 19.5799585,14.585291 L19.4643905,14.5909091 L18.6643905,14.5909091 L18.6643905,13.7727273 L19.4643905,13.7727273 C19.6607584,13.7727273 19.8240772,13.6280112 19.857946,13.437171 L19.8643905,13.3636364 L19.8643905,10.0909091 C19.8643905,9.89007827 19.7228904,9.7230477 19.536291,9.68840918 L19.4643905,9.68181818 L18.6643905,9.68181818 L18.6643905,8.86363636 L19.4643905,8.86363636 Z M5,8.86363636 L5,9.68181818 L4.2,9.68181818 C4.00363209,9.68181818 3.8403133,9.82653422 3.80644454,10.0173745 L3.8,10.0909091 L3.8,13.3636364 C3.8,13.5644672 3.94150013,13.7314978 4.12809949,13.7661363 L4.2,13.7727273 L5,13.7727273 L5,14.5909091 L4.2,14.5909091 C3.57624311,14.5909091 3.06364106,14.1041825 3.00549326,13.4818309 L3,13.3636364 L3,10.0909091 C3,9.4529759 3.47591047,8.92872381 4.08443199,8.86925447 L4.2,8.86363636 L5,8.86363636 Z"
              id="Combined-Shape"
              fill="#ffffff"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  enterpriseRevieLogo: () => (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-307.000000, -250.000000)"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <g id="Enterprise-Role" transform="translate(307.000000, 250.000000)">
            <path
              d="M6,10 C6.27614237,10 6.5,10.2238576 6.5,10.5 C6.5,10.7761424 6.27614237,11 6,11 C5.17157288,11 4.5,11.6715729 4.5,12.5 L4.5,18.5 C4.5,18.7761424 4.27614237,19 4,19 C3.72385763,19 3.5,18.7761424 3.5,18.5 L3.5,12.5 C3.5,11.1192881 4.61928813,10 6,10 Z M18,13 C19.3807119,13 20.5,14.1192881 20.5,15.5 L20.5,15.5 L20.5,18.5 C20.5,18.7761424 20.2761424,19 20,19 C19.7238576,19 19.5,18.7761424 19.5,18.5 L19.5,18.5 L19.5,15.5 C19.5,14.6715729 18.8284271,14 18,14 C17.7238576,14 17.5,13.7761424 17.5,13.5 C17.5,13.2238576 17.7238576,13 18,13 Z M14,5 C15.3807119,5 16.5,6.11928813 16.5,7.5 L16.5,18.5 C16.5,18.7761424 16.2761424,19 16,19 C15.7238576,19 15.5,18.7761424 15.5,18.5 L15.5,7.5 C15.5,6.67157288 14.8284271,6 14,6 L10,6 C9.17157288,6 8.5,6.67157288 8.5,7.5 L8.5,18.5 C8.5,18.7761424 8.27614237,19 8,19 C7.72385763,19 7.5,18.7761424 7.5,18.5 L7.5,7.5 C7.5,6.11928813 8.61928813,5 10,5 L14,5 Z M13.3333333,15.9770387 C14.0305346,15.9770387 14.5,16.6812368 14.5,17.4770387 L14.5,18.4770387 C14.5,18.7531811 14.2761424,18.9770387 14,18.9770387 C13.7238576,18.9770387 13.5,18.7531811 13.5,18.4770387 L13.5,17.4770387 C13.5,17.168271 13.3725118,16.9770387 13.3333333,16.9770387 L10.6666667,16.9770387 C10.6274882,16.9770387 10.5,17.168271 10.5,17.4770387 L10.5,18.4770387 C10.5,18.7531811 10.2761424,18.9770387 10,18.9770387 C9.72385763,18.9770387 9.5,18.7531811 9.5,18.4770387 L9.5,17.4770387 C9.5,16.6812368 9.96946544,15.9770387 10.6666667,15.9770387 L13.3333333,15.9770387 Z M12,13.5 C12.5522847,13.5 13,13.9477153 13,14.5 C13,15.0522847 12.5522847,15.5 12,15.5 C11.4477153,15.5 11,15.0522847 11,14.5 C11,13.9477153 11.4477153,13.5 12,13.5 Z M10.5,10.5 C10.7761424,10.5 11,10.7238576 11,11 L11,11 L11,12 C11,12.2761424 10.7761424,12.5 10.5,12.5 C10.2238576,12.5 10,12.2761424 10,12 L10,12 L10,11 C10,10.7238576 10.2238576,10.5 10.5,10.5 Z M13.5,10.5 C13.7761424,10.5 14,10.7238576 14,11 L14,11 L14,12 C14,12.2761424 13.7761424,12.5 13.5,12.5 C13.2238576,12.5 13,12.2761424 13,12 L13,12 L13,11 C13,10.7238576 13.2238576,10.5 13.5,10.5 Z M10.5,7.5 C10.7761424,7.5 11,7.72385763 11,8 L11,8 L11,9 C11,9.27614237 10.7761424,9.5 10.5,9.5 C10.2238576,9.5 10,9.27614237 10,9 L10,9 L10,8 C10,7.72385763 10.2238576,7.5 10.5,7.5 Z M13.5,7.5 C13.7761424,7.5 14,7.72385763 14,8 L14,8 L14,9 C14,9.27614237 13.7761424,9.5 13.5,9.5 C13.2238576,9.5 13,9.27614237 13,9 L13,9 L13,8 C13,7.72385763 13.2238576,7.5 13.5,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  recommended: ({ color = '#ff9f1b' }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-638.000000, -811.000000)">
          <g id="Group" transform="translate(638.000000, 811.000000)">
            <polygon
              id="Star-Copy-3"
              fill={color}
              points="12 15.5 7.88550323 17.663119 8.67130219 13.0815595 5.34260439 9.83688104 9.94275162 9.16844052 12 5 14.0572484 9.16844052 18.6573956 9.83688104 15.3286978 13.0815595 16.1144968 17.663119"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  newaccount: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path
        fill="#000"
        fillRule="nonzero"
        d="M17.145 4.51c.769 0 1.358.686 1.358 1.5v1.054A2 2 0 0 1 20 9v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7h1.502v-.99c0-.814.59-1.5 1.358-1.5h10.285zM17.502 8H5v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-.866-.991h-.631L17.502 8zm-3.169 4.5c.698 0 1.167.704 1.167 1.5v2a.5.5 0 1 1-1 0v-2c0-.309-.127-.5-.167-.5H9.667c-.04 0-.167.191-.167.5v2a.5.5 0 1 1-1 0v-2c0-.796.47-1.5 1.167-1.5h4.666zm-2.34-3.477a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm5.152-4.514H6.86c-.179 0-.357.208-.357.5L6.502 7h11v-.99c0-.292-.178-.5-.357-.5z"
      />
    </svg>
  ),
  identityaccessrules: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>MFA</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-136.000000, -136.000000)">
          <g id="Group" transform="translate(136.000000, 136.000000)">
            <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24" />
            <path
              d="M11.8585943,4.15156122 C12.8887367,5.21172537 13.9870016,5.92895955 15.1552009,6.31041239 C16.2995704,6.68408406 17.3498269,6.68408406 18.3239944,6.31771721 C18.6236963,6.20500472 18.9419772,6.39866723 18.9929428,6.70078044 L19,6.78571511 L19,13.642858 C19,17.3499056 15.2738611,21 11.5,21 C8.50550286,21 4.17722011,17.8297889 4.0052866,13.8853041 L4,13.642858 L4,6.78571511 C4,6.45395019 4.31719377,6.21418222 4.63637905,6.30467379 C5.79278835,6.63252504 6.85832911,6.63252504 7.84479911,6.31041239 C8.8512609,5.9817718 9.95849144,5.25868247 11.1582103,4.13506278 C11.3571453,3.94874635 11.6686528,3.95608431 11.8585943,4.15156122 Z M11.4861247,5.18924666 C10.3190659,6.224215 9.21082567,6.91632404 8.15520089,7.26101784 C7.2608863,7.55303893 6.31765948,7.62417079 5.33062646,7.47689703 L5,7.41972009 L5,13.642858 C5,17.0713838 8.94310785,20.0000008 11.5,20.0000008 C14.6560054,20.0000008 17.8576808,16.9308744 17.9953925,13.8483462 L18,13.642858 L18,7.4579043 C17.0014101,7.68767805 15.9464372,7.62073639 14.8447991,7.26101784 C13.6481681,6.87028118 12.5281697,6.17795406 11.4861247,5.18924666 Z M15.8510419,13.7248678 L16.8324309,13.9168982 C16.3349478,16.4593312 14.0980344,18.320883 11.4766677,18.320883 C8.94473553,18.320883 6.77040968,16.5839895 6.17729993,14.1724554 L6.1263657,13.94443 L7.10674937,13.7473314 C7.52181095,15.8118798 9.34419456,17.320883 11.4766677,17.320883 C13.6175574,17.320883 15.4449745,15.8001127 15.8510419,13.7248678 Z M13.0337772,14.2707773 L13.6125575,15.0862608 C12.9916176,15.526966 12.2432164,15.755659 11.4663863,15.7285315 C10.8790415,15.708021 10.3173015,15.5428358 9.82232779,15.2530269 L9.61440394,15.1212515 L10.1790489,14.2959176 C10.5665978,14.5610558 11.0209583,14.7123673 11.5012858,14.7291407 C12.0569966,14.7485466 12.5901718,14.5856213 13.0337772,14.2707773 Z M11.6037093,11.814186 C12.1559941,11.814186 12.6037093,12.2619013 12.6037093,12.814186 C12.6037093,13.3664708 12.1559941,13.814186 11.6037093,13.814186 C11.0514246,13.814186 10.6037093,13.3664708 10.6037093,12.814186 C10.6037093,12.2619013 11.0514246,11.814186 11.6037093,11.814186 Z M12.6104885,9.82665631 C13.2084973,10.1007285 13.7190581,10.538041 14.0848705,11.1013427 C14.4658854,11.6880542 14.6574227,12.3617508 14.6496742,13.0441012 L14.6396969,13.2717644 L13.6425972,13.1956579 C13.6839975,12.6532572 13.5490462,12.1123241 13.2461999,11.6459817 C13.0218303,11.3004828 12.7225604,11.0222453 12.3728174,10.8265993 L12.1938529,10.7357299 L12.6104885,9.82665631 Z M10.4839323,9.80013135 L10.9005679,10.7092049 C10.4736977,10.9048429 10.1099855,11.2163747 9.8482209,11.6194567 C9.58323039,12.0275064 9.44678448,12.4926644 9.44454844,12.9659443 L9.45182359,13.1691329 L8.45472389,13.2452394 C8.39677353,12.4860101 8.58620041,11.7267194 9.00955033,11.0748177 C9.37536275,10.511516 9.88592356,10.0742035 10.4839323,9.80013135 Z M11.4766677,7.32088303 C14.018599,7.32088303 16.1990243,9.07132292 16.782451,11.4956461 L16.8324309,11.7248678 L15.8510419,11.9168982 C15.4449745,9.84165336 13.6175574,8.32088303 11.4766677,8.32088303 C9.415277,8.32088303 7.64364774,9.73096275 7.15290597,11.6898669 L7.10674937,11.8944346 L6.1263657,11.697336 C6.63486354,9.16802855 8.86561265,7.32088303 11.4766677,7.32088303 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  entitlementIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-307.000000, -460.000000)">
          <g id="Certifications" transform="translate(307.000000, 460.000000)">
            <rect
              id="Rectangle-Copy-107"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-106"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15,11 C16.6568542,11 18,12.3431458 18,14 C18,14.6545207 17.7903952,15.2600855 17.434648,15.753232 C17.4622402,15.8012429 17.4817674,15.8540548 17.4919443,15.9101244 L17.5,16 L17.5,21 C17.5,21.4157556 17.0308449,21.6378031 16.7121985,21.4094692 L16.6464466,21.3535534 L15,19.707 L13.3535534,21.3535534 C13.0595698,21.647537 12.5708157,21.4728055 12.5069551,21.086032 L12.5,21 L12.5,16 C12.5,15.9103127 12.5236139,15.8261408 12.5649635,15.7533623 C12.2096048,15.2600855 12,14.6545207 12,14 C12,12.3431458 13.3431458,11 15,11 Z M17,3.5 C18.3254834,3.5 19.4100387,4.53153594 19.4946823,5.83562431 L19.5,6 L19.5,18 C19.5,18.2761424 19.2761424,18.5 19,18.5 C18.7545401,18.5 18.5503916,18.3231248 18.5080557,18.0898756 L18.5,18 L18.5,6 C18.5,5.22030388 17.9051119,4.57955132 17.14446,4.50686658 L17,4.5 L5.5,4.5 L5.5,18 C5.5,18.7796961 6.09488808,19.4204487 6.85553999,19.4931334 L7,19.5 L11,19.5 C11.2761424,19.5 11.5,19.7238576 11.5,20 C11.5,20.2454599 11.3231248,20.4496084 11.0898756,20.4919443 L11,20.5 L7,20.5 C5.6745166,20.5 4.58996133,19.4684641 4.50531768,18.1643757 L4.5,18 L4.5,3.5 L17,3.5 Z M15,17 C14.4536881,17 13.9414829,16.8539721 13.500288,16.59882 L13.5,19.792 L14.6464466,18.6464466 C14.820013,18.4728803 15.0894374,18.4535951 15.2843055,18.5885912 L15.3535534,18.6464466 L16.5,19.793 L16.5007215,16.5982359 C16.0592984,16.8537493 15.5467286,17 15,17 Z M15,12 C13.8954305,12 13,12.8954305 13,14 C13,15.1045695 13.8954305,16 15,16 C16.1045695,16 17,15.1045695 17,14 C17,12.8954305 16.1045695,12 15,12 Z M10,12 C10.2761424,12 10.5,12.2238576 10.5,12.5 C10.5,12.7454599 10.3231248,12.9496084 10.0898756,12.9919443 L10,13 L7,13 C6.72385763,13 6.5,12.7761424 6.5,12.5 C6.5,12.2545401 6.67687516,12.0503916 6.91012437,12.0080557 L7,12 L10,12 Z M13,9 C13.2761424,9 13.5,9.22385763 13.5,9.5 C13.5,9.74545989 13.3231248,9.94960837 13.0898756,9.99194433 L13,10 L7,10 C6.72385763,10 6.5,9.77614237 6.5,9.5 C6.5,9.25454011 6.67687516,9.05039163 6.91012437,9.00805567 L7,9 L13,9 Z M9,6 C9.27614237,6 9.5,6.22385763 9.5,6.5 C9.5,6.74545989 9.32312484,6.94960837 9.08987563,6.99194433 L9,7 L7,7 C6.72385763,7 6.5,6.77614237 6.5,6.5 C6.5,6.25454011 6.67687516,6.05039163 6.91012437,6.00805567 L7,6 L9,6 Z"
              id="Combined-Shape"
              fill="#949494"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  requestSuccessIcon: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>confirmation</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-257.000000, -506.000000)"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <g id="confirmation" transform="translate(257.000000, 506.000000)">
            <path
              d="M15.7261547,4.36025061 C15.9743499,4.48130346 16.077419,4.78063808 15.9563662,5.0288332 C15.8353133,5.27702833 15.5359787,5.3800975 15.2877836,5.25904465 C11.5648568,3.44325191 7.0748374,4.98928956 5.25904465,8.7122164 C3.44325191,12.4351432 4.98928956,16.9251626 8.7122164,18.7409553 C12.4351432,20.5567481 16.9251626,19.0107104 18.7409553,15.2877836 C19.0882567,14.5757103 19.3177467,13.825314 19.4272526,13.0574852 C19.5698903,12.0573446 19.5069429,11.0397997 19.2463105,10.0653618 C19.174959,9.79859683 19.3333729,9.52449923 19.6001379,9.45314772 C19.8669029,9.38179622 20.1410005,9.54021016 20.212352,9.80697518 C20.5076448,10.9109991 20.5789984,12.0644305 20.4172353,13.1986742 C20.2930541,14.069402 20.0328908,14.9200955 19.6397494,15.7261547 C17.581851,19.9454718 12.4931623,21.6976478 8.27384525,19.6397494 C4.05452817,17.581851 2.30235216,12.4931623 4.36025061,8.27384525 C6.41814905,4.05452817 11.5068377,2.30235216 15.7261547,4.36025061 Z M18.3535534,6.64644661 C18.5271197,6.82001296 18.5464049,7.08943736 18.4114088,7.2843055 L18.3535534,7.35355339 L10.3535534,15.3535534 C10.179987,15.5271197 9.91056264,15.5464049 9.7156945,15.4114088 L9.64644661,15.3535534 L6.64644661,12.3535534 C6.45118446,12.1582912 6.45118446,11.8417088 6.64644661,11.6464466 C6.82001296,11.4728803 7.08943736,11.4535951 7.2843055,11.5885912 L7.35355339,11.6464466 L10,14.293 L17.6464466,6.64644661 C17.8417088,6.45118446 18.1582912,6.45118446 18.3535534,6.64644661 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  request_new_access: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>request new access</title>
      <desc>Created with Sketch.</desc>
      <g
        id="V3"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        fillRule="evenodd"
      >
        <g id="Export" transform="translate(-163.000000, -126.000000)">
          <g id="request-new-access" transform="translate(163.000000, 126.000000)">
            <g id="Group-5">
              <rect id="Rectangle-Copy-47" opacity="0" x="0" y="0" width="24" height="24" />
              <rect id="Rectangle-Copy-46" opacity="0" x="2" y="2" width="20" height="20" />
              <path
                d="M10,13 C10.5522847,13 11,13.4477153 11,14 L11,19 C11,19.5522847 10.5522847,20 10,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,14 C4,13.4477153 4.44771525,13 5,13 L10,13 Z M16.5,13 C16.7761424,13 17,13.2238576 17,13.5 L17,13.5 L17,16 L19.5,16 C19.7454599,16 19.9496084,16.1768752 19.9919443,16.4101244 L20,16.5 C20,16.7761424 19.7761424,17 19.5,17 L19.5,17 L17,17 L17,19.5 C17,19.7454599 16.8231248,19.9496084 16.5898756,19.9919443 L16.5,20 C16.2238576,20 16,19.7761424 16,19.5 L16,19.5 L16,17 L13.5,17 C13.2545401,17 13.0503916,16.8231248 13.0080557,16.5898756 L13,16.5 C13,16.2238576 13.2238576,16 13.5,16 L13.5,16 L16,16 L16,13.5 C16,13.2545401 16.1768752,13.0503916 16.4101244,13.0080557 Z M10,14 L5,14 L5,19 L10,19 L10,14 Z M10,4 C10.5522847,4 11,4.44771525 11,5 L11,10 C11,10.5522847 10.5522847,11 10,11 L5,11 C4.44771525,11 4,10.5522847 4,10 L4,5 C4,4.44771525 4.44771525,4 5,4 L10,4 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,10 C20,10.5522847 19.5522847,11 19,11 L14,11 C13.4477153,11 13,10.5522847 13,10 L13,5 C13,4.44771525 13.4477153,4 14,4 L19,4 Z M10,5 L5,5 L5,10 L10,10 L10,5 Z M19,5 L14,5 L14,10 L19,10 L19,5 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  request_history: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Request history</title>
      <desc>Created with Sketch.</desc>
      <g
        id="V3"
        strokeWidth="0.9"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        fillRule="evenodd"
      >
        <g id="Export" transform="translate(-307.000000, -126.000000)">
          <g id="Request-history" transform="translate(307.000000, 126.000000)">
            <g id="Group-3">
              <rect
                id="Rectangle-Copy-29"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-28"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M17,3.5 C18.3807119,3.5 19.5,4.61928813 19.5,6 L19.5,18 C19.5,19.3807119 18.3807119,20.5 17,20.5 L7,20.5 C5.61928813,20.5 4.5,19.3807119 4.5,18 L4.5,3.5 L17,3.5 Z M17,4.5 L5.5,4.5 L5.5,18 C5.5,18.8284271 6.17157288,19.5 7,19.5 L17,19.5 C17.8284271,19.5 18.5,18.8284271 18.5,18 L18.5,6 C18.5,5.17157288 17.8284271,4.5 17,4.5 Z M14.5315683,15.6776347 C14.8077107,15.6776347 15.0315683,15.9014923 15.0315683,16.1776347 C15.0315683,16.4537771 14.8077107,16.6776347 14.5315683,16.6776347 L14.5315683,16.6776347 L9.53156833,16.6776347 C9.25542595,16.6776347 9.03156833,16.4537771 9.03156833,16.1776347 C9.03156833,15.9014923 9.25542595,15.6776347 9.53156833,15.6776347 L9.53156833,15.6776347 Z M12.0230146,6.40137283 C14.2321536,6.40137283 16.0230146,8.19223383 16.0230146,10.4013728 C16.0230146,12.6105118 14.2321536,14.4013728 12.0230146,14.4013728 C10.6427096,14.4013728 9.42569822,13.70223 8.70678744,12.6387516 C8.27510186,12.0001628 8.02301455,11.2302069 8.02301455,10.4013728 C8.02301455,9.6721237 8.21816414,8.9884542 8.55908943,8.3997382 C9.25094063,7.20503697 10.5431247,6.40137283 12.0230146,6.40137283 Z M12.0230146,7.40137283 C10.9395541,7.40137283 9.95790801,7.97970297 9.42445853,8.90087324 C9.16266519,9.35294274 9.02301455,9.86578722 9.02301455,10.4013728 C9.02301455,11.0089525 9.20293476,11.587116 9.53525199,12.07871 C10.0905314,12.9001301 11.0135495,13.4013728 12.0230146,13.4013728 C13.6798688,13.4013728 15.0230146,12.0582271 15.0230146,10.4013728 C15.0230146,8.74451858 13.6798688,7.40137283 12.0230146,7.40137283 Z M11.9625547,8.25380649 C12.2386971,8.25380649 12.4625547,8.47766412 12.4625547,8.75380649 L12.4625547,8.75380649 L12.4625547,10.5466997 L13.3161081,11.4002531 C13.5113702,11.5955152 13.5113702,11.9120977 13.3161081,12.1073599 C13.1208459,12.302622 12.8042635,12.302622 12.6090013,12.1073599 L12.6090013,12.1073599 L11.6090013,11.1073599 C11.5152331,11.0135917 11.4625547,10.8864147 11.4625547,10.7538065 L11.4625547,10.7538065 L11.4625547,8.75380649 C11.4625547,8.47766412 11.6864123,8.25380649 11.9625547,8.25380649 Z"
                id="Combined-Shape"
                fillRule="nonzero"
                fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  manage_access_review: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      style={{ marginTop: 2 }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Attestions</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" strokeWidth="0.9" fillRule="evenodd">
        <g id="Icons/Request">
          <g id="Group-2" transform="translate(5.000000, 4.000000)">
            <path
              d="M13,2.5 C13.8284271,2.5 14.5,3.17157288 14.5,4 L14.5,4 L14.5,14 C14.5,14.8284271 13.8284271,15.5 13,15.5 L13,15.5 L11.3224453,15.500412 C10.9699368,15.8113483 10.5069994,16 10,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,0 L10,0 C11.1045695,0 12,0.8954305 12,2 L12,2.5 Z M1,3.5 L1,14 C1,14.5522847 1.44771525,15 2,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,3.5 L1,3.5 Z M13,3.5 L12,3.5 L12,14 C12,14.1730179 11.9780301,14.3409045 11.9367279,14.5010222 L13,14.5 C13.2761424,14.5 13.5,14.2761424 13.5,14 L13.5,14 L13.5,4 C13.5,3.72385763 13.2761424,3.5 13,3.5 L13,3.5 Z M7,11 C7.27614237,11 7.5,11.2238576 7.5,11.5 C7.5,11.7761424 7.27614237,12 7,12 L7,12 L3,12 C2.72385763,12 2.5,11.7761424 2.5,11.5 C2.5,11.2238576 2.72385763,11 3,11 L3,11 Z M9,8 C9.27614237,8 9.5,8.22385763 9.5,8.5 C9.5,8.77614237 9.27614237,9 9,9 L9,9 L3,9 C2.72385763,9 2.5,8.77614237 2.5,8.5 C2.5,8.22385763 2.72385763,8 3,8 L3,8 Z M5,5.5 C5.27614237,5.5 5.5,5.72385763 5.5,6 C5.5,6.27614237 5.27614237,6.5 5,6.5 L5,6.5 L3,6.5 C2.72385763,6.5 2.5,6.27614237 2.5,6 C2.5,5.72385763 2.72385763,5.5 3,5.5 L3,5.5 Z M1,2.5 L11,2.5 L11,2 C11,1.44771525 10.5522847,1 10,1 L1,1 L1,2.5 Z"
              id="Combined-Shape"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  pending_action_certification: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 40 40"
      style={{ marginTop: 2 }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <desc>Created with Sketch.</desc>
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <g>
            <path
              d="M24.707 18.882c2.762 0 5 2.238 5 5 0 1.024-.308 1.976-.836 2.77l.002.039v8.333c0 .742-.897 1.114-1.422.59l-2.744-2.745-2.744 2.744c-.525.525-1.423.153-1.423-.59v-8.332l.001-.043c-.526-.791-.834-1.743-.834-2.766 0-2.762 2.239-5 5-5zm3.626-13.049C30.635 5.833 32.5 7.7 32.5 10v20c0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833V10c0-1.38-1.119-2.5-2.5-2.5H9.167V30c0 1.38 1.119 2.5 2.5 2.5h6.666c.46 0 .834.373.834.833 0 .46-.373.834-.834.834h-6.666C9.365 34.167 7.5 32.3 7.5 30V5.833zm-6.127 22.379v4.8l1.912-1.91c.325-.326.853-.326 1.178 0l1.91 1.91.001-4.8c-.735.426-1.59.67-2.5.67-.911 0-1.765-.244-2.501-.67zm2.501-7.664c-1.84 0-3.333 1.493-3.333 3.334 0 1.84 1.492 3.333 3.333 3.333 1.841 0 3.334-1.492 3.334-3.333 0-1.841-1.493-3.334-3.334-3.334zM16.667 20c.46 0 .833.373.833.833 0 .46-.373.834-.833.834h-5c-.46 0-.834-.373-.834-.834 0-.46.373-.833.834-.833zm5-5c.46 0 .833.373.833.833 0 .46-.373.834-.833.834h-10c-.46 0-.834-.373-.834-.834 0-.46.373-.833.834-.833zM15 10c.46 0 .833.373.833.833 0 .46-.373.834-.833.834h-3.333c-.46 0-.834-.373-.834-.834 0-.46.373-.833.834-.833z"
              transform="translate(-776 -725) translate(776 725)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  access_review: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Access Review</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" strokeWidth="0.87" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-113.000000, -460.000000)">
          <g id="Access-Review" transform="translate(113.000000, 460.000000)">
            <rect
              id="Rectangle-Copy-58"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <path
              d="M15,4 C16.1045695,4 17,4.8954305 17,6 L17,6.5 L18,6.5 C18.7796961,6.5 19.4204487,7.09488808 19.4931334,7.85553999 L19.5,8 L19.5,18 C19.5,18.7796961 18.9051119,19.4204487 18.14446,19.4931334 L18,19.5 L16.3224453,19.500412 C15.9699368,19.8113483 15.5069994,20 15,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 L15,4 Z M16,8 L6,8 L6,18 C6,18.5128358 6.38604019,18.9355072 6.88337887,18.9932723 L7,19 L15,19 C15.5128358,19 15.9355072,18.6139598 15.9932723,18.1166211 L16,18 L16,8 Z M18,7.5 L17,7.5 L17,18 C17,18.1730179 16.9780301,18.3409045 16.9367279,18.5010222 L18,18.5 C18.2454599,18.5 18.4496084,18.3231248 18.4919443,18.0898756 L18.5,18 L18.5,8 C18.5,7.75454011 18.3231248,7.55039163 18.0898756,7.50805567 L18,7.5 Z M13,15 C13,15.2761424 12.7761424,15.5 12.5,15.5 C12.2545401,15.5 12.0503916,15.3231248 12.0080557,15.0898756 L12,15 L12,14 L11,14 L10.9473817,13.9955109 C10.7404133,14.8794985 9.94708346,15.5377961 9,15.5377961 C7.8954305,15.5377961 7,14.6423656 7,13.5377961 C7,12.4332266 7.8954305,11.5377961 9,11.5377961 C9.92035418,11.5377961 10.6955109,12.1594602 10.9284667,13.0057847 L11,13 L15,13 C15.2761424,13 15.5,13.2238576 15.5,13.5 C15.5,13.7454599 15.3231248,13.9496084 15.0898756,13.9919443 L15,14 L15,16 C15,16.2761424 14.7761424,16.5 14.5,16.5 C14.2545401,16.5 14.0503916,16.3231248 14.0080557,16.0898756 L14,16 L14,14 L13,14 L13,15 Z M9,12.5377961 C8.44771525,12.5377961 8,12.9855114 8,13.5377961 C8,14.0900809 8.44771525,14.5377961 9,14.5377961 C9.55228475,14.5377961 10,14.0900809 10,13.5377961 C10,12.9855114 9.55228475,12.5377961 9,12.5377961 Z M15,5 L6,5 L6,7 L16,7 L16,6 C16,5.48716416 15.6139598,5.06449284 15.1166211,5.00672773 L15,5 Z"
              id="Combined-Shape"
              fill="#9b2242"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  accounts_icon: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Accounts</title>
      <desc>Created with Sketch.</desc>
      <g
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        id="Ragav-V5"
        fillRule="evenodd"
      >
        <g id="Icons/Account">
          <rect
            id="Rectangle-Copy-86"
            fill="#D8D8D8"
            fillRule="evenodd"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          />
          <rect
            id="Rectangle-Copy-81"
            fill="#FFF5F5"
            fillRule="evenodd"
            opacity="0"
            x="2"
            y="2"
            width="20"
            height="20"
          />
          <path
            d="M17.5025746,4.50912371 L17.5025746,6.50912371 C17.5025746,6.80090352 17.3241002,7.00912371 17.1454318,7.00912371 L6.85971747,7.00912371 C6.68104907,7.00912371 6.50257462,6.80090352 6.50257462,6.50912371 L6.50257462,5.50912371 L5.50257462,5.50912371 L5.50257462,6.50912371 C5.50257462,7.3219134 6.09161203,8.00912371 6.85971747,8.00912371 L17.1454318,8.00912371 C17.9135372,8.00912371 18.5025746,7.3219134 18.5025746,6.50912371 L18.5025746,4.50912371 L17.5025746,4.50912371 Z"
            id="Rectangle-Copy-87"
            fillRule="nonzero"
            transform="translate(12.002575, 6.259124) scale(1, -1) translate(-12.002575, -6.259124) "
          />
          <path
            d="M18,7 C19.1045695,7 20,7.8954305 20,9 L20,17 C20,18.1045695 19.1045695,19 18,19 L6,19 C4.8954305,19 4,18.1045695 4,17 L4,7 L18,7 Z M5,8 L5,17 C5,17.5522847 5.44771525,18 6,18 L18,18 C18.5522847,18 19,17.5522847 19,17 L19,9 C19,8.44771525 18.5522847,8 18,8 L5,8 Z"
            id="Rectangle"
            fillRule="nonzero"
          />
          <path
            d="M11.9923989,12.0229613 C12.820826,12.0229613 13.4923989,11.3513884 13.4923989,10.5229613 C13.4923989,9.69453419 12.820826,9.02296132 11.9923989,9.02296132 C11.1639718,9.02296132 10.4923989,9.69453419 10.4923989,10.5229613 C10.4923989,11.3513884 11.1639718,12.0229613 11.9923989,12.0229613 Z M11.9923989,11.0229613 C11.7162565,11.0229613 11.4923989,10.7991037 11.4923989,10.5229613 C11.4923989,10.2468189 11.7162565,10.0229613 11.9923989,10.0229613 C12.2685413,10.0229613 12.4923989,10.2468189 12.4923989,10.5229613 C12.4923989,10.7991037 12.2685413,11.0229613 11.9923989,11.0229613 Z"
            id="Oval"
            fillRule="nonzero"
          />
          <path
            d="M14.5,13 L14.5,15 C14.5,15.3087677 14.3725118,15.5 14.3333333,15.5 L9.66666667,15.5 C9.62748823,15.5 9.5,15.3087677 9.5,15 L9.5,13 C9.5,12.7238576 9.27614237,12.5 9,12.5 C8.72385763,12.5 8.5,12.7238576 8.5,13 L8.5,15 C8.5,15.7958018 8.96946544,16.5 9.66666667,16.5 L14.3333333,16.5 C15.0305346,16.5 15.5,15.7958018 15.5,15 L15.5,13 C15.5,12.7238576 15.2761424,12.5 15,12.5 C14.7238576,12.5 14.5,12.7238576 14.5,13 Z"
            id="Rectangle"
            fillRule="nonzero"
            transform="translate(12.000000, 14.500000) scale(1, -1) translate(-12.000000, -14.500000) "
          />
        </g>
      </g>
    </svg>
  ),
  pending_approval: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Pending Approval</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Icons/Review"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <path
            d="M17,4 C18.1045695,4 19,4.8954305 19,6 L19,18 C19,19.1045695 18.1045695,20 17,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 L17,4 Z M17,5 L6,5 L6,18 C6,18.5522847 6.44771525,19 7,19 L17,19 C17.5522847,19 18,18.5522847 18,18 L18,6 C18,5.44771525 17.5522847,5 17,5 Z M14,15.5 C14.2761424,15.5 14.5,15.7238576 14.5,16 C14.5,16.2761424 14.2761424,16.5 14,16.5 L14,16.5 L10,16.5 C9.72385763,16.5 9.5,16.2761424 9.5,16 C9.5,15.7238576 9.72385763,15.5 10,15.5 L10,15.5 Z M12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 C10.6196951,14 9.40268367,13.3008572 8.68377289,12.2373787 C8.2520873,11.59879 8,10.8288341 8,10 C8,9.27075087 8.19514959,8.58708137 8.53607488,7.99836537 C9.22792608,6.80366414 10.5201101,6 12,6 Z M12,7 C10.9165395,7 9.93489346,7.57833014 9.40144397,8.49950041 C9.13965064,8.95156991 9,9.46441439 9,10 C9,10.6075796 9.17992021,11.1857432 9.51223744,11.6773372 C10.0675169,12.4987573 10.9905349,13 12,13 C13.6568542,13 15,11.6568542 15,10 C15,8.34314575 13.6568542,7 12,7 Z M13.084335,8.64644661 C13.2795971,8.45118446 13.5961796,8.45118446 13.7914418,8.64644661 C13.9867039,8.84170876 13.9867039,9.15829124 13.7914418,9.35355339 L13.7914418,9.35355339 L11.7914418,11.3535534 C11.5961796,11.5488155 11.2795971,11.5488155 11.084335,11.3535534 L11.084335,11.3535534 L10.084335,10.3535534 C9.88907284,10.1582912 9.88907284,9.84170876 10.084335,9.64644661 C10.2795971,9.45118446 10.5961796,9.45118446 10.7914418,9.64644661 L10.7914418,9.64644661 L11.4378884,10.2928932 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  attestions: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Attestions</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Icons/Request"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        >
          <g id="Group-2" transform="translate(5.000000, 4.000000)">
            <path
              d="M13,2.5 C13.8284271,2.5 14.5,3.17157288 14.5,4 L14.5,4 L14.5,14 C14.5,14.8284271 13.8284271,15.5 13,15.5 L13,15.5 L11.3224453,15.500412 C10.9699368,15.8113483 10.5069994,16 10,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,0 L10,0 C11.1045695,0 12,0.8954305 12,2 L12,2.5 Z M1,3.5 L1,14 C1,14.5522847 1.44771525,15 2,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,3.5 L1,3.5 Z M13,3.5 L12,3.5 L12,14 C12,14.1730179 11.9780301,14.3409045 11.9367279,14.5010222 L13,14.5 C13.2761424,14.5 13.5,14.2761424 13.5,14 L13.5,14 L13.5,4 C13.5,3.72385763 13.2761424,3.5 13,3.5 L13,3.5 Z M7,11 C7.27614237,11 7.5,11.2238576 7.5,11.5 C7.5,11.7761424 7.27614237,12 7,12 L7,12 L3,12 C2.72385763,12 2.5,11.7761424 2.5,11.5 C2.5,11.2238576 2.72385763,11 3,11 L3,11 Z M9,8 C9.27614237,8 9.5,8.22385763 9.5,8.5 C9.5,8.77614237 9.27614237,9 9,9 L9,9 L3,9 C2.72385763,9 2.5,8.77614237 2.5,8.5 C2.5,8.22385763 2.72385763,8 3,8 L3,8 Z M5,5.5 C5.27614237,5.5 5.5,5.72385763 5.5,6 C5.5,6.27614237 5.27614237,6.5 5,6.5 L5,6.5 L3,6.5 C2.72385763,6.5 2.5,6.27614237 2.5,6 C2.5,5.72385763 2.72385763,5.5 3,5.5 L3,5.5 Z M1,2.5 L11,2.5 L11,2 C11,1.44771525 10.5522847,1 10,1 L1,1 L1,2.5 Z"
              id="Combined-Shape"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  request_review: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Request</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g
          id="confirmation"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        >
          <rect
            id="Rectangle-Copy-134"
            fill="#D8D8D8"
            fillRule="evenodd"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          />
          <rect
            id="Rectangle-Copy-133"
            fill="#FFF5F5"
            fillRule="evenodd"
            opacity="0"
            x="2"
            y="2"
            width="20"
            height="20"
          />
          <path
            d="M16,5.94117647 L17.5,5.94117647 C17.7761424,5.94117647 18,6.151866 18,6.41176471 L18,17.5882353 C18,17.848134 17.7761424,18.0588235 17.5,18.0588235 L16,18.0588235 L16,19 L17.5,19 C18.3284271,19 19,18.3679314 19,17.5882353 L19,6.41176471 C19,5.63206859 18.3284271,5 17.5,5 L16,5 L16,5.94117647 Z"
            id="Rectangle-Copy-2"
            fill="#ffffff"
            fillRule="nonzero"
            transform="translate(17.500000, 12.000000) scale(1, -1) translate(-17.500000, -12.000000) "
          />
          <path
            d="M5,4 L15,4 C16.1045695,4 17,4.8954305 17,6 L17,18 C17,19.1045695 16.1045695,20 15,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 Z M6,5 L6,18 C6,18.5522847 6.44771525,19 7,19 L15,19 C15.5522847,19 16,18.5522847 16,18 L16,6 C16,5.44771525 15.5522847,5 15,5 L6,5 Z"
            id="Rectangle"
            fill="#ffffff"
            fillRule="nonzero"
          />
          <path
            d="M9.84384451,8.63584608 C9.64858236,8.44058393 9.33199987,8.44058393 9.13673772,8.63584608 C8.94147558,8.83110822 8.94147558,9.14769071 9.13673772,9.34295286 L10.1367377,10.3429529 C10.3319999,10.538215 10.6485824,10.538215 10.8438445,10.3429529 L12.8438445,8.34295286 C13.0391067,8.14769071 13.0391067,7.83110822 12.8438445,7.63584608 C12.6485824,7.44058393 12.3319999,7.44058393 12.1367377,7.63584608 L10.4902911,9.28229269 L9.84384451,8.63584608 Z"
            id="Path-2-Copy-3"
            fill="#ffffff"
            fillRule="nonzero"
          />
          <path
            d="M8,13 L14,13 C14.2761424,13 14.5,12.7761424 14.5,12.5 C14.5,12.2238576 14.2761424,12 14,12 L8,12 C7.72385763,12 7.5,12.2238576 7.5,12.5 C7.5,12.7761424 7.72385763,13 8,13 Z"
            id="Path-39"
            fill="#ffffff"
            fillRule="nonzero"
          />
          <path
            d="M8,15 L12,15 C12.2761424,15 12.5,14.7761424 12.5,14.5 C12.5,14.2238576 12.2761424,14 12,14 L8,14 C7.72385763,14 7.5,14.2238576 7.5,14.5 C7.5,14.7761424 7.72385763,15 8,15 Z"
            id="Path-39-Copy"
            fill="#ffffff"
            fillRule="nonzero"
          />
          <path
            d="M8,17 L10,17 C10.2761424,17 10.5,16.7761424 10.5,16.5 C10.5,16.2238576 10.2761424,16 10,16 L8,16 C7.72385763,16 7.5,16.2238576 7.5,16.5 C7.5,16.7761424 7.72385763,17 8,17 Z"
            id="Path-39-Copy-2"
            fill="#ffffff"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  ),
  reports: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Reports</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Icons/Document"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <path
            d="M17,4.5 C18.3188064,4.5 19.4095045,5.4730742 19.4946503,6.7180169 L19.5,6.875 L19.5,18.125 C19.5,18.2128909 19.4950004,18.299613 19.4852612,18.3849318 C19.4280557,18.8854974 19.207923,19.3375148 18.8772318,19.6940109 C18.7093455,19.8740433 18.5190844,20.0260678 18.308299,20.1491819 C18.2925624,20.1583737 18.2766567,20.1674347 18.2606385,20.1763312 C18.1072722,20.2609963 17.9502117,20.3285021 17.7857097,20.3802087 C17.714053,20.4027422 17.6406511,20.4223516 17.5659961,20.4387812 C17.4974549,20.4538737 17.4275563,20.466327 17.3567269,20.4759556 C17.3498385,20.4768916 17.3431101,20.4777792 17.3363735,20.4786414 C17.3163487,20.481205 17.2961295,20.4835557 17.2758395,20.4856753 C17.1852144,20.4951427 17.0931765,20.5 17,20.5 L17,20.5 L7,20.5 C6.90682346,20.5 6.81478557,20.4951427 6.72416053,20.4856753 C6.70387049,20.4835557 6.68365128,20.481205 6.66350596,20.4786259 C6.6568899,20.4777792 6.65016153,20.4768916 6.64344153,20.4759785 C6.57244369,20.466327 6.50254513,20.4538737 6.43371216,20.438717 C6.35934885,20.4223516 6.28594697,20.4027422 6.21397013,20.380108 C6.04978831,20.3285021 5.89272777,20.2609963 5.74516023,20.1795419 C5.72334325,20.1674347 5.70743757,20.1583737 5.69164707,20.1491503 C5.48091556,20.0260678 5.29065452,19.8740433 5.1271909,19.698766 C4.79207701,19.3375148 4.57194429,18.8854974 4.51477202,18.3852223 C4.50499958,18.299613 4.5,18.2128909 4.5,18.125 L4.5,18.125 L4.5,6.875 L4.50534973,6.7180169 C4.59049548,5.4730742 5.68119356,4.5 7,4.5 C7.27614237,4.5 7.5,4.72385763 7.5,5 C7.5,5.27614237 7.27614237,5.5 7,5.5 C6.16461771,5.5 5.5,6.1230791 5.5,6.875 L5.5,6.875 L5.5,18.125 L5.50679863,18.2562539 C5.5787812,18.9480683 6.21375784,19.5 7,19.5 L7,19.5 L17,19.5 L17.1455472,19.4936326 C17.9112729,19.4262508 18.5,18.8326903 18.5,18.125 L18.5,18.125 L18.5,6.875 C18.5,6.1230791 17.8353823,5.5 17,5.5 C16.7238576,5.5 16.5,5.27614237 16.5,5 C16.5,4.72385763 16.7238576,4.5 17,4.5 Z M14,16.5 C14.2761424,16.5 14.5,16.7238576 14.5,17 C14.5,17.2454599 14.3231248,17.4496084 14.0898756,17.4919443 L14,17.5 L10,17.5 C9.72385763,17.5 9.5,17.2761424 9.5,17 C9.5,16.7545401 9.67687516,16.5503916 9.91012437,16.5080557 L10,16.5 L14,16.5 Z M16,13.5 C16.2761424,13.5 16.5,13.7238576 16.5,14 C16.5,14.2454599 16.3231248,14.4496084 16.0898756,14.4919443 L16,14.5 L8,14.5 C7.72385763,14.5 7.5,14.2761424 7.5,14 C7.5,13.7545401 7.67687516,13.5503916 7.91012437,13.5080557 L8,13.5 L16,13.5 Z M16,10.5 C16.2761424,10.5 16.5,10.7238576 16.5,11 C16.5,11.2454599 16.3231248,11.4496084 16.0898756,11.4919443 L16,11.5 L8,11.5 C7.72385763,11.5 7.5,11.2761424 7.5,11 C7.5,10.7545401 7.67687516,10.5503916 7.91012437,10.5080557 L8,10.5 L16,10.5 Z M11.3362054,2.59617092 C12.2332498,2.59617092 12.9923584,3.18674393 13.2459349,4.00029359 L14,4 C15.1045695,4 16,4.8954305 16,6 C16,7.1045695 15.1045695,8 14,8 L10,8 C8.8954305,8 8,7.1045695 8,6 C8,5.10407141 8.58910483,4.34573562 9.40108807,4.09121906 C9.62428283,3.23107978 10.4060987,2.59617092 11.3362054,2.59617092 Z M11.3362054,3.59617092 C10.9164991,3.59617092 10.5485246,3.85722752 10.4030589,4.23621188 L10.3690315,4.34238755 L10.229664,4.87947632 L9.70018926,5.04544046 C9.28721517,5.1748874 9,5.55979299 9,6 C9,6.51283584 9.38604019,6.93550716 9.88337887,6.99327227 L10,7 L14,7 C14.5522847,7 15,6.55228475 15,6 C15,5.48716416 14.6139598,5.06449284 14.1169329,5.00672767 L14.0003893,4.99999992 L12.5102657,5.0005801 L12.2912354,4.29786533 C12.1622808,3.88414004 11.7769874,3.59617092 11.3362054,3.59617092 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  manage_ad_groups: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Manage Ad Groups</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Manage-Ad-Groups"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <path
            d="M18,10 C19.1045695,10 20,10.8954305 20,12 L20,16 C20,17.1045695 19.1045695,18 18,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,12 C4,10.8954305 4.8954305,10 6,10 L18,10 Z M18,11 L6,11 C5.48716416,11 5.06449284,11.3860402 5.00672773,11.8833789 L5,12 L5,16 C5,16.5128358 5.38604019,16.9355072 5.88337887,16.9932723 L6,17 L18,17 C18.5128358,17 18.9355072,16.6139598 18.9932723,16.1166211 L19,16 L19,12 C19,11.4871642 18.6139598,11.0644928 18.1166211,11.0067277 L18,11 Z M14.5,15 C14.7761424,15 15,15.2238576 15,15.5 C15,15.7454599 14.8231248,15.9496084 14.5898756,15.9919443 L14.5,16 L11.5,16 C11.2238576,16 11,15.7761424 11,15.5 C11,15.2545401 11.1768752,15.0503916 11.4101244,15.0080557 L11.5,15 L14.5,15 Z M8,12 C9.1045695,12 10,12.8954305 10,14 C10,15.1045695 9.1045695,16 8,16 C6.8954305,16 6,15.1045695 6,14 C6,12.8954305 6.8954305,12 8,12 Z M8,13 C7.44771525,13 7,13.4477153 7,14 C7,14.5522847 7.44771525,15 8,15 C8.55228475,15 9,14.5522847 9,14 C9,13.4477153 8.55228475,13 8,13 Z M16.5,13 C16.7761424,13 17,13.2238576 17,13.5 C17,13.7454599 16.8231248,13.9496084 16.5898756,13.9919443 L16.5,14 L11.5,14 C11.2238576,14 11,13.7761424 11,13.5 C11,13.2545401 11.1768752,13.0503916 11.4101244,13.0080557 L11.5,13 L16.5,13 Z M17,5.5 L17.14446,5.50686658 C17.9051119,5.57955132 18.5,6.22030388 18.5,7 L18.5,7 L18.5,9 L18.4919443,9.08987563 C18.4496084,9.32312484 18.2454599,9.5 18,9.5 C17.7238576,9.5 17.5,9.27614237 17.5,9 L17.5,9 L17.5,7 L17.4919443,6.91012437 C17.4496084,6.67687516 17.2454599,6.5 17,6.5 L17,6.5 L7,6.5 L6.91012437,6.50805567 C6.67687516,6.55039163 6.5,6.75454011 6.5,7 L6.5,7 L6.5,9 L6.49194433,9.08987563 C6.44960837,9.32312484 6.24545989,9.5 6,9.5 C5.72385763,9.5 5.5,9.27614237 5.5,9 L5.5,9 L5.5,7 L5.50686658,6.85553999 C5.57955132,6.09488808 6.22030388,5.5 7,5.5 L7,5.5 L17,5.5 Z M16,8 C16.2761424,8 16.5,8.22385763 16.5,8.5 C16.5,8.74545989 16.3231248,8.94960837 16.0898756,8.99194433 L16,9 L12,9 C11.7238576,9 11.5,8.77614237 11.5,8.5 C11.5,8.25454011 11.6768752,8.05039163 11.9101244,8.00805567 L12,8 L16,8 Z M9,7.5 C9.77969612,7.5 10.4204487,8.09488808 10.4931334,8.85553999 L10.5,9 L9.5,9 C9.5,8.72385763 9.27614237,8.5 9,8.5 C8.75454011,8.5 8.55039163,8.67687516 8.50805567,8.91012437 L8.5,9 L7.5,9 C7.5,8.17157288 8.17157288,7.5 9,7.5 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),

  user: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>User</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Icons/Role"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <path
            d="M15.3333333,10.5 C16.0305346,10.5 16.5,11.2041982 16.5,12 L16.5,17 C16.5,17.2761424 16.2761424,17.5 16,17.5 C15.7238576,17.5 15.5,17.2761424 15.5,17 L15.5,12 C15.5,11.6912323 15.3725118,11.5 15.3333333,11.5 L8.66666667,11.5 C8.62748823,11.5 8.5,11.6912323 8.5,12 L8.5,17 C8.5,17.2761424 8.27614237,17.5 8,17.5 C7.72385763,17.5 7.5,17.2761424 7.5,17 L7.5,12 C7.5,11.2041982 7.96946544,10.5 8.66666667,10.5 L15.3333333,10.5 Z M18.1666667,11.5 C18.8638679,11.5 19.3333333,12.2041982 19.3333333,13 L19.3333333,17 C19.3333333,17.2761424 19.1094757,17.5 18.8333333,17.5 C18.557191,17.5 18.3333333,17.2761424 18.3333333,17 L18.3333333,13 C18.3333333,12.6912323 18.2058451,12.5 18.1666667,12.5 C17.8905243,12.5 17.6666667,12.2761424 17.6666667,12 C17.6666667,11.7238576 17.8905243,11.5 18.1666667,11.5 Z M5.83333333,11.5 C6.10947571,11.5 6.33333333,11.7238576 6.33333333,12 C6.33333333,12.2761424 6.10947571,12.5 5.83333333,12.5 C5.79415489,12.5 5.66666667,12.6912323 5.66666667,13 L5.66666667,13 L5.66666667,17 C5.66666667,17.2761424 5.44280904,17.5 5.16666667,17.5 C4.89052429,17.5 4.66666667,17.2761424 4.66666667,17 L4.66666667,17 L4.66666667,13 C4.66666667,12.2041982 5.13613211,11.5 5.83333333,11.5 Z M17,8 C17.5522847,8 18,8.44771525 18,9 C18,9.55228475 17.5522847,10 17,10 C16.4477153,10 16,9.55228475 16,9 C16,8.44771525 16.4477153,8 17,8 Z M7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z M12,6 C11.4477153,6 11,6.44771525 11,7 C11,7.55228475 11.4477153,8 12,8 C12.5522847,8 13,7.55228475 13,7 C13,6.44771525 12.5522847,6 12,6 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  change_passwords: () => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Change passwords</title>
      <desc>Created with Sketch.</desc>
      <g id="Ragav-V5" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Password"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        >
          <path
            d="M11.6582103,3.63506195 C11.8571453,3.44874552 12.1686528,3.45608348 12.3585943,3.65156039 C13.3887367,4.71172454 14.4870016,5.42895872 15.6552009,5.81041156 C16.7995704,6.18408324 17.8498269,6.18408324 18.8239944,5.81771639 C19.150942,5.6947573 19.5,5.93640979 19.5,6.28571429 L19.5,6.28571429 L19.5,13.1428571 C19.5,16.8499048 15.7738611,20.4999992 12,20.4999992 C8.94439067,20.4999992 4.5,17.1990713 4.5,13.1428571 L4.5,13.1428571 L4.5,6.28571429 C4.5,5.95394936 4.81719377,5.71418139 5.13637905,5.80467296 C6.29278835,6.13252421 7.35832911,6.13252421 8.34479911,5.81041156 C9.3512609,5.48177097 10.4584914,4.75868164 11.6582103,3.63506195 Z M11.986,4.688 L11.7477208,4.89659199 C10.6678655,5.81717205 9.63869773,6.43987519 8.65520089,6.76101701 C7.74573456,7.05798561 6.78568459,7.12651683 5.78042094,6.96922267 L5.78042094,6.96922267 L5.5,6.919 L5.5,13.1428571 C5.5,16.4968498 9.27353185,19.3724326 11.8313356,19.4958728 L11.8313356,19.4958728 L12,19.5 C15.2261389,19.5 18.5,16.2929523 18.5,13.1428571 L18.5,13.1428571 L18.5,6.955 L18.3960332,6.98071168 C17.5162504,7.16432712 16.5933013,7.11952138 15.6337545,6.84895657 L15.6337545,6.84895657 L15.3447991,6.76101701 C14.2196759,6.39362983 13.1623002,5.75961987 12.1737699,4.86331795 L12.1737699,4.86331795 L11.986,4.688 Z M8.28902914,10.8934983 L8.333734,10.8995746 C8.36209048,10.9076765 8.38755344,10.9238802 8.41012289,10.9481858 C8.44397705,10.9846441 8.46090414,11.0237066 8.46090414,11.0653733 L8.46090414,11.0653733 L8.45309164,11.1278733 L8.28902914,11.8934983 L8.97652914,11.5106858 L9.03902914,11.4794358 L9.05660726,11.4735764 L9.05660726,11.4735764 L9.07809164,11.4716233 C9.1197583,11.4716233 9.15751872,11.4820399 9.19137289,11.5028733 C9.22522705,11.5237066 9.2447583,11.5523524 9.24996664,11.5888108 L9.24996664,11.5888108 L9.38277914,11.9872483 L9.39059164,12.0341233 L9.38668539,12.0701476 C9.38147705,12.0938744 9.37106039,12.1170226 9.35543539,12.139592 C9.33199789,12.1734462 9.30465414,12.1955816 9.27340414,12.2059983 L9.27340414,12.2059983 L9.21090414,12.2216233 L8.42965414,12.3153733 L9.00777914,12.8309983 L9.0338208,12.857908 C9.04770969,12.8729543 9.05465414,12.8822135 9.05465414,12.8856858 C9.07548747,12.9169358 9.08590414,12.9481858 9.08590414,12.9794358 C9.08590414,13.0419358 9.06246664,13.0888108 9.01559164,13.1200608 L9.01559164,13.1200608 L8.67965414,13.3700608 L8.63082601,13.3876389 L8.63082601,13.3876389 L8.57809164,13.3934983 C8.5103833,13.3934983 8.4635083,13.3726649 8.43746664,13.3309983 L8.43746664,13.3309983 L8.40621664,13.2763108 L8.07809164,12.5575608 L7.74996664,13.2763108 L7.73238851,13.3056076 L7.73238851,13.3056076 L7.71090414,13.3309983 C7.68486247,13.3726649 7.63798747,13.3934983 7.57027914,13.3934983 C7.5338208,13.3934983 7.49996664,13.3856858 7.46871664,13.3700608 L7.46871664,13.3700608 L7.14059164,13.1200608 L7.10152914,13.0836024 C7.0806958,13.0558246 7.07027914,13.0211024 7.07027914,12.9794358 C7.07027914,12.9481858 7.0806958,12.9169358 7.10152914,12.8856858 C7.10152914,12.8804774 7.11715414,12.8622483 7.14840414,12.8309983 L7.14840414,12.8309983 L7.71871664,12.3075608 L6.94527914,12.2216233 L6.88277914,12.2059983 L6.84458469,12.1899392 C6.82143655,12.1754716 6.80291803,12.1534809 6.78902914,12.123967 C6.7681958,12.0796962 6.76298747,12.0341233 6.77340414,11.9872483 L6.77340414,11.9872483 L6.90621664,11.5888108 L6.92227567,11.5506163 C6.93674326,11.5274682 6.958734,11.5089496 6.98824789,11.4950608 C7.03251872,11.4742274 7.07548747,11.4690191 7.11715414,11.4794358 L7.11715414,11.4794358 L7.17965414,11.5106858 L7.85152914,11.8856858 L7.70309164,11.1278733 L7.69527914,11.0653733 L7.7009215,11.0245746 C7.70844465,10.9979543 7.72349094,10.9724913 7.74606039,10.9481858 C7.77991455,10.9117274 7.82027914,10.8934983 7.86715414,10.8934983 L7.86715414,10.8934983 L8.28902914,10.8934983 Z M12.2890291,10.8934983 L12.333734,10.8995746 C12.3620905,10.9076765 12.3875534,10.9238802 12.4101229,10.9481858 C12.4439771,10.9846441 12.4609041,11.0237066 12.4609041,11.0653733 L12.4609041,11.0653733 L12.4530916,11.1278733 L12.2890291,11.8934983 L12.9765291,11.5106858 L13.0390291,11.4794358 L13.0566073,11.4735764 L13.0566073,11.4735764 L13.0780916,11.4716233 C13.1197583,11.4716233 13.1575187,11.4820399 13.1913729,11.5028733 C13.2252271,11.5237066 13.2447583,11.5523524 13.2499666,11.5888108 L13.2499666,11.5888108 L13.3827791,11.9872483 L13.3905916,12.0341233 L13.3866854,12.0701476 C13.3814771,12.0938744 13.3710604,12.1170226 13.3554354,12.139592 C13.3319979,12.1734462 13.3046541,12.1955816 13.2734041,12.2059983 L13.2734041,12.2059983 L13.2109041,12.2216233 L12.4296541,12.3153733 L13.0077791,12.8309983 L13.0338208,12.857908 C13.0477097,12.8729543 13.0546541,12.8822135 13.0546541,12.8856858 C13.0754875,12.9169358 13.0859041,12.9481858 13.0859041,12.9794358 C13.0859041,13.0419358 13.0624666,13.0888108 13.0155916,13.1200608 L13.0155916,13.1200608 L12.6796541,13.3700608 L12.630826,13.3876389 L12.630826,13.3876389 L12.5780916,13.3934983 C12.5103833,13.3934983 12.4635083,13.3726649 12.4374666,13.3309983 L12.4374666,13.3309983 L12.4062166,13.2763108 L12.0780916,12.5575608 L11.7499666,13.2763108 L11.7323885,13.3056076 L11.7323885,13.3056076 L11.7109041,13.3309983 C11.6848625,13.3726649 11.6379875,13.3934983 11.5702791,13.3934983 C11.5338208,13.3934983 11.4999666,13.3856858 11.4687166,13.3700608 L11.4687166,13.3700608 L11.1405916,13.1200608 L11.1015291,13.0836024 C11.0806958,13.0558246 11.0702791,13.0211024 11.0702791,12.9794358 C11.0702791,12.9481858 11.0806958,12.9169358 11.1015291,12.8856858 C11.1015291,12.8804774 11.1171541,12.8622483 11.1484041,12.8309983 L11.1484041,12.8309983 L11.7187166,12.3075608 L10.9452791,12.2216233 L10.8827791,12.2059983 L10.8445847,12.1899392 C10.8214365,12.1754716 10.802918,12.1534809 10.7890291,12.123967 C10.7681958,12.0796962 10.7629875,12.0341233 10.7734041,11.9872483 L10.7734041,11.9872483 L10.9062166,11.5888108 L10.9222757,11.5506163 C10.9367433,11.5274682 10.958734,11.5089496 10.9882479,11.4950608 C11.0325187,11.4742274 11.0754875,11.4690191 11.1171541,11.4794358 L11.1171541,11.4794358 L11.1796541,11.5106858 L11.8515291,11.8856858 L11.7030916,11.1278733 L11.6952791,11.0653733 L11.7009215,11.0245746 C11.7084446,10.9979543 11.7234909,10.9724913 11.7460604,10.9481858 C11.7799146,10.9117274 11.8202791,10.8934983 11.8671541,10.8934983 L11.8671541,10.8934983 L12.2890291,10.8934983 Z M16.2890291,10.8934983 L16.333734,10.8995746 C16.3620905,10.9076765 16.3875534,10.9238802 16.4101229,10.9481858 C16.4439771,10.9846441 16.4609041,11.0237066 16.4609041,11.0653733 L16.4609041,11.0653733 L16.4530916,11.1278733 L16.2890291,11.8934983 L16.9765291,11.5106858 L17.0390291,11.4794358 L17.0566073,11.4735764 L17.0566073,11.4735764 L17.0780916,11.4716233 C17.1197583,11.4716233 17.1575187,11.4820399 17.1913729,11.5028733 C17.2252271,11.5237066 17.2447583,11.5523524 17.2499666,11.5888108 L17.2499666,11.5888108 L17.3827791,11.9872483 L17.3905916,12.0341233 L17.3866854,12.0701476 C17.3814771,12.0938744 17.3710604,12.1170226 17.3554354,12.139592 C17.3319979,12.1734462 17.3046541,12.1955816 17.2734041,12.2059983 L17.2734041,12.2059983 L17.2109041,12.2216233 L16.4296541,12.3153733 L17.0077791,12.8309983 L17.0338208,12.857908 C17.0477097,12.8729543 17.0546541,12.8822135 17.0546541,12.8856858 C17.0754875,12.9169358 17.0859041,12.9481858 17.0859041,12.9794358 C17.0859041,13.0419358 17.0624666,13.0888108 17.0155916,13.1200608 L17.0155916,13.1200608 L16.6796541,13.3700608 L16.630826,13.3876389 L16.630826,13.3876389 L16.5780916,13.3934983 C16.5103833,13.3934983 16.4635083,13.3726649 16.4374666,13.3309983 L16.4374666,13.3309983 L16.4062166,13.2763108 L16.0780916,12.5575608 L15.7499666,13.2763108 L15.7323885,13.3056076 L15.7323885,13.3056076 L15.7109041,13.3309983 C15.6848625,13.3726649 15.6379875,13.3934983 15.5702791,13.3934983 C15.5338208,13.3934983 15.4999666,13.3856858 15.4687166,13.3700608 L15.4687166,13.3700608 L15.1405916,13.1200608 L15.1015291,13.0836024 C15.0806958,13.0558246 15.0702791,13.0211024 15.0702791,12.9794358 C15.0702791,12.9481858 15.0806958,12.9169358 15.1015291,12.8856858 C15.1015291,12.8804774 15.1171541,12.8622483 15.1484041,12.8309983 L15.1484041,12.8309983 L15.7187166,12.3075608 L14.9452791,12.2216233 L14.8827791,12.2059983 L14.8445847,12.1899392 C14.8214365,12.1754716 14.802918,12.1534809 14.7890291,12.123967 C14.7681958,12.0796962 14.7629875,12.0341233 14.7734041,11.9872483 L14.7734041,11.9872483 L14.9062166,11.5888108 L14.9222757,11.5506163 C14.9367433,11.5274682 14.958734,11.5089496 14.9882479,11.4950608 C15.0325187,11.4742274 15.0754875,11.4690191 15.1171541,11.4794358 L15.1171541,11.4794358 L15.1796541,11.5106858 L15.8515291,11.8856858 L15.7030916,11.1278733 L15.6952791,11.0653733 L15.7009215,11.0245746 C15.7084446,10.9979543 15.7234909,10.9724913 15.7460604,10.9481858 C15.7799146,10.9117274 15.8202791,10.8934983 15.8671541,10.8934983 L15.8671541,10.8934983 L16.2890291,10.8934983 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  circularkey: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Access ID</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-393.000000, -460.000000)">
          <g id="Access" transform="translate(393.000000, 460.000000)">
            <rect
              id="Rectangle-Copy-116"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-115"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15.5669873,4.82179677 C15.7050585,4.58265046 16.0108537,4.50071288 16.25,4.63878407 C20.3154873,6.98599425 21.7084261,12.1845127 19.3612159,16.25 C17.0140057,20.3154873 11.8154873,21.7084261 7.75,19.3612159 C3.6845127,17.0140057 2.29157388,11.8154873 4.63878407,7.75 C5.38646387,6.45498059 6.44177027,5.40128457 7.70545976,4.66308415 C7.94389959,4.52379646 8.25010824,4.60417516 8.38939593,4.84261499 C8.52868361,5.08105482 8.44830492,5.38726347 8.20986509,5.52655115 C7.09528145,6.17764947 6.16500699,7.10650436 5.50480947,8.25 C3.43374166,11.8371947 4.66280532,16.4241227 8.25,18.4951905 C11.8371947,20.5662583 16.4241227,19.3371947 18.4951905,15.75 C20.5662583,12.1628053 19.3371947,7.57587728 15.75,5.50480947 C15.5108537,5.36673828 15.4289161,5.06094308 15.5669873,4.82179677 Z M12,5.5 C13.3807119,5.5 14.5,6.61928813 14.5,8 C14.5,9.20932545 13.6413382,10.2180997 12.5004345,10.4499027 L12.4995807,11.4997133 L13,11.5 L13.0898756,11.5080557 C13.3231248,11.5503916 13.5,11.7545401 13.5,12 C13.5,12.2761424 13.2761424,12.5 13,12.5 L13,12.5 L12.4995807,12.4997133 L12.4995807,13.4997133 L14,13.5 L14.0898756,13.5080557 C14.3231248,13.5503916 14.5,13.7545401 14.5,14 C14.5,14.2761424 14.2761424,14.5 14,14.5 L14,14.5 L12.4995807,14.4997133 L12.5,15 L12.4919443,15.0898756 C12.4496084,15.3231248 12.2454599,15.5 12,15.5 C11.7238576,15.5 11.5,15.2761424 11.5,15 L11.5,15 L11.5,10 L11.5080557,9.91012437 C11.5503916,9.67687516 11.7545401,9.5 12,9.5 L12,9.5 C12.8284271,9.5 13.5,8.82842712 13.5,8 C13.5,7.17157288 12.8284271,6.5 12,6.5 C11.4723894,6.5 10.9926386,6.77413135 10.7210924,7.21562564 C10.5771837,7.44960014 10.5,7.71850629 10.5,8 C10.5,8.31612045 10.5974542,8.61628399 10.7764619,8.86800579 C10.9364962,9.09304716 10.8837976,9.4052127 10.6587562,9.56524705 C10.4337149,9.7252814 10.1215493,9.6725828 9.96151497,9.44754143 C9.6631005,9.02790902 9.5,8.52555165 9.5,8 C9.5,7.53219189 9.6291723,7.08215865 9.86931129,6.69172782 C10.3209908,5.95736313 11.1214113,5.5 12,5.5 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  recalculateSOD: () => (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Recalculate SOD</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-393.000000, -720.000000)">
          <g id="Refresh" transform="translate(393.000000, 720.000000)">
            <rect
              id="Rectangle-Copy-23"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-22"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M17.2348554,8.62474855 C17.3670933,8.46180694 17.5910902,8.39622628 17.7943524,8.47040836 L17.7943524,8.47040836 L19.9063954,9.24121424 L19.9880623,9.27959456 C20.1926608,9.39933162 20.2888263,9.65174722 20.204673,9.88233081 C20.1100007,10.1417374 19.822963,10.2752808 19.5635565,10.1806084 L19.5635565,10.1806084 L18.5322789,9.80338018 C18.7802736,10.5215382 18.9087752,11.280791 18.9087752,12.0574215 C18.9087752,15.8700705 15.8180125,18.9608332 12.0053635,18.9608332 C10.2530493,18.9608332 8.60192016,18.3046951 7.33719388,17.1432634 C7.13380263,16.9564838 7.12033622,16.6401878 7.30711581,16.4367966 C7.49389539,16.2334053 7.81019134,16.2199389 8.01358259,16.4067185 C9.09556496,17.4003317 10.5060309,17.9608332 12.0053635,17.9608332 C15.2657278,17.9608332 17.9087752,15.3177857 17.9087752,12.0574215 C17.9087752,11.375212 17.7931981,10.7098125 17.5703464,10.082086 L16.9564287,11.2033247 L16.9062748,11.2783388 C16.7573065,11.4627459 16.4933541,11.5201096 16.2779361,11.4024422 C16.0355907,11.2700665 15.9464428,10.966295 16.0788185,10.7239496 L16.0788185,10.7239496 L17.1841279,8.70041792 Z M11.9517101,5.02870005 C13.7040243,5.02870005 15.3551535,5.68483809 16.6198798,6.84626985 C16.823271,7.03304943 16.8367374,7.34934538 16.6499578,7.55273662 C16.4631782,7.75612787 16.1468823,7.76959428 15.943491,7.5828147 C14.8615087,6.58920153 13.4510428,6.02870005 11.9517101,6.02870005 C8.69134585,6.02870005 6.0482984,8.6717475 6.0482984,11.9321118 C6.0482984,12.6811324 6.18762174,13.4098892 6.45527993,14.09077 L6.97845388,12.9711854 C7.09493854,12.7208138 7.39233429,12.612277 7.64270589,12.7287616 C7.86525842,12.8323035 7.97574395,13.0787876 7.91573783,13.3081275 L7.88512963,13.3930136 L6.93673179,15.4314956 C6.84545832,15.6276784 6.64069607,15.7396956 6.43197266,15.7179848 L6.34259657,15.7003482 L4.13017182,15.051067 C3.86520398,14.9733067 3.71344222,14.6954707 3.79120244,14.4305029 C3.86032265,14.1949759 4.08752741,14.0488957 4.3232594,14.0739547 L4.41176651,14.0915335 L5.50883876,14.4127 L5.47166413,14.3175313 C5.19300887,13.5608565 5.0482984,12.756269 5.0482984,11.9321118 C5.0482984,8.11946275 8.13906111,5.02870005 11.9517101,5.02870005 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherrole: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Roles' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-496.000000, -208.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(496.000000, 208.000000)">
            <path d="M19.9990874,11.5539282 C20.2750355,11.5642859 20.490339,11.7963826 20.4799813,12.0723306 C20.3710598,14.9742061 18.7968391,17.6429738 16.2346271,19.1222676 C15.9954808,19.2603387 15.6896856,19.1784012 15.5516144,18.9392549 C15.4359463,18.7389118 15.4746831,18.4917938 15.6309023,18.3356975 C15.5499189,18.249142 15.5,18.1304006 15.5,18 L15.5,18 L15.5,17 L15.4931334,16.85554 C15.4204487,16.0948881 14.7796961,15.5 14,15.5 L14,15.5 L10,15.5 L9.85553999,15.5068666 C9.09488808,15.5795513 8.5,16.2203039 8.5,17 L8.5,17 L8.5,18 L8.49194433,18.0898756 C8.47702894,18.1720517 8.44202897,18.3092918 8.3922139,18.4525967 C8.46230644,18.5961136 8.46053219,18.7703458 8.37402303,18.9184366 C8.23473534,19.1568765 7.92852669,19.2372552 7.69008686,19.0979675 C6.42639737,18.3597671 5.37109098,17.306071 4.62341117,16.0110516 C4.00782902,14.9448321 3.63737835,13.7787285 3.52211042,12.5789903 C3.49570095,12.3041137 3.69712336,12.059873 3.97199997,12.0334636 C4.24687658,12.0070541 4.49111721,12.2084765 4.51752668,12.4833531 C4.61917158,13.5412994 4.94579018,14.5694285 5.48943657,15.5110516 C6.00718837,16.407824 6.69104527,17.1725862 7.49963901,17.7748956 L7.5,17 L7.50531768,16.8356243 C7.58996133,15.5315359 8.6745166,14.5 10,14.5 L10,14.5 L14,14.5 L14.1643757,14.5053177 C15.4684641,14.5899613 16.5,15.6745166 16.5,17 L16.5,17 L16.5014036,17.7490779 C18.3069874,16.3895755 19.3959312,14.2928247 19.480685,12.0348222 C19.4910427,11.7588741 19.7231394,11.5435706 19.9990874,11.5539282 Z M12,9 C13.1045695,9 14,9.8954305 14,11 C14,12.1045695 13.1045695,13 12,13 C10.8954305,13 10,12.1045695 10,11 C10,9.8954305 10.8954305,9 12,9 Z M12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 Z M6,6 L9,11 L3,11 L6,6 Z M20,7 L20,11 L16,11 L16,7 L20,7 Z M6,7.943 L4.765,10 L7.234,10 L6,7.943 Z M19,8 L17,8 L17,10 L19,10 L19,8 Z M7.99835548,4.25367376 C10.4764939,2.93656905 13.4104729,2.936897 15.8747243,4.20237572 C16.1203694,4.32852298 16.2172415,4.62992018 16.0910942,4.87556521 C15.964947,5.12121024 15.6635498,5.21808232 15.4179047,5.09193507 C13.1647831,3.93487885 10.4689758,3.97585925 8.2346271,5.2658611 L8.2346271,5.2658611 L8.1321902,5.31606776 C7.90927281,5.3967236 7.653746,5.3091595 7.53034762,5.0969723 C7.39153806,4.85825383 7.47252204,4.5522047 7.71123681,4.41338874 L7.71123681,4.41338874 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  appswitcherattestation: ({ intl }) => (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Certification' })}</title>

      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-639.000000, -857.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(639.000000, 857.000000)">
            <path d="M15.7828771,13.9808266 L18.2577509,15.0059528 L19.2828771,17.4808266 L18.2577509,19.9557003 L15.7828771,20.9808266 L13.3080034,19.9557003 L12.2828771,17.4808266 L13.3080034,15.0059528 L15.7828771,13.9808266 Z M17,3.5 C18.3254834,3.5 19.4100387,4.53153594 19.4946823,5.83562431 L19.5,6 L19.5,13.5 C19.5,13.7761424 19.2761424,14 19,14 C18.7545401,14 18.5503916,13.8231248 18.5080557,13.5898756 L18.5,13.5 L18.5,6 C18.5,5.22030388 17.9051119,4.57955132 17.14446,4.50686658 L17,4.5 L5.5,4.5 L5.5,18 C5.5,18.7796961 6.09488808,19.4204487 6.85553999,19.4931334 L7,19.5 L11,19.5 C11.2761424,19.5 11.5,19.7238576 11.5,20 C11.5,20.2454599 11.3231248,20.4496084 11.0898756,20.4919443 L11,20.5 L7,20.5 C5.6745166,20.5 4.58996133,19.4684641 4.50531768,18.1643757 L4.5,18 L4.5,3.5 L17,3.5 Z M15.783,15.062 L14.073,15.771 L13.364,17.481 L14.072,19.189 L15.783,19.898 L17.492,19.19 L18.2,17.481 L17.491,15.77 L15.783,15.062 Z M16.9969945,16.3459611 C17.1852698,16.5034508 17.2283729,16.7701032 17.1111907,16.9761757 L17.0597045,17.0502817 L15.7213266,18.6502817 C15.5594486,18.8438031 15.2834007,18.8831866 15.0762854,18.755745 L15.002206,18.7001098 L14.3405839,18.1010167 C14.1358888,17.915667 14.1202062,17.5994732 14.3055559,17.394778 C14.4703112,17.2128268 14.7384495,17.1802188 14.9397657,17.3053959 L15.0117946,17.35975 L15.288,17.609 L16.2926739,16.4086711 C16.4698498,16.1968615 16.7851849,16.1687853 16.9969945,16.3459611 Z M12,13 C12.2761424,13 12.5,13.2238576 12.5,13.5 C12.5,13.7454599 12.3231248,13.9496084 12.0898756,13.9919443 L12,14 L8,14 C7.72385763,14 7.5,13.7761424 7.5,13.5 C7.5,13.2545401 7.67687516,13.0503916 7.91012437,13.0080557 L8,13 L12,13 Z M14,10 C14.2761424,10 14.5,10.2238576 14.5,10.5 C14.5,10.7454599 14.3231248,10.9496084 14.0898756,10.9919443 L14,11 L8,11 C7.72385763,11 7.5,10.7761424 7.5,10.5 C7.5,10.2545401 7.67687516,10.0503916 7.91012437,10.0080557 L8,10 L14,10 Z M10,7 C10.2761424,7 10.5,7.22385763 10.5,7.5 C10.5,7.74545989 10.3231248,7.94960837 10.0898756,7.99194433 L10,8 L8,8 C7.72385763,8 7.5,7.77614237 7.5,7.5 C7.5,7.25454011 7.67687516,7.05039163 7.91012437,7.00805567 L8,7 L10,7 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  requestEmergencyID: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestEmergencyID.RequestableID' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-346.000000, -190.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Requestable-ID" transform="translate(346.000000, 190.000000)">
            <path
              d="M18,9.5 C19.3807119,9.5 20.5,10.6192881 20.5,12 L20.5,16 C20.5,17.3807119 19.3807119,18.5 18,18.5 L6,18.5 C4.61928813,18.5 3.5,17.3807119 3.5,16 L3.5,12 C3.5,10.6192881 4.61928813,9.5 6,9.5 L18,9.5 Z M18,10.5 L6,10.5 C5.17157288,10.5 4.5,11.1715729 4.5,12 L4.5,16 C4.5,16.8284271 5.17157288,17.5 6,17.5 L18,17.5 C18.8284271,17.5 19.5,16.8284271 19.5,16 L19.5,12 C19.5,11.1715729 18.8284271,10.5 18,10.5 Z M8,11.5 C9.38071187,11.5 10.5,12.6192881 10.5,14 C10.5,15.3807119 9.38071187,16.5 8,16.5 C6.61928813,16.5 5.5,15.3807119 5.5,14 C5.5,12.6192881 6.61928813,11.5 8,11.5 Z M15,14.5 L15,15.5 L12,15.5 L12,14.5 L15,14.5 Z M8,12.5 C7.17157288,12.5 6.5,13.1715729 6.5,14 C6.5,14.8284271 7.17157288,15.5 8,15.5 C8.82842712,15.5 9.5,14.8284271 9.5,14 C9.5,13.1715729 8.82842712,12.5 8,12.5 Z M17,12.5 L17,13.5 L12,13.5 L12,12.5 L17,12.5 Z M17,5.5 C17.7796961,5.5 18.4204487,6.09488808 18.4931334,6.85553999 L18.5,7 L18.5,9 L17.5,9 L17.5,7 C17.5,6.75454011 17.3231248,6.55039163 17.0898756,6.50805567 L17,6.5 L7,6.5 C6.75454011,6.5 6.55039163,6.67687516 6.50805567,6.91012437 L6.5,7 L6.5,9 L5.5,9 L5.5,7 C5.5,6.22030388 6.09488808,5.57955132 6.85553999,5.50686658 L7,5.5 L17,5.5 Z M8.90831873,7.22915659 C9.68801485,7.22915659 10.3287674,7.82404468 10.4014521,8.58469658 L10.4083187,8.72915659 L9.40831873,8.72915659 C9.40831873,8.45301422 9.1844611,8.22915659 8.90831873,8.22915659 C8.66285884,8.22915659 8.45871036,8.40603175 8.4163744,8.63928096 L8.40831873,8.72915659 L7.40831873,8.72915659 C7.40831873,7.90072947 8.0798916,7.22915659 8.90831873,7.22915659 Z M16,7.5 L16,8.5 L12,8.5 L12,7.5 L16,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  requestEmergencyRoles: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestableID' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-346.000000, -190.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Requestable-ID" transform="translate(346.000000, 190.000000)">
            <path
              d="M18,9.5 C19.3807119,9.5 20.5,10.6192881 20.5,12 L20.5,16 C20.5,17.3807119 19.3807119,18.5 18,18.5 L6,18.5 C4.61928813,18.5 3.5,17.3807119 3.5,16 L3.5,12 C3.5,10.6192881 4.61928813,9.5 6,9.5 L18,9.5 Z M18,10.5 L6,10.5 C5.17157288,10.5 4.5,11.1715729 4.5,12 L4.5,16 C4.5,16.8284271 5.17157288,17.5 6,17.5 L18,17.5 C18.8284271,17.5 19.5,16.8284271 19.5,16 L19.5,12 C19.5,11.1715729 18.8284271,10.5 18,10.5 Z M8,11.5 C9.38071187,11.5 10.5,12.6192881 10.5,14 C10.5,15.3807119 9.38071187,16.5 8,16.5 C6.61928813,16.5 5.5,15.3807119 5.5,14 C5.5,12.6192881 6.61928813,11.5 8,11.5 Z M15,14.5 L15,15.5 L12,15.5 L12,14.5 L15,14.5 Z M8,12.5 C7.17157288,12.5 6.5,13.1715729 6.5,14 C6.5,14.8284271 7.17157288,15.5 8,15.5 C8.82842712,15.5 9.5,14.8284271 9.5,14 C9.5,13.1715729 8.82842712,12.5 8,12.5 Z M17,12.5 L17,13.5 L12,13.5 L12,12.5 L17,12.5 Z M17,5.5 C17.7796961,5.5 18.4204487,6.09488808 18.4931334,6.85553999 L18.5,7 L18.5,9 L17.5,9 L17.5,7 C17.5,6.75454011 17.3231248,6.55039163 17.0898756,6.50805567 L17,6.5 L7,6.5 C6.75454011,6.5 6.55039163,6.67687516 6.50805567,6.91012437 L6.5,7 L6.5,9 L5.5,9 L5.5,7 C5.5,6.22030388 6.09488808,5.57955132 6.85553999,5.50686658 L7,5.5 L17,5.5 Z M8.90831873,7.22915659 C9.68801485,7.22915659 10.3287674,7.82404468 10.4014521,8.58469658 L10.4083187,8.72915659 L9.40831873,8.72915659 C9.40831873,8.45301422 9.1844611,8.22915659 8.90831873,8.22915659 C8.66285884,8.22915659 8.45871036,8.40603175 8.4163744,8.63928096 L8.40831873,8.72915659 L7.40831873,8.72915659 C7.40831873,7.90072947 8.0798916,7.22915659 8.90831873,7.22915659 Z M16,7.5 L16,8.5 L12,8.5 L12,7.5 L16,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  oneClickDisableUser: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RemoveAccount' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-393.000000, -506.000000)">
          <g id="Remove-account" transform="translate(393.000000, 506.000000)">
            <rect
              id="Rectangle-Copy-17"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-15"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M18,10 C19.1045695,10 20,10.8954305 20,12 L20,16 C20,17.1045695 19.1045695,18 18,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,12 C4,10.8954305 4.8954305,10 6,10 L18,10 Z M18,11 L6,11 C5.48716416,11 5.06449284,11.3860402 5.00672773,11.8833789 L5,12 L5,16 C5,16.5128358 5.38604019,16.9355072 5.88337887,16.9932723 L6,17 L18,17 C18.5128358,17 18.9355072,16.6139598 18.9932723,16.1166211 L19,16 L19,12 C19,11.4871642 18.6139598,11.0644928 18.1166211,11.0067277 L18,11 Z M7.3601962,12.5191546 L7.42944409,12.5770101 L8.136,13.284 L8.84365765,12.5770101 C9.03891979,12.3817479 9.35550228,12.3817479 9.55076443,12.5770101 C9.72433078,12.7505764 9.74361593,13.0200008 9.60861988,13.214869 L9.55076443,13.2841169 L8.843,13.991 L9.55076443,14.6983304 C9.74602658,14.8935926 9.74602658,15.2101751 9.55076443,15.4054372 C9.37719808,15.5790036 9.10777368,15.5982887 8.91290554,15.4632927 L8.84365765,15.4054372 L8.136,14.698 L7.42944409,15.4054372 C7.23418194,15.6006994 6.91759945,15.6006994 6.72233731,15.4054372 C6.54877095,15.2318709 6.5294858,14.9624465 6.66448185,14.7675783 L6.72233731,14.6983304 L7.429,13.991 L6.72233731,13.2841169 C6.52707516,13.0888547 6.52707516,12.7722722 6.72233731,12.5770101 C6.89590366,12.4034437 7.16532806,12.3841586 7.3601962,12.5191546 Z M14.4939328,14.5 C14.7700751,14.5 14.9939328,14.7238576 14.9939328,15 C14.9939328,15.2454599 14.8170576,15.4496084 14.5838084,15.4919443 L14.4939328,15.5 L11.4943897,15.5 C11.2182473,15.5 10.9943897,15.2761424 10.9943897,15 C10.9943897,14.7545401 11.1712648,14.5503916 11.4045141,14.5080557 L11.4943897,14.5 L14.4939328,14.5 Z M16.528533,12.5 C16.8046753,12.5 17.028533,12.7238576 17.028533,13 C17.028533,13.2454599 16.8516578,13.4496084 16.6184086,13.4919443 L16.528533,13.5 L11.5292945,13.5 C11.2531521,13.5 11.0292945,13.2761424 11.0292945,13 C11.0292945,12.7545401 11.2061697,12.5503916 11.4394189,12.5080557 L11.5292945,12.5 L16.528533,12.5 Z M17,5.5 L17.14446,5.50686658 C17.9051119,5.57955132 18.5,6.22030388 18.5,7 L18.5,7 L18.5,9 L18.4919443,9.08987563 C18.4496084,9.32312484 18.2454599,9.5 18,9.5 C17.7238576,9.5 17.5,9.27614237 17.5,9 L17.5,9 L17.5,7 L17.4919443,6.91012437 C17.4496084,6.67687516 17.2454599,6.5 17,6.5 L17,6.5 L7,6.5 L6.91012437,6.50805567 C6.67687516,6.55039163 6.5,6.75454011 6.5,7 L6.5,7 L6.5,9 L6.49194433,9.08987563 C6.44960837,9.32312484 6.24545989,9.5 6,9.5 C5.72385763,9.5 5.5,9.27614237 5.5,9 L5.5,9 L5.5,7 L5.50686658,6.85553999 C5.57955132,6.09488808 6.22030388,5.5 7,5.5 L7,5.5 L17,5.5 Z M9,7.5 C9.77969612,7.5 10.4204487,8.09488808 10.4931334,8.85553999 L10.5,9 L9.5,9 C9.5,8.72385763 9.27614237,8.5 9,8.5 C8.75454011,8.5 8.55039163,8.67687516 8.50805567,8.91012437 L8.5,9 L7.5,9 C7.5,8.17157288 8.17157288,7.5 9,7.5 Z M16,8 C16.2761424,8 16.5,8.22385763 16.5,8.5 C16.5,8.74545989 16.3231248,8.94960837 16.0898756,8.99194433 L16,9 L12,9 C11.7238576,9 11.5,8.77614237 11.5,8.5 C11.5,8.25454011 11.6768752,8.05039163 11.9101244,8.00805567 L12,8 L16,8 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  registerUser: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Admin' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-210.000000, -332.000000)" fill="#000000">
          <g id="Admin" transform="translate(210.000000, 332.000000)">
            <g transform="translate(6.000000, 5.000000)" id="Combined-Shape">
              <path
                d="M10.204087,7.06556984 C10.9875505,7.06556984 11.5374203,7.85738243 11.5374203,8.76556984 L11.5374203,13.5655698 C11.5374203,13.8417122 11.3135627,14.0655698 11.0374203,14.0655698 C10.761278,14.0655698 10.5374203,13.8417122 10.5374203,13.5655698 L10.5374203,8.76556984 C10.5374203,8.34827385 10.3410981,8.06556984 10.204087,8.06556984 L1.87075367,8.06556984 C1.73374256,8.06556984 1.53742033,8.34827385 1.53742033,8.76556984 L1.53742033,13.5655698 C1.53742033,13.8417122 1.31356271,14.0655698 1.03742033,14.0655698 C0.761277957,14.0655698 0.537420332,13.8417122 0.537420332,13.5655698 L0.537420332,8.76556984 C0.537420332,7.85738243 1.08729019,7.06556984 1.87075367,7.06556984 L10.204087,7.06556984 Z M6.11110045,0.92140829 C7.49181232,0.92140829 8.61110045,2.04069642 8.61110045,3.42140829 C8.61110045,4.80212016 7.49181232,5.92140829 6.11110045,5.92140829 C4.73038857,5.92140829 3.61110045,4.80212016 3.61110045,3.42140829 C3.61110045,2.04069642 4.73038857,0.92140829 6.11110045,0.92140829 Z M6.11110045,1.92140829 C5.28267332,1.92140829 4.61110045,2.59298117 4.61110045,3.42140829 C4.61110045,4.24983542 5.28267332,4.92140829 6.11110045,4.92140829 C6.93952757,4.92140829 7.61110045,4.24983542 7.61110045,3.42140829 C7.61110045,2.59298117 6.93952757,1.92140829 6.11110045,1.92140829 Z"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  updateUserDetails: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.UpdateUserDetails' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-259.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Role" transform="translate(259.000000, 250.000000)">
            <path
              d="M15.3333333,10.5 C16.0305346,10.5 16.5,11.2041982 16.5,12 L16.5,17 C16.5,17.2761424 16.2761424,17.5 16,17.5 C15.7238576,17.5 15.5,17.2761424 15.5,17 L15.5,12 C15.5,11.6912323 15.3725118,11.5 15.3333333,11.5 L8.66666667,11.5 C8.62748823,11.5 8.5,11.6912323 8.5,12 L8.5,17 C8.5,17.2761424 8.27614237,17.5 8,17.5 C7.72385763,17.5 7.5,17.2761424 7.5,17 L7.5,12 C7.5,11.2041982 7.96946544,10.5 8.66666667,10.5 L15.3333333,10.5 Z M18.1666667,11.5 C18.8638679,11.5 19.3333333,12.2041982 19.3333333,13 L19.3333333,17 C19.3333333,17.2761424 19.1094757,17.5 18.8333333,17.5 C18.557191,17.5 18.3333333,17.2761424 18.3333333,17 L18.3333333,13 C18.3333333,12.6912323 18.2058451,12.5 18.1666667,12.5 C17.8905243,12.5 17.6666667,12.2761424 17.6666667,12 C17.6666667,11.7238576 17.8905243,11.5 18.1666667,11.5 Z M5.83333333,11.5 C6.10947571,11.5 6.33333333,11.7238576 6.33333333,12 C6.33333333,12.2761424 6.10947571,12.5 5.83333333,12.5 C5.79415489,12.5 5.66666667,12.6912323 5.66666667,13 L5.66666667,13 L5.66666667,17 C5.66666667,17.2761424 5.44280904,17.5 5.16666667,17.5 C4.89052429,17.5 4.66666667,17.2761424 4.66666667,17 L4.66666667,17 L4.66666667,13 C4.66666667,12.2041982 5.13613211,11.5 5.83333333,11.5 Z M17,8 C17.5522847,8 18,8.44771525 18,9 C18,9.55228475 17.5522847,10 17,10 C16.4477153,10 16,9.55228475 16,9 C16,8.44771525 16.4477153,8 17,8 Z M7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z M12,6 C11.4477153,6 11,6.44771525 11,7 C11,7.55228475 11.4477153,8 12,8 C12.5522847,8 13,7.55228475 13,7 C13,6.44771525 12.5522847,6 12,6 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createUserRequest: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateUserRequest' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  updateUserRequest: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.UpdateUserRequest' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewEntitlement: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateNewEntitlement' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  updateExistingEntitlement: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.UpdateExistingEntitlement' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewET: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateNewET' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  updateET: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.UpdateET' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewEP: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateNewEP' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  updateEP: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.UpdateEP' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewRole: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Organization</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  manageRoles: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.ManageRoles' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewADGroup: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateNewADGroup' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewAADGroup: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Organization</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewUNIXGroup: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Organization</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  manageADGroup: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.MyApplication.ManageADGroup' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -711.000000)">
          <g id="My-Applications" transform="translate(560.000000, 711.000000)">
            <g id="Group-6">
              <rect
                id="Rectangle-Copy-14"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <g
                id="Group-9"
                transform="translate(4.000000, 4.000000)"
                fill="#000000"
                fillRule="nonzero"
              >
                <path
                  d="M14,4 C15.1045695,4 16,4.82081129 16,5.83333333 L16,13.1666667 C16,14.1791887 15.1045695,15 14,15 L2,15 C0.8954305,15 0,14.1791887 0,13.1666667 L0,5.83333333 C0,4.82081129 0.8954305,4 2,4 L14,4 Z M14,5 L2,5 C1.44771525,5 1,5.40294373 1,5.9 L1,13.1 C1,13.5970563 1.44771525,14 2,14 L14,14 C14.5522847,14 15,13.5970563 15,13.1 L15,5.9 C15,5.40294373 14.5522847,5 14,5 Z M2.5,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.74545989 13.8231248,2.94960837 13.5898756,2.99194433 L13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.25454011 2.17687516,2.05039163 2.41012437,2.00805567 L2.5,2 L13.5,2 Z M11.4285714,0 C11.7441627,0 12,0.223857625 12,0.5 C12,0.776142375 11.7441627,1 11.4285714,1 L11.4285714,1 L4.57142857,1 C4.25583729,1 4,0.776142375 4,0.5 C4,0.223857625 4.25583729,0 4.57142857,0 L4.57142857,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  manageAADGroup: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.MyApplication.ManageAADGroup' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -711.000000)">
          <g id="My-Applications" transform="translate(560.000000, 711.000000)">
            <g id="Group-6">
              <rect
                id="Rectangle-Copy-14"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <g
                id="Group-9"
                transform="translate(4.000000, 4.000000)"
                fill="#000000"
                fillRule="nonzero"
              >
                <path
                  d="M14,4 C15.1045695,4 16,4.82081129 16,5.83333333 L16,13.1666667 C16,14.1791887 15.1045695,15 14,15 L2,15 C0.8954305,15 0,14.1791887 0,13.1666667 L0,5.83333333 C0,4.82081129 0.8954305,4 2,4 L14,4 Z M14,5 L2,5 C1.44771525,5 1,5.40294373 1,5.9 L1,13.1 C1,13.5970563 1.44771525,14 2,14 L14,14 C14.5522847,14 15,13.5970563 15,13.1 L15,5.9 C15,5.40294373 14.5522847,5 14,5 Z M2.5,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.74545989 13.8231248,2.94960837 13.5898756,2.99194433 L13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.25454011 2.17687516,2.05039163 2.41012437,2.00805567 L2.5,2 L13.5,2 Z M11.4285714,0 C11.7441627,0 12,0.223857625 12,0.5 C12,0.776142375 11.7441627,1 11.4285714,1 L11.4285714,1 L4.57142857,1 C4.25583729,1 4,0.776142375 4,0.5 C4,0.223857625 4.25583729,0 4.57142857,0 L4.57142857,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  manageUNIXGroup: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.MyApplication.UnixGroup' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -711.000000)">
          <g id="My-Applications" transform="translate(560.000000, 711.000000)">
            <g id="Group-6">
              <rect
                id="Rectangle-Copy-14"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <g
                id="Group-9"
                transform="translate(4.000000, 4.000000)"
                fill="#000000"
                fillRule="nonzero"
              >
                <path
                  d="M14,4 C15.1045695,4 16,4.82081129 16,5.83333333 L16,13.1666667 C16,14.1791887 15.1045695,15 14,15 L2,15 C0.8954305,15 0,14.1791887 0,13.1666667 L0,5.83333333 C0,4.82081129 0.8954305,4 2,4 L14,4 Z M14,5 L2,5 C1.44771525,5 1,5.40294373 1,5.9 L1,13.1 C1,13.5970563 1.44771525,14 2,14 L14,14 C14.5522847,14 15,13.5970563 15,13.1 L15,5.9 C15,5.40294373 14.5522847,5 14,5 Z M2.5,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.74545989 13.8231248,2.94960837 13.5898756,2.99194433 L13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.25454011 2.17687516,2.05039163 2.41012437,2.00805567 L2.5,2 L13.5,2 Z M11.4285714,0 C11.7441627,0 12,0.223857625 12,0.5 C12,0.776142375 11.7441627,1 11.4285714,1 L11.4285714,1 L4.57142857,1 C4.25583729,1 4,0.776142375 4,0.5 C4,0.223857625 4.25583729,0 4.57142857,0 L4.57142857,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  createNewOrg: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.CreateNewOrg' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  updateOrg: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.MyApplication.UpdateOrg' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Desktop" transform="translate(-560.000000, -711.000000)">
          <g id="My-Applications" transform="translate(560.000000, 711.000000)">
            <g id="Group-6">
              <rect
                id="Rectangle-Copy-14"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-2"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <g
                id="Group-9"
                transform="translate(4.000000, 4.000000)"
                fill="#000000"
                fillRule="nonzero"
              >
                <path
                  d="M14,4 C15.1045695,4 16,4.82081129 16,5.83333333 L16,13.1666667 C16,14.1791887 15.1045695,15 14,15 L2,15 C0.8954305,15 0,14.1791887 0,13.1666667 L0,5.83333333 C0,4.82081129 0.8954305,4 2,4 L14,4 Z M14,5 L2,5 C1.44771525,5 1,5.40294373 1,5.9 L1,13.1 C1,13.5970563 1.44771525,14 2,14 L14,14 C14.5522847,14 15,13.5970563 15,13.1 L15,5.9 C15,5.40294373 14.5522847,5 14,5 Z M2.5,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.74545989 13.8231248,2.94960837 13.5898756,2.99194433 L13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.25454011 2.17687516,2.05039163 2.41012437,2.00805567 L2.5,2 L13.5,2 Z M11.4285714,0 C11.7441627,0 12,0.223857625 12,0.5 C12,0.776142375 11.7441627,1 11.4285714,1 L11.4285714,1 L4.57142857,1 C4.25583729,1 4,0.776142375 4,0.5 C4,0.223857625 4.25583729,0 4.57142857,0 L4.57142857,0 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  requestAccessForOthersMulti: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.RequestAccessForOthersMulti' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  manageDelegates: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Delegation</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-67.000000, -506.000000)">
          <g id="Delegation" transform="translate(67.000000, 506.000000)">
            <rect
              id="Rectangle-Copy-222"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-221"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M12,16 C13.1045695,16 14,16.8954305 14,18 C14,19.1045695 13.1045695,20 12,20 C10.8954305,20 10,19.1045695 10,18 C10,16.8954305 10.8954305,16 12,16 Z M18,16 C19.1045695,16 20,16.8954305 20,18 C20,19.1045695 19.1045695,20 18,20 C16.8954305,20 16,19.1045695 16,18 C16,16.8954305 16.8954305,16 18,16 Z M6,16 C7.1045695,16 8,16.8954305 8,18 C8,19.1045695 7.1045695,20 6,20 C4.8954305,20 4,19.1045695 4,18 C4,16.8954305 4.8954305,16 6,16 Z M12,17 C11.4477153,17 11,17.4477153 11,18 C11,18.5522847 11.4477153,19 12,19 C12.5522847,19 13,18.5522847 13,18 C13,17.4477153 12.5522847,17 12,17 Z M18,17 C17.4477153,17 17,17.4477153 17,18 C17,18.5522847 17.4477153,19 18,19 C18.5522847,19 19,18.5522847 19,18 C19,17.4477153 18.5522847,17 18,17 Z M6,17 C5.44771525,17 5,17.4477153 5,18 C5,18.5522847 5.44771525,19 6,19 C6.55228475,19 7,18.5522847 7,18 C7,17.4477153 6.55228475,17 6,17 Z M12,3 C13.6568542,3 15,4.34314575 15,6 C15,7.48763919 13.9171963,8.722376 12.496732,8.95906718 L12.5,9 L12.5,10.5 L17.3333333,10.5 L17.4562798,10.5069107 C18.0604451,10.5754069 18.5,11.1438802 18.5,11.8 L18.5,11.8 L18.5,15 L18.4919443,15.0898756 C18.4496084,15.3231248 18.2454599,15.5 18,15.5 C17.7238576,15.5 17.5,15.2761424 17.5,15 L17.5,15 L17.5,11.8 L17.4925035,11.7139602 C17.468471,11.5806983 17.391524,11.5 17.3333333,11.5 L17.3333333,11.5 L12.5,11.5 L12.5,15 C12.5,15.2761424 12.2761424,15.5 12,15.5 C11.7545401,15.5 11.5503916,15.3231248 11.5080557,15.0898756 L11.5,15 L11.5,11.5 L6.66666667,11.5 L6.63007489,11.5094587 C6.56724855,11.5406126 6.5,11.6468379 6.5,11.8 L6.5,11.8 L6.5,15 L6.49194433,15.0898756 C6.44960837,15.3231248 6.24545989,15.5 6,15.5 C5.72385763,15.5 5.5,15.2761424 5.5,15 L5.5,15 L5.5,11.8 L5.50577927,11.6700668 C5.56316461,11.0274658 6.04177519,10.5 6.66666667,10.5 L6.66666667,10.5 L11.5,10.5 L11.5,9 L11.5042593,8.95923219 C10.0833076,8.72295042 9,7.48798523 9,6 C9,4.34314575 10.3431458,3 12,3 Z M12,4 C10.8954305,4 10,4.8954305 10,6 C10,7.1045695 10.8954305,8 12,8 C13.1045695,8 14,7.1045695 14,6 C14,4.8954305 13.1045695,4 12,4 Z M12,5 L12.2938926,5.5954915 L12.9510565,5.69098301 L12.4755283,6.1545085 L12.5877853,6.80901699 L12,6.5 L11.4122147,6.80901699 L11.5244717,6.1545085 L11.0489435,5.69098301 L11.7061074,5.5954915 L12,5 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  changePassword: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Password</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-257.000000, -552.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Password" transform="translate(257.000000, 552.000000)">
            <path
              d="M11.6582103,3.63506195 C11.8571453,3.44874552 12.1686528,3.45608348 12.3585943,3.65156039 C13.3887367,4.71172454 14.4870016,5.42895872 15.6552009,5.81041156 C16.7995704,6.18408324 17.8498269,6.18408324 18.8239944,5.81771639 C19.150942,5.6947573 19.5,5.93640979 19.5,6.28571429 L19.5,6.28571429 L19.5,13.1428571 C19.5,16.8499048 15.7738611,20.4999992 12,20.4999992 C8.94439067,20.4999992 4.5,17.1990713 4.5,13.1428571 L4.5,13.1428571 L4.5,6.28571429 C4.5,5.95394936 4.81719377,5.71418139 5.13637905,5.80467296 C6.29278835,6.13252421 7.35832911,6.13252421 8.34479911,5.81041156 C9.3512609,5.48177097 10.4584914,4.75868164 11.6582103,3.63506195 Z M11.986,4.688 L11.7477208,4.89659199 C10.6678655,5.81717205 9.63869773,6.43987519 8.65520089,6.76101701 C7.74573456,7.05798561 6.78568459,7.12651683 5.78042094,6.96922267 L5.78042094,6.96922267 L5.5,6.919 L5.5,13.1428571 C5.5,16.4968498 9.27353185,19.3724326 11.8313356,19.4958728 L11.8313356,19.4958728 L12,19.5 C15.2261389,19.5 18.5,16.2929523 18.5,13.1428571 L18.5,13.1428571 L18.5,6.955 L18.3960332,6.98071168 C17.5162504,7.16432712 16.5933013,7.11952138 15.6337545,6.84895657 L15.6337545,6.84895657 L15.3447991,6.76101701 C14.2196759,6.39362983 13.1623002,5.75961987 12.1737699,4.86331795 L12.1737699,4.86331795 L11.986,4.688 Z M8.28902914,10.8934983 L8.333734,10.8995746 C8.36209048,10.9076765 8.38755344,10.9238802 8.41012289,10.9481858 C8.44397705,10.9846441 8.46090414,11.0237066 8.46090414,11.0653733 L8.46090414,11.0653733 L8.45309164,11.1278733 L8.28902914,11.8934983 L8.97652914,11.5106858 L9.03902914,11.4794358 L9.05660726,11.4735764 L9.05660726,11.4735764 L9.07809164,11.4716233 C9.1197583,11.4716233 9.15751872,11.4820399 9.19137289,11.5028733 C9.22522705,11.5237066 9.2447583,11.5523524 9.24996664,11.5888108 L9.24996664,11.5888108 L9.38277914,11.9872483 L9.39059164,12.0341233 L9.38668539,12.0701476 C9.38147705,12.0938744 9.37106039,12.1170226 9.35543539,12.139592 C9.33199789,12.1734462 9.30465414,12.1955816 9.27340414,12.2059983 L9.27340414,12.2059983 L9.21090414,12.2216233 L8.42965414,12.3153733 L9.00777914,12.8309983 L9.0338208,12.857908 C9.04770969,12.8729543 9.05465414,12.8822135 9.05465414,12.8856858 C9.07548747,12.9169358 9.08590414,12.9481858 9.08590414,12.9794358 C9.08590414,13.0419358 9.06246664,13.0888108 9.01559164,13.1200608 L9.01559164,13.1200608 L8.67965414,13.3700608 L8.63082601,13.3876389 L8.63082601,13.3876389 L8.57809164,13.3934983 C8.5103833,13.3934983 8.4635083,13.3726649 8.43746664,13.3309983 L8.43746664,13.3309983 L8.40621664,13.2763108 L8.07809164,12.5575608 L7.74996664,13.2763108 L7.73238851,13.3056076 L7.73238851,13.3056076 L7.71090414,13.3309983 C7.68486247,13.3726649 7.63798747,13.3934983 7.57027914,13.3934983 C7.5338208,13.3934983 7.49996664,13.3856858 7.46871664,13.3700608 L7.46871664,13.3700608 L7.14059164,13.1200608 L7.10152914,13.0836024 C7.0806958,13.0558246 7.07027914,13.0211024 7.07027914,12.9794358 C7.07027914,12.9481858 7.0806958,12.9169358 7.10152914,12.8856858 C7.10152914,12.8804774 7.11715414,12.8622483 7.14840414,12.8309983 L7.14840414,12.8309983 L7.71871664,12.3075608 L6.94527914,12.2216233 L6.88277914,12.2059983 L6.84458469,12.1899392 C6.82143655,12.1754716 6.80291803,12.1534809 6.78902914,12.123967 C6.7681958,12.0796962 6.76298747,12.0341233 6.77340414,11.9872483 L6.77340414,11.9872483 L6.90621664,11.5888108 L6.92227567,11.5506163 C6.93674326,11.5274682 6.958734,11.5089496 6.98824789,11.4950608 C7.03251872,11.4742274 7.07548747,11.4690191 7.11715414,11.4794358 L7.11715414,11.4794358 L7.17965414,11.5106858 L7.85152914,11.8856858 L7.70309164,11.1278733 L7.69527914,11.0653733 L7.7009215,11.0245746 C7.70844465,10.9979543 7.72349094,10.9724913 7.74606039,10.9481858 C7.77991455,10.9117274 7.82027914,10.8934983 7.86715414,10.8934983 L7.86715414,10.8934983 L8.28902914,10.8934983 Z M12.2890291,10.8934983 L12.333734,10.8995746 C12.3620905,10.9076765 12.3875534,10.9238802 12.4101229,10.9481858 C12.4439771,10.9846441 12.4609041,11.0237066 12.4609041,11.0653733 L12.4609041,11.0653733 L12.4530916,11.1278733 L12.2890291,11.8934983 L12.9765291,11.5106858 L13.0390291,11.4794358 L13.0566073,11.4735764 L13.0566073,11.4735764 L13.0780916,11.4716233 C13.1197583,11.4716233 13.1575187,11.4820399 13.1913729,11.5028733 C13.2252271,11.5237066 13.2447583,11.5523524 13.2499666,11.5888108 L13.2499666,11.5888108 L13.3827791,11.9872483 L13.3905916,12.0341233 L13.3866854,12.0701476 C13.3814771,12.0938744 13.3710604,12.1170226 13.3554354,12.139592 C13.3319979,12.1734462 13.3046541,12.1955816 13.2734041,12.2059983 L13.2734041,12.2059983 L13.2109041,12.2216233 L12.4296541,12.3153733 L13.0077791,12.8309983 L13.0338208,12.857908 C13.0477097,12.8729543 13.0546541,12.8822135 13.0546541,12.8856858 C13.0754875,12.9169358 13.0859041,12.9481858 13.0859041,12.9794358 C13.0859041,13.0419358 13.0624666,13.0888108 13.0155916,13.1200608 L13.0155916,13.1200608 L12.6796541,13.3700608 L12.630826,13.3876389 L12.630826,13.3876389 L12.5780916,13.3934983 C12.5103833,13.3934983 12.4635083,13.3726649 12.4374666,13.3309983 L12.4374666,13.3309983 L12.4062166,13.2763108 L12.0780916,12.5575608 L11.7499666,13.2763108 L11.7323885,13.3056076 L11.7323885,13.3056076 L11.7109041,13.3309983 C11.6848625,13.3726649 11.6379875,13.3934983 11.5702791,13.3934983 C11.5338208,13.3934983 11.4999666,13.3856858 11.4687166,13.3700608 L11.4687166,13.3700608 L11.1405916,13.1200608 L11.1015291,13.0836024 C11.0806958,13.0558246 11.0702791,13.0211024 11.0702791,12.9794358 C11.0702791,12.9481858 11.0806958,12.9169358 11.1015291,12.8856858 C11.1015291,12.8804774 11.1171541,12.8622483 11.1484041,12.8309983 L11.1484041,12.8309983 L11.7187166,12.3075608 L10.9452791,12.2216233 L10.8827791,12.2059983 L10.8445847,12.1899392 C10.8214365,12.1754716 10.802918,12.1534809 10.7890291,12.123967 C10.7681958,12.0796962 10.7629875,12.0341233 10.7734041,11.9872483 L10.7734041,11.9872483 L10.9062166,11.5888108 L10.9222757,11.5506163 C10.9367433,11.5274682 10.958734,11.5089496 10.9882479,11.4950608 C11.0325187,11.4742274 11.0754875,11.4690191 11.1171541,11.4794358 L11.1171541,11.4794358 L11.1796541,11.5106858 L11.8515291,11.8856858 L11.7030916,11.1278733 L11.6952791,11.0653733 L11.7009215,11.0245746 C11.7084446,10.9979543 11.7234909,10.9724913 11.7460604,10.9481858 C11.7799146,10.9117274 11.8202791,10.8934983 11.8671541,10.8934983 L11.8671541,10.8934983 L12.2890291,10.8934983 Z M16.2890291,10.8934983 L16.333734,10.8995746 C16.3620905,10.9076765 16.3875534,10.9238802 16.4101229,10.9481858 C16.4439771,10.9846441 16.4609041,11.0237066 16.4609041,11.0653733 L16.4609041,11.0653733 L16.4530916,11.1278733 L16.2890291,11.8934983 L16.9765291,11.5106858 L17.0390291,11.4794358 L17.0566073,11.4735764 L17.0566073,11.4735764 L17.0780916,11.4716233 C17.1197583,11.4716233 17.1575187,11.4820399 17.1913729,11.5028733 C17.2252271,11.5237066 17.2447583,11.5523524 17.2499666,11.5888108 L17.2499666,11.5888108 L17.3827791,11.9872483 L17.3905916,12.0341233 L17.3866854,12.0701476 C17.3814771,12.0938744 17.3710604,12.1170226 17.3554354,12.139592 C17.3319979,12.1734462 17.3046541,12.1955816 17.2734041,12.2059983 L17.2734041,12.2059983 L17.2109041,12.2216233 L16.4296541,12.3153733 L17.0077791,12.8309983 L17.0338208,12.857908 C17.0477097,12.8729543 17.0546541,12.8822135 17.0546541,12.8856858 C17.0754875,12.9169358 17.0859041,12.9481858 17.0859041,12.9794358 C17.0859041,13.0419358 17.0624666,13.0888108 17.0155916,13.1200608 L17.0155916,13.1200608 L16.6796541,13.3700608 L16.630826,13.3876389 L16.630826,13.3876389 L16.5780916,13.3934983 C16.5103833,13.3934983 16.4635083,13.3726649 16.4374666,13.3309983 L16.4374666,13.3309983 L16.4062166,13.2763108 L16.0780916,12.5575608 L15.7499666,13.2763108 L15.7323885,13.3056076 L15.7323885,13.3056076 L15.7109041,13.3309983 C15.6848625,13.3726649 15.6379875,13.3934983 15.5702791,13.3934983 C15.5338208,13.3934983 15.4999666,13.3856858 15.4687166,13.3700608 L15.4687166,13.3700608 L15.1405916,13.1200608 L15.1015291,13.0836024 C15.0806958,13.0558246 15.0702791,13.0211024 15.0702791,12.9794358 C15.0702791,12.9481858 15.0806958,12.9169358 15.1015291,12.8856858 C15.1015291,12.8804774 15.1171541,12.8622483 15.1484041,12.8309983 L15.1484041,12.8309983 L15.7187166,12.3075608 L14.9452791,12.2216233 L14.8827791,12.2059983 L14.8445847,12.1899392 C14.8214365,12.1754716 14.802918,12.1534809 14.7890291,12.123967 C14.7681958,12.0796962 14.7629875,12.0341233 14.7734041,11.9872483 L14.7734041,11.9872483 L14.9062166,11.5888108 L14.9222757,11.5506163 C14.9367433,11.5274682 14.958734,11.5089496 14.9882479,11.4950608 C15.0325187,11.4742274 15.0754875,11.4690191 15.1171541,11.4794358 L15.1171541,11.4794358 L15.1796541,11.5106858 L15.8515291,11.8856858 L15.7030916,11.1278733 L15.6952791,11.0653733 L15.7009215,11.0245746 C15.7084446,10.9979543 15.7234909,10.9724913 15.7460604,10.9481858 C15.7799146,10.9117274 15.8202791,10.8934983 15.8671541,10.8934983 L15.8671541,10.8934983 L16.2890291,10.8934983 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  changePasswordForServiceAccounts: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>accounts</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-209.000000, -506.000000)">
          <g id="accounts" transform="translate(209.000000, 506.000000)">
            <rect
              id="Rectangle-Copy-17"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-15"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M19,11 C19.5522847,11 20,11.4477153 20,12 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,12 C4,11.4477153 4.44771525,11 5,11 L19,11 Z M19,12 L5,12 L5,17 L19,17 L19,12 Z M9.5,15 C9.77614237,15 10,15.2238576 10,15.5 C10,15.7454599 9.82312484,15.9496084 9.58987563,15.9919443 L9.5,16 L6.5,16 C6.22385763,16 6,15.7761424 6,15.5 C6,15.2545401 6.17687516,15.0503916 6.41012437,15.0080557 L6.5,15 L9.5,15 Z M17.3535534,12.6464466 C17.5271197,12.820013 17.5464049,13.0894374 17.4114088,13.2843055 L17.3535534,13.3535534 L15,15.7071068 L13.6464466,14.3535534 C13.4511845,14.1582912 13.4511845,13.8417088 13.6464466,13.6464466 C13.820013,13.4728803 14.0894374,13.4535951 14.2843055,13.5885912 L14.3535534,13.6464466 L15,14.293 L16.6464466,12.6464466 C16.8417088,12.4511845 17.1582912,12.4511845 17.3535534,12.6464466 Z M11.5,13 C11.7761424,13 12,13.2238576 12,13.5 C12,13.7454599 11.8231248,13.9496084 11.5898756,13.9919443 L11.5,14 L6.5,14 C6.22385763,14 6,13.7761424 6,13.5 C6,13.2545401 6.17687516,13.0503916 6.41012437,13.0080557 L6.5,13 L11.5,13 Z M18,9 C18.2761424,9 18.5,9.22385763 18.5,9.5 C18.5,9.74545989 18.3231248,9.94960837 18.0898756,9.99194433 L18,10 L7,10 C6.72385763,10 6.5,9.77614237 6.5,9.5 C6.5,9.25454011 6.67687516,9.05039163 6.91012437,9.00805567 L7,9 L18,9 Z M16,7 C16.2761424,7 16.5,7.22385763 16.5,7.5 C16.5,7.74545989 16.3231248,7.94960837 16.0898756,7.99194433 L16,8 L8,8 C7.72385763,8 7.5,7.77614237 7.5,7.5 C7.5,7.25454011 7.67687516,7.05039163 7.91012437,7.00805567 L8,7 L16,7 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  resetSaviyntPassword: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Password</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-257.000000, -552.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Password" transform="translate(257.000000, 552.000000)">
            <path
              d="M11.6582103,3.63506195 C11.8571453,3.44874552 12.1686528,3.45608348 12.3585943,3.65156039 C13.3887367,4.71172454 14.4870016,5.42895872 15.6552009,5.81041156 C16.7995704,6.18408324 17.8498269,6.18408324 18.8239944,5.81771639 C19.150942,5.6947573 19.5,5.93640979 19.5,6.28571429 L19.5,6.28571429 L19.5,13.1428571 C19.5,16.8499048 15.7738611,20.4999992 12,20.4999992 C8.94439067,20.4999992 4.5,17.1990713 4.5,13.1428571 L4.5,13.1428571 L4.5,6.28571429 C4.5,5.95394936 4.81719377,5.71418139 5.13637905,5.80467296 C6.29278835,6.13252421 7.35832911,6.13252421 8.34479911,5.81041156 C9.3512609,5.48177097 10.4584914,4.75868164 11.6582103,3.63506195 Z M11.986,4.688 L11.7477208,4.89659199 C10.6678655,5.81717205 9.63869773,6.43987519 8.65520089,6.76101701 C7.74573456,7.05798561 6.78568459,7.12651683 5.78042094,6.96922267 L5.78042094,6.96922267 L5.5,6.919 L5.5,13.1428571 C5.5,16.4968498 9.27353185,19.3724326 11.8313356,19.4958728 L11.8313356,19.4958728 L12,19.5 C15.2261389,19.5 18.5,16.2929523 18.5,13.1428571 L18.5,13.1428571 L18.5,6.955 L18.3960332,6.98071168 C17.5162504,7.16432712 16.5933013,7.11952138 15.6337545,6.84895657 L15.6337545,6.84895657 L15.3447991,6.76101701 C14.2196759,6.39362983 13.1623002,5.75961987 12.1737699,4.86331795 L12.1737699,4.86331795 L11.986,4.688 Z M8.28902914,10.8934983 L8.333734,10.8995746 C8.36209048,10.9076765 8.38755344,10.9238802 8.41012289,10.9481858 C8.44397705,10.9846441 8.46090414,11.0237066 8.46090414,11.0653733 L8.46090414,11.0653733 L8.45309164,11.1278733 L8.28902914,11.8934983 L8.97652914,11.5106858 L9.03902914,11.4794358 L9.05660726,11.4735764 L9.05660726,11.4735764 L9.07809164,11.4716233 C9.1197583,11.4716233 9.15751872,11.4820399 9.19137289,11.5028733 C9.22522705,11.5237066 9.2447583,11.5523524 9.24996664,11.5888108 L9.24996664,11.5888108 L9.38277914,11.9872483 L9.39059164,12.0341233 L9.38668539,12.0701476 C9.38147705,12.0938744 9.37106039,12.1170226 9.35543539,12.139592 C9.33199789,12.1734462 9.30465414,12.1955816 9.27340414,12.2059983 L9.27340414,12.2059983 L9.21090414,12.2216233 L8.42965414,12.3153733 L9.00777914,12.8309983 L9.0338208,12.857908 C9.04770969,12.8729543 9.05465414,12.8822135 9.05465414,12.8856858 C9.07548747,12.9169358 9.08590414,12.9481858 9.08590414,12.9794358 C9.08590414,13.0419358 9.06246664,13.0888108 9.01559164,13.1200608 L9.01559164,13.1200608 L8.67965414,13.3700608 L8.63082601,13.3876389 L8.63082601,13.3876389 L8.57809164,13.3934983 C8.5103833,13.3934983 8.4635083,13.3726649 8.43746664,13.3309983 L8.43746664,13.3309983 L8.40621664,13.2763108 L8.07809164,12.5575608 L7.74996664,13.2763108 L7.73238851,13.3056076 L7.73238851,13.3056076 L7.71090414,13.3309983 C7.68486247,13.3726649 7.63798747,13.3934983 7.57027914,13.3934983 C7.5338208,13.3934983 7.49996664,13.3856858 7.46871664,13.3700608 L7.46871664,13.3700608 L7.14059164,13.1200608 L7.10152914,13.0836024 C7.0806958,13.0558246 7.07027914,13.0211024 7.07027914,12.9794358 C7.07027914,12.9481858 7.0806958,12.9169358 7.10152914,12.8856858 C7.10152914,12.8804774 7.11715414,12.8622483 7.14840414,12.8309983 L7.14840414,12.8309983 L7.71871664,12.3075608 L6.94527914,12.2216233 L6.88277914,12.2059983 L6.84458469,12.1899392 C6.82143655,12.1754716 6.80291803,12.1534809 6.78902914,12.123967 C6.7681958,12.0796962 6.76298747,12.0341233 6.77340414,11.9872483 L6.77340414,11.9872483 L6.90621664,11.5888108 L6.92227567,11.5506163 C6.93674326,11.5274682 6.958734,11.5089496 6.98824789,11.4950608 C7.03251872,11.4742274 7.07548747,11.4690191 7.11715414,11.4794358 L7.11715414,11.4794358 L7.17965414,11.5106858 L7.85152914,11.8856858 L7.70309164,11.1278733 L7.69527914,11.0653733 L7.7009215,11.0245746 C7.70844465,10.9979543 7.72349094,10.9724913 7.74606039,10.9481858 C7.77991455,10.9117274 7.82027914,10.8934983 7.86715414,10.8934983 L7.86715414,10.8934983 L8.28902914,10.8934983 Z M12.2890291,10.8934983 L12.333734,10.8995746 C12.3620905,10.9076765 12.3875534,10.9238802 12.4101229,10.9481858 C12.4439771,10.9846441 12.4609041,11.0237066 12.4609041,11.0653733 L12.4609041,11.0653733 L12.4530916,11.1278733 L12.2890291,11.8934983 L12.9765291,11.5106858 L13.0390291,11.4794358 L13.0566073,11.4735764 L13.0566073,11.4735764 L13.0780916,11.4716233 C13.1197583,11.4716233 13.1575187,11.4820399 13.1913729,11.5028733 C13.2252271,11.5237066 13.2447583,11.5523524 13.2499666,11.5888108 L13.2499666,11.5888108 L13.3827791,11.9872483 L13.3905916,12.0341233 L13.3866854,12.0701476 C13.3814771,12.0938744 13.3710604,12.1170226 13.3554354,12.139592 C13.3319979,12.1734462 13.3046541,12.1955816 13.2734041,12.2059983 L13.2734041,12.2059983 L13.2109041,12.2216233 L12.4296541,12.3153733 L13.0077791,12.8309983 L13.0338208,12.857908 C13.0477097,12.8729543 13.0546541,12.8822135 13.0546541,12.8856858 C13.0754875,12.9169358 13.0859041,12.9481858 13.0859041,12.9794358 C13.0859041,13.0419358 13.0624666,13.0888108 13.0155916,13.1200608 L13.0155916,13.1200608 L12.6796541,13.3700608 L12.630826,13.3876389 L12.630826,13.3876389 L12.5780916,13.3934983 C12.5103833,13.3934983 12.4635083,13.3726649 12.4374666,13.3309983 L12.4374666,13.3309983 L12.4062166,13.2763108 L12.0780916,12.5575608 L11.7499666,13.2763108 L11.7323885,13.3056076 L11.7323885,13.3056076 L11.7109041,13.3309983 C11.6848625,13.3726649 11.6379875,13.3934983 11.5702791,13.3934983 C11.5338208,13.3934983 11.4999666,13.3856858 11.4687166,13.3700608 L11.4687166,13.3700608 L11.1405916,13.1200608 L11.1015291,13.0836024 C11.0806958,13.0558246 11.0702791,13.0211024 11.0702791,12.9794358 C11.0702791,12.9481858 11.0806958,12.9169358 11.1015291,12.8856858 C11.1015291,12.8804774 11.1171541,12.8622483 11.1484041,12.8309983 L11.1484041,12.8309983 L11.7187166,12.3075608 L10.9452791,12.2216233 L10.8827791,12.2059983 L10.8445847,12.1899392 C10.8214365,12.1754716 10.802918,12.1534809 10.7890291,12.123967 C10.7681958,12.0796962 10.7629875,12.0341233 10.7734041,11.9872483 L10.7734041,11.9872483 L10.9062166,11.5888108 L10.9222757,11.5506163 C10.9367433,11.5274682 10.958734,11.5089496 10.9882479,11.4950608 C11.0325187,11.4742274 11.0754875,11.4690191 11.1171541,11.4794358 L11.1171541,11.4794358 L11.1796541,11.5106858 L11.8515291,11.8856858 L11.7030916,11.1278733 L11.6952791,11.0653733 L11.7009215,11.0245746 C11.7084446,10.9979543 11.7234909,10.9724913 11.7460604,10.9481858 C11.7799146,10.9117274 11.8202791,10.8934983 11.8671541,10.8934983 L11.8671541,10.8934983 L12.2890291,10.8934983 Z M16.2890291,10.8934983 L16.333734,10.8995746 C16.3620905,10.9076765 16.3875534,10.9238802 16.4101229,10.9481858 C16.4439771,10.9846441 16.4609041,11.0237066 16.4609041,11.0653733 L16.4609041,11.0653733 L16.4530916,11.1278733 L16.2890291,11.8934983 L16.9765291,11.5106858 L17.0390291,11.4794358 L17.0566073,11.4735764 L17.0566073,11.4735764 L17.0780916,11.4716233 C17.1197583,11.4716233 17.1575187,11.4820399 17.1913729,11.5028733 C17.2252271,11.5237066 17.2447583,11.5523524 17.2499666,11.5888108 L17.2499666,11.5888108 L17.3827791,11.9872483 L17.3905916,12.0341233 L17.3866854,12.0701476 C17.3814771,12.0938744 17.3710604,12.1170226 17.3554354,12.139592 C17.3319979,12.1734462 17.3046541,12.1955816 17.2734041,12.2059983 L17.2734041,12.2059983 L17.2109041,12.2216233 L16.4296541,12.3153733 L17.0077791,12.8309983 L17.0338208,12.857908 C17.0477097,12.8729543 17.0546541,12.8822135 17.0546541,12.8856858 C17.0754875,12.9169358 17.0859041,12.9481858 17.0859041,12.9794358 C17.0859041,13.0419358 17.0624666,13.0888108 17.0155916,13.1200608 L17.0155916,13.1200608 L16.6796541,13.3700608 L16.630826,13.3876389 L16.630826,13.3876389 L16.5780916,13.3934983 C16.5103833,13.3934983 16.4635083,13.3726649 16.4374666,13.3309983 L16.4374666,13.3309983 L16.4062166,13.2763108 L16.0780916,12.5575608 L15.7499666,13.2763108 L15.7323885,13.3056076 L15.7323885,13.3056076 L15.7109041,13.3309983 C15.6848625,13.3726649 15.6379875,13.3934983 15.5702791,13.3934983 C15.5338208,13.3934983 15.4999666,13.3856858 15.4687166,13.3700608 L15.4687166,13.3700608 L15.1405916,13.1200608 L15.1015291,13.0836024 C15.0806958,13.0558246 15.0702791,13.0211024 15.0702791,12.9794358 C15.0702791,12.9481858 15.0806958,12.9169358 15.1015291,12.8856858 C15.1015291,12.8804774 15.1171541,12.8622483 15.1484041,12.8309983 L15.1484041,12.8309983 L15.7187166,12.3075608 L14.9452791,12.2216233 L14.8827791,12.2059983 L14.8445847,12.1899392 C14.8214365,12.1754716 14.802918,12.1534809 14.7890291,12.123967 C14.7681958,12.0796962 14.7629875,12.0341233 14.7734041,11.9872483 L14.7734041,11.9872483 L14.9062166,11.5888108 L14.9222757,11.5506163 C14.9367433,11.5274682 14.958734,11.5089496 14.9882479,11.4950608 C15.0325187,11.4742274 15.0754875,11.4690191 15.1171541,11.4794358 L15.1171541,11.4794358 L15.1796541,11.5106858 L15.8515291,11.8856858 L15.7030916,11.1278733 L15.6952791,11.0653733 L15.7009215,11.0245746 C15.7084446,10.9979543 15.7234909,10.9724913 15.7460604,10.9481858 C15.7799146,10.9117274 15.8202791,10.8934983 15.8671541,10.8934983 L15.8671541,10.8934983 L16.2890291,10.8934983 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  pendingTasks: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.RequestableTime' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-67.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Requestable-time" transform="translate(67.000000, 250.000000)">
            <path
              d="M17.634962,10.0157091 C18.9541089,10.0157091 20.009962,11.1419523 20.009962,12.5157091 C20.009962,12.7104248 19.8986587,12.8791443 19.7362045,12.9617152 C20.7898226,13.5632581 21.5,14.6986936 21.5,16 C21.5,17.9329966 19.9329966,19.5 18,19.5 C16.8233711,19.5 15.7451288,18.9144632 15.0985974,17.9580548 C14.7106922,17.38423 14.5,16.7071824 14.5,16 C14.5,15.3768476 14.6635149,14.7763654 14.9693716,14.2482065 C15.5907445,13.1752086 16.7368301,12.5 18,12.5 C18.3595081,12.5 18.7063563,12.5542032 19.0328183,12.6548832 L19.0180177,12.6055847 L19.009962,12.5157091 C19.009962,11.7294669 18.4580304,11.0944903 17.7662159,11.0225077 L17.634962,11.0157091 L6.38496203,11.0157091 C5.67727177,11.0157091 5.08371127,11.6044362 5.01632938,12.3701618 L5.00996203,12.5157091 L5.00996203,15.5157091 C5.00996203,16.3019512 5.56189369,16.9369279 6.25370816,17.0089104 L6.38496203,17.0157091 L13.634962,17.0157091 C13.9111044,17.0157091 14.134962,17.2395667 14.134962,17.5157091 C14.134962,17.7611689 13.9580869,17.9653174 13.7248377,18.0076534 L13.634962,18.0157091 L6.38496203,18.0157091 C5.11858099,18.0157091 4.09485154,16.9777632 4.0149794,15.6793156 L4.00996203,15.5157091 L4.00996203,12.5157091 C4.00996203,11.1969026 4.98303623,10.1062045 6.22797893,10.0210588 L6.38496203,10.0157091 L17.634962,10.0157091 Z M18,13.5 C17.0972897,13.5 16.279085,13.9820398 15.8347407,14.7493415 C15.6164934,15.126215 15.5,15.5540182 15.5,16 C15.5,16.5059843 15.6500906,16.9882919 15.9270619,17.3980133 C16.3895359,18.082147 17.1589952,18.5 18,18.5 C19.3807119,18.5 20.5,17.3807119 20.5,16 C20.5,14.6192881 19.3807119,13.5 18,13.5 Z M18,14.5 C18.2454599,14.5 18.4496084,14.6768752 18.4919443,14.9101244 L18.5,15 L18.5,16.0657415 L19.2773501,16.5839749 C19.5071144,16.7371511 19.5692014,17.0475858 19.4160251,17.2773501 C19.2798685,17.4815851 19.0194583,17.5533342 18.8018994,17.4591765 L18.7226499,17.4160251 L17.7226499,16.7493585 C17.6113704,16.6751722 17.5356422,16.5604209 17.5098021,16.4318934 L17.5,16.3333333 L17.5,15 C17.5,14.7238576 17.7238576,14.5 18,14.5 Z M8,11.5 C9.38071187,11.5 10.5,12.6192881 10.5,14 C10.5,15.3807119 9.38071187,16.5 8,16.5 C6.61928813,16.5 5.5,15.3807119 5.5,14 C5.5,12.6192881 6.61928813,11.5 8,11.5 Z M13,14.5 C13.2761424,14.5 13.5,14.7238576 13.5,15 C13.5,15.2454599 13.3231248,15.4496084 13.0898756,15.4919443 L13,15.5 L12,15.5 C11.7238576,15.5 11.5,15.2761424 11.5,15 C11.5,14.7545401 11.6768752,14.5503916 11.9101244,14.5080557 L12,14.5 L13,14.5 Z M8,12.5 C7.17157288,12.5 6.5,13.1715729 6.5,14 C6.5,14.8284271 7.17157288,15.5 8,15.5 C8.82842712,15.5 9.5,14.8284271 9.5,14 C9.5,13.1715729 8.82842712,12.5 8,12.5 Z M15,12.5 C15.2761424,12.5 15.5,12.7238576 15.5,13 C15.5,13.2454599 15.3231248,13.4496084 15.0898756,13.4919443 L15,13.5 L12,13.5 C11.7238576,13.5 11.5,13.2761424 11.5,13 C11.5,12.7545401 11.6768752,12.5503916 11.9101244,12.5080557 L12,12.5 L15,12.5 Z M17,5.5 C17.7796961,5.5 18.4204487,6.09488808 18.4931334,6.85553999 L18.5,7 L18.5,9 C18.5,9.27614237 18.2761424,9.5 18,9.5 C17.7545401,9.5 17.5503916,9.32312484 17.5080557,9.08987563 L17.5,9 L17.5,7 C17.5,6.75454011 17.3231248,6.55039163 17.0898756,6.50805567 L17,6.5 L7,6.5 C6.75454011,6.5 6.55039163,6.67687516 6.50805567,6.91012437 L6.5,7 L6.5,9 C6.5,9.27614237 6.27614237,9.5 6,9.5 C5.75454011,9.5 5.55039163,9.32312484 5.50805567,9.08987563 L5.5,9 L5.5,7 C5.5,6.22030388 6.09488808,5.57955132 6.85553999,5.50686658 L7,5.5 L17,5.5 Z M8.90831873,7.22915659 C9.73674585,7.22915659 10.4083187,7.90072947 10.4083187,8.72915659 C10.4083187,9.00529897 10.1844611,9.22915659 9.90831873,9.22915659 C9.66285884,9.22915659 9.45871036,9.05228143 9.4163744,8.81903223 L9.40026306,8.63928096 C9.3579271,8.40603175 9.15377862,8.22915659 8.90831873,8.22915659 C8.66285884,8.22915659 8.45871036,8.40603175 8.4163744,8.63928096 L8.40026306,8.81903223 C8.3579271,9.05228143 8.15377862,9.22915659 7.90831873,9.22915659 C7.63217635,9.22915659 7.40831873,9.00529897 7.40831873,8.72915659 C7.40831873,7.90072947 8.0798916,7.22915659 8.90831873,7.22915659 Z M16,7.5 C16.2761424,7.5 16.5,7.72385763 16.5,8 C16.5,8.24545989 16.3231248,8.44960837 16.0898756,8.49194433 L16,8.5 L12,8.5 C11.7238576,8.5 11.5,8.27614237 11.5,8 C11.5,7.75454011 11.6768752,7.55039163 11.9101244,7.50805567 L12,7.5 L16,7.5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  segregationofduty: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Policy</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-113.000000, -506.000000)">
          <g id="Policy" transform="translate(113.000000, 506.000000)">
            <rect
              id="Rectangle-Copy-177"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-176"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M11.6582103,3.63506195 C11.8571453,3.44874552 12.1686528,3.45608348 12.3585943,3.65156039 C13.3887367,4.71172454 14.4870016,5.42895872 15.6552009,5.81041156 C16.7995704,6.18408324 17.8498269,6.18408324 18.8239944,5.81771639 C19.150942,5.6947573 19.5,5.93640979 19.5,6.28571429 L19.5,6.28571429 L19.5,13.1428571 C19.5,16.8499048 15.7738611,20.4999992 12,20.4999992 C8.94439067,20.4999992 4.5,17.1990713 4.5,13.1428571 L4.5,13.1428571 L4.5,6.28571429 C4.5,5.95394936 4.81719377,5.71418139 5.13637905,5.80467296 C6.29278835,6.13252421 7.35832911,6.13252421 8.34479911,5.81041156 C9.3512609,5.48177097 10.4584914,4.75868164 11.6582103,3.63506195 Z M11.986,4.688 L11.7477208,4.89659199 C10.6678655,5.81717205 9.63869773,6.43987519 8.65520089,6.76101701 C7.74573456,7.05798561 6.78568459,7.12651683 5.78042094,6.96922267 L5.78042094,6.96922267 L5.5,6.919 L5.5,13.1428571 C5.5,16.4968498 9.27353185,19.3724326 11.8313356,19.4958728 L11.8313356,19.4958728 L12,19.5 C15.2261389,19.5 18.5,16.2929523 18.5,13.1428571 L18.5,13.1428571 L18.5,6.955 L18.3960332,6.98071168 C17.5162504,7.16432712 16.5933013,7.11952138 15.6337545,6.84895657 L15.6337545,6.84895657 L15.3447991,6.76101701 C14.2196759,6.39362983 13.1623002,5.75961987 12.1737699,4.86331795 L12.1737699,4.86331795 L11.986,4.688 Z M15.8787322,8.51492875 C16.1943056,8.43603541 16.5,8.67471442 16.5,9 L16.5,9 L16.5,15 C16.5,15.189386 16.3929988,15.3625176 16.2236068,15.4472136 L16.2236068,15.4472136 L12.2236068,17.4472136 C12.2158405,17.4510967 12.2079984,17.4547656 12.2000888,17.4582203 C12.1849232,17.464992 12.1692176,17.4709443 12.1531577,17.4761065 C12.1406671,17.4799832 12.1283127,17.4834307 12.1158713,17.4863942 C12.0992762,17.4904617 12.081835,17.4936598 12.0641034,17.4959291 C12.0529743,17.4973123 12.0418951,17.4983669 12.0307984,17.4990512 C12.0206115,17.499686 12.0103424,17.5 12,17.5 L11.9702105,17.4991124 C11.9587764,17.4984305 11.9473603,17.4973555 11.9359831,17.4958875 L12,17.5 C11.9599323,17.5 11.9209653,17.495287 11.8836233,17.4863852 C11.8472024,17.4775986 11.8110427,17.4645384 11.7763932,17.4472136 L11.8468423,17.4761065 C11.8307824,17.4709443 11.8150768,17.464992 11.799771,17.4582955 L11.7763932,17.4472136 L7.7763932,15.4472136 C7.60700119,15.3625176 7.5,15.189386 7.5,15 L7.5,15 L7.5,9 C7.5,8.67471442 7.80569445,8.43603541 8.12126781,8.51492875 L8.12126781,8.51492875 L12,9.484 Z M8.5,9.641 L8.5,14.691 L11.5,16.1899992 L11.5,10.3909992 L8.5,9.641 Z M15.5,9.64 L12.5,10.3899992 L12.5,16.1899992 L15.5,14.69 L15.5,9.64 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  requestconfig: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Manage AD Group</title>
      <g id="V3" stroke="none" strokeWdth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-136.000000, -688.000000)">
          <g id="Group" transform="translate(136.000000, 688.000000)">
            <rect
              id="Rectangle-Copy-13"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-12"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M10,13 C10.5522847,13 11,13.4477153 11,14 L11,19 C11,19.5522847 10.5522847,20 10,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,14 C4,13.4477153 4.44771525,13 5,13 L10,13 Z M17.1863718,12.841018 L17.613,13.664 L18.125,13.931 L19.0886267,13.8323424 L19.9815394,15.2280918 L19.43,16.018 L19.43,16.534 L20.0338388,17.2885973 L19.216617,18.7145154 L18.238,18.714 L17.739,18.972 L17.3504235,19.841018 L15.676584,19.841018 L15.256,19.04 L14.735,18.824 L13.7499953,18.8244181 L12.8854971,17.4641354 L13.409,16.67 L13.409,16.141 L12.8315903,15.3866896 L13.6549667,13.9500327 L14.622,14.007 L15.113,13.721 L15.5075383,12.841018 L17.1863718,12.841018 Z M10,14 L5,14 L5,19 L10,19 L10,14 Z M16.578,13.841 L16.155,13.841 L15.8946692,14.4234932 L14.865844,15.023687 L14.214,14.984 L14.03,15.306 L14.4094848,15.8023478 L14.4094848,16.970221 L14.076,17.474 L14.299,17.824 L14.8344998,17.8244181 L15.0254982,17.8623363 L15.9742159,18.2544823 L16.281,18.841 L16.702,18.841 L16.9690286,18.2457318 L17.9953106,17.7145154 L18.637,17.714 L18.827,17.381 L18.4304806,16.8856794 L18.4304806,15.7048904 L18.779,15.204 L18.578,14.889 L17.9289155,14.9561197 L16.8713386,14.4052548 L16.578,13.841 Z M16.3540541,15.3955915 C16.9063388,15.3955915 17.3540541,15.8433068 17.3540541,16.3955915 C17.3540541,16.9478763 16.9063388,17.3955915 16.3540541,17.3955915 C15.8017693,17.3955915 15.3540541,16.9478763 15.3540541,16.3955915 C15.3540541,15.8433068 15.8017693,15.3955915 16.3540541,15.3955915 Z M10,4 C10.5522847,4 11,4.44771525 11,5 L11,10 C11,10.5522847 10.5522847,11 10,11 L5,11 C4.44771525,11 4,10.5522847 4,10 L4,5 C4,4.44771525 4.44771525,4 5,4 L10,4 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,10 C20,10.5522847 19.5522847,11 19,11 L14,11 C13.4477153,11 13,10.5522847 13,10 L13,5 C13,4.44771525 13.4477153,4 14,4 L19,4 Z M10,5 L5,5 L5,10 L10,10 L10,5 Z M19,5 L14,5 L14,10 L19,10 L19,5 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  aobheader: () => (
    <svg
      width="155px"
      height="104px"
      viewBox="0 0 155 104"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 53</title>
      <defs>
        <path
          d="M5.78,1.07 C5.435,1.415 5.435,1.975 5.78,2.32 L5.78,2.32 C6.125,2.665 6.685,2.665 7.03,2.32 L7.03,2.32 C7.375,1.975 7.375,1.415 7.03,1.07 L7.03,1.07 C6.858,0.897 6.631,0.811 6.405,0.811 L6.405,0.811 C6.179,0.811 5.952,0.897 5.78,1.07 L5.78,1.07 Z M10.47,2.32 L6.98,5.8 L6.98,5.86 C6.844,6.026 6.844,6.264 6.98,6.43 L6.98,6.43 C7.152,6.6 7.428,6.6 7.6,6.43 L7.6,6.43 L11.09,2.94 L11.09,2.88 C11.228,2.719 11.228,2.482 11.09,2.32 L11.09,2.32 L11.13,2.329 C11.118,2.316 11.106,2.303 11.091,2.29 L11.091,2.29 C11.007,2.213 10.901,2.176 10.796,2.176 L10.796,2.176 C10.676,2.176 10.557,2.225 10.47,2.32 L10.47,2.32 Z M1.719,2.32 C1.549,2.491 1.549,2.769 1.719,2.94 L1.719,2.94 L5.211,6.43 L5.27,6.48 C5.436,6.577 5.643,6.559 5.788,6.434 L5.788,6.434 C5.978,6.273 6.001,5.99 5.84,5.8 L5.84,5.8 L2.35,2.32 L2.29,2.27 C2.213,2.217 2.124,2.191 2.035,2.191 L2.035,2.191 C1.921,2.191 1.807,2.235 1.719,2.32 L1.719,2.32 Z M11.12,6.38 C10.774,6.725 10.774,7.285 11.12,7.63 L11.12,7.63 C11.465,7.975 12.025,7.975 12.37,7.63 L12.37,7.63 C12.715,7.285 12.715,6.725 12.37,6.38 L12.37,6.38 C12.197,6.208 11.971,6.121 11.745,6.121 L11.745,6.121 C11.519,6.121 11.292,6.208 11.12,6.38 L11.12,6.38 Z M0.48,6.38 C0.135,6.725 0.135,7.285 0.48,7.63 L0.48,7.63 C0.826,7.975 1.385,7.975 1.73,7.63 L1.73,7.63 C2.075,7.285 2.075,6.725 1.73,6.38 L1.73,6.38 C1.557,6.208 1.332,6.121 1.105,6.121 L1.105,6.121 C0.879,6.121 0.653,6.208 0.48,6.38 L0.48,6.38 Z M5.211,7.58 L1.719,11.07 L1.67,11.13 C1.574,11.295 1.592,11.503 1.716,11.649 L1.716,11.649 C1.877,11.838 2.16,11.861 2.35,11.7 L2.35,11.7 L5.84,8.2 L5.84,8.14 C5.975,7.977 5.975,7.742 5.84,7.58 L5.84,7.58 L5.88,7.58 C5.869,7.568 5.858,7.557 5.845,7.546 L5.845,7.546 C5.76,7.468 5.652,7.431 5.545,7.431 L5.545,7.431 C5.422,7.431 5.299,7.481 5.211,7.58 L5.211,7.58 Z M7.03,7.58 C6.859,7.752 6.859,8.028 7.03,8.2 L7.03,8.2 L10.51,11.7 L10.57,11.7 C10.733,11.834 10.968,11.834 11.13,11.7 L11.13,11.7 C11.302,11.525 11.302,11.245 11.13,11.07 L11.13,11.07 L7.6,7.57 L7.59,7.53 C7.515,7.476 7.426,7.449 7.339,7.449 L7.339,7.449 C7.226,7.449 7.114,7.494 7.03,7.58 L7.03,7.58 Z M5.78,11.68 C5.435,12.025 5.435,12.585 5.78,12.93 L5.78,12.93 C6.125,13.275 6.685,13.275 7.03,12.93 L7.03,12.93 C7.375,12.585 7.375,12.025 7.03,11.68 L7.03,11.68 C6.858,11.508 6.631,11.421 6.405,11.421 L6.405,11.421 C6.179,11.421 5.952,11.508 5.78,11.68 L5.78,11.68 Z"
          id="path-1"
        />
        <path
          d="M5.14,2.52 C5.14,3.564 5.986,4.41 7.03,4.41 L7.03,4.41 C8.074,4.41 8.92,3.564 8.92,2.52 L8.92,2.52 C8.92,1.476 8.074,0.63 7.03,0.63 L7.03,0.63 C5.986,0.63 5.14,1.476 5.14,2.52 L5.14,2.52 Z M6.93,3.567 C6.379,3.54 5.954,3.07 5.981,2.519 L5.981,2.519 C6.009,1.967 6.478,1.543 7.03,1.57 L7.03,1.57 C7.562,1.597 7.981,2.037 7.98000179,2.57 L7.98000179,2.57 C7.98000179,2.587 7.98000179,2.602 7.978,2.619 L7.978,2.619 C7.952,3.153 7.511,3.569 6.983,3.569 L6.983,3.569 C6.965,3.569 6.948,3.568 6.93,3.567 L6.93,3.567 Z M11.79,3.47 C11.27,3.47 10.85,3.892 10.85,4.41 L10.85,4.41 L10.85,4.42 C10.85,4.945 11.275,5.369 11.8,5.369 L11.8,5.369 C12.324,5.369 12.75,4.945 12.75,4.42 L12.75,4.42 C12.75,3.895 12.324,3.47 11.8,3.47 L11.8,3.47 L11.79,3.47 Z M2.32,3.47 C1.801,3.47 1.38,3.892 1.38,4.41 L1.38,4.41 L1.38,4.431 C1.386,4.954 1.815,5.376 2.34,5.369 L2.34,5.369 C2.865,5.364 3.286,4.935 3.28,4.41 L3.28,4.41 C3.275,3.889 2.851,3.47 2.332,3.47 L2.332,3.47 C2.328,3.47 2.324,3.47 2.32,3.47 L2.32,3.47 Z M3.9,5.83 C3.24,5.83 2.8,6.5 2.8,7.26 L2.8,7.26 L2.8,11.99 C2.8,12.252 3.009,12.464 3.27,12.47 L3.27,12.47 C3.533,12.464 3.745,12.253 3.75,11.99 L3.75,11.99 L3.75,7.26 C3.73,7.086 3.784,6.912 3.9,6.78 L3.9,6.78 L10.22,6.78 C10.26,6.78 10.38,6.96 10.38,7.26 L10.38,7.26 L10.38,11.99 C10.38,12.25 10.59,12.46 10.85,12.46 L10.85,12.46 C11.109,12.46 11.32,12.25 11.32,11.99 L11.32,11.99 L11.32,7.26 C11.32,6.5 10.88,5.83 10.22,5.83 L10.22,5.83 L3.9,5.83 Z M12.42,7.231 C12.42,7.507 12.644,7.73 12.92,7.73 L12.92,7.73 C12.96,7.73 13.079,7.91 13.079,8.2 L13.079,8.2 L13.079,11.99 C13.079,12.252 13.289,12.464 13.55,12.47 L13.55,12.47 C13.813,12.464 14.025,12.253 14.03,11.99 L14.03,11.99 L14.03,8.2 C14.031,8.198 14.031,8.196 14.031,8.194 L14.031,8.194 C14.108,7.491 13.602,6.858 12.9,6.78 L12.9,6.78 L12.92,6.73 C12.644,6.73 12.42,6.953 12.42,7.231 L12.42,7.231 Z M0.111,8.2 L0.111,12.039 C0.115,12.302 0.327,12.514 0.59,12.52 L0.59,12.52 C0.851,12.514 1.06,12.301 1.06,12.039 L1.06,12.039 L1.06,8.249 C1.06,7.96 1.22,7.78 1.22,7.78 L1.22,7.78 C1.496,7.78 1.72,7.556 1.72,7.28 L1.72,7.28 C1.72,7.004 1.496,6.78 1.22,6.78 L1.22,6.78 C0.524,6.869 0.028,7.502 0.111,8.2 L0.111,8.2 Z"
          id="path-3"
        />
        <path
          d="M7.545,0.955 C7.444,0.998 7.363,1.079 7.32,1.18 L7.32,1.18 L5.079,7.52 L1.25,4.15 C1.08,3.992 0.814,4.003 0.657,4.173 L0.657,4.173 C0.558,4.28 0.521,4.43 0.561,4.57 L0.561,4.57 L2.4,12.39 C2.443,12.583 2.613,12.72 2.811,12.72 L2.811,12.72 L12.63,12.72 C12.827,12.72 12.998,12.583 13.04,12.39 L13.04,12.39 L14.88,4.57 C14.934,4.344 14.795,4.118 14.569,4.064 L14.569,4.064 C14.424,4.029 14.273,4.073 14.169,4.18 L14.169,4.18 L10.92,7.54 L8.11,1.18 C8.04,1.017 7.881,0.92 7.715,0.92 L7.715,0.92 C7.658,0.92 7.6,0.931 7.545,0.955 L7.545,0.955 Z M5.622,8.555 C5.656,8.516 5.682,8.47 5.7,8.42 L5.7,8.42 L7.799,2.49 L10.44,8.49 C10.539,8.706 10.794,8.801 11.01,8.702 L11.01,8.702 C11.055,8.682 11.094,8.654 11.129,8.62 L11.129,8.62 L13.75,5.92 L12.34,11.92 L3.18,11.92 L1.68,5.69 L5.03,8.599 C5.109,8.668 5.206,8.701 5.304,8.701 L5.304,8.701 C5.421,8.701 5.539,8.652 5.622,8.555 L5.622,8.555 Z M12.361,14.01 L11.539,14.01 C11.767,14.015 11.954,14.199 11.96,14.43 L11.96,14.43 C11.965,14.639 11.82,14.817 11.622,14.86 L11.622,14.86 L12.361,14.86 C12.594,14.896 12.814,14.735 12.85,14.5 L12.85,14.5 C12.886,14.266 12.725,14.046 12.491,14.01 L12.491,14.01 C12.469,14.007 12.447,14.005 12.425,14.005 L12.425,14.005 C12.403,14.005 12.381,14.007 12.361,14.01 L12.361,14.01 Z M9.849,14.01 C10.078,14.015 10.264,14.199 10.27,14.43 L10.27,14.43 C10.274,14.639 10.13,14.817 9.932,14.86 L9.932,14.86 L11.437,14.86 C11.248,14.818 11.104,14.652 11.1,14.45 L11.1,14.45 L11.1,14.43 C11.1,14.198 11.288,14.01 11.52,14.01 L11.52,14.01 L9.849,14.01 Z M8.159,14.01 C8.388,14.015 8.574,14.199 8.58,14.43 L8.58,14.43 C8.585,14.639 8.439,14.817 8.243,14.86 L8.243,14.86 L9.747,14.86 C9.558,14.818 9.415,14.652 9.41,14.45 L9.41,14.45 L9.41,14.43 C9.41,14.198 9.598,14.01 9.83,14.01 L9.83,14.01 L8.159,14.01 Z M3.08,14.01 C2.846,14.046 2.685,14.266 2.721,14.5 L2.721,14.5 C2.749,14.686 2.894,14.831 3.08,14.86 L3.08,14.86 L8.058,14.86 C7.869,14.818 7.725,14.652 7.72,14.45 L7.72,14.45 C7.719,14.443 7.719,14.437 7.72,14.43 L7.72,14.43 C7.72,14.198 7.908,14.01 8.14,14.01 L8.14,14.01 L3.08,14.01 Z M11.437,14.86 C11.47,14.867 11.505,14.871 11.54,14.87 L11.54,14.87 C11.568,14.869 11.595,14.866 11.622,14.86 L11.622,14.86 L11.437,14.86 Z M9.747,14.86 C9.78,14.867 9.814,14.871 9.849,14.87 L9.849,14.87 C9.878,14.869 9.906,14.866 9.932,14.86 L9.932,14.86 L9.747,14.86 Z M8.058,14.86 C8.091,14.867 8.125,14.871 8.16,14.87 L8.16,14.87 C8.188,14.869 8.216,14.866 8.243,14.86 L8.243,14.86 L8.058,14.86 Z"
          id="path-5"
        />
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-53">
          <path
            d="M25.6198,11.1201 C32.7888,11.1201 38.5998,16.9311 38.5998,24.1001 C38.5998,31.2681 32.7888,37.0801 25.6198,37.0801 C18.4518,37.0801 12.6398,31.2681 12.6398,24.1001 C12.6398,16.9311 18.4518,11.1201 25.6198,11.1201"
            id="Fill-1"
            fillOpacity="0.2"
            fill="#FFFFFF"
          />
          <g id="Group-5" transform="translate(19.000000, 16.910000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g id="Clip-4" />
            <polygon
              id="Fill-3"
              fill="#FFFFFF"
              mask="url(#mask-2)"
              points="-6.6658 7.0134 6.4512 -6.1036 19.5672 7.0134 6.4512 20.1304"
            />
          </g>
          <path
            d="M14.6301,75.5601 C22.3171,75.5601 28.5501,81.7921 28.5501,89.4801 C28.5501,97.1671 22.3171,103.4001 14.6301,103.4001 C6.9421,103.4001 0.7101,97.1671 0.7101,89.4801 C0.7101,81.7921 6.9421,75.5601 14.6301,75.5601"
            id="Fill-6"
            fillOpacity="0.2"
            fill="#FFFFFF"
          />
          <g id="Group-10" transform="translate(8.000000, 81.910000)">
            <mask id="mask-4" fill="white">
              <use xlinkHref="#path-3" />
            </mask>
            <g id="Clip-9" />
            <polygon
              id="Fill-8"
              fill="#FFFFFF"
              mask="url(#mask-4)"
              points="-2.73 15.301 16.85 15.301 16.85 -2.22 -2.73 -2.22"
            />
          </g>
          <path
            d="M140.57,5.6602 C148.174,5.6602 154.34,11.8252 154.34,19.4302 C154.34,27.0352 148.174,33.2002 140.57,33.2002 C132.965,33.2002 126.799,27.0352 126.799,19.4302 C126.799,11.8252 132.965,5.6602 140.57,5.6602"
            id="Fill-11"
            fillOpacity="0.2"
            fill="#FFFFFF"
          />
          <g id="Group-15" transform="translate(133.000000, 10.910000)">
            <mask id="mask-6" fill="white">
              <use xlinkHref="#path-5" />
            </mask>
            <g id="Clip-14" />
            <polygon
              id="Fill-13"
              fill="#FFFFFF"
              mask="url(#mask-6)"
              points="-1.99 17.39 17.419 17.39 17.419 -1.6 -1.99 -1.6"
            />
          </g>
          <g id="Group-52" transform="translate(37.000000, 0.910000)">
            <path
              d="M23.5002,11.2599 C23.1812,12.3759 22.9802,13.5219 22.9002,14.6799 C23.0112,15.7599 23.1912,16.8329 23.4402,17.8899 C23.9002,21.9799 26.0602,26.6099 29.7702,28.8899 C32.8702,30.7699 35.4002,30.2399 37.4202,27.5199 C39.5902,24.6099 40.3302,20.7599 41.1002,17.2999 C41.1002,17.2999 43.4002,11.6599 41.6002,10.0799 C39.8002,8.4999 38.9002,3.9399 33.6002,4.8099 C30.4692,5.3119 27.4132,6.1989 24.5002,7.4499 L23.5002,11.2599 Z"
              id="Fill-16"
              fill="#EEBCA1"
            />
            <path
              d="M42.9304,15.7599 C42.9304,15.6199 43.0204,15.4799 43.0604,15.3399 C43.8104,12.7499 43.8394,9.7899 42.1294,7.5699 C41.2874,6.4629 40.0734,5.6979 38.7104,5.4199 C38.6224,5.4129 38.5404,5.3739 38.4804,5.3099 C38.4254,5.2389 38.4004,5.1489 38.4094,5.0599 C38.4334,4.3859 38.3594,3.7129 38.1904,3.0599 C37.9704,2.2619 37.3714,1.6229 36.5904,1.3499 C35.4504,1.0299 34.2804,1.8499 33.0904,1.8499 C31.9004,1.8499 31.0904,1.1599 30.0904,0.9699 C28.8054,0.7719 27.4924,1.0299 26.3804,1.6999 C24.3954,2.9389 22.7824,4.6909 21.7104,6.7699 C20.7804,8.3899 21.0104,8.6199 20.0004,10.2299 C18.6594,12.3399 17.2804,13.5099 17.4604,13.7199 C17.6394,13.9299 19.0004,12.4899 21.3604,12.0399 C22.5394,11.8199 22.7204,12.0899 24.7204,12.0399 C26.4874,12.1039 28.2524,11.8669 29.9404,11.3399 C31.4594,10.7979 32.8444,9.9349 34.0004,8.8099 C33.3794,9.8259 33.2164,11.0569 33.5504,12.1999 C33.8854,12.8839 34.3474,13.4969 34.9094,14.0099 C35.3194,14.4439 35.7634,14.8419 36.2404,15.1999 C36.5024,15.4379 36.7434,15.6989 36.9604,15.9799 C37.1324,15.2559 37.5024,14.5949 38.0304,14.0699 C38.3204,13.8299 39.2404,13.0699 39.8804,13.3399 C40.8804,13.7299 40.8804,16.1999 40.6804,17.4599 L40.1194,21.4599 C40.2564,21.2509 40.3734,21.0299 40.4704,20.7999 L40.9504,20.0499 C41.2404,19.5899 41.4804,19.0999 41.7204,18.6199 C42.1924,17.6969 42.5964,16.7409 42.9304,15.7599"
              id="Fill-18"
              fill="#000000"
            />
            <polygon
              id="Fill-20"
              fill="#EEBCA1"
              points="37.6101 18.34 43.2401 33.95 32.9301 37.13 28.2201 24.91"
            />
            <path
              d="M39.6501,24.1301 L40.3801,25.9801 C40.3801,25.9801 38.2701,29.0701 35.0901,29.5501 C31.6001,30.0201 30.3801,29.3301 30.3801,29.3301 C30.3801,29.3301 35.0801,30.7301 39.6501,24.1301"
              id="Fill-22"
              fillOpacity="0.1"
              fill="#000000"
            />
            <path
              d="M23.9001,11.5202 C25.0841,12.3072 26.4791,12.7152 27.9001,12.6902 C30.5201,12.7702 35.2801,11.0002 35.2801,11.0002 L36.6401,6.5102 L23.9001,11.5202 Z"
              id="Fill-24"
              fillOpacity="0.1"
              fill="#000000"
            />
            <path
              d="M2.7898,52.84 L76.2298,33.59 C78.0688,33.111 79.9468,34.214 80.4258,36.052 C80.4278,36.058 80.4288,36.064 80.4308,36.07 L90.7798,76.71 C91.2468,78.513 90.1848,80.358 88.3908,80.86 L17.9398,100.94 C16.1598,101.45 14.2958,100.454 13.7298,98.69 L0.3998,57.21 C-0.1822,55.407 0.8088,53.474 2.6108,52.892 C2.6698,52.873 2.7298,52.856 2.7898,52.84"
              id="Fill-26"
              fill="#D9ECFF"
            />
            <path
              d="M80.4304,36.07 C79.9604,34.229 78.0884,33.116 76.2474,33.586 L76.2304,33.59 L2.7894,52.84 C0.9584,53.323 -0.1346,55.199 0.3474,57.031 C0.3634,57.091 0.3814,57.151 0.4004,57.21 L1.0504,59.21 L80.6804,37.07 L80.4304,36.07 Z"
              id="Fill-28"
              fill="#002D99"
            />
            <path
              d="M38.8171,55.1325 L76.0961,44.9685 C76.6241,44.8255 77.1681,45.1365 77.3121,45.6635 C77.4561,46.1915 77.1441,46.7355 76.6171,46.8795 L39.3381,57.0425 C38.8101,57.1875 38.2661,56.8755 38.1221,56.3485 C37.9781,55.8205 38.2891,55.2765 38.8171,55.1325"
              id="Fill-30"
              fillOpacity="0.5"
              fill="#001D6B"
            />
            <path
              d="M40.8449,62.3102 L78.0339,51.8222 C78.5599,51.6742 79.1069,51.9802 79.2559,52.5062 C79.4039,53.0322 79.0979,53.5802 78.5719,53.7282 L41.3829,64.2162 C40.8559,64.3652 40.3089,64.0582 40.1609,63.5322 C40.0119,63.0062 40.3189,62.4582 40.8449,62.3102"
              id="Fill-32"
              fillOpacity="0.5"
              fill="#001D6B"
            />
            <path
              d="M43.9177,70.61 L80.9357,59.532 C81.4597,59.376 82.0117,59.672 82.1677,60.197 C82.3247,60.72 82.0267,61.272 81.5037,61.428 L44.4847,72.506 C43.9617,72.664 43.4097,72.366 43.2527,71.842 C43.0967,71.318 43.3947,70.766 43.9177,70.61"
              id="Fill-34"
              fillOpacity="0.5"
              fill="#001D6B"
            />
            <path
              d="M46.9148,78.6159 L66.5828,72.7299 C67.1068,72.5729 67.6578,72.8709 67.8148,73.3939 C67.9728,73.9189 67.6748,74.4699 67.1498,74.6269 L47.4818,80.5119 C46.9588,80.6699 46.4068,80.3719 46.2498,79.8479 C46.0938,79.3239 46.3918,78.7719 46.9148,78.6159"
              id="Fill-36"
              fillOpacity="0.5"
              fill="#001D6B"
            />
            <path
              d="M56.3298,53.61 C55.9898,57.89 55.4798,61.9 54.8698,65.61 C53.9668,67.478 52.7978,69.207 51.3998,70.74 C50.7648,71.461 50.0718,72.13 49.3298,72.74 C47.9098,73.9 47.1898,74.06 46.5698,75.12 C46.0398,76.03 45.8398,77.12 46.0898,77.27 C46.3398,77.42 46.4898,77.27 46.8998,76.839 C48.2798,75.48 49.2998,76.52 49.2998,76.52 C49.2998,76.52 42.0298,87.49 44.4098,88.19 C46.2238,88.572 48.0968,88.572 49.9098,88.19 C52.6838,86.45 55.0438,84.122 56.8198,81.37 C59.0798,77.81 59.5598,75.26 61.0198,70.08 C62.0698,66.31 64.4898,63.93 66.2398,59.08 C66.2398,59.08 70.3508,49.38 69.8698,47.35 C69.3908,45.32 57.2208,48.18 57.2208,48.18 L56.3298,53.61 Z"
              id="Fill-38"
              fill="#EEBCA1"
            />
            <path
              d="M68.8396,54.6198 C69.6526,52.7778 70.2676,50.8528 70.6696,48.8798 C71.1306,47.1078 71.2386,45.2638 70.9896,43.4498 C70.5106,41.3098 69.1996,39.8298 65.8396,37.0098 C63.1026,34.7008 60.2346,32.5508 57.2496,30.5698 C53.8396,28.2998 50.3906,26.0998 46.1806,25.8198 C44.2446,25.6208 42.2906,25.9278 40.5096,26.7098 L40.5096,27.1398 C40.6236,29.3468 39.8496,31.5078 38.3606,33.1398 C37.4886,34.1488 36.2506,34.7678 34.9206,34.8598 C33.7836,34.8668 32.6966,34.3988 31.9206,33.5698 C31.4806,33.0868 31.1736,32.4978 31.0296,31.8598 C28.8716,32.1628 26.8926,33.2268 25.4496,34.8598 C24.5806,36.0608 23.9526,37.4198 23.5996,38.8598 C22.5996,41.9298 20.9096,44.8598 21.0006,48.0698 C24.5696,47.1598 29.4296,45.9798 33.0006,45.0698 C34.6796,44.6398 36.3096,44.4498 38.0006,44.0698 C39.6906,43.6898 41.3796,43.4298 42.9996,43.0698 C43.7186,42.9548 44.4506,42.9548 45.1696,43.0698 C47.3556,43.2938 49.4336,44.1248 51.1696,45.4698 C52.2696,46.2148 53.2766,47.0878 54.1696,48.0698 C54.3026,48.2128 54.4136,48.3748 54.4996,48.5498 C54.8906,49.3898 55.4996,49.4498 55.4996,50.3498 C55.4996,50.9598 55.0696,52.0698 55.4996,52.9298 C55.7796,53.4708 55.4996,54.2498 55.7396,54.7798 C55.8156,54.9458 56.0116,55.0188 56.1776,54.9428 C56.1926,54.9368 56.2066,54.9298 56.2206,54.9198 C56.6496,54.4868 57.1286,54.1068 57.6506,53.7898 C58.4196,53.4198 58.4896,53.1698 59.3296,53.0198 C60.3456,52.8578 61.3826,52.8818 62.3906,53.0898 C63.6686,53.3358 64.8796,53.8538 65.9406,54.6098 C66.4286,55.0288 66.8676,55.5028 67.2496,56.0198 C67.3636,56.1688 67.5776,56.1978 67.7266,56.0838 C67.7506,56.0648 67.7726,56.0438 67.7896,56.0198 L68.8396,54.6198 Z"
              id="Fill-40"
              fill="#FFFFFF"
            />
            <path
              d="M88.7546,71.8395 L88.7546,71.8395 C96.2746,71.8395 102.3696,77.9355 102.3696,85.4545 C102.3696,92.9745 96.2746,99.0695 88.7546,99.0695 C81.2356,99.0695 75.1406,92.9745 75.1406,85.4545 C75.1406,77.9355 81.2356,71.8395 88.7546,71.8395"
              id="Fill-42"
              fill="#F8AA42"
            />
            <polygon
              id="Fill-44"
              fill="#FFFFFF"
              points="81.19 86.97 96.32 86.97 96.32 83.94 81.19 83.94"
            />
            <polygon
              id="Fill-46"
              fill="#FFFFFF"
              points="87.24 93.02 90.27 93.02 90.27 77.89 87.24 77.89"
            />
            <path
              d="M5.28,54.0104 C5.97,54.0104 6.53,54.5704 6.53,55.2604 C6.53,55.9494 5.97,56.5104 5.28,56.5104 C4.59,56.5104 4.03,55.9494 4.03,55.2604 C4.03,54.5704 4.59,54.0104 5.28,54.0104"
              id="Fill-47"
              fill="#FD7366"
            />
            <path
              d="M9.1799,53.07 C9.8699,53.07 10.4299,53.63 10.4299,54.32 C10.4299,55.01 9.8699,55.57 9.1799,55.57 C8.4899,55.57 7.9299,55.01 7.9299,54.32 C7.9299,53.63 8.4899,53.07 9.1799,53.07"
              id="Fill-48"
              fill="#FAA979"
            />
            <path
              d="M13.0798,52.1398 C13.7698,52.1398 14.3298,52.6998 14.3298,53.3898 C14.3298,54.0808 13.7698,54.6398 13.0798,54.6398 C12.3898,54.6398 11.8298,54.0808 11.8298,53.3898 C11.8298,52.6998 12.3898,52.1398 13.0798,52.1398"
              id="Fill-49"
              fill="#14965E"
            />
            <path
              d="M42.03,27.07 C42.22,27.07 42.13,29.49 41.03,32.07 C40.24,33.93 39.28,36.18 37.03,37.07 C34.19,38.2 30.97,36.5 31.03,36.07 C31.09,35.64 35.03,37.07 38.03,35.07 C41.65,32.7 41.74,27 42.03,27.07"
              id="Fill-50"
              fillOpacity="0.1"
              fill="#000000"
            />
            <path
              d="M70.03,45.07 C70.329,47.889 69.621,50.723 68.03,53.07 C67.7,53.51 67.22,54.16 67.03,54.07 C66.56,53.84 68.33,49.24 70.03,45.07"
              id="Fill-51"
              fillOpacity="0.1"
              fill="#000000"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  ReOrderIcon: () => (
    <svg
      className="more"
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Move</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons" transform="translate(-367.000000, -780.000000)">
          <g id="Move" transform="translate(361.000000, 774.000000)">
            <g id="Group-2">
              <rect id="Rectangle" x="0" y="0" width="40" height="40" />
              <g id="Group" transform="translate(6.500000, 6.500000)" fill="#000000">
                <rect id="矩形" x="0" y="8.5" width="27" height="1.6" rx="0.8" />
                <rect id="矩形备份" x="0" y="12.6" width="27" height="1.6" rx="0.8" />
                <rect id="矩形备份-2" x="0" y="16.7" width="27" height="1.6" rx="0.8" />
                <g
                  id="Arrow"
                  transform="translate(13.166667, 3.000000) scale(1, -1) translate(-13.166667, -3.000000) translate(7.166667, 0.000000)"
                  fillRule="nonzero"
                >
                  <path
                    d="M1.04345238,0.202772228 C1.29814214,-0.0430122909 1.69669001,-0.0653563381 1.97753578,0.135740087 L2.05799689,0.202772228 L6.33333333,4.32830769 L10.6086698,0.202772228 C10.8633595,-0.0430122909 11.2619074,-0.0653563381 11.5427532,0.135740087 L11.6232143,0.202772228 C11.877904,0.448556748 11.9010577,0.833169378 11.6926751,1.10419537 L11.6232143,1.18184316 L6.84060559,5.79722777 C6.58591583,6.04301229 6.18736796,6.06535634 5.90652219,5.86425991 L5.82606108,5.79722777 L1.04345238,1.18184316 C0.763293651,0.911480185 0.763293651,0.4731352 1.04345238,0.202772228 Z"
                    id="Path-43-Copy"
                  />
                </g>
                <g id="Arrow-Copy" transform="translate(7.166667, 20.800000)" fillRule="nonzero">
                  <path
                    d="M1.04345238,0.202772228 C1.29814214,-0.0430122909 1.69669001,-0.0653563381 1.97753578,0.135740087 L2.05799689,0.202772228 L6.33333333,4.32830769 L10.6086698,0.202772228 C10.8633595,-0.0430122909 11.2619074,-0.0653563381 11.5427532,0.135740087 L11.6232143,0.202772228 C11.877904,0.448556748 11.9010577,0.833169378 11.6926751,1.10419537 L11.6232143,1.18184316 L6.84060559,5.79722777 C6.58591583,6.04301229 6.18736796,6.06535634 5.90652219,5.86425991 L5.82606108,5.79722777 L1.04345238,1.18184316 C0.763293651,0.911480185 0.763293651,0.4731352 1.04345238,0.202772228 Z"
                    id="Path-43-Copy"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  completedTasks: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.ManageAccessforOthers' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-467.000000, -460.000000)">
          <g id="Manage-Access-for-Others" transform="translate(467.000000, 460.000000)">
            <g>
              <rect
                id="Rectangle-Copy-134"
                fill="#D8D8D8"
                opacity="0"
                x="0"
                y="0"
                width="24"
                height="24"
              />
              <rect
                id="Rectangle-Copy-133"
                fill="#FFF5F5"
                opacity="0"
                x="2"
                y="2"
                width="20"
                height="20"
              />
              <path
                d="M15,4 C15.7402524,4 16.3865739,4.40216612 16.7323937,4.99992752 L17.5,5 C18.3284271,5 19,5.63206859 19,6.41176471 L19,17.5882353 C19,18.3679314 18.3284271,19 17.5,19 L16.7318119,19.0010775 C16.3858493,19.5982846 15.7398375,20 15,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 L15,4 Z M15,5 L6,5 L6,18 C6,18.5522847 6.44771525,19 7,19 L15,19 C15.5522847,19 16,18.5522847 16,18 L16,6 C16,5.44771525 15.5522847,5 15,5 Z M17.5,5.94117647 L16.9991452,5.94095939 C16.9997138,5.96057012 17,5.98025164 17,6 L17,18 L16.998,18.058 L17.5,18.0588235 C17.7761424,18.0588235 18,17.848134 18,17.5882353 L18,6.41176471 C18,6.151866 17.7761424,5.94117647 17.5,5.94117647 Z M10,16 C10.2761424,16 10.5,16.2238576 10.5,16.5 C10.5,16.7761424 10.2761424,17 10,17 L10,17 L8,17 C7.72385763,17 7.5,16.7761424 7.5,16.5 C7.5,16.2238576 7.72385763,16 8,16 L8,16 Z M12,14 C12.2761424,14 12.5,14.2238576 12.5,14.5 C12.5,14.7761424 12.2761424,15 12,15 L12,15 L8,15 C7.72385763,15 7.5,14.7761424 7.5,14.5 C7.5,14.2238576 7.72385763,14 8,14 L8,14 Z M14,12 C14.2761424,12 14.5,12.2238576 14.5,12.5 C14.5,12.7761424 14.2761424,13 14,13 L14,13 L8,13 C7.72385763,13 7.5,12.7761424 7.5,12.5 C7.5,12.2238576 7.72385763,12 8,12 L8,12 Z M12.1367377,7.63584608 C12.3319999,7.44058393 12.6485824,7.44058393 12.8438445,7.63584608 C13.0391067,7.83110822 13.0391067,8.14769071 12.8438445,8.34295286 L12.8438445,8.34295286 L10.8438445,10.3429529 C10.6485824,10.538215 10.3319999,10.538215 10.1367377,10.3429529 L10.1367377,10.3429529 L9.13673772,9.34295286 C8.94147558,9.14769071 8.94147558,8.83110822 9.13673772,8.63584608 C9.33199987,8.44058393 9.64858236,8.44058393 9.84384451,8.63584608 L9.84384451,8.63584608 L10.4902911,9.28229269 Z"
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  certificate: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>certificate</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-307.000000, -460.000000)">
          <g id="Certifications" transform="translate(307.000000, 460.000000)">
            <rect
              id="Rectangle-Copy-107"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-106"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15,11 C16.6568542,11 18,12.3431458 18,14 C18,14.6545207 17.7903952,15.2600855 17.434648,15.753232 C17.4622402,15.8012429 17.4817674,15.8540548 17.4919443,15.9101244 L17.5,16 L17.5,21 C17.5,21.4157556 17.0308449,21.6378031 16.7121985,21.4094692 L16.6464466,21.3535534 L15,19.707 L13.3535534,21.3535534 C13.0595698,21.647537 12.5708157,21.4728055 12.5069551,21.086032 L12.5,21 L12.5,16 C12.5,15.9103127 12.5236139,15.8261408 12.5649635,15.7533623 C12.2096048,15.2600855 12,14.6545207 12,14 C12,12.3431458 13.3431458,11 15,11 Z M17,3.5 C18.3254834,3.5 19.4100387,4.53153594 19.4946823,5.83562431 L19.5,6 L19.5,18 C19.5,18.2761424 19.2761424,18.5 19,18.5 C18.7545401,18.5 18.5503916,18.3231248 18.5080557,18.0898756 L18.5,18 L18.5,6 C18.5,5.22030388 17.9051119,4.57955132 17.14446,4.50686658 L17,4.5 L5.5,4.5 L5.5,18 C5.5,18.7796961 6.09488808,19.4204487 6.85553999,19.4931334 L7,19.5 L11,19.5 C11.2761424,19.5 11.5,19.7238576 11.5,20 C11.5,20.2454599 11.3231248,20.4496084 11.0898756,20.4919443 L11,20.5 L7,20.5 C5.6745166,20.5 4.58996133,19.4684641 4.50531768,18.1643757 L4.5,18 L4.5,3.5 L17,3.5 Z M15,17 C14.4536881,17 13.9414829,16.8539721 13.500288,16.59882 L13.5,19.792 L14.6464466,18.6464466 C14.820013,18.4728803 15.0894374,18.4535951 15.2843055,18.5885912 L15.3535534,18.6464466 L16.5,19.793 L16.5007215,16.5982359 C16.0592984,16.8537493 15.5467286,17 15,17 Z M15,12 C13.8954305,12 13,12.8954305 13,14 C13,15.1045695 13.8954305,16 15,16 C16.1045695,16 17,15.1045695 17,14 C17,12.8954305 16.1045695,12 15,12 Z M10,12 C10.2761424,12 10.5,12.2238576 10.5,12.5 C10.5,12.7454599 10.3231248,12.9496084 10.0898756,12.9919443 L10,13 L7,13 C6.72385763,13 6.5,12.7761424 6.5,12.5 C6.5,12.2545401 6.67687516,12.0503916 6.91012437,12.0080557 L7,12 L10,12 Z M13,9 C13.2761424,9 13.5,9.22385763 13.5,9.5 C13.5,9.74545989 13.3231248,9.94960837 13.0898756,9.99194433 L13,10 L7,10 C6.72385763,10 6.5,9.77614237 6.5,9.5 C6.5,9.25454011 6.67687516,9.05039163 6.91012437,9.00805567 L7,9 L13,9 Z M9,6 C9.27614237,6 9.5,6.22385763 9.5,6.5 C9.5,6.74545989 9.32312484,6.94960837 9.08987563,6.99194433 L9,7 L7,7 C6.72385763,7 6.5,6.77614237 6.5,6.5 C6.5,6.25454011 6.67687516,6.05039163 6.91012437,6.00805567 L7,6 L9,6 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  downloadMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.Download' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-280.000000, -564.000000)">
          <g id="Download" transform="translate(280.000000, 564.000000)">
            <rect
              id="Rectangle-Copy-346"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-345"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M17,16.5 C17.2761424,16.5 17.5,16.7238576 17.5,17 C17.5,17.2454599 17.3231248,17.4496084 17.0898756,17.4919443 L17,17.5 L7,17.5 C6.72385763,17.5 6.5,17.2761424 6.5,17 C6.5,16.7545401 6.67687516,16.5503916 6.91012437,16.5080557 L7,16.5 L17,16.5 Z M12,6.5 C12.2454599,6.5 12.4496084,6.67687516 12.4919443,6.91012437 L12.5,7 L12.5,13.793 L14.6464466,11.6464466 C14.820013,11.4728803 15.0894374,11.4535951 15.2843055,11.5885912 L15.3535534,11.6464466 C15.5271197,11.820013 15.5464049,12.0894374 15.4114088,12.2843055 L15.3535534,12.3535534 L12.3535534,15.3535534 L12.3412864,15.3654113 C12.3288187,15.3770608 12.3157542,15.3880797 12.3021439,15.3984173 L12.3535534,15.3535534 C12.3267191,15.3803877 12.2975936,15.4035342 12.2668065,15.422993 C12.2556825,15.4299807 12.2440467,15.4367067 12.2321272,15.4429657 C12.2182757,15.4502504 12.2045389,15.4566485 12.1905951,15.4623894 C12.1780251,15.4675915 12.1647369,15.4724419 12.1511992,15.4767316 C12.1358347,15.481552 12.1204743,15.4856039 12.1049871,15.4889143 C12.0943062,15.4912471 12.0832525,15.4932298 12.0720792,15.494843 C12.0548708,15.4972949 12.0377348,15.498877 12.0205695,15.4995793 C12.0137573,15.4998604 12.0068949,15.5 12,15.5 L11.9804335,15.4996194 C11.9629328,15.4989382 11.945461,15.4973429 11.9280959,15.4948333 L12,15.5 C11.963903,15.5 11.9286993,15.4961748 11.8947723,15.4889078 C11.8795257,15.4856039 11.8641653,15.481552 11.8489884,15.4767587 C11.8352631,15.4724419 11.8219749,15.4675915 11.8089634,15.4622078 C11.7954611,15.4566485 11.7817243,15.4502504 11.7682418,15.443195 C11.7559533,15.4367067 11.7443175,15.4299807 11.7329897,15.422812 C11.7272981,15.4192668 11.7214636,15.4154054 11.7156945,15.4114088 L11.6978561,15.3984173 C11.6842458,15.3880797 11.6711813,15.3770608 11.6587136,15.3654113 L11.6464466,15.3535534 L8.64644661,12.3535534 C8.45118446,12.1582912 8.45118446,11.8417088 8.64644661,11.6464466 C8.82001296,11.4728803 9.08943736,11.4535951 9.2843055,11.5885912 L9.35355339,11.6464466 L11.5,13.793 L11.5,7 C11.5,6.72385763 11.7238576,6.5 12,6.5 Z"
              id="Combined-Shape"
              fill="#999999"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  fullScreenMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.fullScreen' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-568.000000, -62.000000)" fill="#000000">
          <g id="fullscreen" transform="translate(570.000000, 64.000000)">
            <g
              id="Group-Copy"
              transform="translate(10.242641, 9.853116) scale(1, -1) rotate(-45.000000) translate(-10.242641, -9.853116) translate(5.742641, 1.353116)"
            >
              <path
                fill="#999999"
                d="M4.30425876,9.23999862 L4.39413439,9.23194295 C4.63959428,9.23194295 4.84374276,9.40881811 4.88607872,9.64206732 L4.89413439,9.73194295 L4.894,14.973 L7.5851677,12.288892 C7.78063167,12.0938319 8.09721399,12.0941593 8.29227411,12.2896233 C8.46566088,12.463369 8.4846674,12.7328132 8.3494699,12.9275417 L8.29154287,12.9967297 L4.82197765,16.4591264 C4.64848595,16.6322596 4.3795152,16.6514967 4.18480593,16.5168375 L4.11560248,16.4591264 L0.646037268,12.9967297 C0.4505733,12.8016696 0.450245914,12.4850873 0.64530603,12.2896233 C0.8186928,12.1158775 1.08809711,12.0963138 1.28310475,12.2311082 L1.35241243,12.288892 L3.894,14.825 L3.89413439,9.73194295 C3.89413439,9.48648306 4.07100955,9.28233458 4.30425876,9.23999862 Z M0.744762237,3.3536738 L4.21432745,-0.108722889 C4.38781916,-0.281856139 4.65678991,-0.301093167 4.85149918,-0.166433973 L4.92070262,-0.108722889 L8.39026784,3.3536738 C8.5857318,3.54873392 8.58605919,3.86531624 8.39099907,4.06078021 C8.2176123,4.23452596 7.94820799,4.25408972 7.75320035,4.11929525 L7.68389267,4.06151145 L5.067,1.45 L5.06751504,7.14155322 C5.06751504,7.4176956 4.84365741,7.64155322 4.56751504,7.64155322 C4.32205515,7.64155322 4.11790667,7.46467806 4.07557071,7.23142886 L4.06751504,7.14155322 L4.067,1.45 L1.4511374,4.06151145 C1.27739165,4.23489821 1.00794745,4.25390474 0.81321902,4.11870724 L0.744030999,4.06078021 C0.57064423,3.88703446 0.551637709,3.61759026 0.686835206,3.42286183 L0.744762237,3.3536738 L4.21432745,-0.108722889 L0.744762237,3.3536738 Z"
                id="Combined-Shape"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  languageMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.Language' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-280.000000, -496.000000)"
          fill="#999999"
          fillRule="nonzero"
        >
          <g id="Language" transform="translate(280.000000, 496.000000)">
            <path
              d="M19,5 C20.1045695,5 21,5.8954305 21,7 L21,15 C21,16.1045695 20.1045695,17 19,17 L16.5,17 L10.875,20 L10.875,17 L5,17 C3.8954305,17 3,16.1045695 3,15 L3,7 C3,5.8954305 3.8954305,5 5,5 L19,5 Z M19,5.8 L5,5.8 C4.37867966,5.8 3.86764746,6.27219968 3.80619546,6.87730697 L3.8,7 L3.8,15 C3.8,15.6213203 4.27219968,16.1323525 4.87730697,16.1938045 L5,16.2 L11.675,16.2 L11.675,18.666 L16.3,16.2 L19,16.2 C19.6213203,16.2 20.1323525,15.7278003 20.1938045,15.122693 L20.2,15 L20.2,7 C20.2,6.37867966 19.7278003,5.86764746 19.122693,5.80619546 L19,5.8 Z M13.3332819,7.96321004 C13.5166621,8.02433676 13.6263024,8.20541309 13.604047,8.3901275 L13.5862642,8.46917446 L11.6888976,14.1612743 C11.6190385,14.3708516 11.3925105,14.4841156 11.1829331,14.4142565 C10.999553,14.3531297 10.8899127,14.1720534 10.9121681,13.987339 L10.9299509,13.908292 L12.8273175,8.21619225 C12.8971766,8.00661492 13.1237046,7.89335093 13.3332819,7.96321004 Z M15.5363663,8.69943672 C15.6065104,8.55907678 15.7767378,8.50157082 15.9176304,8.57063872 C16.058523,8.63970661 16.1173299,8.809489 16.0493422,8.950906 C15.9930802,9.10529884 15.9526921,9.26502135 15.9288033,9.42760021 C16.1265384,9.36283774 16.3152341,9.27319013 16.4903489,9.16081506 C16.5752497,9.1030089 16.6846498,9.09523707 16.7768699,9.14046047 C16.86909,9.18568387 16.929929,9.27693847 16.9362084,9.3794581 C16.9424878,9.48197772 16.8932406,9.57997516 16.8072291,9.63611536 C16.5110354,9.82406186 16.186989,9.96399686 15.8470911,10.0507377 C15.8333195,10.1965536 15.8218131,10.3602057 15.8125718,10.5416938 C15.9964398,10.5418603 16.1800931,10.5542596 16.3623149,10.5788095 C16.3631518,10.5557986 16.3631518,10.5425479 16.3631518,10.541014 C16.3631518,10.3832609 16.4910359,10.2553768 16.648789,10.2553768 C16.8065421,10.2553768 16.9344262,10.3832609 16.9344262,10.541014 C16.9344262,10.5556586 16.9341405,10.6160509 16.9288477,10.7092172 C17.6861776,10.9631858 18.076975,11.468358 18.076975,11.9692 C18.076975,13.0198365 17.0677616,13.3683767 17.0248046,13.3827414 C16.9279883,13.4150305 16.8213003,13.393216 16.7449289,13.3255151 C16.6685576,13.2578143 16.6341055,13.1545125 16.6545505,13.0545225 C16.6749954,12.9545326 16.7472314,12.8730453 16.8440477,12.8407562 C17.2210498,12.711455 17.4824846,12.3670824 17.5057006,11.9692 C17.5057006,11.7167567 17.2752942,11.4590148 16.8596692,11.2930482 C16.7627868,11.8281466 16.538693,12.5103711 16.027271,12.8677832 C16.0682725,12.9757879 16.1343476,13.0725059 16.2200533,13.1499699 C16.2868872,13.1836964 16.3373116,13.2429311 16.3599351,13.3142924 C16.3825587,13.3856536 16.3754727,13.4631207 16.340278,13.5291933 C16.290507,13.6254766 16.1906337,13.6854015 16.0822562,13.6840324 C16.0362737,13.6840324 15.9909085,13.6734238 15.9497576,13.6529056 C15.7392036,13.5200909 15.5797612,13.3199649 15.4973483,13.0850588 C15.4060874,13.1022403 15.3134653,13.111173 15.220603,13.1117488 C14.9136041,13.1253798 14.6150049,13.0093879 14.39771,12.792093 C14.1804151,12.5747981 14.0644231,12.2761989 14.0780542,11.9692 C14.0807345,11.2922302 14.5702656,10.7154361 15.2377926,10.6027288 C15.244548,10.4498872 15.2528571,10.3066315 15.2628287,10.1755812 C14.9654492,10.2239593 14.6649429,10.2506283 14.3636914,10.2553768 C14.2059383,10.2554557 14.0779903,10.1276355 14.0779114,9.96988243 C14.0778325,9.81212936 14.2056527,9.68418129 14.3634058,9.68410241 C14.6861132,9.67687358 15.0077057,9.64353078 15.325032,9.58440075 C15.3523551,9.28075236 15.4235397,8.98266641 15.5363663,8.69943672 Z M8.412,8.8 L8.47056,8.806 C8.54352,8.822 8.596,8.87 8.628,8.95 L8.628,8.95 L10.068,12.82 L10.08,12.874 L10.0756667,12.908 C10.0698889,12.9293333 10.0583333,12.948 10.041,12.964 C10.015,12.988 9.986,13 9.954,13 L9.954,13 L9.42,13 L9.361875,12.992875 C9.308625,12.978625 9.27,12.943 9.246,12.886 L9.246,12.886 L8.97,12.16 L7.194,12.16 L6.918,12.886 L6.889125,12.935875 C6.855375,12.978625 6.807,13 6.744,13 L6.744,13 L6.21,13 L6.176,12.996 C6.15466667,12.9906667 6.136,12.98 6.12,12.964 C6.096,12.94 6.084,12.91 6.084,12.874 L6.084,12.874 L6.096,12.82 L7.536,8.95 L7.56384,8.896 C7.60608,8.832 7.6688,8.8 7.752,8.8 L7.752,8.8 L8.412,8.8 Z M15.2223168,11.2034838 C14.8829154,11.3037976 14.6498283,11.6152848 14.6493286,11.9692 C14.6393864,12.1235452 14.6963739,12.2746997 14.8057386,12.3840644 C14.9151033,12.4934291 15.0662578,12.5504166 15.220603,12.5404744 C15.2555041,12.5400587 15.2903507,12.5375961 15.3249634,12.5330992 C15.2508507,12.1593588 15.2158751,11.7789142 15.220603,11.3979256 C15.220603,11.3302296 15.2217027,11.2680606 15.2223168,11.2034838 Z M15.7942825,11.1123769 C15.7929057,11.2045492 15.7918774,11.2985524 15.7918774,11.3979256 C15.7893889,11.6848949 15.8101742,11.9715934 15.8540292,12.2552028 C16.1018531,11.9339573 16.257857,11.5514819 16.3054102,11.14855 C16.1361475,11.1240153 15.9653135,11.1119252 15.7942825,11.1123769 Z M8.082,9.616 L7.404,11.464 L8.76,11.464 L8.082,9.616 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  muteEmailMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.Mute.Email' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-424.000000, -564.000000)">
          <g id="Mute-email" transform="translate(424.169031, 563.619707)">
            <rect
              id="Rectangle-Copy-350"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-349"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <g
              id="Group-2-Copy"
              strokeWidth="1"
              transform="translate(5.000000, 5.000000)"
              fill="#999999"
            >
              <path
                fill="#999999"
                d="M12,5.15789474 C13.1045695,5.15789474 14,6.05332524 14,7.15789474 L14,11.1578947 C14,12.2624642 13.1045695,13.1578947 12,13.1578947 L2,13.1578947 C0.8954305,13.1578947 0,12.2624642 0,11.1578947 L0,7.15789474 C0,6.05332524 0.8954305,5.15789474 2,5.15789474 L12,5.15789474 Z M12,6.15789474 L2,6.15789474 C1.48716416,6.15789474 1.06449284,6.54393493 1.00672773,7.04127361 L1,7.15789474 L1,11.1578947 C1,11.6707306 1.38604019,12.0934019 1.88337887,12.151167 L2,12.1578947 L12,12.1578947 C12.5128358,12.1578947 12.9355072,11.7718545 12.9932723,11.2745159 L13,11.1578947 L13,7.15789474 C13,6.6450589 12.6139598,6.22238758 12.1166211,6.16462247 L12,6.15789474 Z"
                id="Rectangle"
                fillRule="nonzero"
              />
              <path
                fill="#999999"
                d="M10,0 C11.1045695,0 12,0.8954305 12,2 L12,6 L2,6 L2,2 C2,0.8954305 2.8954305,0 4,0 L10,0 Z M10,1 L4,1 C3.48716416,1 3.06449284,1.38604019 3.00672773,1.88337887 L3,2 L3,5 L11,5 L11,2 C11,1.48716416 10.6139598,1.06449284 10.1166211,1.00672773 L10,1 Z"
                id="Rectangle"
                fillRule="nonzero"
              />
              <path
                fill="#999999"
                d="M10.0063177,3.40397104 C10.2824601,3.40397104 10.5063177,3.62782867 10.5063177,3.90397104 C10.5063177,4.14943093 10.3294425,4.35357941 10.0961933,4.39591537 L10.0063177,4.40397104 L4.00631769,4.40397104 C3.73017532,4.40397104 3.50631769,4.18011342 3.50631769,3.90397104 C3.50631769,3.65851115 3.68319286,3.45436267 3.91644206,3.41202671 L4.00631769,3.40397104 L10.0063177,3.40397104 Z"
                id="Line-Copy-2"
                fillRule="nonzero"
              />
              <path
                fill="#999999"
                d="M6,1.76905482 C6.27614237,1.76905482 6.5,1.99291244 6.5,2.26905482 C6.5,2.5145147 6.32312484,2.71866319 6.08987563,2.76099915 L6,2.76905482 L4,2.76905482 C3.72385763,2.76905482 3.5,2.54519719 3.5,2.26905482 C3.5,2.02359493 3.67687516,1.81944644 3.91012437,1.77711048 L4,1.76905482 L6,1.76905482 Z"
                id="Line-Copy"
                fillRule="nonzero"
              />
            </g>
            <g
              id="Group-7"
              strokeWidth="1"
              transform="translate(11.078737, 11.505273) rotate(125.000000) translate(-11.078737, -11.505273) translate(2.578737, 2.505273)"
            >
              <path
                d="M12.8943079,2.56831743 C13.0537882,2.3428831 13.3658232,2.28941681 13.5912575,2.44889713 C13.7916436,2.59065742 13.8561537,2.85295472 13.7560072,3.06782262 L13.7106778,3.14584677 L4.00818497,16.8608616 C3.84870464,17.0862959 3.53666966,17.1397622 3.31123533,16.9802819 C3.11084926,16.8385216 3.04633917,16.5762243 3.14648563,16.3613564 L3.19181503,16.2833323 L12.8943079,2.56831743 Z"
                id="Path-53"
                fill="#999999"
                fillRule="nonzero"
                transform="translate(8.451246, 9.714590) rotate(54.723044) translate(-8.451246, -9.714590) "
              />
              <path
                d="M12.8943079,1.56831743 C13.0537882,1.3428831 13.3658232,1.28941681 13.5912575,1.44889713 C13.7916436,1.59065742 13.8561537,1.85295472 13.7560072,2.06782262 L13.7106778,2.14584677 L4.00818497,15.8608616 C3.84870464,16.0862959 3.53666966,16.1397622 3.31123533,15.9802819 C3.11084926,15.8385216 3.04633917,15.5762243 3.14648563,15.3613564 L3.19181503,15.2833323 L12.8943079,1.56831743 Z"
                id="Path-53-Copy"
                fill="#999999"
                fillRule="nonzero"
                transform="translate(8.451246, 8.714590) rotate(54.723044) translate(-8.451246, -8.714590) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  passwordMenu: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Password</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-352.000000, -496.000000)"
          fill="#999999"
          fillRule="nonzero"
        >
          <g id="Password" transform="translate(352.000000, 496.000000)">
            <path
              d="M11.6582103,3.63506195 C11.8571453,3.44874552 12.1686528,3.45608348 12.3585943,3.65156039 C13.3887367,4.71172454 14.4870016,5.42895872 15.6552009,5.81041156 C16.7995704,6.18408324 17.8498269,6.18408324 18.8239944,5.81771639 C19.150942,5.6947573 19.5,5.93640979 19.5,6.28571429 L19.5,6.28571429 L19.5,13.1428571 C19.5,16.8499048 15.7738611,20.4999992 12,20.4999992 C8.94439067,20.4999992 4.5,17.1990713 4.5,13.1428571 L4.5,13.1428571 L4.5,6.28571429 C4.5,5.95394936 4.81719377,5.71418139 5.13637905,5.80467296 C6.29278835,6.13252421 7.35832911,6.13252421 8.34479911,5.81041156 C9.3512609,5.48177097 10.4584914,4.75868164 11.6582103,3.63506195 Z M11.986,4.688 L11.7477208,4.89659199 C10.6678655,5.81717205 9.63869773,6.43987519 8.65520089,6.76101701 C7.74573456,7.05798561 6.78568459,7.12651683 5.78042094,6.96922267 L5.78042094,6.96922267 L5.5,6.919 L5.5,13.1428571 C5.5,16.4968498 9.27353185,19.3724326 11.8313356,19.4958728 L11.8313356,19.4958728 L12,19.5 C15.2261389,19.5 18.5,16.2929523 18.5,13.1428571 L18.5,13.1428571 L18.5,6.955 L18.3960332,6.98071168 C17.5162504,7.16432712 16.5933013,7.11952138 15.6337545,6.84895657 L15.6337545,6.84895657 L15.3447991,6.76101701 C14.2196759,6.39362983 13.1623002,5.75961987 12.1737699,4.86331795 L12.1737699,4.86331795 L11.986,4.688 Z M8.28902914,10.8934983 L8.333734,10.8995746 C8.36209048,10.9076765 8.38755344,10.9238802 8.41012289,10.9481858 C8.44397705,10.9846441 8.46090414,11.0237066 8.46090414,11.0653733 L8.46090414,11.0653733 L8.45309164,11.1278733 L8.28902914,11.8934983 L8.97652914,11.5106858 L9.03902914,11.4794358 L9.05660726,11.4735764 L9.05660726,11.4735764 L9.07809164,11.4716233 C9.1197583,11.4716233 9.15751872,11.4820399 9.19137289,11.5028733 C9.22522705,11.5237066 9.2447583,11.5523524 9.24996664,11.5888108 L9.24996664,11.5888108 L9.38277914,11.9872483 L9.39059164,12.0341233 L9.38668539,12.0701476 C9.38147705,12.0938744 9.37106039,12.1170226 9.35543539,12.139592 C9.33199789,12.1734462 9.30465414,12.1955816 9.27340414,12.2059983 L9.27340414,12.2059983 L9.21090414,12.2216233 L8.42965414,12.3153733 L9.00777914,12.8309983 L9.0338208,12.857908 C9.04770969,12.8729543 9.05465414,12.8822135 9.05465414,12.8856858 C9.07548747,12.9169358 9.08590414,12.9481858 9.08590414,12.9794358 C9.08590414,13.0419358 9.06246664,13.0888108 9.01559164,13.1200608 L9.01559164,13.1200608 L8.67965414,13.3700608 L8.63082601,13.3876389 L8.63082601,13.3876389 L8.57809164,13.3934983 C8.5103833,13.3934983 8.4635083,13.3726649 8.43746664,13.3309983 L8.43746664,13.3309983 L8.40621664,13.2763108 L8.07809164,12.5575608 L7.74996664,13.2763108 L7.73238851,13.3056076 L7.73238851,13.3056076 L7.71090414,13.3309983 C7.68486247,13.3726649 7.63798747,13.3934983 7.57027914,13.3934983 C7.5338208,13.3934983 7.49996664,13.3856858 7.46871664,13.3700608 L7.46871664,13.3700608 L7.14059164,13.1200608 L7.10152914,13.0836024 C7.0806958,13.0558246 7.07027914,13.0211024 7.07027914,12.9794358 C7.07027914,12.9481858 7.0806958,12.9169358 7.10152914,12.8856858 C7.10152914,12.8804774 7.11715414,12.8622483 7.14840414,12.8309983 L7.14840414,12.8309983 L7.71871664,12.3075608 L6.94527914,12.2216233 L6.88277914,12.2059983 L6.84458469,12.1899392 C6.82143655,12.1754716 6.80291803,12.1534809 6.78902914,12.123967 C6.7681958,12.0796962 6.76298747,12.0341233 6.77340414,11.9872483 L6.77340414,11.9872483 L6.90621664,11.5888108 L6.92227567,11.5506163 C6.93674326,11.5274682 6.958734,11.5089496 6.98824789,11.4950608 C7.03251872,11.4742274 7.07548747,11.4690191 7.11715414,11.4794358 L7.11715414,11.4794358 L7.17965414,11.5106858 L7.85152914,11.8856858 L7.70309164,11.1278733 L7.69527914,11.0653733 L7.7009215,11.0245746 C7.70844465,10.9979543 7.72349094,10.9724913 7.74606039,10.9481858 C7.77991455,10.9117274 7.82027914,10.8934983 7.86715414,10.8934983 L7.86715414,10.8934983 L8.28902914,10.8934983 Z M12.2890291,10.8934983 L12.333734,10.8995746 C12.3620905,10.9076765 12.3875534,10.9238802 12.4101229,10.9481858 C12.4439771,10.9846441 12.4609041,11.0237066 12.4609041,11.0653733 L12.4609041,11.0653733 L12.4530916,11.1278733 L12.2890291,11.8934983 L12.9765291,11.5106858 L13.0390291,11.4794358 L13.0566073,11.4735764 L13.0566073,11.4735764 L13.0780916,11.4716233 C13.1197583,11.4716233 13.1575187,11.4820399 13.1913729,11.5028733 C13.2252271,11.5237066 13.2447583,11.5523524 13.2499666,11.5888108 L13.2499666,11.5888108 L13.3827791,11.9872483 L13.3905916,12.0341233 L13.3866854,12.0701476 C13.3814771,12.0938744 13.3710604,12.1170226 13.3554354,12.139592 C13.3319979,12.1734462 13.3046541,12.1955816 13.2734041,12.2059983 L13.2734041,12.2059983 L13.2109041,12.2216233 L12.4296541,12.3153733 L13.0077791,12.8309983 L13.0338208,12.857908 C13.0477097,12.8729543 13.0546541,12.8822135 13.0546541,12.8856858 C13.0754875,12.9169358 13.0859041,12.9481858 13.0859041,12.9794358 C13.0859041,13.0419358 13.0624666,13.0888108 13.0155916,13.1200608 L13.0155916,13.1200608 L12.6796541,13.3700608 L12.630826,13.3876389 L12.630826,13.3876389 L12.5780916,13.3934983 C12.5103833,13.3934983 12.4635083,13.3726649 12.4374666,13.3309983 L12.4374666,13.3309983 L12.4062166,13.2763108 L12.0780916,12.5575608 L11.7499666,13.2763108 L11.7323885,13.3056076 L11.7323885,13.3056076 L11.7109041,13.3309983 C11.6848625,13.3726649 11.6379875,13.3934983 11.5702791,13.3934983 C11.5338208,13.3934983 11.4999666,13.3856858 11.4687166,13.3700608 L11.4687166,13.3700608 L11.1405916,13.1200608 L11.1015291,13.0836024 C11.0806958,13.0558246 11.0702791,13.0211024 11.0702791,12.9794358 C11.0702791,12.9481858 11.0806958,12.9169358 11.1015291,12.8856858 C11.1015291,12.8804774 11.1171541,12.8622483 11.1484041,12.8309983 L11.1484041,12.8309983 L11.7187166,12.3075608 L10.9452791,12.2216233 L10.8827791,12.2059983 L10.8445847,12.1899392 C10.8214365,12.1754716 10.802918,12.1534809 10.7890291,12.123967 C10.7681958,12.0796962 10.7629875,12.0341233 10.7734041,11.9872483 L10.7734041,11.9872483 L10.9062166,11.5888108 L10.9222757,11.5506163 C10.9367433,11.5274682 10.958734,11.5089496 10.9882479,11.4950608 C11.0325187,11.4742274 11.0754875,11.4690191 11.1171541,11.4794358 L11.1171541,11.4794358 L11.1796541,11.5106858 L11.8515291,11.8856858 L11.7030916,11.1278733 L11.6952791,11.0653733 L11.7009215,11.0245746 C11.7084446,10.9979543 11.7234909,10.9724913 11.7460604,10.9481858 C11.7799146,10.9117274 11.8202791,10.8934983 11.8671541,10.8934983 L11.8671541,10.8934983 L12.2890291,10.8934983 Z M16.2890291,10.8934983 L16.333734,10.8995746 C16.3620905,10.9076765 16.3875534,10.9238802 16.4101229,10.9481858 C16.4439771,10.9846441 16.4609041,11.0237066 16.4609041,11.0653733 L16.4609041,11.0653733 L16.4530916,11.1278733 L16.2890291,11.8934983 L16.9765291,11.5106858 L17.0390291,11.4794358 L17.0566073,11.4735764 L17.0566073,11.4735764 L17.0780916,11.4716233 C17.1197583,11.4716233 17.1575187,11.4820399 17.1913729,11.5028733 C17.2252271,11.5237066 17.2447583,11.5523524 17.2499666,11.5888108 L17.2499666,11.5888108 L17.3827791,11.9872483 L17.3905916,12.0341233 L17.3866854,12.0701476 C17.3814771,12.0938744 17.3710604,12.1170226 17.3554354,12.139592 C17.3319979,12.1734462 17.3046541,12.1955816 17.2734041,12.2059983 L17.2734041,12.2059983 L17.2109041,12.2216233 L16.4296541,12.3153733 L17.0077791,12.8309983 L17.0338208,12.857908 C17.0477097,12.8729543 17.0546541,12.8822135 17.0546541,12.8856858 C17.0754875,12.9169358 17.0859041,12.9481858 17.0859041,12.9794358 C17.0859041,13.0419358 17.0624666,13.0888108 17.0155916,13.1200608 L17.0155916,13.1200608 L16.6796541,13.3700608 L16.630826,13.3876389 L16.630826,13.3876389 L16.5780916,13.3934983 C16.5103833,13.3934983 16.4635083,13.3726649 16.4374666,13.3309983 L16.4374666,13.3309983 L16.4062166,13.2763108 L16.0780916,12.5575608 L15.7499666,13.2763108 L15.7323885,13.3056076 L15.7323885,13.3056076 L15.7109041,13.3309983 C15.6848625,13.3726649 15.6379875,13.3934983 15.5702791,13.3934983 C15.5338208,13.3934983 15.4999666,13.3856858 15.4687166,13.3700608 L15.4687166,13.3700608 L15.1405916,13.1200608 L15.1015291,13.0836024 C15.0806958,13.0558246 15.0702791,13.0211024 15.0702791,12.9794358 C15.0702791,12.9481858 15.0806958,12.9169358 15.1015291,12.8856858 C15.1015291,12.8804774 15.1171541,12.8622483 15.1484041,12.8309983 L15.1484041,12.8309983 L15.7187166,12.3075608 L14.9452791,12.2216233 L14.8827791,12.2059983 L14.8445847,12.1899392 C14.8214365,12.1754716 14.802918,12.1534809 14.7890291,12.123967 C14.7681958,12.0796962 14.7629875,12.0341233 14.7734041,11.9872483 L14.7734041,11.9872483 L14.9062166,11.5888108 L14.9222757,11.5506163 C14.9367433,11.5274682 14.958734,11.5089496 14.9882479,11.4950608 C15.0325187,11.4742274 15.0754875,11.4690191 15.1171541,11.4794358 L15.1171541,11.4794358 L15.1796541,11.5106858 L15.8515291,11.8856858 L15.7030916,11.1278733 L15.6952791,11.0653733 L15.7009215,11.0245746 C15.7084446,10.9979543 15.7234909,10.9724913 15.7460604,10.9481858 C15.7799146,10.9117274 15.8202791,10.8934983 15.8671541,10.8934983 L15.8671541,10.8934983 L16.2890291,10.8934983 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  resetMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.Reset' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-393.000000, -720.000000)">
          <g id="Refresh" transform="translate(393.000000, 720.000000)">
            <rect
              id="Rectangle-Copy-23"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-22"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M17.2348554,8.62474855 C17.3670933,8.46180694 17.5910902,8.39622628 17.7943524,8.47040836 L17.7943524,8.47040836 L19.9063954,9.24121424 L19.9880623,9.27959456 C20.1926608,9.39933162 20.2888263,9.65174722 20.204673,9.88233081 C20.1100007,10.1417374 19.822963,10.2752808 19.5635565,10.1806084 L19.5635565,10.1806084 L18.5322789,9.80338018 C18.7802736,10.5215382 18.9087752,11.280791 18.9087752,12.0574215 C18.9087752,15.8700705 15.8180125,18.9608332 12.0053635,18.9608332 C10.2530493,18.9608332 8.60192016,18.3046951 7.33719388,17.1432634 C7.13380263,16.9564838 7.12033622,16.6401878 7.30711581,16.4367966 C7.49389539,16.2334053 7.81019134,16.2199389 8.01358259,16.4067185 C9.09556496,17.4003317 10.5060309,17.9608332 12.0053635,17.9608332 C15.2657278,17.9608332 17.9087752,15.3177857 17.9087752,12.0574215 C17.9087752,11.375212 17.7931981,10.7098125 17.5703464,10.082086 L16.9564287,11.2033247 L16.9062748,11.2783388 C16.7573065,11.4627459 16.4933541,11.5201096 16.2779361,11.4024422 C16.0355907,11.2700665 15.9464428,10.966295 16.0788185,10.7239496 L16.0788185,10.7239496 L17.1841279,8.70041792 Z M11.9517101,5.02870005 C13.7040243,5.02870005 15.3551535,5.68483809 16.6198798,6.84626985 C16.823271,7.03304943 16.8367374,7.34934538 16.6499578,7.55273662 C16.4631782,7.75612787 16.1468823,7.76959428 15.943491,7.5828147 C14.8615087,6.58920153 13.4510428,6.02870005 11.9517101,6.02870005 C8.69134585,6.02870005 6.0482984,8.6717475 6.0482984,11.9321118 C6.0482984,12.6811324 6.18762174,13.4098892 6.45527993,14.09077 L6.97845388,12.9711854 C7.09493854,12.7208138 7.39233429,12.612277 7.64270589,12.7287616 C7.86525842,12.8323035 7.97574395,13.0787876 7.91573783,13.3081275 L7.88512963,13.3930136 L6.93673179,15.4314956 C6.84545832,15.6276784 6.64069607,15.7396956 6.43197266,15.7179848 L6.34259657,15.7003482 L4.13017182,15.051067 C3.86520398,14.9733067 3.71344222,14.6954707 3.79120244,14.4305029 C3.86032265,14.1949759 4.08752741,14.0488957 4.3232594,14.0739547 L4.41176651,14.0915335 L5.50883876,14.4127 L5.47166413,14.3175313 C5.19300887,13.5608565 5.0482984,12.756269 5.0482984,11.9321118 C5.0482984,8.11946275 8.13906111,5.02870005 11.9517101,5.02870005 Z"
              id="Combined-Shape"
              fill="#999999"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  signoutMenu: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.dropDownIcon}
    >
      <title>{intl.formatMessage({ id: 'Icon.Menu.SignOut' })}</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-352.000000, -564.000000)">
          <g id="signout" transform="translate(352.000000, 564.000000)">
            <rect
              id="Rectangle-Copy-348"
              fill="#D8D8D8"
              fillRule="evenodd"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-347"
              fill="#FFF5F5"
              fillRule="evenodd"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M5.16976035,9.07277545 C6.79988883,5.87346818 10.7318165,4.61166407 13.9511835,6.25201347 C14.6718893,6.61923144 15.3089056,7.10773469 15.840716,7.69456551 C16.02615,7.89918428 16.0105977,8.21538453 15.8059789,8.40081853 C15.6013601,8.58625254 15.2851599,8.57070022 15.0997259,8.36608145 C14.6491646,7.86890566 14.1092992,7.45490371 13.497193,7.14302 C10.7684735,5.75266798 7.43942276,6.82100144 6.06076688,9.52676595 C4.682111,12.2325305 5.77457801,15.5537397 8.50329749,16.9440918 C10.9184453,18.1746711 13.8499721,17.4874041 15.4428268,15.3591291 C15.6082893,15.1380482 15.9216447,15.0929606 16.1427256,15.2584231 C16.3638065,15.4238856 16.4088941,15.737241 16.2434316,15.9583219 C14.3594918,18.475527 10.8986171,19.2868943 8.04930699,17.8350983 C4.82994002,16.1947489 3.53963188,12.2720827 5.16976035,9.07277545 Z M16.673867,9.34331645 C16.8691291,9.14805431 17.1857116,9.14805431 17.3809737,9.34331645 L17.3809737,9.34331645 L19.3809737,11.3433165 L19.4388292,11.4125643 C19.5738252,11.6074325 19.5545401,11.8768569 19.3809737,12.0504232 L19.3809737,12.0504232 L17.3809737,14.0504232 L17.3117259,14.1082787 C17.1168577,14.2432747 16.8474333,14.2239896 16.673867,14.0504232 L16.673867,14.0504232 L16.6160115,13.9811753 C16.4810155,13.7863072 16.5003006,13.5168828 16.673867,13.3433165 L16.673867,13.3433165 L17.8198839,12.1968698 L10.9858839,12.1968698 L10.8960083,12.1888142 C10.6627591,12.1464782 10.4858839,11.9423297 10.4858839,11.6968698 C10.4858839,11.4207275 10.7097415,11.1968698 10.9858839,11.1968698 L10.9858839,11.1968698 L17.8198839,11.1968698 L16.673867,10.0504232 L16.6160115,9.98117535 C16.4810155,9.78630721 16.5003006,9.51688281 16.673867,9.34331645 Z"
              id="Combined-Shape"
              fill="#999999"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  approvalIcon: ({ intl }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      version="1.1"
      className={styles.IconPosition}
    >
      <title>{intl.formatMessage({ id: 'Icon.Right.Copy' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="right-copy" stroke="light-black" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M18,3.5 C18.7796961,3.5 19.4204487,4.09488808 19.4931334,4.85553999 L19.5,5 L19.5,15 C19.5,15.2761424 19.2761424,15.5 19,15.5 C18.7545401,15.5 18.5503916,15.3231248 18.5080557,15.0898756 L18.5,15 L18.5,5 C18.5,4.75454011 18.3231248,4.55039163 18.0898756,4.50805567 L18,4.5 L6,4.5 C5.75454011,4.5 5.55039163,4.67687516 5.50805567,4.91012437 L5.5,5 L5.5,19 C5.5,19.2454599 5.67687516,19.4496084 5.91012437,19.4919443 L6,19.5 L14,19.5 C14.2761424,19.5 14.5,19.7238576 14.5,20 C14.5,20.2454599 14.3231248,20.4496084 14.0898756,20.4919443 L14,20.5 L6,20.5 C5.22030388,20.5 4.57955132,19.9051119 4.50686658,19.14446 L4.5,19 L4.5,5 C4.5,4.22030388 5.09488808,3.57955132 5.85553999,3.50686658 L6,3.5 L18,3.5 Z M15,12.5 C16.9329966,12.5 18.5,14.0670034 18.5,16 C18.5,16.9135532 18.1499941,17.7453581 17.5767634,18.3686335 L18.7071068,19.5 C18.9023689,19.6952621 18.9023689,20.0118446 18.7071068,20.2071068 C18.5118446,20.4023689 18.1952621,20.4023689 18,20.2071068 L16.7969196,19.0041311 C16.2716561,19.3189937 15.6569662,19.5 15,19.5 C13.0670034,19.5 11.5,17.9329966 11.5,16 C11.5,14.0670034 13.0670034,12.5 15,12.5 Z M15,13.5 C13.6192881,13.5 12.5,14.6192881 12.5,16 C12.5,17.3807119 13.6192881,18.5 15,18.5 C16.3807119,18.5 17.5,17.3807119 17.5,16 C17.5,14.6192881 16.3807119,13.5 15,13.5 Z M11,12.5 C11.2761424,12.5 11.5,12.7238576 11.5,13 C11.5,13.2454599 11.3231248,13.4496084 11.0898756,13.4919443 L11,13.5 L8,13.5 C7.72385763,13.5 7.5,13.2761424 7.5,13 C7.5,12.7545401 7.67687516,12.5503916 7.91012437,12.5080557 L8,12.5 L11,12.5 Z M16,9.5 C16.2761424,9.5 16.5,9.72385763 16.5,10 C16.5,10.2454599 16.3231248,10.4496084 16.0898756,10.4919443 L16,10.5 L8,10.5 C7.72385763,10.5 7.5,10.2761424 7.5,10 C7.5,9.75454011 7.67687516,9.55039163 7.91012437,9.50805567 L8,9.5 L16,9.5 Z M8,6.5 L16,6.5 C16.2761424,6.5 16.5,6.72385763 16.5,7 C16.5,7.24545989 16.3231248,7.44960837 16.0898756,7.49194433 L16,7.5 L8,7.5 C7.72385763,7.5 7.5,7.27614237 7.5,7 C7.5,6.75454011 7.67687516,6.55039163 7.91012437,6.50805567 L8,6.5 L16,6.5 L8,6.5 Z"
          id="Combined-Shape"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  applicationCollection: ({ intl }) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{intl.formatMessage({ id: 'Icon.Organization.AplicationCollection' })}</title>
      <desc>Created with Sketch.</desc>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-210.000000, -250.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Organization" transform="translate(210.000000, 250.000000)">
            <path
              d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  accept: ({ selected, intl, disabled, tooltip, height }) => (
    <svg
      width={height || '18px'}
      height={height || '18px'}
      viewBox="0 0 24 24"
      version="1.1"
      className={`mr-1 ${selected ? styles.selectedAccept : styles.selectIconBg}`}
    >
      <title>
        {tooltip != '' ? intl.formatMessage({ id: `Icon.${tooltip || 'Approve'}` }) : ''}
      </title>
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        fillRule="evenodd"
        className={`${styles.selectIconAccept} ${disabled ? styles.disabled : ''}`}
      >
        <g id="Export" transform="translate(-354.000000, -1319.000000)">
          <g id="Group" transform="translate(354.000000, 1319.000000)">
            <rect id="Rectangle-Copy-277" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle-Copy-276" opacity="0" x="2" y="2" width="20" height="20" />
            <path
              d="M17.4698933,7.46944662 C17.7629098,7.17667678 18.2377835,7.17687676 18.5305534,7.4698933 C18.7967078,7.73627197 18.8207384,8.15294581 18.6027603,8.44646553 L18.5301067,8.53055338 L10.5233657,16.5305534 C10.2565623,16.7971321 9.83908787,16.8207578 9.54557301,16.6018554 L9.46151198,16.5289093 L6.46825295,13.5195908 C6.1761444,13.225915 6.17741489,12.7510429 6.47109067,12.4589344 C6.73806866,12.1933811 7.15479561,12.1702899 7.4478232,12.3889292 L7.53174705,12.4617721 L9.995,14.938 L17.4698933,7.46944662 Z"
              id="Path-18-Copy-2"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  reject: ({ selected, intl, disabled, tooltip }) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 24 24"
      version="1.1"
      className={`mr-1 ${selected ? styles.selectedReject : styles.selectRejectIconBg}`}
    >
      <title>{intl.formatMessage({ id: `Icon.${tooltip || 'Reject'}` })}</title>
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
        fillRule="evenodd"
        className={`${styles.selectIconAccept} ${disabled ? styles.disabled : ''}`}
      >
        <g id="Export" transform="translate(-67.000000, -1275.000000)" fillRule="nonzero">
          <g id="Combined-Shape" transform="translate(67.000000, 1275.000000)">
            <path d="M17.179825,6.21966991 C17.4483105,6.48815536 17.4706843,6.909555 17.2469464,7.20352615 L17.179825,7.28033009 L12.76,11.699 L17.179825,16.1191649 C17.4727182,16.4120581 17.4727182,16.8869318 17.179825,17.179825 C16.9113396,17.4483105 16.4899399,17.4706843 16.1959688,17.2469464 L16.1191649,17.179825 L11.699,12.76 L7.28033009,17.179825 C6.98743687,17.4727182 6.51256313,17.4727182 6.21966991,17.179825 C5.95118446,16.9113396 5.92881068,16.4899399 6.15254855,16.1959688 L6.21966991,16.1191649 L10.639,11.699 L6.21966991,7.28033009 C5.9267767,6.98743687 5.9267767,6.51256313 6.21966991,6.21966991 C6.48815536,5.95118446 6.909555,5.92881068 7.20352615,6.15254855 L7.28033009,6.21966991 L11.699,10.639 L16.1191649,6.21966991 C16.4120581,5.9267767 16.8869318,5.9267767 17.179825,6.21966991 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  ruleDesigner: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Rule Designer</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-351.000000, -688.000000)">
          <g id="Group" transform="translate(351.000000, 688.000000)">
            <rect
              id="Rectangle-Copy-134"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-133"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M16,5.94117647 L17.5,5.94117647 C17.7761424,5.94117647 18,6.151866 18,6.41176471 L18,17.5882353 C18,17.848134 17.7761424,18.0588235 17.5,18.0588235 L16,18.0588235 L16,19 L17.5,19 C18.3284271,19 19,18.3679314 19,17.5882353 L19,6.41176471 C19,5.63206859 18.3284271,5 17.5,5 L16,5 L16,5.94117647 Z"
              id="Rectangle-Copy-2"
              fill="#000000"
              fillRule="nonzero"
              transform="translate(17.500000, 12.000000) scale(1, -1) translate(-17.500000, -12.000000) "
            />
            <path
              d="M5,4 L15,4 C16.1045695,4 17,4.8954305 17,6 L17,18 C17,19.1045695 16.1045695,20 15,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 Z M6,5 L6,18 C6,18.5522847 6.44771525,19 7,19 L15,19 C15.5522847,19 16,18.5522847 16,18 L16,6 C16,5.44771525 15.5522847,5 15,5 L6,5 Z"
              id="Rectangle"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M9.84384451,8.63584608 C9.64858236,8.44058393 9.33199987,8.44058393 9.13673772,8.63584608 C8.94147558,8.83110822 8.94147558,9.14769071 9.13673772,9.34295286 L10.1367377,10.3429529 C10.3319999,10.538215 10.6485824,10.538215 10.8438445,10.3429529 L12.8438445,8.34295286 C13.0391067,8.14769071 13.0391067,7.83110822 12.8438445,7.63584608 C12.6485824,7.44058393 12.3319999,7.44058393 12.1367377,7.63584608 L10.4902911,9.28229269 L9.84384451,8.63584608 Z"
              id="Path-2-Copy-3"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M8,13 L14,13 C14.2761424,13 14.5,12.7761424 14.5,12.5 C14.5,12.2238576 14.2761424,12 14,12 L8,12 C7.72385763,12 7.5,12.2238576 7.5,12.5 C7.5,12.7761424 7.72385763,13 8,13 Z"
              id="Path-39"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M8,15 L12,15 C12.2761424,15 12.5,14.7761424 12.5,14.5 C12.5,14.2238576 12.2761424,14 12,14 L8,14 C7.72385763,14 7.5,14.2238576 7.5,14.5 C7.5,14.7761424 7.72385763,15 8,15 Z"
              id="Path-39-Copy"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M8,17 L10,17 C10.2761424,17 10.5,16.7761424 10.5,16.5 C10.5,16.2238576 10.2761424,16 10,16 L8,16 C7.72385763,16 7.5,16.2238576 7.5,16.5 C7.5,16.7761424 7.72385763,17 8,17 Z"
              id="Path-39-Copy-2"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  customSQL: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Custom SQL</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-568.000000, -280.000000)">
          <g id="Group" transform="translate(568.000000, 280.000000)">
            <rect
              id="Rectangle-Copy-255"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-254"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M12.9724069,7.73980585 L13.0615528,7.75378875 C13.2996839,7.81332152 13.4548385,8.03442891 13.4393391,8.27098185 L13.4253563,8.36012781 L11.4850713,16.1212678 C11.4180969,16.3891653 11.1466296,16.5520456 10.8787322,16.4850713 C10.6406011,16.4255385 10.4854465,16.2044311 10.5009459,15.9678781 L10.5149287,15.8787322 L12.4552138,8.11759219 C12.5147465,7.87946112 12.7358539,7.72430653 12.9724069,7.73980585 Z M8.35355339,7.64644661 C8.52711974,7.82001296 8.54640489,8.08943736 8.41140884,8.2843055 L8.35355339,8.35355339 L4.707,12 L8.35355339,15.6464466 C8.52711974,15.820013 8.54640489,16.0894374 8.41140884,16.2843055 L8.35355339,16.3535534 C8.17998704,16.5271197 7.91056264,16.5464049 7.7156945,16.4114088 L7.64644661,16.3535534 L3.64644661,12.3535534 C3.47288026,12.179987 3.45359511,11.9105626 3.58859116,11.7156945 L3.64644661,11.6464466 L7.64644661,7.64644661 C7.84170876,7.45118446 8.15829124,7.45118446 8.35355339,7.64644661 Z M15.6464466,7.64644661 C15.8417088,7.45118446 16.1582912,7.45118446 16.3535534,7.64644661 L16.3535534,7.64644661 L20.3535534,11.6464466 L20.4114088,11.7156945 C20.5464049,11.9105626 20.5271197,12.179987 20.3535534,12.3535534 L20.3535534,12.3535534 L16.3535534,16.3535534 L16.2843055,16.4114088 C16.0894374,16.5464049 15.820013,16.5271197 15.6464466,16.3535534 L15.6464466,16.3535534 L15.5885912,16.2843055 C15.4535951,16.0894374 15.4728803,15.820013 15.6464466,15.6464466 L15.6464466,15.6464466 L19.293,12 L15.6464466,8.35355339 L15.5885912,8.2843055 C15.4535951,8.08943736 15.4728803,7.82001296 15.6464466,7.64644661 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  sync: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Sync</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-640.000000, -280.000000)">
          <g id="Group" transform="translate(640.000000, 280.000000)">
            <rect
              id="Rectangle-Copy-309"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-308"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M18.0009882,12.4999816 C18.2771306,12.4999816 18.5009882,12.7238392 18.5009882,12.9999816 C18.5009882,13.2454415 18.3241131,13.44959 18.0908639,13.4919259 L18.0009882,13.4999816 L7.42698822,13.4999816 L11.3133357,16.6095472 C11.5050077,16.7628848 11.5539279,17.0285316 11.4412771,17.2371157 L11.3914226,17.3123291 C11.238085,17.5040011 10.9724382,17.5529212 10.7638541,17.4402704 L10.6886407,17.390416 L5.6886407,13.390416 C5.34263859,13.1136143 5.50450941,12.5732074 5.91553722,12.5067378 L6.00098822,12.4999816 L18.0009882,12.4999816 Z M13.2371341,6.55971115 L13.3123475,6.6095656 L18.3123475,10.6095656 C18.6583496,10.8863673 18.4964788,11.4267742 18.085451,11.4932438 L18,11.5 L6,11.5 C5.72385763,11.5 5.5,11.2761424 5.5,11 C5.5,10.7545401 5.67687516,10.5503916 5.91012437,10.5080557 L6,10.5 L16.574,10.5 L12.6876525,7.3904344 C12.4959805,7.23709683 12.4470604,6.97144999 12.5597112,6.76286589 L12.6095656,6.68765248 C12.7629032,6.49598051 13.02855,6.44706036 13.2371341,6.55971115 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  indentityRepository: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Indentity Repository</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.900000036">
        <g id="Export" transform="translate(-424.000000, -688.000000)">
          <g id="Connectors" transform="translate(424.000000, 688.000000)">
            <rect
              id="Rectangle-Copy-219"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-218"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M18,15 C19.1045695,15 20,15.8954305 20,17 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,17 C4,15.8954305 4.8954305,15 6,15 L18,15 Z M18,16 L6,16 C5.48716416,16 5.06449284,16.3860402 5.00672773,16.8833789 L5,17 L5,18 C5,18.5128358 5.38604019,18.9355072 5.88337887,18.9932723 L6,19 L18,19 C18.5128358,19 18.9355072,18.6139598 18.9932723,18.1166211 L19,18 L19,17 C19,16.4871642 18.6139598,16.0644928 18.1166211,16.0067277 L18,16 Z M7.5,17 C7.77614237,17 8,17.2238576 8,17.5 C8,17.7761424 7.77614237,18 7.5,18 C7.22385763,18 7,17.7761424 7,17.5 C7,17.2238576 7.22385763,17 7.5,17 Z M9.5,17 C9.77614237,17 10,17.2238576 10,17.5 C10,17.7761424 9.77614237,18 9.5,18 C9.22385763,18 9,17.7761424 9,17.5 C9,17.2238576 9.22385763,17 9.5,17 Z M18,9 C19.1045695,9 20,9.8954305 20,11 L20,12 C20,13.1045695 19.1045695,14 18,14 L6,14 C4.8954305,14 4,13.1045695 4,12 L4,11 C4,9.8954305 4.8954305,9 6,9 L18,9 Z M18,10 L6,10 C5.48716416,10 5.06449284,10.3860402 5.00672773,10.8833789 L5,11 L5,12 C5,12.5128358 5.38604019,12.9355072 5.88337887,12.9932723 L6,13 L18,13 C18.5128358,13 18.9355072,12.6139598 18.9932723,12.1166211 L19,12 L19,11 C19,10.4871642 18.6139598,10.0644928 18.1166211,10.0067277 L18,10 Z M7.5,11 C7.77614237,11 8,11.2238576 8,11.5 C8,11.7761424 7.77614237,12 7.5,12 C7.22385763,12 7,11.7761424 7,11.5 C7,11.2238576 7.22385763,11 7.5,11 Z M9.5,11 C9.77614237,11 10,11.2238576 10,11.5 C10,11.7761424 9.77614237,12 9.5,12 C9.22385763,12 9,11.7761424 9,11.5 C9,11.2238576 9.22385763,11 9.5,11 Z M10.5134662,3.50905818 C12.1487899,3.50905818 13.6224325,4.38955651 14.413731,5.76277555 C14.7519767,5.5974768 15.1264879,5.50905818 15.5134662,5.50905818 C16.8941781,5.50905818 18.0134662,6.6283463 18.0134662,8.00905818 C18.0134662,8.28520055 17.7896086,8.50905818 17.5134662,8.50905818 C17.2373238,8.50905818 17.0134662,8.28520055 17.0134662,8.00905818 C17.0134662,7.18063105 16.3418933,6.50905818 15.5134662,6.50905818 C15.2065109,6.50905818 14.9145791,6.60091296 14.6672184,6.77033417 C14.5984234,6.8174529 14.5220276,6.84503756 14.4445977,6.85431614 C14.4264834,6.86596763 14.4067093,6.87612087 14.3860257,6.88504413 C14.1324727,6.99443098 13.8382518,6.87756121 13.7288649,6.6240082 C13.1796648,5.35099104 11.9239723,4.50905818 10.5134662,4.50905818 C8.58046957,4.50905818 7.0134662,6.07606155 7.0134662,8.00905818 C7.0134662,8.28520055 6.78960857,8.50905818 6.5134662,8.50905818 C6.23732382,8.50905818 6.0134662,8.28520055 6.0134662,8.00905818 C6.0134662,5.5237768 8.02818482,3.50905818 10.5134662,3.50905818 Z"
              id="Combined-Shape"
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  resultNotFound: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="94" viewBox="0 0 87 94">
      <g fill="none" fillRule="evenodd" transform="translate(0 2)">
        <rect
          width="78"
          height="66.247"
          x="8.899"
          y="18.787"
          fill="#D2E4FA"
          opacity=".628"
          rx="6"
        />
        <g stroke="#4982C3" strokeLinecap="round" strokeWidth="3">
          <path d="M13.843 0L13.843 11.865" transform="translate(48.45)" />
          <path
            d="M25.127 1.358L25.311 12.626"
            transform="translate(48.45) rotate(29 25.219 6.992)"
          />
          <path
            d="M3.253 1.358L3.437 12.626"
            transform="translate(48.45) scale(-1 1) rotate(29 0 -5.943)"
          />
        </g>
        <rect
          width="75"
          height="64.236"
          x="1.5"
          y="26.219"
          stroke="#4982C3"
          strokeWidth="3"
          rx="6"
        />
        <path
          stroke="#4982C3"
          strokeLinecap="square"
          strokeWidth="3"
          d="M3.418 42.826L75.683 42.826"
        />
        <circle cx="7.91" cy="34.607" r="1.978" fill="#4982C3" />
        <circle cx="14.831" cy="34.607" r="1.978" fill="#4982C3" />
        <circle cx="21.753" cy="34.607" r="1.978" fill="#4982C3" />
      </g>
    </svg>
  ),
  emptyEmailTemplate: () => (
    <svg width="463px" height="150px" viewBox="0 0 463 218" version="1.1">
      <defs>
        <linearGradient x1="50%" y1="-117.673165%" x2="50%" y2="44.694893%" id="linearGradient-1">
          <stop stopColor="#D8D8D8" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="illustration" transform="translate(12.000000, 24.000000)">
          <path
            d="M436,178.935673 C416.239766,106.906433 300.377631,54 218,54 C135.622369,54 42.0701754,91.6081871 0,167.461988"
            id="Oval"
            fill="url(#linearGradient-1)"
          />
          <rect id="Rectangle-Copy" fill="#C2CBFF" x="186" y="0" width="65" height="67" rx="6" />
          <rect
            id="Rectangle"
            stroke="#DDDDDD"
            strokeWidth="3"
            fill="#FFFFFF"
            x="175.5"
            y="33.5"
            width="86"
            height="52"
            rx="6"
          />
          <line
            x1="195"
            y1="21"
            x2="239"
            y2="21"
            id="Path-2-Copy-3"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="194.75"
            y1="11"
            x2="219"
            y2="11"
            id="Path-2-Copy-2"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="207"
            y1="59.5"
            x2="231"
            y2="59.5"
            id="Path-2-Copy-5"
            stroke="#352170"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="207"
            y1="59.5"
            x2="231"
            y2="59.5"
            id="Path-2-Copy-6"
            stroke="#352170"
            strokeWidth="3"
            strokeLinecap="round"
            transform="translate(219.000000, 59.500000) rotate(90.000000) translate(-219.000000, -59.500000) "
          />
        </g>
      </g>
    </svg>
  ),
  trash: () => (
    <svg
      width="16px"
      height="18px"
      viewBox="0 0 16 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Trash</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons" transform="translate(-592.000000, -513.000000)">
          <g id="Group" transform="translate(588.000000, 510.000000)">
            <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="2" y="2" width="20" height="20" />
            <path
              d="M20,9 L20,18.5 C20,19.8807119 18.8807119,21 17.5,21 L6.5,21 C5.11928813,21 4,19.8807119 4,18.5 L4,9 L20,9 Z M19,10 L5,10 L5,18.5 C5,19.2796961 5.59488808,19.9204487 6.35553999,19.9931334 L6.5,20 L17.5,20 C18.2796961,20 18.9204487,19.4051119 18.9931334,18.64446 L19,18.5 L19,10 Z"
              id="矩形"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M18,5 C19.1045695,5 20,5.8954305 20,7 L20,8 L4,8 L4,7 C4,5.8954305 4.8954305,5 6,5 L18,5 Z M18,6 L6,6 C5.48716416,6 5.06449284,6.38604019 5.00672773,6.88337887 L5,7 L19,7 C19,6.48716416 18.6139598,6.06449284 18.1166211,6.00672773 L18,6 Z"
              id="矩形"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M12.5,3.5 C13.3284271,3.5 14,4.17157288 14,5 C14,5.27614237 13.7761424,5.5 13.5,5.5 C13.2545401,5.5 13.0503916,5.32312484 13.0080557,5.08987563 L13,5 C13,4.75454011 12.8231248,4.55039163 12.5898756,4.50805567 L12.5,4.5 L11.5,4.5 C11.2545401,4.5 11.0503916,4.67687516 11.0080557,4.91012437 L11,5 C11,5.27614237 10.7761424,5.5 10.5,5.5 C10.2238576,5.5 10,5.27614237 10,5 C10,4.22030388 10.5948881,3.57955132 11.35554,3.50686658 L11.5,3.5 L12.5,3.5 Z"
              id="路径"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M7.5,11.5 C7.74545989,11.5 7.94960837,11.6768752 7.99194433,11.9101244 L8,12 L8,18 C8,18.2761424 7.77614237,18.5 7.5,18.5 C7.25454011,18.5 7.05039163,18.3231248 7.00805567,18.0898756 L7,18 L7,12 C7,11.7238576 7.22385763,11.5 7.5,11.5 Z"
              id="直线"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M10.5,11.5 C10.7454599,11.5 10.9496084,11.6768752 10.9919443,11.9101244 L11,12 L11,18 C11,18.2761424 10.7761424,18.5 10.5,18.5 C10.2545401,18.5 10.0503916,18.3231248 10.0080557,18.0898756 L10,18 L10,12 C10,11.7238576 10.2238576,11.5 10.5,11.5 Z"
              id="直线备份"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M13.5,11.5 C13.7454599,11.5 13.9496084,11.6768752 13.9919443,11.9101244 L14,12 L14,18 C14,18.2761424 13.7761424,18.5 13.5,18.5 C13.2545401,18.5 13.0503916,18.3231248 13.0080557,18.0898756 L13,18 L13,12 C13,11.7238576 13.2238576,11.5 13.5,11.5 Z"
              id="直线备份-2"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M16.5,11.5 C16.7454599,11.5 16.9496084,11.6768752 16.9919443,11.9101244 L17,12 L17,18 C17,18.2761424 16.7761424,18.5 16.5,18.5 C16.2545401,18.5 16.0503916,18.3231248 16.0080557,18.0898756 L16,18 L16,12 C16,11.7238576 16.2238576,11.5 16.5,11.5 Z"
              id="直线备份-3"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  call: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Call</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-638.000000, -688.000000)">
          <g id="Group" transform="translate(638.000000, 688.000000)">
            <rect
              id="Rectangle-Copy-389"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-388"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <g
              id="noun_call_469214"
              transform="translate(5.000000, 5.000000)"
              fill="#010101"
              fillRule="nonzero"
            >
              <path
                d="M13.2725771,9.85 C12.6725771,9.3 12.1225771,8.7 11.5725771,8.15 C10.9725771,7.55 10.1225771,7.55 9.47257713,8.15 L9.37257713,8.2 C9.07257713,8.5 8.77257713,8.75 8.47257713,9.1 C8.42257713,9.05 8.37257713,9.05 8.32257713,9.05 C8.22257713,9 8.02257713,8.95 7.92257713,8.85 C7.02257713,8.3 6.22257713,7.55 5.37257713,6.55 C4.97257713,6.1 4.72257713,5.65 4.52257713,5.25 C4.77257713,5 5.02257713,4.75 5.27257713,4.5 L5.47257713,4.3 C6.12257713,3.65 6.12257713,2.8 5.47257713,2.15 C5.27257713,1.95 5.07257713,1.75 4.87257713,1.55 L4.72257713,1.3 L4.72257713,1.3 C4.62257713,1.2 4.57257713,1.15 4.47257713,1.05 C4.27257713,0.85 4.07257713,0.65 3.87257713,0.45 C3.27257713,-0.15 2.42257713,-0.15 1.77257713,0.45 C1.62257713,0.6 1.47257713,0.75 1.32257713,0.9 C1.12257713,1.1 0.922577127,1.3 0.722577127,1.5 C0.322577127,1.9 0.0725771274,2.4 0.0225771274,2.95 C-0.0774228726,3.85 0.172577127,4.65 0.422577127,5.25 C0.922577127,6.6 1.72257713,7.85 2.77257713,9.2 C4.12257713,10.8 5.72257713,12.05 7.57257713,12.95 C8.62257713,13.45 9.47257713,13.7 10.3225771,13.75 C10.4225771,13.75 10.4225771,13.75 10.5225771,13.75 C11.2725771,13.75 11.8725771,13.5 12.3225771,12.95 C12.5225771,12.75 12.7225771,12.55 12.9225771,12.35 C13.0225771,12.25 13.1225771,12.15 13.2725771,12.05 C13.9225771,11.35 13.9225771,10.5 13.2725771,9.85 Z M12.6225771,11.4 C12.5225771,11.5 12.4225771,11.6 12.2725771,11.7 C12.0725771,11.9 11.8225771,12.15 11.6225771,12.4 C11.2725771,12.75 10.9225771,12.9 10.3225771,12.85 C9.62257713,12.8 8.82257713,12.55 7.92257713,12.15 C6.22257713,11.3 4.67257713,10.1 3.37257713,8.6 C2.37257713,7.4 1.67257713,6.2 1.17257713,4.95 C0.972577127,4.2 0.822577127,3.65 0.872577127,3.05 C0.922577127,2.7 1.02257713,2.45 1.27257713,2.2 C1.52257713,2 1.72257713,1.75 1.92257713,1.55 C2.07257713,1.4 2.22257713,1.25 2.32257713,1.15 C2.52257713,1 2.67257713,0.9 2.82257713,0.9 C2.97257713,0.9 3.12257713,1 3.27257713,1.15 C3.47257713,1.35 3.67257713,1.55 3.87257713,1.75 C3.92257713,1.8 4.02257713,1.9 4.12257713,2 L4.37257713,2.25 C4.57257713,2.45 4.77257713,2.65 4.97257713,2.85 C5.32257713,3.2 5.32257713,3.45 4.97257713,3.75 L4.72257713,3.95 C4.47257713,4.2 4.17257713,4.5 3.87257713,4.75 C3.72257713,4.9 3.57257713,5.15 3.72257713,5.5 C3.92257713,6.05 4.27257713,6.55 4.72257713,7.15 C5.57257713,8.2 6.47257713,9.05 7.47257713,9.65 C7.62257713,9.75 7.77257713,9.85 7.92257713,9.9 C8.02257713,9.95 8.07257713,9.95 8.17257713,10 C8.47257713,10.15 8.77257713,10.1 9.02257713,9.9 C9.37257713,9.6 9.67257713,9.25 9.97257713,8.95 L10.0725771,8.9 C10.3725771,8.6 10.6725771,8.6 10.9725771,8.9 C11.5225771,9.45 12.0725771,10 12.6725771,10.6 C12.9225771,10.75 12.9225771,11.1 12.6225771,11.4 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  organization: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Organization</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-280.000000, -208.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(280.000000, 208.000000)">
            <path d="M18,11 C18.5522847,11 19,11.4477153 19,12 L19,19 C19,19.5522847 18.5522847,20 18,20 L14,20 L13.95,19.997 L11.0507041,19.9987368 C11.0339086,19.9995756 11.0170038,20 11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,15 C6,14.4477153 6.44771525,14 7,14 L11,14 C11.5522847,14 12,14.4477153 12,15 L12,18.997 L13,18.997 L13,12 C13,11.4477153 13.4477153,11 14,11 L18,11 Z M11,15 L7,15 L7,19 L10.439,19 L10.473652,18.9976869 L11,18.997 L11,15 Z M18,12 L14,12 L14,18.997 L14.473652,18.9976869 C14.4852432,18.9976869 14.4967422,18.9980813 14.5081365,18.9988574 L18,19 L18,12 Z M9.51750287,16.5086787 C9.79364525,16.5086787 10.0175029,16.7325363 10.0175029,17.0086787 C10.0175029,17.284821 9.79364525,17.5086787 9.51750287,17.5086787 L9.51750287,17.5086787 L8.51750287,17.5086787 C8.2413605,17.5086787 8.01750287,17.284821 8.01750287,17.0086787 C8.01750287,16.7325363 8.2413605,16.5086787 8.51750287,16.5086787 L8.51750287,16.5086787 Z M16.5082701,15.5188868 C16.7844125,15.5188868 17.0082701,15.7427444 17.0082701,16.0188868 C17.0082701,16.2950291 16.7844125,16.5188868 16.5082701,16.5188868 L16.5082701,16.5188868 L15.5082701,16.5188868 C15.2321277,16.5188868 15.0082701,16.2950291 15.0082701,16.0188868 C15.0082701,15.7427444 15.2321277,15.5188868 15.5082701,15.5188868 L15.5082701,15.5188868 Z M16.5082701,13.5188868 C16.7844125,13.5188868 17.0082701,13.7427444 17.0082701,14.0188868 C17.0082701,14.2950291 16.7844125,14.5188868 16.5082701,14.5188868 L16.5082701,14.5188868 L15.5082701,14.5188868 C15.2321277,14.5188868 15.0082701,14.2950291 15.0082701,14.0188868 C15.0082701,13.7427444 15.2321277,13.5188868 15.5082701,13.5188868 L15.5082701,13.5188868 Z M15.3333333,7.5 C16.0305346,7.5 16.5,8.20419816 16.5,9 L16.5,10 C16.5,10.2761424 16.2761424,10.5 16,10.5 C15.7238576,10.5 15.5,10.2761424 15.5,10 L15.5,9 C15.5,8.69123234 15.3725118,8.5 15.3333333,8.5 L9.66666667,8.5 C9.62748823,8.5 9.5,8.69123234 9.5,9 L9.5,13 C9.5,13.2761424 9.27614237,13.5 9,13.5 C8.72385763,13.5 8.5,13.2761424 8.5,13 L8.5,9 C8.5,8.20419816 8.96946544,7.5 9.66666667,7.5 L15.3333333,7.5 Z M12.5,4 C13.3284271,4 14,4.67157288 14,5.5 C14,6.32842712 13.3284271,7 12.5,7 C11.6715729,7 11,6.32842712 11,5.5 C11,4.67157288 11.6715729,4 12.5,4 Z M12.5,5 C12.2238576,5 12,5.22385763 12,5.5 C12,5.77614237 12.2238576,6 12.5,6 C12.7761424,6 13,5.77614237 13,5.5 C13,5.22385763 12.7761424,5 12.5,5 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  email: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Email</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-568.000000, -688.000000)">
          <g id="Group" transform="translate(568.000000, 688.000000)">
            <rect
              id="Rectangle-Copy-387"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-386"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M18,6 C19.1045695,6 20,6.8954305 20,8 L20,16 C20,17.1045695 19.1045695,18 18,18 L6,18 C4.8954305,18 4,17.1045695 4,16 L4,8 C4,6.8954305 4.8954305,6 6,6 L18,6 Z M18.9539537,7.69915409 L12.9761871,12.8218071 C12.4519014,13.2711948 11.6948808,13.301154 11.1395638,12.9116847 L11.0238129,12.8218071 L5.04604633,7.69915409 C5.02738835,7.75837369 5.01409237,7.81997173 5.00672773,7.88337887 L5,8 L5,16 C5,16.5128358 5.38604019,16.9355072 5.88337887,16.9932723 L6,17 L18,17 C18.5128358,17 18.9355072,16.6139598 18.9932723,16.1166211 L19,16 L19,8 C19,7.89516817 18.983869,7.79410395 18.9539537,7.69915409 Z M18,7 L6,7 C5.92948071,7 5.8606663,7.00729948 5.79427113,7.02118407 L11.6746043,12.0625505 C11.8384436,12.2029842 12.0704669,12.2205384 12.2513522,12.1152131 L12.3253957,12.0625505 L18.2057289,7.02118407 C18.1764756,7.0150666 18.1467526,7.01022746 18.1166211,7.00672773 L18,7 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  password: () => (
    <svg
      width="15px"
      height="18px"
      viewBox="0 0 15 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>;ock/Password</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="icons" transform="translate(-365.000000, -513.000000)">
          <g id="Group" transform="translate(360.000000, 510.000000)">
            <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="2" y="2" width="20" height="20" />
            <path
              d="M19.5,11 L19.5,18 C19.5,19.6568542 18.1568542,21 16.5,21 L8.5,21 C6.84314575,21 5.5,19.6568542 5.5,18 L5.5,11 L19.5,11 Z M18.5,12 L6.5,12 L6.5,18 C6.5,19.0543618 7.31587779,19.9181651 8.35073766,19.9945143 L8.5,20 L16.5,20 C17.5543618,20 18.4181651,19.1841222 18.4945143,18.1492623 L18.5,18 L18.5,12 Z"
              id="矩形"
              fill="#000000"
              fillRule="nonzero"
            />
            <path
              d="M14,3 C15.3254834,3 16.4100387,4.03153594 16.4946823,5.33562431 L16.5,5.5 L16.5,9.5 C16.5,9.77614237 16.2761424,10 16,10 C15.7545401,10 15.5503916,9.82312484 15.5080557,9.58987563 L15.5,9.5 L15.5,5.5 C15.5,4.72030388 14.9051119,4.07955132 14.14446,4.00686658 L14,4 L11,4 C10.2203039,4 9.57955132,4.59488808 9.50686658,5.35553999 L9.5,5.5 L9.5,9.5 C9.5,9.77614237 9.27614237,10 9,10 C8.75454011,10 8.55039163,9.82312484 8.50805567,9.58987563 L8.5,9.5 L8.5,5.5 C8.5,4.1745166 9.53153594,3.08996133 10.8356243,3.00531768 L11,3 L14,3 Z"
              id="路径-2"
              fill="#000000"
              fillRule="nonzero"
            />
            <rect id="Rectangle" fill="#000000" x="12" y="13.5" width="1" height="4" rx="0.5" />
          </g>
        </g>
      </g>
    </svg>
  ),
  discontinueRequestNew: () => (
    <svg
      width="437px"
      height="100px"
      viewBox="0 0 437 100"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Discontinue</title>
      <defs>
        <linearGradient x1="50%" y1="-117.673165%" x2="50%" y2="44.694893%" id="linearGradient-1">
          <stop stopColor="#D8D8D8" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
        <rect id="path-2" x="0" y="0" width="54" height="69" rx="6" />
        <filter
          x="-8.3%"
          y="-6.5%"
          width="111.1%"
          height="108.7%"
          filterUnits="objectBoundingBox"
          id="filter-3"
        >
          <feOffset dx="-3" dy="-3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.943368902   0 0 0 0 0.95172431   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
        <rect id="path-4" x="0" y="0" width="54" height="69" rx="6" />
        <filter
          x="-2.8%"
          y="-6.5%"
          width="111.1%"
          height="108.7%"
          filterUnits="objectBoundingBox"
          id="filter-5"
        >
          <feOffset dx="3" dy="-3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.945098039   0 0 0 0 0.952941176   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
        <rect id="path-6" x="0" y="0" width="72" height="89" rx="6" />
        <filter
          x="-12.5%"
          y="-9.0%"
          width="116.7%"
          height="112.4%"
          filterUnits="objectBoundingBox"
          id="filter-7"
        >
          <feOffset dx="-6" dy="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.215686275   0 0 0 0 0.317647059   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="illustration" transform="translate(0.000000, 5.000000)">
          <path
            d="M436.489796,180.98538 C416.729562,108.95614 300.867426,56.0497076 218.489796,56.0497076 C136.112165,56.0497076 42.5599714,93.6578947 0.489795918,169.511696"
            id="Oval"
            fill="url(#linearGradient-1)"
          />
          <g id="Group" transform="translate(136.000000, 12.000000)">
            <g id="Rectangle-Copy-2">
              <use fill="black" fillOpacity="1" filter="url(#filter-3)" />
              <rect
                stroke="#E9E9E9"
                strokeWidth="2"
                strokeLinejoin="square"
                fill="#FFFFFF"
                fillRule="evenodd"
                x="1"
                y="1"
                width="52"
                height="67"
                rx="6"
              />
            </g>
            <line
              x1="9"
              y1="16.5"
              x2="45"
              y2="16.5"
              id="Path-2-Copy-9"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="27"
              x2="45"
              y2="27"
              id="Path-2-Copy-8"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="37.5"
              x2="45"
              y2="37.5"
              id="Path-2-Copy-7"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="48.5"
              x2="20.5"
              y2="48.5"
              id="Path-2-Copy-4"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </g>
          <g id="Group-Copy" transform="translate(219.000000, 12.000000)">
            <g id="Rectangle-Copy-2">
              <use fill="black" fillOpacity="1" filter="url(#filter-5)" />
              <rect
                stroke="#E9E9E9"
                strokeWidth="2"
                strokeLinejoin="square"
                fill="#FFFFFF"
                fillRule="evenodd"
                x="1"
                y="1"
                width="52"
                height="67"
                rx="6"
              />
            </g>
            <line
              x1="9"
              y1="16.5"
              x2="45"
              y2="16.5"
              id="Path-2-Copy-9"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="27"
              x2="45"
              y2="27"
              id="Path-2-Copy-8"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="37.5"
              x2="45"
              y2="37.5"
              id="Path-2-Copy-7"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <line
              x1="32.5"
              y1="48.5"
              x2="44"
              y2="48.5"
              id="Path-2-Copy-4"
              stroke="#E9EAEF"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </g>
          <g id="Group-2" transform="translate(172.000000, 0.000000)">
            <g id="Rectangle">
              <use fill="black" fillOpacity="1" filter="url(#filter-7)" />
              <rect
                stroke="#EEEEEE"
                strokeWidth="3"
                strokeLinejoin="square"
                fill="#FFFFFF"
                fillRule="evenodd"
                x="1.5"
                y="1.5"
                width="69"
                height="86"
                rx="6"
              />
            </g>
            <path
              d="M27,51.5714286 C29.5,49.8571429 32.5,49 36,49 C39.5,49 42.5,49.8571429 45,51.5714286"
              id="Path-3"
              stroke="#352170"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle id="Oval" fill="#352170" cx="25" cy="34" r="3" />
            <circle id="Oval-Copy" fill="#352170" cx="47" cy="34" r="3" />
          </g>
        </g>
      </g>
    </svg>
  ),

  pendingActionsEmptyRequestsImage: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 180 180">
      <defs>
        <linearGradient id="uv0aqx9qmd" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFF" />
          <stop offset="63.828%" stopColor="#FFF" stopOpacity=".877" />
          <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="afha4jzwyf" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFF" />
          <stop offset="63.593%" stopColor="#FFF" stopOpacity=".752" />
          <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="v8li3xeslh" x1="91.791%" x2="32.368%" y1="15.745%" y2="93.776%">
          <stop offset="0%" stopColor="#A3B4F9" />
          <stop offset="100%" stopColor="#596BD4" />
        </linearGradient>
        <path id="esgymsw7db" d="M0 0H480V1007H0z" />
        <path id="ta3hvwdlxg" d="M0 0.084L63.592 0.084 63.592 59.587 0 59.587z" />
        <filter
          id="vxbf7wq1za"
          width="105.6%"
          height="102.7%"
          x="-2.2%"
          y="-1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4" />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.874509804 0 0 0 0 0.878431373 0 0 0 0 0.921568627 0 0 0 1 0"
          />
        </filter>
        <circle id="ghslrkm1uc" cx="90" cy="90" r="90" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <path fill="#F7F8FC" d="M0 0H480V944H0z" transform="translate(-150 -324)" />
          <g transform="translate(-150 -324) translate(0 -3)">
            <use fill="#000" filter="url(#vxbf7wq1za)" xlinkHref="#esgymsw7db" />
            <use fill="#FFF" xlinkHref="#esgymsw7db" />
          </g>
          <g transform="translate(-150 -324) translate(150 324)">
            <mask id="y8dlh2rg1e" fill="#fff">
              <use xlinkHref="#ghslrkm1uc" />
            </mask>
            <use fill="#EDF2FF" xlinkHref="#ghslrkm1uc" />
            <path
              fill="url(#uv0aqx9qmd)"
              d="M98 47c0-20.434 16.56-37 36.986-37 12.58 0 23.693 6.284 30.375 15.885 2.29-.794 4.749-1.225 7.308-1.225C185.002 24.66 195 34.662 195 47"
              mask="url(#y8dlh2rg1e)"
              transform="matrix(-1 0 0 1 293 0)"
            />
            <path
              fill="url(#afha4jzwyf)"
              d="M-25 153c0-20.434 16.56-37 36.986-37 12.58 0 23.693 6.284 30.375 15.885 2.29-.794 4.749-1.225 7.308-1.225C62.002 130.66 72 140.662 72 153"
              mask="url(#y8dlh2rg1e)"
            />
            <g mask="url(#y8dlh2rg1e)">
              <g transform="translate(49 58)">
                <g transform="translate(0 .917)">
                  <mask id="kwhi1udwni" fill="#fff">
                    <use xlinkHref="#ta3hvwdlxg" />
                  </mask>
                  <path
                    fill="url(#v8li3xeslh)"
                    d="M63.592 11.169c-.55-3.503-3.568-6.085-7.115-6.085h-25.51c-1.898 0-3.616-1.12-4.383-2.855C26.008.925 24.717.084 23.292.084H4.416C2.927.084 1.592 1 1.057 2.39.124 4.815-.198 7.43.117 10.01l5.647 46.23c.064.53.377.997.841 1.26L9.91 59.37c.252.143.537.217.828.217h46.868c.868 0 1.592-.661 1.673-1.525l4.314-46.893"
                    mask="url(#kwhi1udwni)"
                  />
                </g>
                <path
                  fill="#BBC5FF"
                  d="M15.466 17.955C15.848 14.01 19.163 11 23.125 11l52.19.893c3.41.058 6.047 3.008 5.722 6.402l-3.573 37.467c-.471 4.078-3.924 7.155-8.028 7.155l-58.79-.387c-2.537-.016-4.627-1.997-4.78-4.53l1.583.242c1.065.163 2.143-.18 2.918-.926.883-.85 1.433-1.985 1.553-3.203l3.546-36.158z"
                />
                <path
                  stroke="#596BD4"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M41 43c1.944 1.333 4.278 2 7 2 2.722 0 5.056-.667 7-2"
                />
                <circle cx="40" cy="31" r="2" fill="#596BD4" />
                <circle cx="55" cy="31" r="2" fill="#596BD4" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),

  pendingActionsLastPageImage: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="406" height="162" viewBox="0 0 406 162">
      <defs>
        <linearGradient id="a0a52hiuwc" x1="50%" x2="50%" y1="-72.647%" y2="73.43%">
          <stop offset="0%" stopColor="#EDF2FF" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="9f6duiix3d" x1="37.966%" x2="100%" y1="50.873%" y2="49.127%">
          <stop offset="0%" stopColor="#B5C4FF" />
          <stop offset="100%" stopColor="#6678DF" />
        </linearGradient>
        <linearGradient id="d74ndmmfxe" x1="91.791%" x2="32.368%" y1="49.4%" y2="50.766%">
          <stop offset="0%" stopColor="#B5C4FF" />
          <stop offset="100%" stopColor="#6678DF" />
        </linearGradient>
        <filter
          id="4rjsk4qo8a"
          width="105.6%"
          height="102.7%"
          x="-2.2%"
          y="-1%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4" />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0.874509804 0 0 0 0 0.878431373 0 0 0 0 0.921568627 0 0 0 1 0"
          />
        </filter>
        <path id="afdqfum1kb" d="M0 0H480V1007H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <path fill="#F7F8FC" d="M0 0H480V944H0z" transform="translate(-37 -765)" />
          <g transform="translate(-37 -765) translate(0 -3)">
            <use fill="#000" filter="url(#4rjsk4qo8a)" xlinkHref="#afdqfum1kb" />
            <use fill="#FFF" xlinkHref="#afdqfum1kb" />
          </g>
          <g>
            <g transform="translate(-37 -765) translate(37 765) translate(153)">
              <path
                fill="url(#9f6duiix3d)"
                d="M0 0h58.863c0 4.296-3.482 7.778-7.778 7.778H0V0z"
                transform="rotate(180 29.431 3.889)"
              />
              <path
                fill="#BBC5FF"
                d="M15.49 0h42.667c5.523 0 10 4.477 10 10v50c0 5.523-4.477 10-10 10H25.49c-5.523 0-10-4.477-10-10V0z"
              />
              <rect width="32.529" height="2.333" x="28.657" y="14" fill="#EDF2FF" rx="1.167" />
              <rect width="32.529" height="2.333" x="28.657" y="23.333" fill="#EDF2FF" rx="1.167" />
              <rect width="32.529" height="2.333" x="28.657" y="32.667" fill="#EDF2FF" rx="1.167" />
              <rect width="32.529" height="2.333" x="28.657" y="42" fill="#596BD4" rx="1.167" />
              <rect width="2.324" height="2.333" x="22.461" y="14" fill="#EDF2FF" rx="1.162" />
              <rect width="2.324" height="2.333" x="22.461" y="23.333" fill="#EDF2FF" rx="1.162" />
              <rect width="2.324" height="2.333" x="22.461" y="32.667" fill="#EDF2FF" rx="1.162" />
              <rect width="2.324" height="2.333" x="22.461" y="42" fill="#596BD4" rx="1.162" />
              <path fill="url(#d74ndmmfxe)" d="M22.46 63H79c0 3.866-3.134 7-7 7H22.46v-7z" />
              <ellipse cx="22.461" cy="63" fill="#BBC5FF" rx="6.971" ry="7" />
              <path
                fill="#BBC5FF"
                d="M15.278 7.778v-.033C15.278 3.468 11.811 0 7.533 0H27.26v7.778h-11.98z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  reserveSlot: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
        fill="#3751FF"
        d="M14.25 3.75c.276 0 .5.187.5.417V5H15c.92 0 1.667.746 1.667 1.667v7.5c0 .92-.747 1.666-1.667 1.666H5c-.92 0-1.667-.746-1.667-1.666v-7.5C3.333 5.747 4.08 5 5 5h.417v-.833c0-.23.224-.417.5-.417s.5.187.5.417V5h7.333v-.833c0-.23.224-.417.5-.417zm1.583 4.333H4.167v6.084c0 .46.373.833.833.833h10c.46 0 .833-.373.833-.833V8.083zM7.5 9.583c.23 0 .417.224.417.5s-.187.5-.417.5H5.833c-.23 0-.416-.224-.416-.5s.186-.5.416-.5zm4.167 0c.23 0 .416.224.416.5s-.186.5-.416.5H10c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zM15 5.833H5c-.46 0-.833.373-.833.834v.416h11.666v-.416c0-.46-.373-.834-.833-.834z"
      />
    </svg>
  ),
  addMore: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <circle cx="8" cy="8" r="7.5" stroke="#4852FF" />
        <rect width="8" height="1" x="4" y="7.5" fill="#4852FF" rx=".5" />
        <rect
          width="8"
          height="1"
          x="4"
          y="7.5"
          fill="#4852FF"
          rx=".5"
          transform="rotate(90 8 8)"
        />
      </g>
    </svg>
  ),
  advancedValue: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15">
      <g fill="#999">
        <polygon points="13 0 13 4 12 4 12 1 1 1 1 14 8 14 8 15 0 15 0 0" />
        <g transform="rotate(90 5.453 10.979)">
          <polygon points="4 0 5 0 5 8 4 8" />
          <polygon points="4 0 5 0 5 8 4 8" transform="rotate(90 4.5 4)" />
        </g>
      </g>
    </svg>
  ),
  sapCredential: () => (
    <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg">
      <title>Credentials</title>

      <g>
        <title>background</title>
        <rect fill="none" id="canvas_background" height="52" width="52" y="-1" x="-1" />
      </g>
      <g>
        <title>Layer 1</title>
        <g fill="none" id="V3">
          <g id="Export">
            <g id="Group">
              <rect
                height="95.19231"
                width="97.11538"
                y="0"
                x="0"
                opacity="0"
                fill="#D8D8D8"
                id="Rectangle-Copy-116"
              />
              <rect
                height="95.19231"
                width="97.11538"
                y="3.80769"
                x="3.88462"
                opacity="0"
                fill="#FFF5F5"
                id="Rectangle-Copy-115"
              />
              <path
                stroke="#3751ff"
                fill="#000000"
                id="Combined-Shape"
                d="m30.23588,9.17997c0.26817,-0.4553 0.86211,-0.61131 1.32662,-0.34844c7.89643,4.46873 10.60195,14.36591 6.04295,22.10598c-4.559,7.74007 -14.65613,10.39201 -22.55256,5.92328c-7.89643,-4.46873 -10.60195,-14.36591 -6.04295,-22.10598c1.45222,-2.46552 3.50196,-4.4716 5.95644,-5.87702c0.46312,-0.26517 1.05788,-0.11214 1.32842,0.3418c0.27052,0.45395 0.1144,1.03693 -0.3487,1.30212c-2.16488,1.23959 -3.97175,3.00798 -5.25406,5.18503c-4.02266,6.82946 -1.63542,15.56227 5.332,19.50527c6.96743,3.943 15.87666,1.60304 19.89931,-5.22642c4.02266,-6.82946 1.63542,-15.56227 -5.332,-19.50527c-0.4645,-0.26286 -0.62364,-0.84506 -0.35546,-1.30035zm-6.92819,1.29119c2.68176,0 4.85577,2.13096 4.85577,4.75962c0,2.30238 -1.66778,4.22292 -3.88378,4.66423l-0.00165,1.99868l0.97197,0.00055l0.17457,0.01535c0.45302,0.08059 0.79658,0.46926 0.79658,0.93658c0,0.52573 -0.4348,0.95192 -0.97115,0.95192l0,0l-0.97197,-0.00055l0,1.90385l2.91428,0.00055l0.17457,0.01535c0.45302,0.08059 0.79658,0.46926 0.79658,0.93658c0,0.52573 -0.4348,0.95192 -0.97115,0.95192l0,0l-2.91428,-0.00055l0.00082,0.95248l-0.01565,0.17112c-0.08222,0.44405 -0.47874,0.78081 -0.9555,0.78081c-0.53635,0 -0.97115,-0.4262 -0.97115,-0.95192l0,0l0,-9.51923l0.01565,-0.17112c0.08222,-0.44405 0.47874,-0.78081 0.9555,-0.78081l0,0c1.60907,0 2.91346,-1.27857 2.91346,-2.85577c0,-1.5772 -1.3044,-2.85577 -2.91346,-2.85577c-1.02478,0 -1.9566,0.5219 -2.48404,1.36245c-0.27952,0.44544 -0.42942,0.95741 -0.42942,1.49332c0,0.60184 0.18928,1.1733 0.53697,1.65256c0.31085,0.42844 0.20849,1.02275 -0.22861,1.32744c-0.43712,0.30467 -1.04343,0.20434 -1.35427,-0.2241c-0.5796,-0.79891 -0.89639,-1.75533 -0.89639,-2.75589c0,-0.89064 0.25089,-1.74743 0.71731,-2.49074c0.8773,-1.39813 2.43196,-2.26887 4.13846,-2.26887z"
              />
              <g transform="matrix(1.94231, 0, 0, -1.90385, -81.5769, -34.2692)" id="Group-6" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  infinityLoop: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="29" viewBox="0 0 42 29">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-658 -148)">
          <path fill="#F7F8FC" d="M0 0H1367V764H0z" />
          <path fill="#000" fillOpacity=".5" d="M0 0H1367V764H0z" />
          <rect width="518" height="600" x="425" y="89" fill="#F7F8FC" fillRule="nonzero" rx="3" />
          <g transform="translate(645 129)">
            <circle cx="34" cy="34" r="34" fill="#E3E7FF" />
            <g stroke="#3751FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
              <path
                d="M29.626 11L26.833 13.793 24.04 11M16.46 17.24L13.667 14.447 10.874 17.24"
                transform="translate(14 20)"
              />
              <g>
                <path
                  d="M13.667 26.5C6.395 26.5.5 20.605.5 13.334.5 6.062 6.395.167 13.667.167c7.271 0 13.166 5.895 13.166 13.167"
                  transform="translate(14 20) translate(0 .333)"
                />
                <path
                  strokeDasharray="4 4"
                  d="M26.833.167C34.105.167 40 6.062 40 13.334c0 7.27-5.895 13.166-13.167 13.166-7.271 0-13.166-5.895-13.166-13.166"
                  transform="translate(14 20) translate(0 .333)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  rulerAndPencil: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="#000" fillRule="nonzero">
          <g>
            <path
              d="M9.167 5.013l.111.101 2.813 2.814 2.87-2.867c.093-.094.22-.147.353-.147 1.065 0 1.899.278 2.475.854.575.575.853 1.41.853 2.475 0 .106-.034.208-.095.293l-.051.06-2.837 2.836 2.657 2.657c.476.476.507 1.23.09 1.74l-.088.1-1.698 1.697c-.476.476-1.23.505-1.74.088l-.1-.09-2.657-2.657-2.113 2.114c-.046.047-.101.084-.161.109l-.094.028-3.536.707c-.323.065-.61-.193-.598-.508l.01-.08.707-3.536c.013-.064.038-.125.075-.18l.062-.075 2.081-2.083L5.743 8.65l-.096-.104c-.452-.531-.532-1.273-.138-1.773l.092-.103 1.697-1.697.097-.087c.498-.399 1.24-.322 1.772.127zm5.785 7.126L12.83 14.26l2.657 2.657c.102.101.256.116.372.045l.054-.043 1.697-1.697c.1-.1.115-.255.042-.372l-.043-.054-1.202-1.201-.71.709c-.195.195-.511.195-.706 0-.174-.174-.193-.443-.058-.638l.058-.07.708-.708-.747-.749zm-7.817 2.774l-.375 1.884 1.881-.377-1.506-1.507zM13.9 7.535l-6.364 6.364 2.121 2.121 6.364-6.364L13.9 7.535zm-5.85-1.886l-.044.031-1.697 1.697-.03.044c-.05.1-.023.277.101.441l.07.08 2.814 2.814 2.122-2.121-1.373-1.373-1.385 1.385c-.196.195-.512.195-.707 0-.174-.173-.193-.443-.058-.638l.058-.069 1.384-1.385-.733-.734-.08-.07c-.165-.124-.341-.15-.442-.102zm7.468.269l-.911.91 2.121 2.121.911-.91-.015-.22c-.044-.467-.165-.839-.359-1.123l-.087-.116-.096-.105c-.267-.267-.646-.442-1.15-.518l-.193-.024-.22-.015z"
              transform="translate(-501 -341) translate(501 341)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  info: () => (
    <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-603 -397)">
          <path fill="#F8F9FC" d="M0 0H1367V1555H0z" />
          <rect width="921" height="1284" x="223" y="193" fill="#FFF" stroke="#ECECEC" rx="3" />
          <g fill="#C9C9C9" fillRule="nonzero">
            <path
              d="M6.006 0c2.428.002 4.615 1.468 5.54 3.712.926 2.244.409 4.825-1.311 6.538-1.72 1.714-4.303 2.222-6.543 1.288C1.45 10.604-.006 8.412 0 5.984.009 2.674 2.696-.003 6.006 0zm-.458 4.56h-1.07c-.079 0-.156.012-.231.032-.092.02-.162.094-.175.186-.026.101.025.205.12.248.115.054.239.087.366.098.333.016.468.162.417.505-.093.642-.22 1.28-.327 1.92-.074.432-.135.865-.206 1.297-.094.582.448 1.128.879 1.2.255.036.513.053.77.05.552-.001 1.08-.23 1.458-.632.069-.063.12-.143.15-.231.015-.078-.004-.158-.05-.221-.057-.035-.126-.043-.189-.02-.098.032-.186.1-.282.141-.112.053-.23.093-.35.12-.097.024-.2.004-.282-.055-.08-.058-.132-.15-.14-.25-.02-.111-.024-.225-.011-.338.04-.278.098-.554.149-.83.136-.753.275-1.506.416-2.26.038-.206.103-.41.06-.626-.007-.097-.052-.187-.126-.25-.073-.062-.169-.093-.265-.084H5.548zM6.2 1.891c-.442-.02-.852.231-1.037.634-.185.402-.108.876.194 1.2.303.323.771.43 1.185.272.414-.158.69-.55.7-.993.017-.594-.448-1.09-1.042-1.11V1.89z"
              transform="translate(609 402)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  accessmanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>intelligence</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-496.000000, -208.000000)">
          <g id="Group" transform="translate(496.000000, 208.000000)">
            <rect
              id="Rectangle-Copy-136"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-135"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M19.9990874,11.5539282 C20.2750355,11.5642859 20.490339,11.7963826 20.4799813,12.0723306 C20.3710598,14.9742061 18.7968391,17.6429738 16.2346271,19.1222676 C15.9954808,19.2603387 15.6896856,19.1784012 15.5516144,18.9392549 C15.4359463,18.7389118 15.4746831,18.4917938 15.6309023,18.3356975 C15.5499189,18.249142 15.5,18.1304006 15.5,18 L15.5,18 L15.5,17 L15.4931334,16.85554 C15.4204487,16.0948881 14.7796961,15.5 14,15.5 L14,15.5 L10,15.5 L9.85553999,15.5068666 C9.09488808,15.5795513 8.5,16.2203039 8.5,17 L8.5,17 L8.5,18 L8.49194433,18.0898756 C8.47702894,18.1720517 8.44202897,18.3092918 8.3922139,18.4525967 C8.46230644,18.5961136 8.46053219,18.7703458 8.37402303,18.9184366 C8.23473534,19.1568765 7.92852669,19.2372552 7.69008686,19.0979675 C6.42639737,18.3597671 5.37109098,17.306071 4.62341117,16.0110516 C4.00782902,14.9448321 3.63737835,13.7787285 3.52211042,12.5789903 C3.49570095,12.3041137 3.69712336,12.059873 3.97199997,12.0334636 C4.24687658,12.0070541 4.49111721,12.2084765 4.51752668,12.4833531 C4.61917158,13.5412994 4.94579018,14.5694285 5.48943657,15.5110516 C6.00718837,16.407824 6.69104527,17.1725862 7.49963901,17.7748956 L7.5,17 L7.50531768,16.8356243 C7.58996133,15.5315359 8.6745166,14.5 10,14.5 L10,14.5 L14,14.5 L14.1643757,14.5053177 C15.4684641,14.5899613 16.5,15.6745166 16.5,17 L16.5,17 L16.5014036,17.7490779 C18.3069874,16.3895755 19.3959312,14.2928247 19.480685,12.0348222 C19.4910427,11.7588741 19.7231394,11.5435706 19.9990874,11.5539282 Z M12,9 C13.1045695,9 14,9.8954305 14,11 C14,12.1045695 13.1045695,13 12,13 C10.8954305,13 10,12.1045695 10,11 C10,9.8954305 10.8954305,9 12,9 Z M12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 Z M6,6 L9,11 L3,11 L6,6 Z M20,7 L20,11 L16,11 L16,7 L20,7 Z M6,7.943 L4.765,10 L7.234,10 L6,7.943 Z M19,8 L17,8 L17,10 L19,10 L19,8 Z M7.99835548,4.25367376 C10.4764939,2.93656905 13.4104729,2.936897 15.8747243,4.20237572 C16.1203694,4.32852298 16.2172415,4.62992018 16.0910942,4.87556521 C15.964947,5.12121024 15.6635498,5.21808232 15.4179047,5.09193507 C13.1647831,3.93487885 10.4689758,3.97585925 8.2346271,5.2658611 L8.2346271,5.2658611 L8.1321902,5.31606776 C7.90927281,5.3967236 7.653746,5.3091595 7.53034762,5.0969723 C7.39153806,4.85825383 7.47252204,4.5522047 7.71123681,4.41338874 L7.71123681,4.41338874 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  accountmanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>User Management</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-352.000000, -752.000000)">
          <g id="Group" transform="translate(352.000000, 752.000000)">
            <rect
              id="Rectangle-Copy-58"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-57"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15,4 C16.1045695,4 17,4.8954305 17,6 L17,6.5 L18,6.5 C18.7796961,6.5 19.4204487,7.09488808 19.4931334,7.85553999 L19.5,8 L19.5,18 C19.5,18.7796961 18.9051119,19.4204487 18.14446,19.4931334 L18,19.5 L16.3224453,19.500412 C15.9699368,19.8113483 15.5069994,20 15,20 L7,20 C5.8954305,20 5,19.1045695 5,18 L5,4 L15,4 Z M6,8 L6,18 C6,18.5128358 6.38604019,18.9355072 6.88337887,18.9932723 L7,19 L15,19 C15.5128358,19 15.9355072,18.6139598 15.9932723,18.1166211 L16,18 L16,8 L6,8 Z M17,18 C17,18.1730179 16.9780301,18.3409045 16.9367279,18.5010222 L18,18.5 C18.2454599,18.5 18.4496084,18.3231248 18.4919443,18.0898756 L18.5,18 L18.5,8 C18.5,7.75454011 18.3231248,7.55039163 18.0898756,7.50805567 L18,7.5 L17,7.5 L17,18 Z M13.5,13.5 L13.6197813,13.5080631 C14.1640915,13.5825569 14.5,14.1625097 14.5,14.8 L14.5,14.8 L14.5,17 L14.4919443,17.0898756 C14.4496084,17.3231248 14.2454599,17.5 14,17.5 C13.7238576,17.5 13.5,17.2761424 13.5,17 L13.5,17 L13.5,14.8 L13.4967408,14.7202097 C13.4947491,14.6956758 13.492033,14.6732029 13.489136,14.6527856 L13.489136,14.6527856 L13.4739263,14.5549036 C13.4695807,14.5182516 13.4733831,14.5 13.5,14.5 L13.5,14.5 L8.5,14.5 L8.51955526,14.5060894 C8.52824648,14.5142122 8.52897075,14.5304689 8.52607368,14.5549036 L8.52607368,14.5549036 L8.51086403,14.6527856 C8.50506988,14.6936203 8.5,14.7426771 8.5,14.8 L8.5,14.8 L8.5,17 L8.49194433,17.0898756 C8.44960837,17.3231248 8.24545989,17.5 8,17.5 C7.72385763,17.5 7.5,17.2761424 7.5,17 L7.5,17 L7.5,14.8 L7.50509499,14.6644389 C7.55243137,14.0374535 7.92656858,13.5 8.5,13.5 L8.5,13.5 L13.5,13.5 Z M10.9870361,10 C11.8154632,10 12.4870361,10.6715729 12.4870361,11.5 C12.4870361,12.3284271 11.8154632,13 10.9870361,13 C10.1586089,13 9.48703605,12.3284271 9.48703605,11.5 C9.48703605,10.6715729 10.1586089,10 10.9870361,10 Z M10.9870361,11 C10.7108937,11 10.4870361,11.2238576 10.4870361,11.5 C10.4870361,11.7761424 10.7108937,12 10.9870361,12 C11.2631784,12 11.4870361,11.7761424 11.4870361,11.5 C11.4870361,11.2238576 11.2631784,11 10.9870361,11 Z M6,7 L16,7 L16,6 C16,5.48716416 15.6139598,5.06449284 15.1166211,5.00672773 L15,5 L6,5 L6,7 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  certifications: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>certifications</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-424.000000, -352.000000)">
          <g id="Group" transform="translate(424.000000, 352.000000)">
            <rect
              id="Rectangle-Copy-107"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-106"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15,11 C16.6568542,11 18,12.3431458 18,14 C18,14.6545207 17.7903952,15.2600855 17.434648,15.753232 C17.4622402,15.8012429 17.4817674,15.8540548 17.4919443,15.9101244 L17.5,16 L17.5,21 C17.5,21.4157556 17.0308449,21.6378031 16.7121985,21.4094692 L16.6464466,21.3535534 L15,19.707 L13.3535534,21.3535534 C13.0595698,21.647537 12.5708157,21.4728055 12.5069551,21.086032 L12.5,21 L12.5,16 C12.5,15.9103127 12.5236139,15.8261408 12.5649635,15.7533623 C12.2096048,15.2600855 12,14.6545207 12,14 C12,12.3431458 13.3431458,11 15,11 Z M17,3.5 C18.3254834,3.5 19.4100387,4.53153594 19.4946823,5.83562431 L19.5,6 L19.5,18 C19.5,18.2761424 19.2761424,18.5 19,18.5 C18.7545401,18.5 18.5503916,18.3231248 18.5080557,18.0898756 L18.5,18 L18.5,6 C18.5,5.22030388 17.9051119,4.57955132 17.14446,4.50686658 L17,4.5 L5.5,4.5 L5.5,18 C5.5,18.7796961 6.09488808,19.4204487 6.85553999,19.4931334 L7,19.5 L11,19.5 C11.2761424,19.5 11.5,19.7238576 11.5,20 C11.5,20.2454599 11.3231248,20.4496084 11.0898756,20.4919443 L11,20.5 L7,20.5 C5.6745166,20.5 4.58996133,19.4684641 4.50531768,18.1643757 L4.5,18 L4.5,3.5 L17,3.5 Z M15,17 C14.4536881,17 13.9414829,16.8539721 13.500288,16.59882 L13.5,19.792 L14.6464466,18.6464466 C14.820013,18.4728803 15.0894374,18.4535951 15.2843055,18.5885912 L15.3535534,18.6464466 L16.5,19.793 L16.5007215,16.5982359 C16.0592984,16.8537493 15.5467286,17 15,17 Z M15,12 C13.8954305,12 13,12.8954305 13,14 C13,15.1045695 13.8954305,16 15,16 C16.1045695,16 17,15.1045695 17,14 C17,12.8954305 16.1045695,12 15,12 Z M10,12 C10.2761424,12 10.5,12.2238576 10.5,12.5 C10.5,12.7454599 10.3231248,12.9496084 10.0898756,12.9919443 L10,13 L7,13 C6.72385763,13 6.5,12.7761424 6.5,12.5 C6.5,12.2545401 6.67687516,12.0503916 6.91012437,12.0080557 L7,12 L10,12 Z M13,9 C13.2761424,9 13.5,9.22385763 13.5,9.5 C13.5,9.74545989 13.3231248,9.94960837 13.0898756,9.99194433 L13,10 L7,10 C6.72385763,10 6.5,9.77614237 6.5,9.5 C6.5,9.25454011 6.67687516,9.05039163 6.91012437,9.00805567 L7,9 L13,9 Z M9,6 C9.27614237,6 9.5,6.22385763 9.5,6.5 C9.5,6.74545989 9.32312484,6.94960837 9.08987563,6.99194433 L9,7 L7,7 C6.72385763,7 6.5,6.77614237 6.5,6.5 C6.5,6.25454011 6.67687516,6.05039163 6.91012437,6.00805567 L7,6 L9,6 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  entitlementmanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Document</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-208.000000, -352.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(208.000000, 352.000000)">
            <path d="M17,4.5 C18.3188064,4.5 19.4095045,5.4730742 19.4946503,6.7180169 L19.5,6.875 L19.5,18.125 C19.5,18.2128909 19.4950004,18.299613 19.4852612,18.3849318 C19.4280557,18.8854974 19.207923,19.3375148 18.8772318,19.6940109 C18.7093455,19.8740433 18.5190844,20.0260678 18.308299,20.1491819 C18.2925624,20.1583737 18.2766567,20.1674347 18.2606385,20.1763312 C18.1072722,20.2609963 17.9502117,20.3285021 17.7857097,20.3802087 C17.714053,20.4027422 17.6406511,20.4223516 17.5659961,20.4387812 C17.4974549,20.4538737 17.4275563,20.466327 17.3567269,20.4759556 C17.3498385,20.4768916 17.3431101,20.4777792 17.3363735,20.4786414 C17.3163487,20.481205 17.2961295,20.4835557 17.2758395,20.4856753 C17.1852144,20.4951427 17.0931765,20.5 17,20.5 L17,20.5 L7,20.5 C6.90682346,20.5 6.81478557,20.4951427 6.72416053,20.4856753 C6.70387049,20.4835557 6.68365128,20.481205 6.66350596,20.4786259 C6.6568899,20.4777792 6.65016153,20.4768916 6.64344153,20.4759785 C6.57244369,20.466327 6.50254513,20.4538737 6.43371216,20.438717 C6.35934885,20.4223516 6.28594697,20.4027422 6.21397013,20.380108 C6.04978831,20.3285021 5.89272777,20.2609963 5.74516023,20.1795419 C5.72334325,20.1674347 5.70743757,20.1583737 5.69164707,20.1491503 C5.48091556,20.0260678 5.29065452,19.8740433 5.1271909,19.698766 C4.79207701,19.3375148 4.57194429,18.8854974 4.51477202,18.3852223 C4.50499958,18.299613 4.5,18.2128909 4.5,18.125 L4.5,18.125 L4.5,6.875 L4.50534973,6.7180169 C4.59049548,5.4730742 5.68119356,4.5 7,4.5 C7.27614237,4.5 7.5,4.72385763 7.5,5 C7.5,5.27614237 7.27614237,5.5 7,5.5 C6.16461771,5.5 5.5,6.1230791 5.5,6.875 L5.5,6.875 L5.5,18.125 L5.50679863,18.2562539 C5.5787812,18.9480683 6.21375784,19.5 7,19.5 L7,19.5 L17,19.5 L17.1455472,19.4936326 C17.9112729,19.4262508 18.5,18.8326903 18.5,18.125 L18.5,18.125 L18.5,6.875 C18.5,6.1230791 17.8353823,5.5 17,5.5 C16.7238576,5.5 16.5,5.27614237 16.5,5 C16.5,4.72385763 16.7238576,4.5 17,4.5 Z M14,16.5 C14.2761424,16.5 14.5,16.7238576 14.5,17 C14.5,17.2454599 14.3231248,17.4496084 14.0898756,17.4919443 L14,17.5 L10,17.5 C9.72385763,17.5 9.5,17.2761424 9.5,17 C9.5,16.7545401 9.67687516,16.5503916 9.91012437,16.5080557 L10,16.5 L14,16.5 Z M16,13.5 C16.2761424,13.5 16.5,13.7238576 16.5,14 C16.5,14.2454599 16.3231248,14.4496084 16.0898756,14.4919443 L16,14.5 L8,14.5 C7.72385763,14.5 7.5,14.2761424 7.5,14 C7.5,13.7545401 7.67687516,13.5503916 7.91012437,13.5080557 L8,13.5 L16,13.5 Z M16,10.5 C16.2761424,10.5 16.5,10.7238576 16.5,11 C16.5,11.2454599 16.3231248,11.4496084 16.0898756,11.4919443 L16,11.5 L8,11.5 C7.72385763,11.5 7.5,11.2761424 7.5,11 C7.5,10.7545401 7.67687516,10.5503916 7.91012437,10.5080557 L8,10.5 L16,10.5 Z M11.3362054,2.59617092 C12.2332498,2.59617092 12.9923584,3.18674393 13.2459349,4.00029359 L14,4 C15.1045695,4 16,4.8954305 16,6 C16,7.1045695 15.1045695,8 14,8 L10,8 C8.8954305,8 8,7.1045695 8,6 C8,5.10407141 8.58910483,4.34573562 9.40108807,4.09121906 C9.62428283,3.23107978 10.4060987,2.59617092 11.3362054,2.59617092 Z M11.3362054,3.59617092 C10.9164991,3.59617092 10.5485246,3.85722752 10.4030589,4.23621188 L10.3690315,4.34238755 L10.229664,4.87947632 L9.70018926,5.04544046 C9.28721517,5.1748874 9,5.55979299 9,6 C9,6.51283584 9.38604019,6.93550716 9.88337887,6.99327227 L10,7 L14,7 C14.5522847,7 15,6.55228475 15,6 C15,5.48716416 14.6139598,5.06449284 14.1169329,5.00672767 L14.0003893,4.99999992 L12.5102657,5.0005801 L12.2912354,4.29786533 C12.1622808,3.88414004 11.7769874,3.59617092 11.3362054,3.59617092 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  passwordmanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Request Access for Multi-User</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-640.000000, -630.000000)">
          <g id="Group" transform="translate(640.000000, 630.000000)">
            <rect
              id="Rectangle-Copy-324"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-323"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15.3169043,8.9374231 L15.4375266,8.94460843 C16.0677123,9.02058691 16.483571,9.68843313 16.483571,10.4374231 L16.483571,10.4374231 L16.483571,14.4374231 L17.983571,14.4374231 C18.0971291,14.4374231 18.2092136,14.4437325 18.319493,14.45602 L18.3169043,14.4374231 L18.3169043,11.4374231 L18.3113498,11.3272886 C18.2864121,11.0838354 18.1845188,10.9374231 18.1502376,10.9374231 C17.8740953,10.9374231 17.6502376,10.7135655 17.6502376,10.4374231 C17.6502376,10.1612807 17.8740953,9.9374231 18.1502376,9.9374231 C18.8474389,9.9374231 19.3169043,10.6416213 19.3169043,11.4374231 L19.3169043,11.4374231 L19.3169043,14.4374231 L19.3088486,14.5272987 C19.296677,14.5943579 19.2711306,14.6567574 19.235073,14.7116336 C20.2668315,15.1841688 20.983571,16.2270942 20.983571,17.4374231 C20.983571,19.0942774 19.6404252,20.4374231 17.983571,20.4374231 L5.98357097,20.4374231 C4.32671672,20.4374231 2.98357097,19.0942774 2.98357097,17.4374231 C2.98357097,16.2270942 3.70031048,15.1841688 4.73250058,14.7099357 C4.6960113,14.6567574 4.6704649,14.5943579 4.65829331,14.5272987 L4.65023764,14.4374231 L4.65023764,11.4374231 C4.65023764,10.6416213 5.11970308,9.9374231 5.8169043,9.9374231 C6.09304668,9.9374231 6.3169043,10.1612807 6.3169043,10.4374231 C6.3169043,10.7135655 6.09304668,10.9374231 5.8169043,10.9374231 C5.78262317,10.9374231 5.68072985,11.0838354 5.65579217,11.3272886 L5.65023764,11.4374231 L5.65023764,14.4374231 L5.64764895,14.45602 C5.75792835,14.4437325 5.87001283,14.4374231 5.98357097,14.4374231 L7.48357097,14.4374231 L7.48357097,10.4374231 L7.48839511,10.2980631 C7.53959021,9.56121109 7.99404825,8.9374231 8.65023764,8.9374231 L8.65023764,8.9374231 L15.3169043,8.9374231 Z M17.983571,15.4374231 L5.98357097,15.4374231 C4.87900147,15.4374231 3.98357097,16.3328536 3.98357097,17.4374231 C3.98357097,18.4917849 4.79944876,19.3555882 5.83430863,19.4319374 L5.98357097,19.4374231 L17.983571,19.4374231 C19.0881405,19.4374231 19.983571,18.5419926 19.983571,17.4374231 C19.983571,16.3830613 19.1676932,15.519258 18.1328333,15.4429088 L17.983571,15.4374231 Z M6.98357097,16.4374231 C7.53585572,16.4374231 7.98357097,16.8851384 7.98357097,17.4374231 C7.98357097,17.9897079 7.53585572,18.4374231 6.98357097,18.4374231 C6.43128622,18.4374231 5.98357097,17.9897079 5.98357097,17.4374231 C5.98357097,16.8851384 6.43128622,16.4374231 6.98357097,16.4374231 Z M16.983571,16.4374231 C17.5358557,16.4374231 17.983571,16.8851384 17.983571,17.4374231 C17.983571,17.9897079 17.5358557,18.4374231 16.983571,18.4374231 C16.4312862,18.4374231 15.983571,17.9897079 15.983571,17.4374231 C15.983571,16.8851384 16.4312862,16.4374231 16.983571,16.4374231 Z M11.983571,16.4374231 C12.5358557,16.4374231 12.983571,16.8851384 12.983571,17.4374231 C12.983571,17.9897079 12.5358557,18.4374231 11.983571,18.4374231 C11.4312862,18.4374231 10.983571,17.9897079 10.983571,17.4374231 C10.983571,16.8851384 11.4312862,16.4374231 11.983571,16.4374231 Z M15.3169043,9.9374231 L8.65023764,9.9374231 L8.63182768,9.94624318 C8.58117915,9.98706768 8.48357097,10.1672514 8.48357097,10.4374231 L8.48357097,10.4374231 L8.48357097,14.4374231 L15.483571,14.4374231 L15.483571,10.4374231 L15.4780164,10.3272886 C15.4530788,10.0838354 15.3511854,9.9374231 15.3169043,9.9374231 L15.3169043,9.9374231 Z M16.983571,6.4374231 C17.5358557,6.4374231 17.983571,6.88513835 17.983571,7.4374231 C17.983571,7.98970785 17.5358557,8.4374231 16.983571,8.4374231 C16.4312862,8.4374231 15.983571,7.98970785 15.983571,7.4374231 C15.983571,6.88513835 16.4312862,6.4374231 16.983571,6.4374231 Z M6.98357097,6.4374231 C7.53585572,6.4374231 7.98357097,6.88513835 7.98357097,7.4374231 C7.98357097,7.98970785 7.53585572,8.4374231 6.98357097,8.4374231 C6.43128622,8.4374231 5.98357097,7.98970785 5.98357097,7.4374231 C5.98357097,6.88513835 6.43128622,6.4374231 6.98357097,6.4374231 Z M11.983571,3.4374231 C13.0881405,3.4374231 13.983571,4.3328536 13.983571,5.4374231 C13.983571,6.5419926 13.0881405,7.4374231 11.983571,7.4374231 C10.8790015,7.4374231 9.98357097,6.5419926 9.98357097,5.4374231 C9.98357097,4.3328536 10.8790015,3.4374231 11.983571,3.4374231 Z M11.983571,4.4374231 C11.4312862,4.4374231 10.983571,4.88513835 10.983571,5.4374231 C10.983571,5.98970785 11.4312862,6.4374231 11.983571,6.4374231 C12.5358557,6.4374231 12.983571,5.98970785 12.983571,5.4374231 C12.983571,4.88513835 12.5358557,4.4374231 11.983571,4.4374231 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  privilegeaccessmanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Privileged sessions</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-64.000000, -64.000000)">
          <g id="Group" transform="translate(64.000000, 64.000000)">
            <rect
              id="Rectangle-Copy-19"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-18"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M15.5,17 C15.7761424,17 16,17.2238576 16,17.5 C16,17.7761424 15.7761424,18 15.5,18 L15.5,18 L8.5,18 C8.22385763,18 8,17.7761424 8,17.5 C8,17.2238576 8.22385763,17 8.5,17 L8.5,17 Z M18,6 C18.5522847,6 19,6.44771525 19,7 L19,15 C19,15.5522847 18.5522847,16 18,16 L6,16 C5.44771525,16 5,15.5522847 5,15 L5,7 C5,6.44771525 5.44771525,6 6,6 L18,6 Z M18,7 L6,7 L6,15 L18,15 L18,7 Z M10,10.5 C10.2761424,10.5 10.5,10.7238576 10.5,11 L10.5,11 L10.5,13 C10.5,13.2761424 10.2761424,13.5 10,13.5 C9.72385763,13.5 9.5,13.2761424 9.5,13 L9.5,13 L9.5,11 C9.5,10.7238576 9.72385763,10.5 10,10.5 Z M12,9.5 C12.2761424,9.5 12.5,9.72385763 12.5,10 L12.5,10 L12.5,13 C12.5,13.2761424 12.2761424,13.5 12,13.5 C11.7238576,13.5 11.5,13.2761424 11.5,13 L11.5,13 L11.5,10 C11.5,9.72385763 11.7238576,9.5 12,9.5 Z M14,8.5 C14.2761424,8.5 14.5,8.72385763 14.5,9 L14.5,9 L14.5,13 C14.5,13.2761424 14.2761424,13.5 14,13.5 C13.7238576,13.5 13.5,13.2761424 13.5,13 L13.5,13 L13.5,9 C13.5,8.72385763 13.7238576,8.5 14,8.5 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  usermanagement: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>User</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-352.000000, -208.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(352.000000, 208.000000)">
            <path d="M15.3333333,10.5 C16.0305346,10.5 16.5,11.2041982 16.5,12 L16.5,17 C16.5,17.2761424 16.2761424,17.5 16,17.5 C15.7238576,17.5 15.5,17.2761424 15.5,17 L15.5,12 C15.5,11.6912323 15.3725118,11.5 15.3333333,11.5 L8.66666667,11.5 C8.62748823,11.5 8.5,11.6912323 8.5,12 L8.5,17 C8.5,17.2761424 8.27614237,17.5 8,17.5 C7.72385763,17.5 7.5,17.2761424 7.5,17 L7.5,12 C7.5,11.2041982 7.96946544,10.5 8.66666667,10.5 L15.3333333,10.5 Z M18.1666667,11.5 C18.8638679,11.5 19.3333333,12.2041982 19.3333333,13 L19.3333333,17 C19.3333333,17.2761424 19.1094757,17.5 18.8333333,17.5 C18.557191,17.5 18.3333333,17.2761424 18.3333333,17 L18.3333333,13 C18.3333333,12.6912323 18.2058451,12.5 18.1666667,12.5 C17.8905243,12.5 17.6666667,12.2761424 17.6666667,12 C17.6666667,11.7238576 17.8905243,11.5 18.1666667,11.5 Z M5.83333333,11.5 C6.10947571,11.5 6.33333333,11.7238576 6.33333333,12 C6.33333333,12.2761424 6.10947571,12.5 5.83333333,12.5 C5.79415489,12.5 5.66666667,12.6912323 5.66666667,13 L5.66666667,13 L5.66666667,17 C5.66666667,17.2761424 5.44280904,17.5 5.16666667,17.5 C4.89052429,17.5 4.66666667,17.2761424 4.66666667,17 L4.66666667,17 L4.66666667,13 C4.66666667,12.2041982 5.13613211,11.5 5.83333333,11.5 Z M17,8 C17.5522847,8 18,8.44771525 18,9 C18,9.55228475 17.5522847,10 17,10 C16.4477153,10 16,9.55228475 16,9 C16,8.44771525 16.4477153,8 17,8 Z M7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 Z M12,5 C13.1045695,5 14,5.8954305 14,7 C14,8.1045695 13.1045695,9 12,9 C10.8954305,9 10,8.1045695 10,7 C10,5.8954305 10.8954305,5 12,5 Z M12,6 C11.4477153,6 11,6.44771525 11,7 C11,7.55228475 11.4477153,8 12,8 C12.5522847,8 13,7.55228475 13,7 C13,6.44771525 12.5522847,6 12,6 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  arrowRightIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <g fill="#3751FF" fillRule="nonzero">
          <g>
            <path
              d="M16 8.467h.022c.02 0 .038.002.057.003L16 8.467c.049 0 .096.004.143.011l.046.01c.022.004.045.01.067.017l.043.015c.076.027.146.065.21.112l.011.008 5.333 4c.383.287.46.83.174 1.213-.259.345-.725.442-1.094.249l-.12-.075-3.947-2.961v11.6c0 .48-.387.867-.866.867-.435 0-.795-.32-.857-.738l-.01-.128V11.066l-3.946 2.96c-.345.26-.82.222-1.12-.067l-.094-.106c-.258-.344-.221-.819.068-1.12l.106-.093 5.333-4c.069-.051.138-.09.213-.117l.033-.012c.025-.008.05-.016.076-.022l.037-.007c.024-.005.048-.008.073-.01.02-.003.038-.004.057-.005H16z"
              transform="translate(-1130 -486) rotate(90 338 824)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  confirmationIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>confirmation</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-352.000000, -424.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(352.000000, 424.000000)">
            <path d="M15.7261547,4.36025061 C15.9743499,4.48130346 16.077419,4.78063808 15.9563662,5.0288332 C15.8353133,5.27702833 15.5359787,5.3800975 15.2877836,5.25904465 C11.5648568,3.44325191 7.0748374,4.98928956 5.25904465,8.7122164 C3.44325191,12.4351432 4.98928956,16.9251626 8.7122164,18.7409553 C12.4351432,20.5567481 16.9251626,19.0107104 18.7409553,15.2877836 C19.0882567,14.5757103 19.3177467,13.825314 19.4272526,13.0574852 C19.5698903,12.0573446 19.5069429,11.0397997 19.2463105,10.0653618 C19.174959,9.79859683 19.3333729,9.52449923 19.6001379,9.45314772 C19.8669029,9.38179622 20.1410005,9.54021016 20.212352,9.80697518 C20.5076448,10.9109991 20.5789984,12.0644305 20.4172353,13.1986742 C20.2930541,14.069402 20.0328908,14.9200955 19.6397494,15.7261547 C17.581851,19.9454718 12.4931623,21.6976478 8.27384525,19.6397494 C4.05452817,17.581851 2.30235216,12.4931623 4.36025061,8.27384525 C6.41814905,4.05452817 11.5068377,2.30235216 15.7261547,4.36025061 Z M18.3535534,6.64644661 C18.5271197,6.82001296 18.5464049,7.08943736 18.4114088,7.2843055 L18.3535534,7.35355339 L10.3535534,15.3535534 C10.179987,15.5271197 9.91056264,15.5464049 9.7156945,15.4114088 L9.64644661,15.3535534 L6.64644661,12.3535534 C6.45118446,12.1582912 6.45118446,11.8417088 6.64644661,11.6464466 C6.82001296,11.4728803 7.08943736,11.4535951 7.2843055,11.5885912 L7.35355339,11.6464466 L10,14.293 L17.6464466,6.64644661 C17.8417088,6.45118446 18.1582912,6.45118446 18.3535534,6.64644661 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  provisionIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Past Sessions</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-352.000000, -64.000000)">
          <g id="Group" transform="translate(352.000000, 64.000000)">
            <rect id="Rectangle" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24" />
            <g
              id="Group-10"
              transform="translate(3.000000, 5.000000)"
              fill="#000000"
              fillRule="nonzero"
            >
              <path
                d="M16.7350005,8.57600085 C16.9691688,8.42964568 17.277644,8.50083226 17.4239992,8.73500053 C17.5703543,8.9691688 17.4991677,9.27764399 17.2649995,9.42399915 L17.2649995,9.42399915 L9.26499947,14.4239992 C9.10286433,14.5253336 8.89713567,14.5253336 8.73500053,14.4239992 L8.73500053,14.4239992 L0.73500053,9.42399915 C0.500832264,9.27764399 0.429645682,8.9691688 0.576000848,8.73500053 C0.722356014,8.50083226 1.0308312,8.42964568 1.26499947,8.57600085 L1.26499947,8.57600085 L9,13.4103762 Z M8.73500053,0.576000848 C8.89713567,0.474666384 9.10286433,0.474666384 9.26499947,0.576000848 L9.26499947,0.576000848 L17.2649995,5.57600085 C17.5783335,5.77183462 17.5783335,6.22816538 17.2649995,6.42399915 L17.2649995,6.42399915 L9.26499947,11.4239992 C9.10286433,11.5253336 8.89713567,11.5253336 8.73500053,11.4239992 L8.73500053,11.4239992 L0.73500053,6.42399915 C0.42166649,6.22816538 0.42166649,5.77183462 0.73500053,5.57600085 L0.73500053,5.57600085 Z M9,1.58962382 L1.94339811,6 L9,10.4103762 L16.0566019,6 L9,1.58962382 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  discoverIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Discover</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-280.000000, -352.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(280.000000, 352.000000)">
            <path d="M12,3.5 C16.6944204,3.5 20.5,7.30557963 20.5,12 C20.5,16.6944204 16.6944204,20.5 12,20.5 C7.30557963,20.5 3.5,16.6944204 3.5,12 C3.5,11.7238576 3.72385763,11.5 4,11.5 C4.27614237,11.5 4.5,11.7238576 4.5,12 C4.5,16.1421356 7.85786438,19.5 12,19.5 C16.1421356,19.5 19.5,16.1421356 19.5,12 C19.5,7.85786438 16.1421356,4.5 12,4.5 C9.68597038,4.5 7.54633587,5.55402374 6.13134134,7.32951461 C5.95923721,7.54546549 5.64465648,7.5810103 5.4287056,7.40890617 C5.21275473,7.23680204 5.17720992,6.92222131 5.34931404,6.70627043 C6.95207172,4.69518024 9.37824942,3.5 12,3.5 Z M15.7584253,7.8609288 C17.4297047,9.36575547 18.0018494,11.7142346 17.2596141,13.7968633 C17.1669103,14.0569799 16.8808929,14.1926947 16.6207764,14.0999909 C16.3606598,14.007287 16.224945,13.7212696 16.3176488,13.4611531 C16.9249969,11.7570027 16.4568571,9.83543234 15.0892947,8.60407363 C13.2423707,6.94109579 10.3970331,7.09021362 8.7340553,8.93713761 C7.07107746,10.7840616 7.22019529,13.6293992 9.06711928,15.2923771 C9.6445614,15.8123083 10.3315852,16.1661479 11.0718024,16.3351731 C11.3410154,16.3966466 11.5094215,16.6647209 11.447948,16.9339339 C11.3864744,17.2031469 11.1184001,17.371553 10.8491871,17.3100794 C9.94386277,17.1033528 9.10290705,16.6702332 8.39798868,16.0355219 C6.14063713,14.0029934 5.95838201,10.5253586 7.99091047,8.26800701 C10.0234389,6.01065546 13.5010738,5.82840034 15.7584253,7.8609288 Z M13.8870129,14.0946967 L13.9441739,14.164519 L15.0678824,15.8189915 C15.2230341,16.0474264 15.1636264,16.3583849 14.9351914,16.5135367 C14.7321381,16.6514494 14.463881,16.6198335 14.2978071,16.450668 L14.2406461,16.3808457 L13.1169376,14.7263732 C12.9617859,14.4979382 13.0211937,14.1869797 13.2496287,14.031828 C13.452682,13.8939153 13.7209391,13.9255311 13.8870129,14.0946967 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z M12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  editPrivilege: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-64.000000, -811.000000)">
          <g id="Group" transform="translate(64.000000, 811.000000)">
            <rect
              id="Rectangle-Copy-378"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-377"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M14.9071712,4.01261272 C15.1666602,4.10705898 15.3004537,4.39398015 15.2060075,4.65346911 C15.1115612,4.91295806 14.82464,5.0467516 14.5651511,4.95230534 C10.6728168,3.53561152 6.36899916,5.54251465 4.95230534,9.43484893 C3.53561152,13.3271832 5.54251465,17.6310008 9.43484893,19.0476947 C13.3271832,20.4643885 17.6310008,18.4574854 19.0476947,14.5651511 C19.2803322,13.9259847 19.4237286,13.2676245 19.4777369,12.603081 C19.5273557,11.9925467 19.5012194,11.3799638 19.4011827,10.7778342 C19.3559252,10.5054258 19.5400675,10.2479067 19.8124759,10.2026492 C20.0848844,10.1573917 20.3424035,10.341534 20.387661,10.6139425 C20.5010914,11.2966895 20.5307367,11.991515 20.4744506,12.6840851 C20.4132127,13.4375858 20.250693,14.1837446 19.9873873,14.9071712 C18.3818009,19.3184834 13.504141,21.5929736 9.09282878,19.9873873 C4.6815166,18.3818009 2.40702639,13.504141 4.01261272,9.09282878 C5.61819905,4.6815166 10.495859,2.40702639 14.9071712,4.01261272 Z M11.5404275,9.30304035 C11.7135934,8.89898655 12.2864066,8.89898655 12.4595725,9.30304035 L12.4595725,9.30304035 L13.7,12.199 L15.6876525,10.6095656 C16.0331698,10.3331517 16.5243426,10.6085548 16.5000259,11.0236959 L16.5000259,11.0236959 L16.4880935,11.1084652 L15.4880935,15.6084652 C15.437256,15.837234 15.2343493,16 15,16 L15,16 L9,16 C8.76565068,16 8.56274398,15.837234 8.51190647,15.6084652 L8.51190647,15.6084652 L7.51190647,11.1084652 C7.40952037,10.6477278 7.94379572,10.3147242 8.31234752,10.6095656 L8.31234752,10.6095656 L10.299,12.199 Z M12,10.768 L10.9595725,13.1969596 C10.8294085,13.5006757 10.4456774,13.5968544 10.1876525,13.3904344 L10.1876525,13.3904344 L8.796,12.277 L9.401,15 L14.598,15 L15.203,12.277 L13.8123475,13.3904344 C13.5777794,13.5780889 13.2393219,13.5156619 13.0819286,13.2745743 L13.0819286,13.2745743 L13.0404275,13.1969596 L12,10.768 Z M18.6908514,4.51981375 L18.7754268,4.53036524 C19.2479521,4.6307572 19.6449138,4.82993938 19.9552666,5.12964359 C20.2656194,5.4293478 20.478534,5.81911632 20.5953557,6.28785018 C20.6370461,6.45512825 20.589622,6.63208413 20.4698664,6.75609473 L20.4698664,6.75609473 L17.8648975,9.45361898 C17.7688926,9.55303496 17.6360204,9.60827955 17.4978311,9.60623509 L17.4978311,9.60623509 L16.127249,9.58595778 C15.8636462,9.58205786 15.6483601,9.37415847 15.635263,9.11085235 L15.635263,9.11085235 L15.5671654,7.74181291 C15.5602994,7.6037791 15.6108732,7.46905985 15.7068781,7.36964387 L15.7068781,7.36964387 L18.311847,4.67211962 C18.4316026,4.54810902 18.6067956,4.49453814 18.7754268,4.53036524 Z M18.8226928,5.58226019 L16.5768623,7.90788577 L16.6107374,8.59258532 L17.2962021,8.60254414 L19.5413379,6.2776379 L19.5138255,6.21008523 C19.4690319,6.11442332 19.416544,6.02939461 19.3564478,5.95428878 L19.3564478,5.95428878 L19.2606082,5.84898339 C19.159084,5.75094257 19.0366396,5.6706643 18.8908892,5.60852265 L18.8908892,5.60852265 L18.8226928,5.58226019 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  addPrivilege: () => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-137.000000, -811.000000)">
          <g id="Group" transform="translate(137.000000, 811.000000)">
            <rect
              id="Rectangle-Copy-408"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-407"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M14.9071712,4.01261272 C15.1666602,4.10705898 15.3004537,4.39398015 15.2060075,4.65346911 C15.1115612,4.91295806 14.82464,5.0467516 14.5651511,4.95230534 C10.6728168,3.53561152 6.36899916,5.54251465 4.95230534,9.43484893 C3.53561152,13.3271832 5.54251465,17.6310008 9.43484893,19.0476947 C13.3271832,20.4643885 17.6310008,18.4574854 19.0476947,14.5651511 C19.2803322,13.9259847 19.4237286,13.2676245 19.4777369,12.603081 C19.5273557,11.9925467 19.5012194,11.3799638 19.4011827,10.7778342 C19.3559252,10.5054258 19.5400675,10.2479067 19.8124759,10.2026492 C20.0848844,10.1573917 20.3424035,10.341534 20.387661,10.6139425 C20.5010914,11.2966895 20.5307367,11.991515 20.4744506,12.6840851 C20.4132127,13.4375858 20.250693,14.1837446 19.9873873,14.9071712 C18.3818009,19.3184834 13.504141,21.5929736 9.09282878,19.9873873 C4.6815166,18.3818009 2.40702639,13.504141 4.01261272,9.09282878 C5.61819905,4.6815166 10.495859,2.40702639 14.9071712,4.01261272 Z M12.4128806,9.21696972 L12.4595725,9.30304035 L13.7,12.199 L15.6876525,10.6095656 C16.0101353,10.3515793 16.4595002,10.574287 16.498212,10.942653 L16.5000259,11.0236959 L16.4880935,11.1084652 L15.4880935,15.6084652 C15.4436107,15.8086379 15.2826999,15.9582772 15.0861715,15.9925593 L15,16 L9,16 C8.79494434,16 8.61396194,15.8753823 8.53786318,15.6909706 L8.51190647,15.6084652 L7.51190647,11.1084652 C7.4159195,10.6765239 7.87949826,10.3568486 8.24149788,10.5615183 L8.31234752,10.6095656 L10.299,12.199 L11.5404275,9.30304035 C11.7002729,8.93006761 12.2006463,8.9013774 12.4128806,9.21696972 Z M12,10.768 L10.9595725,13.1969596 C10.8412416,13.4730651 10.5133511,13.5776522 10.2608546,13.4392997 L10.1876525,13.3904344 L8.796,12.277 L9.401,15 L14.598,15 L15.203,12.277 L13.8123475,13.3904344 C13.6038425,13.5572384 13.3132521,13.5264471 13.1407082,13.3482218 L13.0819286,13.2745743 L13.0404275,13.1969596 L12,10.768 Z M17.71875,4.96875 C17.9718805,4.96875 18.1810773,5.07455771 18.2141856,5.21183604 L18.21875,5.25 L18.21875,6.99975 L19.96875,7 C20.1240801,7 20.25,7.22385763 20.25,7.5 C20.25,7.75313051 20.1441923,7.96232731 20.006914,7.99543559 L19.96875,8 L18.21875,7.99975 L18.21875,9.75 C18.21875,9.90533009 17.9948924,10.03125 17.71875,10.03125 C17.4656195,10.03125 17.2564227,9.92544229 17.2233144,9.78816396 L17.21875,9.75 L17.21875,7.99975 L15.46875,8 C15.3134199,8 15.1875,7.77614237 15.1875,7.5 C15.1875,7.24686949 15.2933077,7.03767269 15.430586,7.00456441 L15.46875,7 L17.21875,6.99975 L17.21875,5.25 C17.21875,5.09466991 17.4426076,4.96875 17.71875,4.96875 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  undoButton: ({intl, color}) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="V3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Export" transform="translate(-351.000000, -902.000000)" fill="#000000" fill-rule="nonzero">
                <g id="Combined-Shape" transform="translate(351.000000, 902.000000)">
                    <path d="M8.3200922,10.1158894 C8.53223065,10.2926714 8.56089268,10.6079538 8.38411064,10.8200922 C8.2073286,11.0322306 7.89204625,11.0608927 7.6799078,10.8841106 L4.6799078,8.38411064 L4.61759373,8.32214364 C4.61602141,8.3202791 4.61446248,8.31840291 4.61291708,8.31651521 L4.6799078,8.38411064 C4.64545391,8.35539907 4.61594869,8.32321075 4.59139212,8.28854443 C4.58092127,8.27342983 4.57116544,8.25790241 4.56226876,8.24183325 C4.55464098,8.22839643 4.54775593,8.21441249 4.54156296,8.20019484 C4.53623185,8.1877206 4.53125629,8.17494511 4.5268028,8.16192747 C4.52080939,8.14450622 4.51584186,8.12673042 4.51187069,8.1087748 C4.50925132,8.09705141 4.50697067,8.08464085 4.505157,8.07207924 C4.50271797,8.05495502 4.50116782,8.03820801 4.50045505,8.02143141 C4.50015387,8.01444344 4.5,8.00723969 4.5,8 L4.50045505,7.97856859 C4.50116782,7.96179199 4.50271797,7.94504498 4.50510549,7.92839707 L4.5,8 C4.5,7.96245908 4.50413729,7.92588447 4.51198078,7.89070726 C4.51584186,7.87326958 4.52080939,7.85549378 4.5267733,7.83798801 C4.53125629,7.82505489 4.53623185,7.8122794 4.54170448,7.79977102 C4.54775593,7.78558751 4.55464098,7.77160357 4.5622181,7.75790557 C4.57116544,7.74209759 4.58092127,7.72657017 4.59147424,7.71164647 C4.59825323,7.70176979 4.60550066,7.69227745 4.61313441,7.68300034 C4.61446248,7.68159709 4.61602141,7.6797209 4.61759373,7.67785636 L4.6799078,7.61588936 L4.6799078,7.61588936 L7.6799078,5.11588936 C7.89204625,4.93910732 8.2073286,4.96776935 8.38411064,5.1799078 C8.56089268,5.39204625 8.53223065,5.7073286 8.3200922,5.88411064 L6.38,7.49998746 L15.5,7.5 C18.2614237,7.5 20.5,9.73857625 20.5,12.5 C20.5,15.1887547 18.3776933,17.3818181 15.7168896,17.4953805 L15.5,17.5 L5,17.5 C4.72385763,17.5 4.5,17.2761424 4.5,17 C4.5,16.7545401 4.67687516,16.5503916 4.91012437,16.5080557 L5,16.5 L15.5,16.5 C17.709139,16.5 19.5,14.709139 19.5,12.5 C19.5,10.3578046 17.8160315,8.60892112 15.6996403,8.50489531 L15.5,8.5 L6.38,8.49998746 L8.3200922,10.1158894 Z"></path>
                </g>
            </g>
        </g>
    </svg>
  ),
  campaginCertIcon: ({ intl, color }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      version="1.1"
      className={styles.IconPosition}
    >
      <title>Icon</title>
      <desc>Created with Sketch.</desc>
      <g id="right-copy" stroke="light-black" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M18,3.5 C18.7796961,3.5 19.4204487,4.09488808 19.4931334,4.85553999 L19.5,5 L19.5,15 C19.5,15.2761424 19.2761424,15.5 19,15.5 C18.7545401,15.5 18.5503916,15.3231248 18.5080557,15.0898756 L18.5,15 L18.5,5 C18.5,4.75454011 18.3231248,4.55039163 18.0898756,4.50805567 L18,4.5 L6,4.5 C5.75454011,4.5 5.55039163,4.67687516 5.50805567,4.91012437 L5.5,5 L5.5,19 C5.5,19.2454599 5.67687516,19.4496084 5.91012437,19.4919443 L6,19.5 L14,19.5 C14.2761424,19.5 14.5,19.7238576 14.5,20 C14.5,20.2454599 14.3231248,20.4496084 14.0898756,20.4919443 L14,20.5 L6,20.5 C5.22030388,20.5 4.57955132,19.9051119 4.50686658,19.14446 L4.5,19 L4.5,5 C4.5,4.22030388 5.09488808,3.57955132 5.85553999,3.50686658 L6,3.5 L18,3.5 Z M15,12.5 C16.9329966,12.5 18.5,14.0670034 18.5,16 C18.5,16.9135532 18.1499941,17.7453581 17.5767634,18.3686335 L18.7071068,19.5 C18.9023689,19.6952621 18.9023689,20.0118446 18.7071068,20.2071068 C18.5118446,20.4023689 18.1952621,20.4023689 18,20.2071068 L16.7969196,19.0041311 C16.2716561,19.3189937 15.6569662,19.5 15,19.5 C13.0670034,19.5 11.5,17.9329966 11.5,16 C11.5,14.0670034 13.0670034,12.5 15,12.5 Z M15,13.5 C13.6192881,13.5 12.5,14.6192881 12.5,16 C12.5,17.3807119 13.6192881,18.5 15,18.5 C16.3807119,18.5 17.5,17.3807119 17.5,16 C17.5,14.6192881 16.3807119,13.5 15,13.5 Z M11,12.5 C11.2761424,12.5 11.5,12.7238576 11.5,13 C11.5,13.2454599 11.3231248,13.4496084 11.0898756,13.4919443 L11,13.5 L8,13.5 C7.72385763,13.5 7.5,13.2761424 7.5,13 C7.5,12.7545401 7.67687516,12.5503916 7.91012437,12.5080557 L8,12.5 L11,12.5 Z M16,9.5 C16.2761424,9.5 16.5,9.72385763 16.5,10 C16.5,10.2454599 16.3231248,10.4496084 16.0898756,10.4919443 L16,10.5 L8,10.5 C7.72385763,10.5 7.5,10.2761424 7.5,10 C7.5,9.75454011 7.67687516,9.55039163 7.91012437,9.50805567 L8,9.5 L16,9.5 Z M8,6.5 L16,6.5 C16.2761424,6.5 16.5,6.72385763 16.5,7 C16.5,7.24545989 16.3231248,7.44960837 16.0898756,7.49194433 L16,7.5 L8,7.5 C7.72385763,7.5 7.5,7.27614237 7.5,7 C7.5,6.75454011 7.67687516,6.55039163 7.91012437,6.50805567 L8,6.5 L16,6.5 L8,6.5 Z"
          id="Combined-Shape"
          fill={color || '#fff'}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  campaginVeiwAll: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/Veiw" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="unview-eye"
          transform="translate(3.000000, 7.000000)"
          fill="#747474"
          fillRule="nonzero"
        >
          <path
            d="M8.6699988,0 C11.5128312,0 14.3077912,1.74685002 17.0604332,5.18765248 L17.3399976,5.53710798 L17.0235522,5.85355339 C14.2702771,8.60682851 11.4839341,10 8.6699988,10 C5.85606352,10 3.06972053,8.60682851 0.316445414,5.85355339 L8.8817842e-15,5.53710798 L0.2795644,5.18765248 C3.03220637,1.74685002 5.82716639,0 8.6699988,0 Z M8.6699988,1 C6.27135782,1 3.82831078,2.47160955 1.3458198,5.46208622 C3.81576703,7.83039708 6.25555358,9 8.6699988,9 C11.084444,9 13.5242306,7.83039708 15.9941778,5.46208622 C13.5116868,2.47160955 11.0686398,1 8.6699988,1 Z M8.65856773,2.56240411 C10.0392796,2.56240411 11.1585677,3.68169224 11.1585677,5.06240411 C11.1585677,6.44311599 10.0392796,7.56240411 8.65856773,7.56240411 C7.27785585,7.56240411 6.15856773,6.44311599 6.15856773,5.06240411 C6.15856773,3.68169224 7.27785585,2.56240411 8.65856773,2.56240411 Z M8.65856773,3.56240411 C7.8301406,3.56240411 7.15856773,4.23397699 7.15856773,5.06240411 C7.15856773,5.89083124 7.8301406,6.56240411 8.65856773,6.56240411 C9.48699485,6.56240411 10.1585677,5.89083124 10.1585677,5.06240411 C10.1585677,4.23397699 9.48699485,3.56240411 8.65856773,3.56240411 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  ),
  campaginUnVeiwAll: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/Unveiw" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="unview-eye"
          transform="translate(3.000000, 7.000000)"
          fill="#747474"
          fillRule="nonzero"
        >
          <path
            d="M8.6699988,0 C11.5128312,0 14.3077912,1.74685002 17.0604332,5.18765248 L17.3399976,5.53710798 L17.0235522,5.85355339 C14.2702771,8.60682851 11.4839341,10 8.6699988,10 C5.85606352,10 3.06972053,8.60682851 0.316445414,5.85355339 L8.8817842e-15,5.53710798 L0.2795644,5.18765248 C3.03220637,1.74685002 5.82716639,0 8.6699988,0 Z M8.6699988,1 C6.27135782,1 3.82831078,2.47160955 1.3458198,5.46208622 C3.81576703,7.83039708 6.25555358,9 8.6699988,9 C11.084444,9 13.5242306,7.83039708 15.9941778,5.46208622 C13.5116868,2.47160955 11.0686398,1 8.6699988,1 Z M8.65856773,2.56240411 C10.0392796,2.56240411 11.1585677,3.68169224 11.1585677,5.06240411 C11.1585677,6.44311599 10.0392796,7.56240411 8.65856773,7.56240411 C7.27785585,7.56240411 6.15856773,6.44311599 6.15856773,5.06240411 C6.15856773,3.68169224 7.27785585,2.56240411 8.65856773,2.56240411 Z M8.65856773,3.56240411 C7.8301406,3.56240411 7.15856773,4.23397699 7.15856773,5.06240411 C7.15856773,5.89083124 7.8301406,6.56240411 8.65856773,6.56240411 C9.48699485,6.56240411 10.1585677,5.89083124 10.1585677,5.06240411 C10.1585677,4.23397699 9.48699485,3.56240411 8.65856773,3.56240411 Z"
            id="Combined-Shape"
          />
          <path
            d="M15.915065,0.208708922 C16.1506922,0.0647144784 16.4584364,0.138997563 16.6024309,0.374624835 C16.730426,0.584071299 16.6859548,0.850499043 16.5090036,1.00825135 L16.436515,1.06199076 L1.93072381,9.92664092 C1.69509654,10.0706354 1.38735233,9.99635228 1.24335789,9.760725 C1.11536283,9.55127854 1.15983396,9.2848508 1.33678518,9.12709849 L1.4092738,9.07335908 L15.915065,0.208708922 Z"
            id="Path-10"
          />
        </g>
      </g>
    </svg>
  ),
  campaginEdit: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/Edit-Pen" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="pen" transform="translate(5.000000, 4.253816)" fill="#747474" fillRule="nonzero">
          <path
            d="M10.1648274,2.51650552e-14 C10.4069003,2.51650552e-14 10.6031391,0.196238827 10.6031391,0.438311688 L10.6031391,0.438311688 L10.6031391,2.19155844 C10.6031391,2.28239088 10.5755095,2.36677008 10.5281963,2.43675008 C10.5495641,2.48662669 10.5613528,2.54320489 10.5613528,2.60253647 L10.5613528,2.60253647 L10.5613528,10.4921469 C10.5613528,10.5786805 10.5357387,10.6632781 10.4877385,10.7352784 L10.4877385,10.7352784 L8.73449171,13.3651486 C8.56099828,13.6253887 8.17859041,13.6253887 8.00509698,13.3651486 L8.00509698,13.3651486 L6.25185022,10.7352784 C6.20384997,10.6632781 6.1782359,10.5786805 6.1782359,10.4921469 L6.1782359,10.4921469 L6.1782359,2.60253647 C6.1782359,2.51170403 6.20586551,2.42732483 6.25317876,2.35734483 C6.23181092,2.30746822 6.22002225,2.25089003 6.22002225,2.19155844 L6.22002225,2.19155844 L6.22002225,0.438311688 C6.22002225,0.196238827 6.41626108,2.51650552e-14 6.65833394,2.51650552e-14 L6.65833394,2.51650552e-14 Z M9.68472941,3.04084816 L7.05485928,3.04084816 L7.05485928,10.3589001 L8.36979434,12.3304261 L9.68472941,10.3580235 L9.68472941,3.04084816 Z M9.72651576,0.876623377 L7.09664563,0.876623377 L7.09664563,1.75324675 L9.72651576,1.75324675 L9.72651576,0.876623377 Z"
            id="Combined-Shape"
            transform="translate(8.390688, 6.780164) rotate(45.000000) translate(-8.390688, -6.780164) "
          />
          <path
            d="M5.53507343,2.34259934 C5.76519207,2.34259934 5.95174009,2.52914736 5.95174009,2.759266 C5.95174009,2.96381591 5.80434413,3.13393964 5.60996979,3.16921961 L5.53507343,3.17593267 L1.25,3.17593267 C1.04545009,3.17593267 0.875326358,3.32332864 0.840046391,3.51770298 L0.833333333,3.59259934 L0.833333333,13.6141226 C0.833333333,13.8186725 0.9807293,13.9887963 1.17510364,14.0240762 L1.25,14.0307893 L10.6872294,14.0307893 C10.8917793,14.0307893 11.0619031,13.8833933 11.097183,13.689019 L11.1038961,13.6141226 L11.1038961,10.8819805 C11.1038961,10.6518618 11.2904441,10.4653138 11.5205628,10.4653138 C11.7251127,10.4653138 11.8952364,10.6127098 11.9305164,10.8070841 L11.9372294,10.8819805 L11.9372294,13.6141226 C11.9372294,14.2638694 11.4414894,14.7978298 10.8076128,14.8584005 L10.6872294,14.8641226 L1.25,14.8641226 C0.600253235,14.8641226 0.0662927682,14.3683825 0.00572214838,13.734506 L-8.8817842e-15,13.6141226 L-8.8817842e-15,3.59259934 C-8.8817842e-15,2.94285257 0.495740069,2.4088921 1.12961666,2.34832148 L1.25,2.34259934 L5.53507343,2.34259934 Z"
            id="Path-2"
          />
        </g>
      </g>
    </svg>
  ),
  campaginNavigation: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/FullScreen" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Group"
          transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(4.500000, 6.500000)"
          fill="#747474"
          fillRule="nonzero"
        >
          <path
            d="M1.16643029,4.19915298 L5.09961758,0.169993344 C5.29629219,-0.0314802489 5.60120426,-0.0538662037 5.82193164,0.10283548 L5.90038242,0.169993344 L9.83356971,4.19915298 C10.0551526,4.42614267 10.0555238,4.79454664 9.83439866,5.02200629 C9.63784301,5.22419264 9.33243944,5.24695881 9.11137382,5.09009972 L9.03280487,5.02285722 L6.06622885,1.98386504 L6.06622885,10.4441015 C6.06622885,10.7654459 5.81304201,11 5.5,11 C5.22174043,11 4.98059656,10.7155315 4.93260344,10.4441015 L4.93318729,8.60707391 L4.93260344,1.98386504 L1.96719513,5.02285722 C1.77023253,5.22462583 1.46478374,5.24674355 1.24403464,5.08941545 L1.16560134,5.02200629 C0.969045691,4.81981993 0.947499416,4.50627016 1.10076273,4.27966645 L1.16643029,4.19915298 L5.09961758,0.169993344 L1.16643029,4.19915298 Z"
            id="Combined-Shape"
            transform="translate(5.500000, 5.500000) rotate(90.000000) translate(-5.500000, -5.500000) "
          />
          <path
            d="M14.5,0 C14.7485281,0 14.9547056,0.201698235 14.9934558,0.465964527 L15,0.556179775 L15,10.4438202 C15,10.7509898 14.7761424,11 14.5,11 C14.2514719,11 14.0452944,10.7983018 14.0065442,10.5340355 L14,10.4438202 L14,0.556179775 C14,0.249010167 14.2238576,0 14.5,0 Z"
            id="Path-4"
          />
        </g>
      </g>
    </svg>
  ),
  campaginBelongs: ({ intl, bgColor, mainColor }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/belong" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle
          id="Oval-Copy"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-bg')}
          opacity="0.80078125"
          cx="12"
          cy="12"
          r="12"
        />
        <g id="Belong-to-me" transform="translate(4.000000, 4.000000)">
          <rect id="Rectangle" x="0" y="0" width="16" height="16" />
          <g
            id="Belong-to-Me"
            transform="translate(2.166667, 2.000000)"
            fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          >
            <path
              d="M4.40313514,6.28529859 L1.33703704,6.28618087 C1.22133877,6.28618087 1.05555556,6.52490869 1.05555556,6.87729198 L1.05555556,10.9306253 C1.05555556,11.1638122 0.866520228,11.3528475 0.633333333,11.3528475 C0.400146439,11.3528475 0.211111111,11.1638122 0.211111111,10.9306253 L0.211111111,6.87729198 C0.211111111,6.11037817 0.675445657,5.44173642 1.33703704,5.44173642 L4.94692802,5.44113275 C4.7339185,5.69860631 4.55087322,5.98177591 4.40313514,6.28529859 Z M4.91777432,0.253333333 C6.08370879,0.253333333 7.02888543,1.19850997 7.02888543,2.36444444 C7.02888543,3.53037892 6.08370879,4.47555556 4.91777432,4.47555556 C3.75183985,4.47555556 2.80666321,3.53037892 2.80666321,2.36444444 C2.80666321,1.19850997 3.75183985,0.253333333 4.91777432,0.253333333 Z M4.91777432,1.09777778 C4.21821364,1.09777778 3.65110765,1.66488376 3.65110765,2.36444444 C3.65110765,3.06400513 4.21821364,3.63111111 4.91777432,3.63111111 C5.617335,3.63111111 6.18444099,3.06400513 6.18444099,2.36444444 C6.18444099,1.66488376 5.617335,1.09777778 4.91777432,1.09777778 Z"
              id="Combined-Shape"
              fillRule="nonzero"
            />
            <g id="Group" transform="translate(4.823956, 4.753033)">
              <path
                d="M3.37777778,0 C5.24327293,0 6.75555556,1.51228262 6.75555556,3.37777778 C6.75555556,5.24327293 5.24327293,6.75555556 3.37777778,6.75555556 C1.51228262,6.75555556 0,5.24327293 0,3.37777778 C0,1.51228262 1.51228262,0 3.37777778,0 Z M3.37777778,0.844444444 C1.97865641,0.844444444 0.844444444,1.97865641 0.844444444,3.37777778 C0.844444444,4.77689914 1.97865641,5.91111111 3.37777778,5.91111111 C4.77689914,5.91111111 5.91111111,4.77689914 5.91111111,3.37777778 C5.91111111,1.97865641 4.77689914,0.844444444 3.37777778,0.844444444 Z"
                id="Oval"
                fillRule="nonzero"
              />
              <circle id="Oval" cx="3.37777778" cy="3.37777778" r="1.26666667" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginDoesNotBelong: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g id="Icons/NOTbelong" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle
          id="Oval-Copy"
          fill={getComputedStyle(document.body).getPropertyValue('--primary-bg')}
          opacity="0.80078125"
          cx="12"
          cy="12"
          r="12"
        />
        <g id="Group-3" transform="translate(4.000000, 4.000000)">
          <rect id="Rectangle" x="0" y="0" width="16" height="16" />
          <path
            d="M6.59202403,8.28529859 L3.52592593,8.28618087 C3.41022766,8.28618087 3.24444444,8.52490869 3.24444444,8.87729198 L3.24444444,12.9306253 C3.24444444,13.1638122 3.05540912,13.3528475 2.82222222,13.3528475 C2.58903533,13.3528475 2.4,13.1638122 2.4,12.9306253 L2.4,8.87729198 C2.4,8.11037817 2.86433455,7.44173642 3.52592593,7.44173642 L7.13581691,7.44113275 C6.92280739,7.69860631 6.73976211,7.98177591 6.59202403,8.28529859 Z M7.10666321,2.25333333 C8.27259768,2.25333333 9.21777432,3.19850997 9.21777432,4.36444444 C9.21777432,5.53037892 8.27259768,6.47555556 7.10666321,6.47555556 C5.94072874,6.47555556 4.9955521,5.53037892 4.9955521,4.36444444 C4.9955521,3.19850997 5.94072874,2.25333333 7.10666321,2.25333333 Z M7.10666321,3.09777778 C6.40710253,3.09777778 5.83999654,3.66488376 5.83999654,4.36444444 C5.83999654,5.06400513 6.40710253,5.63111111 7.10666321,5.63111111 C7.80622389,5.63111111 8.37332988,5.06400513 8.37332988,4.36444444 C8.37332988,3.66488376 7.80622389,3.09777778 7.10666321,3.09777778 Z"
            id="Combined-Shape"
            fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
            fillRule="nonzero"
          />
          <g
            id="Group"
            transform="translate(7.012845, 6.753033)"
            fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
          >
            <path
              d="M3.37777778,0 C5.24327293,0 6.75555556,1.51228262 6.75555556,3.37777778 C6.75555556,5.24327293 5.24327293,6.75555556 3.37777778,6.75555556 C1.51228262,6.75555556 0,5.24327293 0,3.37777778 C0,1.51228262 1.51228262,0 3.37777778,0 Z M3.37777778,0.844444444 C1.97865641,0.844444444 0.844444444,1.97865641 0.844444444,3.37777778 C0.844444444,4.77689914 1.97865641,5.91111111 3.37777778,5.91111111 C4.77689914,5.91111111 5.91111111,4.77689914 5.91111111,3.37777778 C5.91111111,1.97865641 4.77689914,0.844444444 3.37777778,0.844444444 Z"
              id="Oval"
              fillRule="nonzero"
            />
            <polygon
              id="Rectangle"
              transform="translate(3.333333, 3.446967) rotate(-45.000000) translate(-3.333333, -3.446967) "
              points="0.666666667 3.046967 6 3.046967 6 3.846967 0.666666667 3.846967"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginApprove: ({ intl }) => (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g>
          <path fill="#F9FAFD" d="M0 0H1367V764H0z" transform="translate(-1230 -298)" />
          <g
            fill="#FFF"
            fillRule="nonzero"
            stroke="#ECECEC"
            transform="translate(-1230 -298) translate(322 245)"
          >
            <rect width="1012" height="568" rx="2" />
          </g>
          <g transform="translate(-1230 -298) translate(1230 298)">
            <circle cx="10" cy="10" r="10" fill="#E6FBF6" />
            <path
              fillRule="nonzero"
              stroke="#31B793"
              strokeLinecap="round"
              strokeWidth="1.2"
              d="M5.5 10.663l1.858 2.03c.373.408 1.005.436 1.413.063.021-.02.042-.04.062-.062L14.5 6.5h0"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginReject: ({ intl }) => (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g>
          <path fill="#F9FAFD" d="M0 0H1367V764H0z" transform="translate(-1260 -298)" />
          <g
            fill="#FFF"
            fillRule="nonzero"
            stroke="#ECECEC"
            transform="translate(-1260 -298) translate(322 245)"
          >
            <rect width="1012" height="568" rx="2" />
          </g>
          <g transform="translate(-1260 -298) translate(1260 298)">
            <circle cx="10" cy="10" r="10" fill="#FFEFEE" opacity=".801" />
            <path
              fill="#F06A60"
              fillRule="nonzero"
              d="M6.45 5.62l.06.053L10 9.163l3.49-3.49c.23-.23.605-.23.837 0 .212.212.23.545.053.777l-.053.06-3.49 3.49 3.49 3.49c.23.23.23.605 0 .837-.212.212-.545.23-.777.053l-.06-.053-3.49-3.49-3.49 3.49c-.23.23-.605.23-.837 0-.212-.212-.23-.545-.053-.777l.053-.06L9.163 10l-3.49-3.49c-.23-.23-.23-.605 0-.837.212-.212.545-.23.777-.053z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginCertSmallIcon: ({ intl, color }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <desc>Created with Sketch.</desc>
      <g id="right-copy" stroke="light-black" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M18,3.5 C18.7796961,3.5 19.4204487,4.09488808 19.4931334,4.85553999 L19.5,5 L19.5,15 C19.5,15.2761424 19.2761424,15.5 19,15.5 C18.7545401,15.5 18.5503916,15.3231248 18.5080557,15.0898756 L18.5,15 L18.5,5 C18.5,4.75454011 18.3231248,4.55039163 18.0898756,4.50805567 L18,4.5 L6,4.5 C5.75454011,4.5 5.55039163,4.67687516 5.50805567,4.91012437 L5.5,5 L5.5,19 C5.5,19.2454599 5.67687516,19.4496084 5.91012437,19.4919443 L6,19.5 L14,19.5 C14.2761424,19.5 14.5,19.7238576 14.5,20 C14.5,20.2454599 14.3231248,20.4496084 14.0898756,20.4919443 L14,20.5 L6,20.5 C5.22030388,20.5 4.57955132,19.9051119 4.50686658,19.14446 L4.5,19 L4.5,5 C4.5,4.22030388 5.09488808,3.57955132 5.85553999,3.50686658 L6,3.5 L18,3.5 Z M15,12.5 C16.9329966,12.5 18.5,14.0670034 18.5,16 C18.5,16.9135532 18.1499941,17.7453581 17.5767634,18.3686335 L18.7071068,19.5 C18.9023689,19.6952621 18.9023689,20.0118446 18.7071068,20.2071068 C18.5118446,20.4023689 18.1952621,20.4023689 18,20.2071068 L16.7969196,19.0041311 C16.2716561,19.3189937 15.6569662,19.5 15,19.5 C13.0670034,19.5 11.5,17.9329966 11.5,16 C11.5,14.0670034 13.0670034,12.5 15,12.5 Z M15,13.5 C13.6192881,13.5 12.5,14.6192881 12.5,16 C12.5,17.3807119 13.6192881,18.5 15,18.5 C16.3807119,18.5 17.5,17.3807119 17.5,16 C17.5,14.6192881 16.3807119,13.5 15,13.5 Z M11,12.5 C11.2761424,12.5 11.5,12.7238576 11.5,13 C11.5,13.2454599 11.3231248,13.4496084 11.0898756,13.4919443 L11,13.5 L8,13.5 C7.72385763,13.5 7.5,13.2761424 7.5,13 C7.5,12.7545401 7.67687516,12.5503916 7.91012437,12.5080557 L8,12.5 L11,12.5 Z M16,9.5 C16.2761424,9.5 16.5,9.72385763 16.5,10 C16.5,10.2454599 16.3231248,10.4496084 16.0898756,10.4919443 L16,10.5 L8,10.5 C7.72385763,10.5 7.5,10.2761424 7.5,10 C7.5,9.75454011 7.67687516,9.55039163 7.91012437,9.50805567 L8,9.5 L16,9.5 Z M8,6.5 L16,6.5 C16.2761424,6.5 16.5,6.72385763 16.5,7 C16.5,7.24545989 16.3231248,7.44960837 16.0898756,7.49194433 L16,7.5 L8,7.5 C7.72385763,7.5 7.5,7.27614237 7.5,7 C7.5,6.75454011 7.67687516,6.55039163 7.91012437,6.50805567 L8,6.5 L16,6.5 L8,6.5 Z"
          id="Combined-Shape"
          fill={color || '#fff'}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  campaginMembershipReview: ({ intl, color }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Icons/Group/grey</title>
      <g id="Icons/Group/grey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect
          id="Rectangle-Copy-51"
          fill="#D8D8D8"
          opacity="0"
          x="0"
          y="0"
          width="24"
          height="24"
        />
        <rect
          id="Rectangle-Copy-50"
          fill="#FFF5F5"
          opacity="0"
          x="2"
          y="2"
          width="20"
          height="20"
        />
        <path
          d="M10,6 C11.6568542,6 13,7.34314575 13,9 C13,10.165353 12.3355389,11.1755129 11.3648117,11.6722845 C13.7421893,12.2776977 15.5,14.4335695 15.5,17 C15.5,17.2761424 15.2761424,17.5 15,17.5 C14.7238576,17.5 14.5,17.2761424 14.5,17 C14.5,14.5147186 12.4852814,12.5 10,12.5 C7.51471863,12.5 5.5,14.5147186 5.5,17 C5.5,17.2761424 5.27614237,17.5 5,17.5 C4.72385763,17.5 4.5,17.2761424 4.5,17 C4.5,14.4335695 6.25781071,12.2776977 8.63514294,11.6706738 C7.66446108,11.1755129 7,10.165353 7,9 C7,7.34314575 8.34314575,6 10,6 Z M14.7335411,6.47735377 C16.1142529,6.47735377 17.2335411,7.59664189 17.2335411,8.97735377 C17.2335411,9.71501409 16.9140574,10.378055 16.4059115,10.8356552 C18.0683866,11.5716447 19.2335411,13.3793957 19.2335411,15.4773538 C19.2335411,15.7534961 19.0096834,15.9773538 18.7335411,15.9773538 C18.4573987,15.9773538 18.2335411,15.7534961 18.2335411,15.4773538 C18.2335411,13.2559553 16.6525619,11.4773538 14.7335411,11.4773538 C14.4573987,11.4773538 14.2335411,11.2534961 14.2335411,10.9773538 C14.2335411,10.7012114 14.4573987,10.4773538 14.7335411,10.4773538 C15.5619682,10.4773538 16.2335411,9.80578089 16.2335411,8.97735377 C16.2335411,8.14892664 15.5619682,7.47735377 14.7335411,7.47735377 C14.4573987,7.47735377 14.2335411,7.25349614 14.2335411,6.97735377 C14.2335411,6.70121139 14.4573987,6.47735377 14.7335411,6.47735377 Z M10,7 C8.8954305,7 8,7.8954305 8,9 C8,10.1045695 8.8954305,11 10,11 C11.1045695,11 12,10.1045695 12,9 C12,7.8954305 11.1045695,7 10,7 Z"
          id="Combined-Shape"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  campaginApproveUntil: ({ intl }) => (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1">
      <g id="Cert" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Cert-02.5-RoleOwner-step2-No-Smart" transform="translate(-938.000000, -105.000000)">
          <rect fill="#F9FAFD" x="0" y="0" width="1367" height="764" />
          <rect
            id="Rectangle"
            stroke="#ECECEC"
            fill="#FFFFFF"
            x="322.5"
            y="88.5"
            width="1011"
            height="53"
            rx="3"
          />
          <g id="Group-17" transform="translate(938.000000, 105.000000)">
            <circle id="Oval-Copy" fill="#DDDDDD" cx="10" cy="10" r="10" />
            <path
              d="M5.5,10.6630822 L7.35775948,12.6935963 C7.73056513,13.1010695 8.3631061,13.1291731 8.77057928,12.7563674 C8.79242184,12.7363832 8.81336617,12.7154389 8.83335038,12.6935963 L14.5,6.5 L14.5,6.5"
              id="first-step-path-copy-2"
              stroke="#747474"
              strokeWidth="1.2"
              strokeLinecap="round"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginReassign: ({ intl }) => (
    <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1">
      <g id="Cert" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Cert-02.5-RoleOwner-step2-No-Smart" transform="translate(-1089.000000, -107.000000)">
          <rect fill="#F9FAFD" x="0" y="0" width="1367" height="764" />
          <rect
            id="Rectangle"
            stroke="#ECECEC"
            fill="#FFFFFF"
            x="322.5"
            y="88.5"
            width="1011"
            height="53"
            rx="3"
          />
          <g
            id="Icons/Delegation"
            transform="translate(1089.000000, 107.000000)"
            fill="#747474"
            fillRule="nonzero"
          >
            <path
              d="M8,13 C9.1045695,13 10,13.8954305 10,15 C10,16.1045695 9.1045695,17 8,17 C6.8954305,17 6,16.1045695 6,15 C6,13.8954305 6.8954305,13 8,13 Z M14,13 C15.1045695,13 16,13.8954305 16,15 C16,16.1045695 15.1045695,17 14,17 C12.8954305,17 12,16.1045695 12,15 C12,13.8954305 12.8954305,13 14,13 Z M2,13 C3.1045695,13 4,13.8954305 4,15 C4,16.1045695 3.1045695,17 2,17 C0.8954305,17 0,16.1045695 0,15 C0,13.8954305 0.8954305,13 2,13 Z M8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 C8.55228475,16 9,15.5522847 9,15 C9,14.4477153 8.55228475,14 8,14 Z M14,14 C13.4477153,14 13,14.4477153 13,15 C13,15.5522847 13.4477153,16 14,16 C14.5522847,16 15,15.5522847 15,15 C15,14.4477153 14.5522847,14 14,14 Z M2,14 C1.44771525,14 1,14.4477153 1,15 C1,15.5522847 1.44771525,16 2,16 C2.55228475,16 3,15.5522847 3,15 C3,14.4477153 2.55228475,14 2,14 Z M8,0 C9.65685425,0 11,1.34314575 11,3 C11,4.48763919 9.91719625,5.722376 8.49673205,5.95906718 L8.5,6 L8.5,7.5 L13.3333333,7.5 L13.4562798,7.50691071 C14.0604451,7.5754069 14.5,8.14388023 14.5,8.8 L14.5,8.8 L14.5,12 L14.4919443,12.0898756 C14.4496084,12.3231248 14.2454599,12.5 14,12.5 C13.7238576,12.5 13.5,12.2761424 13.5,12 L13.5,12 L13.5,8.8 L13.4925035,8.71396024 C13.468471,8.58069826 13.391524,8.5 13.3333333,8.5 L13.3333333,8.5 L8.5,8.5 L8.5,12 C8.5,12.2761424 8.27614237,12.5 8,12.5 C7.75454011,12.5 7.55039163,12.3231248 7.50805567,12.0898756 L7.5,12 L7.5,8.5 L2.66666667,8.5 L2.63007489,8.50945871 C2.56724855,8.54061264 2.5,8.64683791 2.5,8.8 L2.5,8.8 L2.5,12 L2.49194433,12.0898756 C2.44960837,12.3231248 2.24545989,12.5 2,12.5 C1.72385763,12.5 1.5,12.2761424 1.5,12 L1.5,12 L1.5,8.8 L1.50577927,8.67006684 C1.56316461,8.02746584 2.04177519,7.5 2.66666667,7.5 L2.66666667,7.5 L7.5,7.5 L7.5,6 L7.50425926,5.95923219 C6.08330755,5.72295042 5,4.48798523 5,3 C5,1.34314575 6.34314575,0 8,0 Z M8,1 C6.8954305,1 6,1.8954305 6,3 C6,4.1045695 6.8954305,5 8,5 C9.1045695,5 10,4.1045695 10,3 C10,1.8954305 9.1045695,1 8,1 Z M8,2 L8.29389263,2.5954915 L8.95105652,2.69098301 L8.47552826,3.1545085 L8.58778525,3.80901699 L8,3.5 L7.41221475,3.80901699 L7.52447174,3.1545085 L7.04894348,2.69098301 L7.70610737,2.5954915 L8,2 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  campaginConsult: ({ intl }) => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>consult</title>
      <g id="Cert" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Cert-02.4-RoleOwner-step2-No-Smart" transform="translate(-1216.000000, -195.000000)">
          <rect fill="#F9FAFD" x="0" y="0" width="1367" height="764" />
          <rect
            id="Rectangle"
            stroke="#ECECEC"
            fill="#FFFFFF"
            x="322.5"
            y="180.5"
            width="1011"
            height="53"
            rx="3"
          />
          <g id="Group" transform="translate(1216.000000, 195.000000)">
            <rect
              id="Rectangle"
              stroke="#D6D6D6"
              strokeWidth="4"
              fill="#FFFFFF"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <rect
              id="Rectangle"
              fill="#FFFFFF"
              opacity="0"
              x="2.83333333"
              y="2.83333333"
              width="18.3333333"
              height="18.3333333"
            />
            <path
              d="M19.3333333,8.60833333 L11.0833333,8.60833333 C10.0708113,8.60833333 9.25,9.42914463 9.25,10.4416667 L9.25,16.7262045 L9.25502859,16.8630283 C9.3250153,17.8116499 10.116835,18.5595378 11.0833333,18.5595378 L14.0936667,18.55875 L18.0431752,20.2214517 C18.5098059,20.4178087 19.0472635,20.1987086 19.2436205,19.7320779 L19.2832733,19.6170151 C19.3045347,19.5388064 19.3153776,19.4579477 19.3153776,19.3765422 L19.315,18.55875 L19.3333333,18.5595378 C20.3458554,18.5595378 21.1666667,17.7387265 21.1666667,16.7262045 L21.1666667,10.4416667 C21.1666667,9.42914463 20.3458554,8.60833333 19.3333333,8.60833333 Z M11.0833333,9.525 L19.3333333,9.525 C19.8395944,9.525 20.25,9.93540565 20.25,10.4416667 L20.25,16.7262045 C20.25,17.2324655 19.8395944,17.6428712 19.3333333,17.6428712 L18.3987109,17.6428712 L18.3987109,19.3765422 L14.3640082,17.6787497 L14.1862404,17.6428712 L11.0833333,17.6428712 C10.5770723,17.6428712 10.1666667,17.2324655 10.1666667,16.7262045 L10.1666667,10.4416667 C10.1666667,9.93540565 10.5770723,9.525 11.0833333,9.525 Z"
              id="Path-2"
              fill="#747474"
              fillRule="nonzero"
            />
            <path
              d="M13.8333333,10.9916667 C14.0358377,10.9916667 14.2,11.1707528 14.2,11.3916667 C14.2,11.5849663 14.0743133,11.7462416 13.9072295,11.7835401 L13.8333333,11.7916667 L12,11.7916667 C11.7974956,11.7916667 11.6333333,11.6125806 11.6333333,11.3916667 C11.6333333,11.198367 11.7590201,11.0370918 11.9261039,10.9997932 L12,10.9916667 L13.8333333,10.9916667 Z"
              id="Line"
              fill="#747474"
              fillRule="nonzero"
            />
            <path
              d="M15.6666667,13.2833333 C15.8691711,13.2833333 16.0333333,13.4624194 16.0333333,13.6833333 C16.0333333,13.876633 15.9076466,14.0379082 15.7405628,14.0752068 L15.6666667,14.0833333 L12,14.0833333 C11.7974956,14.0833333 11.6333333,13.9042472 11.6333333,13.6833333 C11.6333333,13.4900337 11.7590201,13.3287584 11.9261039,13.2914599 L12,13.2833333 L15.6666667,13.2833333 Z"
              id="Line-Copy"
              fill="#747474"
              fillRule="nonzero"
            />
            <path
              d="M14.75,15.575 C14.9525044,15.575 15.1166667,15.7540861 15.1166667,15.975 C15.1166667,16.1682997 14.9909799,16.3295749 14.8238961,16.3668734 L14.75,16.375 L12,16.375 C11.7974956,16.375 11.6333333,16.1959139 11.6333333,15.975 C11.6333333,15.7817003 11.7590201,15.6204251 11.9261039,15.5831266 L12,15.575 L14.75,15.575 Z"
              id="Line-Copy-2"
              fill="#747474"
              fillRule="nonzero"
            />
            <path
              d="M13.8333333,4.025 C14.7998316,4.025 15.5916514,4.77288797 15.6616381,5.72150952 L15.6666667,5.85833333 L15.6666667,8.88158797 L14.75,8.88158797 L14.75,5.85833333 C14.75,5.38823381 14.3961298,5.0007851 13.940236,4.94783375 L13.8333333,4.94166667 L4.66666667,4.94166667 C4.19656715,4.94166667 3.80911844,5.29553684 3.75616709,5.75143064 L3.75,5.85833333 L3.75,12.8957493 C3.75,13.3658488 4.10387017,13.7532975 4.55976397,13.8062489 L4.66666667,13.812416 L5.75556314,13.812416 L5.75556314,15.7131654 L9.53242959,14.1434323 L9.88423708,14.989901 L6.10737064,16.5596341 C5.99586946,16.605976 5.87631115,16.6298321 5.75556314,16.6298321 C5.28546362,16.6298321 4.89801491,16.2759619 4.84506356,15.8200681 L4.83889648,15.7131654 L4.83808333,14.7289167 L4.66666667,14.7290826 C3.70016835,14.7290826 2.90834864,13.9811947 2.83836193,13.0325731 L2.83333333,12.8957493 L2.83333333,5.85833333 C2.83333333,4.89183502 3.58122131,4.1000153 4.52984285,4.03002859 L4.66666667,4.025 L13.8333333,4.025 Z"
              id="Path"
              fill="#747474"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  notSuportedIcon: () => (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-136.000000, -564.000000)"
          fill="#747474"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(136.000000, 564.000000)">
            <path d="M14,3.25003939 L14.0898756,3.25809506 C14.3231248,3.30043102 14.5,3.5045795 14.5,3.75003939 C14.5,4.02618177 14.2761424,4.25003939 14,4.25003939 L14,4.25003939 L7,4.25003939 L6.83562431,4.25535707 C5.53153594,4.34000072 4.5,5.42455599 4.5,6.75003939 L4.5,6.75003939 L4.5,16.7500394 L4.50531768,16.9144151 C4.58996133,18.2185035 5.6745166,19.2500394 7,19.2500394 L7,19.2500394 L17,19.2500394 L17.1643757,19.2447217 C18.4684641,19.1600781 19.5,18.0755228 19.5,16.7500394 L19.5,16.7500394 L19.5,9.75003939 L19.5080557,9.66016376 C19.5503916,9.42691455 19.7545401,9.25003939 20,9.25003939 C20.2761424,9.25003939 20.5,9.47389702 20.5,9.75003939 L20.5,9.75003939 L20.5,16.7500394 L20.4948211,16.9420746 C20.3951264,18.7857618 18.8685634,20.2500394 17,20.2500394 L17,20.2500394 L7,20.2500394 L6.8079648,20.2448605 C4.9642776,20.1451658 3.5,18.6186028 3.5,16.7500394 L3.5,16.7500394 L3.5,6.75003939 L3.50517886,6.55800419 C3.60487355,4.71431699 5.1314366,3.25003939 7,3.25003939 L7,3.25003939 L14,3.25003939 Z M12,8.75003939 C13.6568542,8.75003939 15,10.0931851 15,11.7500394 C15,13.4068936 13.6568542,14.7500394 12,14.7500394 C10.3431458,14.7500394 9,13.4068936 9,11.7500394 C9,10.0931851 10.3431458,8.75003939 12,8.75003939 Z M12,9.75003939 C10.8954305,9.75003939 10,10.6454699 10,11.7500394 C10,12.8546089 10.8954305,13.7500394 12,13.7500394 C13.1045695,13.7500394 14,12.8546089 14,11.7500394 C14,10.6454699 13.1045695,9.75003939 12,9.75003939 Z M20,3.25003939 L20.0115408,3.25017177 C20.0324012,3.25065039 20.0532373,3.25242689 20.0739178,3.25550126 L20,3.25003939 C20.036097,3.25003939 20.0713007,3.25386455 20.1052277,3.26113162 C20.1204743,3.26443553 20.1358347,3.26848741 20.1510116,3.27328074 C20.1647369,3.27759749 20.1780251,3.28244785 20.1910366,3.28783163 C20.2045389,3.29339086 20.2182757,3.299789 20.2317582,3.30684436 C20.2440467,3.31333273 20.2556825,3.32005873 20.2670103,3.3272274 C20.2788346,3.33464874 20.2906092,3.34281393 20.3020925,3.351542 C20.3157542,3.36195965 20.3288187,3.3729786 20.3412864,3.38462814 C20.345325,3.38839635 20.3494658,3.39239839 20.3535534,3.396486 L20.3654113,3.40875296 C20.3770608,3.42122071 20.3880797,3.43428516 20.3984173,3.44789547 L20.3535534,3.396486 C20.3803877,3.42332027 20.4035342,3.45244582 20.422993,3.48323287 C20.4299807,3.49435692 20.4367067,3.50599272 20.4429657,3.51791215 C20.4502504,3.53176371 20.4566485,3.54550053 20.4623894,3.55944429 C20.4675915,3.57201432 20.4724419,3.58530254 20.4767316,3.59884022 C20.4810375,3.61257575 20.4847255,3.62626999 20.4878228,3.64007007 C20.489314,3.64649199 20.4906992,3.65330349 20.4919443,3.66016376 L20.4948333,3.67813528 C20.4971991,3.69450515 20.4987524,3.71096982 20.4994933,3.72746419 L20.5,3.75003939 L20.5,6.75003939 C20.5,7.02618177 20.2761424,7.25003939 20,7.25003939 C19.7545401,7.25003939 19.5503916,7.07316423 19.5080557,6.83991503 L19.5,6.75003939 L19.5,4.95603939 L15.3535534,9.10359278 C15.1582912,9.29885493 14.8417088,9.29885493 14.6464466,9.10359278 C14.4728803,8.93002643 14.4535951,8.66060203 14.5885912,8.46573389 L14.6464466,8.396486 L18.793,4.24903939 L17,4.25003939 C16.7545401,4.25003939 16.5503916,4.07316423 16.5080557,3.83991503 L16.5,3.75003939 C16.5,3.5045795 16.6768752,3.30043102 16.9101244,3.25809506 L17,3.25003939 L20,3.25003939 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  requestDiscontinued: () => (
    <svg
      width="400px"
      height="200px"
      viewBox="0 0 467 229"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Artboard</title>
      <defs>
        <linearGradient x1="50%" y1="-117.673165%" x2="50%" y2="44.694893%" id="linearGradient-1">
          <stop stopColor="#D8D8D8" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
        <rect id="path-2" x="0" y="0" width="54" height="69" rx="6" />
        <filter
          x="-8.3%"
          y="-6.5%"
          width="111.1%"
          height="108.7%"
          filterUnits="objectBoundingBox"
          id="filter-3"
        >
          <feOffset dx="-3" dy="-3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.943368902   0 0 0 0 0.95172431   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
        <rect id="path-4" x="0" y="0" width="54" height="69" rx="6" />
        <filter
          x="-2.8%"
          y="-6.5%"
          width="111.1%"
          height="108.7%"
          filterUnits="objectBoundingBox"
          id="filter-5"
        >
          <feOffset dx="3" dy="-3" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.945098039   0 0 0 0 0.952941176   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
        <rect id="path-6" x="0" y="0" width="72" height="89" rx="6" />
        <filter
          x="-12.5%"
          y="-9.0%"
          width="116.7%"
          height="112.4%"
          filterUnits="objectBoundingBox"
          id="filter-7"
        >
          <feOffset dx="-6" dy="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0.761032774   0 0 0 0 0.795170949   0 0 0 0 1  0 0 0 1 0"
            type="matrix"
            in="shadowOffsetOuter1"
          />
        </filter>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard" transform="translate(-319.000000, -174.000000)">
          <g id="illustration" transform="translate(334.000000, 222.000000)">
            <path
              d="M436.489796,180.98538 C416.729562,108.95614 300.867426,56.0497076 218.489796,56.0497076 C136.112165,56.0497076 42.5599714,93.6578947 0.489795918,169.511696"
              id="Oval"
              fill="url(#linearGradient-1)"
            />
            <g id="Group" transform="translate(136.000000, 12.000000)">
              <g id="Rectangle-Copy-2">
                <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-2" />
                <rect
                  stroke="#E9E9E9"
                  strokeWidth="2"
                  strokeLinejoin="square"
                  fill="#FFFFFF"
                  fillRule="evenodd"
                  x="1"
                  y="1"
                  width="52"
                  height="67"
                  rx="6"
                />
              </g>
              <line
                x1="9"
                y1="16.5"
                x2="45"
                y2="16.5"
                id="Path-2-Copy-9"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="9"
                y1="27"
                x2="45"
                y2="27"
                id="Path-2-Copy-8"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="9"
                y1="37.5"
                x2="45"
                y2="37.5"
                id="Path-2-Copy-7"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="9"
                y1="48.5"
                x2="20.5"
                y2="48.5"
                id="Path-2-Copy-4"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </g>
            <g id="Group-Copy" transform="translate(219.000000, 12.000000)">
              <g id="Rectangle-Copy-2">
                <use fill="black" fillOpacity="1" filter="url(#filter-5)" xlinkHref="#path-4" />
                <rect
                  stroke="#E9E9E9"
                  strokeWidth="2"
                  strokeLinejoin="square"
                  fill="#FFFFFF"
                  fillRule="evenodd"
                  x="1"
                  y="1"
                  width="52"
                  height="67"
                  rx="6"
                />
              </g>
              <line
                x1="9"
                y1="16.5"
                x2="45"
                y2="16.5"
                id="Path-2-Copy-9"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="9"
                y1="27"
                x2="45"
                y2="27"
                id="Path-2-Copy-8"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="9"
                y1="37.5"
                x2="45"
                y2="37.5"
                id="Path-2-Copy-7"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <line
                x1="32.5"
                y1="48.5"
                x2="44"
                y2="48.5"
                id="Path-2-Copy-4"
                stroke="#E9EAEF"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </g>
            <g id="Group-2" transform="translate(172.000000, 0.000000)">
              <g id="Rectangle">
                <use fill="black" fillOpacity="1" filter="url(#filter-7)" xlinkHref="#path-6" />
                <rect
                  stroke="#EEEEEE"
                  strokeWidth="3"
                  strokeLinejoin="square"
                  fill="#FFFFFF"
                  fillRule="evenodd"
                  x="1.5"
                  y="1.5"
                  width="69"
                  height="86"
                  rx="6"
                />
              </g>
              <path
                d="M27,51.5714286 C29.5,49.8571429 32.5,49 36,49 C39.5,49 42.5,49.8571429 45,51.5714286"
                id="Path-3"
                stroke="#352170"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <circle id="Oval" fill="#352170" cx="25" cy="34" r="3" />
              <circle id="Oval-Copy" fill="#352170" cx="47" cy="34" r="3" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  manageAccess: () => (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="20_Icons"
          transform="translate(-262.000000, -570.000000)"
          fill="#000000"
          fillRule="nonzero"
        >
          <g id="request-new-access-copy-2" transform="translate(256.000000, 564.000000)">
            <path
              d="M16.6666667,21.6666667 C17.5871412,21.6666667 18.3333333,22.4128588 18.3333333,23.3333333 L18.3333333,31.6666667 C18.3333333,32.5871412 17.5871412,33.3333333 16.6666667,33.3333333 L8.33333333,33.3333333 C7.41285875,33.3333333 6.66666667,32.5871412 6.66666667,31.6666667 L6.66666667,23.3333333 C6.66666667,22.4128588 7.41285875,21.6666667 8.33333333,21.6666667 L16.6666667,21.6666667 Z M27.5,21.6666667 C27.9602373,21.6666667 28.3333333,22.0397627 28.3333333,22.5 L28.3333333,22.5 L28.3326667,26.6666667 L32.5,26.6666667 C32.9248344,26.6666667 33.2754183,26.984571 33.3268405,27.3954684 L33.3333333,27.5 C33.3333333,27.9602373 32.9602373,28.3333333 32.5,28.3333333 L32.5,28.3333333 L28.3326667,28.3326667 L28.3333333,32.5 C28.3333333,32.9248344 28.015429,33.2754183 27.6045316,33.3268405 L27.5,33.3333333 C27.0397627,33.3333333 26.6666667,32.9602373 26.6666667,32.5 L26.6666667,32.5 L26.6666667,28.3326667 L22.5,28.3333333 C22.0751656,28.3333333 21.7245817,28.015429 21.6731595,27.6045316 L21.6666667,27.5 C21.6666667,27.0397627 22.0397627,26.6666667 22.5,26.6666667 L22.5,26.6666667 L26.6666667,26.6666667 L26.6666667,22.5 C26.6666667,22.0751656 26.984571,21.7245817 27.3954684,21.6731595 Z M16.6666667,23.3333333 L8.33333333,23.3333333 L8.33333333,31.6666667 L16.6666667,31.6666667 L16.6666667,23.3333333 Z M16.6666667,6.66666667 C17.5871412,6.66666667 18.3333333,7.41285875 18.3333333,8.33333333 L18.3333333,16.6666667 C18.3333333,17.5871412 17.5871412,18.3333333 16.6666667,18.3333333 L8.33333333,18.3333333 C7.41285875,18.3333333 6.66666667,17.5871412 6.66666667,16.6666667 L6.66666667,8.33333333 C6.66666667,7.41285875 7.41285875,6.66666667 8.33333333,6.66666667 L16.6666667,6.66666667 Z M31.6666667,6.66666667 C32.5871412,6.66666667 33.3333333,7.41285875 33.3333333,8.33333333 L33.3333333,16.6666667 C33.3333333,17.5871412 32.5871412,18.3333333 31.6666667,18.3333333 L23.3333333,18.3333333 C22.4128588,18.3333333 21.6666667,17.5871412 21.6666667,16.6666667 L21.6666667,8.33333333 C21.6666667,7.41285875 22.4128588,6.66666667 23.3333333,6.66666667 L31.6666667,6.66666667 Z M16.6666667,8.33333333 L8.33333333,8.33333333 L8.33333333,16.6666667 L16.6666667,16.6666667 L16.6666667,8.33333333 Z M31.6666667,8.33333333 L23.3333333,8.33333333 L23.3333333,16.6666667 L31.6666667,16.6666667 L31.6666667,8.33333333 Z"
              id="Combined-Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  request_history_header: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <g fill="#000" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M17.333.667c1.841 0 3.334 1.492 3.334 3.333v16c0 1.84-1.493 3.333-3.334 3.333H4C2.16 23.333.667 21.841.667 20V.667h16.666zm0 1.333H2v18c0 1.105.895 2 2 2h13.333c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2zm-3.29 14.904c.367 0 .666.298.666.666 0 .368-.299.667-.667.667H7.375c-.368 0-.666-.299-.666-.667 0-.368.298-.666.666-.666zM10.696 4.535c2.946 0 5.334 2.388 5.334 5.333 0 2.946-2.388 5.334-5.334 5.334-1.84 0-3.463-.932-4.421-2.35-.576-.852-.912-1.878-.912-2.984 0-.972.26-1.883.715-2.668C7 5.607 8.724 4.535 10.697 4.535zm0 1.333c-1.444 0-2.753.772-3.464 2-.35.603-.536 1.286-.536 2 0 .81.24 1.581.683 2.237.74 1.095 1.971 1.763 3.317 1.763 2.21 0 4-1.79 4-4 0-2.209-1.79-4-4-4zm-.08 1.137c.368 0 .666.299.666.667v2.39l1.138 1.138c.26.26.26.683 0 .943-.26.26-.682.26-.942 0l-1.334-1.333c-.125-.125-.195-.295-.195-.472V7.672c0-.368.299-.667.667-.667z"
                transform="translate(-62 -32) translate(62 32) translate(5.333 4)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  request_entitlement: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M14.824 11.329c1.657 0 3 1.343 3 3 0 .614-.184 1.186-.501 1.661l.001.024v5c0 .446-.539.669-.853.354l-1.647-1.647-1.646 1.647c-.315.315-.854.092-.854-.354v-5-.025c-.315-.474-.5-1.046-.5-1.66 0-1.657 1.344-3 3-3zM17 3.5c1.38 0 2.5 1.12 2.5 2.5v12c0 .276-.224.5-.5.5s-.5-.224-.5-.5V6c0-.828-.672-1.5-1.5-1.5H5.5V18c0 .828.672 1.5 1.5 1.5h4c.276 0 .5.224.5.5s-.224.5-.5.5H7c-1.38 0-2.5-1.12-2.5-2.5V3.5zm-.675 13.427c-.441.256-.954.402-1.5.402-.547 0-1.06-.146-1.501-.402v2.88l1.147-1.146c.195-.195.511-.195.707 0l1.146 1.146zm-1.5-4.598c-1.105 0-2 .895-2 2s.895 2 2 2c1.104 0 2-.895 2-2s-.896-2-2-2zM10 12c.276 0 .5.224.5.5s-.224.5-.5.5H7c-.276 0-.5-.224-.5-.5s.224-.5.5-.5zm3-3c.276 0 .5.224.5.5s-.224.5-.5.5H7c-.276 0-.5-.224-.5-.5S6.724 9 7 9zM9 6c.276 0 .5.224.5.5S9.276 7 9 7H7c-.276 0-.5-.224-.5-.5S6.724 6 7 6z" />
    </svg>
  ),
  request_applicationrole: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M15.333 10.5c.698 0 1.167.704 1.167 1.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.309-.127-.5-.167-.5H8.667c-.04 0-.167.191-.167.5v5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-5c0-.796.47-1.5 1.167-1.5h6.666zm2.834 1c.697 0 1.166.704 1.166 1.5v4c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-4c0-.309-.127-.5-.166-.5-.276 0-.5-.224-.5-.5s.224-.5.5-.5zm-12.334 0c.276 0 .5.224.5.5s-.224.5-.5.5c-.039 0-.166.191-.166.5v4c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-4c0-.796.47-1.5 1.166-1.5zM17 8c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM7 8c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm5-3c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0 1c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z" />
    </svg>
  ),
  sod_recalculate: ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-1148 -61)">
          <path fill="#F7F8FC" d="M0 0H1367V976H0z" />
          <rect width="1140" height="946" x="114" y="30" fill="#FFF" stroke="#ECECEC" rx="3" />
          <g>
            <path
              fill={
                color
                  ? getComputedStyle(document.body).getPropertyValue('color')
                  : getComputedStyle(document.body).getPropertyValue('--primary-main')
              }
              fillRule="nonzero"
              d="M21.888 5.74l.024.088 1.125 5.621c.06.3-.112.589-.391.686l-.087.023-5.634 1.063c-.33.062-.65-.154-.717-.483-.06-.3.112-.59.392-.686l.087-.023 4.312-.816-.162-.14c-1.653-1.407-2.796-1.875-4.723-1.875-3.695 0-6.69 2.994-6.69 6.688 0 3.695 2.995 6.69 6.69 6.69 2.36 0 4.506-1.232 5.713-3.21.635-1.04.975-2.233.975-3.48 0-.393.32-.712.713-.712.393 0 .712.319.712.712 0 1.51-.414 2.961-1.184 4.223C21.58 22.506 18.975 24 16.113 24 11.634 24 8 20.367 8 15.886c0-4.48 3.633-8.113 8.114-8.113 2.17 0 3.586.537 5.339 1.96l-.736-3.68c-.06-.3.112-.589.391-.686l.087-.023c.3-.057.593.117.693.397z"
              transform="translate(1140 56)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  sod_downloadreport: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-1188 -62)">
          <path fill="#F7F8FC" d="M0 0H1367V976H0z" />
          <rect width="1140" height="946" x="114" y="30" fill="#FFF" stroke="#ECECEC" rx="3" />
          <g>
            <path
              fill={getComputedStyle(document.body).getPropertyValue('--primary-main')}
              fillRule="nonzero"
              d="M24.485 23.636c.468 0 .848.38.848.849 0 .416-.3.763-.696.835l-.152.013H7.515c-.468 0-.848-.38-.848-.848 0-.417.3-.763.696-.835l.152-.014h16.97zM16 6.666c.417 0 .763.3.835.697l.013.152v11.528L20.49 15.4c.294-.295.752-.327 1.082-.098l.118.098c.294.295.327.752.098 1.082l-.098.118-5.091 5.09-.02.02c-.016.015-.032.03-.049.043l.069-.062c-.032.032-.067.061-.103.088-.025.018-.051.035-.079.05l-.014.008-.005.003-.1.045-.03.011c-.024.008-.05.015-.075.021l-.026.006c-.027.005-.056.01-.084.012l-.039.003-.045.001h-.021c-.018 0-.035-.001-.053-.003l.074.003c-.049 0-.097-.004-.143-.012l-.036-.007c-.024-.005-.048-.01-.07-.018l-.049-.016-.049-.02-.057-.029c-.016-.008-.03-.017-.045-.026-.011-.007-.023-.014-.033-.022l-.012-.008c-.036-.026-.07-.055-.102-.086l-.004-.004-5.09-5.091c-.332-.331-.332-.869 0-1.2.294-.295.75-.327 1.082-.098l.117.098 3.642 3.642V7.515c0-.468.38-.848.849-.848z"
              transform="translate(1182 56)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),

  nodescription: () => (
    <svg
      width="77px"
      height="76px"
      viewBox="0 0 85 76"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <ellipse id="path-1" cx="38.5" cy="38" rx="38.5" ry="38" />
      </defs>
      <g id="V8" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="07---RNA---No-Description" transform="translate(-399.000000, -153.000000)">
          <g id="Group-2" transform="translate(351.000000, 0.000000)">
            <g id="Group-5" transform="translate(24.000000, 129.000000)">
              <g id="Group" transform="translate(23.000000, 21.000000)">
                <g
                  id="336uae7iwc-link"
                  transform="translate(4.000000, 3.000000)"
                  fill="#EDF2FF"
                  fillRule="nonzero"
                >
                  <ellipse id="336uae7iwc" cx="38.5" cy="38" rx="38.5" ry="38" />
                </g>
                <g id="Clipped" transform="translate(4.000000, 3.000000)">
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1" />
                  </mask>
                  <g id="336uae7iwc" />
                  <rect
                    id="Rectangle-Copy-317"
                    fill="#FFFFFF"
                    mask="url(#mask-2)"
                    x="19"
                    y="15"
                    width="38"
                    height="47"
                    rx="2"
                  />
                  <rect
                    id="Rectangle"
                    fill="#C2CBFF"
                    opacity="0.848133176"
                    mask="url(#mask-2)"
                    x="28"
                    y="45"
                    width="20"
                    height="2"
                    rx="1"
                  />
                  <rect
                    id="Rectangle-Copy-11"
                    fill="#C2CBFF"
                    opacity="0.848133176"
                    mask="url(#mask-2)"
                    x="25"
                    y="39"
                    width="26"
                    height="2"
                    rx="1"
                  />
                  <rect
                    id="Rectangle"
                    fill="#98A7FF"
                    mask="url(#mask-2)"
                    x="31"
                    y="23"
                    width="14"
                    height="10"
                    rx="2"
                  />
                  <rect
                    id="Rectangle-Copy-20"
                    fill="#C2CBFF"
                    opacity="0.848133176"
                    mask="url(#mask-2)"
                    x="31"
                    y="51"
                    width="14"
                    height="2"
                    rx="1"
                  />
                </g>
                <circle id="Oval" stroke="#DFDFDF" cx="3" cy="52" r="1.5" />
                <circle id="Oval-Copy-2" fill="#D8D8D8" cx="75" cy="69" r="1" />
                <g
                  id="Group-3-Copy"
                  transform="translate(8.000000, 3.000000)"
                  stroke="#DFDFDF"
                  strokeLinecap="round"
                >
                  <line
                    x1="3"
                    y1="4.09139389e-13"
                    x2="3"
                    y2="4.8"
                    id="Path-8"
                    transform="translate(3.000000, 2.400000) rotate(-135.000000) translate(-3.000000, -2.400000) "
                  />
                  <line
                    x1="3"
                    y1="7.04858394e-13"
                    x2="3"
                    y2="4.8"
                    id="Path-8-Copy"
                    transform="translate(3.000000, 2.400000) rotate(-45.000000) translate(-3.000000, -2.400000) "
                  />
                </g>
                <g
                  id="Group-3-Copy-9"
                  transform="translate(82.000000, 41.000000)"
                  stroke="#AAB5F9"
                  strokeLinecap="round"
                >
                  <line
                    x1="2.54"
                    y1="-0.04"
                    x2="2.46"
                    y2="3.88"
                    id="Path-8"
                    transform="translate(2.500000, 1.920000) rotate(-135.000000) translate(-2.500000, -1.920000) "
                  />
                  <line
                    x1="2.46"
                    y1="-0.04"
                    x2="2.54"
                    y2="3.88"
                    id="Path-8-Copy"
                    transform="translate(2.500000, 1.920000) rotate(-45.000000) translate(-2.500000, -1.920000) "
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  smartfooter_confirm: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <g fill="#ffffff" fillRule="nonzero">
          <g>
            <path
              d="M16 8.467h.022c.02 0 .038.002.057.003L16 8.467c.049 0 .096.004.143.011l.046.01c.022.004.045.01.067.017l.043.015c.076.027.146.065.21.112l.011.008 5.333 4c.383.287.46.83.174 1.213-.259.345-.725.442-1.094.249l-.12-.075-3.947-2.961v11.6c0 .48-.387.867-.866.867-.435 0-.795-.32-.857-.738l-.01-.128V11.066l-3.946 2.96c-.345.26-.82.222-1.12-.067l-.094-.106c-.258-.344-.221-.819.068-1.12l.106-.093 5.333-4c.069-.051.138-.09.213-.117l.033-.012c.025-.008.05-.016.076-.022l.037-.007c.024-.005.048-.008.073-.01.02-.003.038-.004.057-.005H16z"
              transform="translate(-1130 -486) rotate(90 338 824)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  copy_access: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20">
      <defs>
        <linearGradient id="b48lkaxb3a" x1="88.778%" x2="39.097%" y1="0%" y2="61.349%">
          <stop offset="0%" stopColor="#FFEEB4" />
          <stop offset="100%" stopColor="#F6BC41" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-992 -155) translate(992 155)">
            <circle cx="10" cy="10" r="10" fill="url(#b48lkaxb3a)" />
            <g stroke="#FFF" strokeWidth=".5">
              <path
                fill="#F1F2FA"
                d="M4.971 0L7.774 0.296 9.833 3.208 5 8.997 0 3.208 2.169 0.296z"
                transform="translate(5 5.833)"
              />
              <path d="M0.167 3.163L9.833 3.163" transform="translate(5 5.833)" />
              <path
                strokeLinecap="square"
                d="M2.167 2.996L3.624 0.374"
                transform="translate(5 5.833)"
              />
              <path
                strokeLinecap="round"
                d="M2.165 3.329L4.832 8.829"
                transform="translate(5 5.833) rotate(-1.134 3.498 6.08)"
              />
              <path
                strokeLinecap="round"
                d="M5.168 3.329L7.835 8.829"
                transform="translate(5 5.833) scale(-1 1) rotate(-1.134 0 663.261)"
              />
              <path
                strokeLinecap="square"
                d="M6.333 2.996L7.79 0.374"
                transform="translate(5 5.833) matrix(-1 0 0 1 14.124 0)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  confirmIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <g fill="var(--primary-main)" fillRule="nonzero">
          <g>
            <path
              d="M26.21 7.267c.414.202.586.7.384 1.114-.202.414-.7.586-1.114.384-6.205-3.026-13.689-.45-16.715 5.755s-.45 13.689 5.755 16.715 13.689.45 16.715-5.755c.579-1.187.961-2.438 1.144-3.718.237-1.666.133-3.362-.302-4.986-.119-.445.145-.902.59-1.02.445-.12.901.144 1.02.589.492 1.84.611 3.762.342 5.653-.207 1.451-.64 2.869-1.296 4.212-3.43 7.032-11.911 9.953-18.943 6.523-7.032-3.43-9.953-11.911-6.523-18.943 3.43-7.032 11.911-9.953 18.943-6.523zm4.38 3.81c.289.29.32.739.096 1.064l-.097.115-13.333 13.333c-.29.29-.738.322-1.063.097l-.116-.097-5-5c-.325-.325-.325-.853 0-1.178.29-.29.739-.322 1.064-.097l.115.097 4.41 4.41 12.745-12.744c.325-.325.853-.325 1.178 0z"
              transform="translate(-907 -999) translate(907 999)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  resizeIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>resize</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-599.000000, -1279.000000)"
          fill="#d2d2d2"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(599.000000, 1279.000000)">
            <path
              d="M12,2 C12.506261,2 12.9246546,2.3344046 12.9908712,2.76827193 L13,2.88888889 L13,17.1111111 C13,17.6020309 12.5522847,18 12,18 C11.493739,18 11.0753454,17.6655954 11.0091288,17.2317281 L11,17.1111111 L11,2.88888889 C11,2.39796911 11.4477153,2 12,2 Z"
              id="Path-104-Copy-2"
              transform="translate(12.000000, 10.000000) rotate(-90.000000) translate(-12.000000, -10.000000) "
            />
            <path
              d="M12,7 C12.506261,7 12.9246546,7.3344046 12.9908712,7.76827193 L13,7.88888889 L13,22.1111111 C13,22.6020309 12.5522847,23 12,23 C11.493739,23 11.0753454,22.6655954 11.0091288,22.2317281 L11,22.1111111 L11,7.88888889 C11,7.39796911 11.4477153,7 12,7 Z"
              id="Path-104-Copy-3"
              transform="translate(12.000000, 15.000000) rotate(-90.000000) translate(-12.000000, -15.000000) "
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  nextIcon: props => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>arrow_right</title>
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Export"
          transform="translate(-113.000000, -1275.000000)"
          stroke={props.color}
          strokeWidth="1.2"
        >
          <g id="Group" transform="translate(113.000000, 1275.000000)">
            <g
              id="Arrow"
              transform="translate(12.000000, 12.000000) scale(-1, -1) rotate(90.000000) translate(-12.000000, -12.000000) "
            >
              <polyline id="Path-43-Copy" points="7 10 12 15 17 10" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  prevIcon: props => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>arrow_lett</title>
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Export"
          transform="translate(-113.000000, -1275.000000)"
          stroke={props.color}
          strokeWidth="1.2"
        >
          <g id="Group" transform="translate(113.000000, 1275.000000)">
            <g
              id="Arrow"
              transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) "
            >
              <polyline id="Path-43-Copy" points="7 10 12 15 17 10" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  playIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Play</title>
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-393.000000, -1275.000000)" fill="#3751ff">
          <g id="Group" transform="translate(393.000000, 1275.000000)">
            <circle cx="12" cy="12" r="12" fill="#EFF1FF" />
            <g
              id="Dropdown"
              transform="translate(12.000000, 12.000000) scale(-1, 1) rotate(90.000000) translate(-12.000000, -12.000000) "
            >
              <polyline id="Path-43" points="6 9 12 15 18 9" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  eyeViewIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-934 -1304) translate(934 1304)">
            <circle cx="12" cy="12" r="12" fill="#EFF1FF" />
            <g fill="#3751FF" fillRule="nonzero">
              <path
                d="M8.67 0c2.843 0 5.638 1.747 8.39 5.188l.28.35-.316.316C14.27 8.607 11.484 10 8.67 10 5.856 10 3.07 8.607.316 5.854L0 5.537l.28-.35C3.032 1.748 5.827 0 8.67 0zm0 1C6.271 1 3.828 2.472 1.346 5.462 3.816 7.83 6.256 9 8.67 9c2.414 0 4.854-1.17 7.324-3.538C13.512 2.472 11.07 1 8.67 1zm-.011 1.562c1.38 0 2.5 1.12 2.5 2.5 0 1.381-1.12 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.38 1.119-2.5 2.5-2.5zm0 1c-.829 0-1.5.672-1.5 1.5 0 .829.671 1.5 1.5 1.5.828 0 1.5-.671 1.5-1.5 0-.828-.672-1.5-1.5-1.5z"
                transform="translate(3 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  unViewIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-934 -854) translate(934 854)">
            <circle cx="12" cy="12" r="12" fill="#EFF1FF" />
            <g fill="#3751FF" fillRule="nonzero">
              <path
                d="M8.67 0c2.843 0 5.638 1.747 8.39 5.188l.28.35-.316.316C14.27 8.607 11.484 10 8.67 10 5.856 10 3.07 8.607.316 5.854L0 5.537l.28-.35C3.032 1.748 5.827 0 8.67 0zm0 1C6.271 1 3.828 2.472 1.346 5.462 3.816 7.83 6.256 9 8.67 9c2.414 0 4.854-1.17 7.324-3.538C13.512 2.472 11.07 1 8.67 1zm-.011 1.562c1.38 0 2.5 1.12 2.5 2.5 0 1.381-1.12 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.38 1.119-2.5 2.5-2.5zm0 1c-.829 0-1.5.672-1.5 1.5 0 .829.671 1.5 1.5 1.5.828 0 1.5-.671 1.5-1.5 0-.828-.672-1.5-1.5-1.5z"
                transform="translate(3 7)"
              />
              <path
                d="M15.915.209c.236-.144.543-.07.687.166.128.21.084.475-.093.633l-.072.054L1.93 9.927c-.236.144-.544.07-.688-.166-.128-.21-.083-.476.094-.634l.072-.054L15.915.21z"
                transform="translate(3 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  archieveIcon: () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="#999">
          <g transform="translate(-456 -185) translate(456 185)">
            <path
              fillRule="nonzero"
              d="M6 8h12c1.105 0 2 .82 2 1.833v7.334C20 18.179 19.105 19 18 19H6c-1.105 0-2-.82-2-1.833V9.833C4 8.821 4.895 8 6 8zm0 1c-.552 0-1 .403-1 .9v7.2c0 .497.448.9 1 .9h12c.552 0 1-.403 1-.9V9.9c0-.497-.448-.9-1-.9H6z"
            />
            <path
              fillRule="nonzero"
              d="M12.4 6c1.23 0 2.26.853 2.53 2h-1.046c-.238-.586-.813-1-1.484-1H6.6C5.716 7 5 7.716 5 8.6V10h-.93C4.024 9.809 4 9.608 4 9.4v-.8C4 7.164 5.164 6 6.6 6h5.8z"
            />
            <rect width="22" height="1" x="1" y="13" rx=".5" transform="rotate(-40 12 13.5)" />
          </g>
        </g>
      </g>
    </svg>
  ),
  selectedArchieveIcon: () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="#999" fillRule="nonzero">
          <g>
            <path
              d="M6 8h12c1.105 0 2 .82 2 1.833v7.334C20 18.179 19.105 19 18 19H6c-1.105 0-2-.82-2-1.833V9.833C4 8.821 4.895 8 6 8zm0 1c-.552 0-1 .403-1 .9v7.2c0 .497.448.9 1 .9h12c.552 0 1-.403 1-.9V9.9c0-.497-.448-.9-1-.9H6z"
              transform="translate(-456 -137) translate(456 137)"
            />
            <path
              d="M12.4 6c1.23 0 2.26.853 2.53 2h-1.046c-.238-.586-.813-1-1.484-1H6.6C5.716 7 5 7.716 5 8.6V10h-.93C4.024 9.809 4 9.608 4 9.4v-.8C4 7.164 5.164 6 6.6 6h5.8z"
              transform="translate(-456 -137) translate(456 137)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonEditorIcon: () => (
    <svg width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-432 -574) translate(432 574)">
            <path
              fill="#000"
              fillRule="nonzero"
              d="M20.667 6.667v.036c.504.094.955.368 1.253.771l3.058 4.14c.231.314.355.687.355 1.068v12.11c0 1.035-.895 1.875-2 1.875H10c-1.105 0-2-.84-2-1.875V8.542c0-1.036.895-1.875 2-1.875h10.667zM19.333 8H10c-.368 0-.667.277-.667.619v16.095c0 .342.299.62.667.62h13.333c.369 0 .667-.278.667-.62V12.72c0-.018 0-.035-.002-.053h-2.665c-1.04 0-1.894-.794-1.99-1.808l-.01-.192V8zm1.49.267c-.043-.059-.096-.109-.157-.15v2.55c0 .327.237.6.547.656l.12.01h1.776z"
            />
            <rect width="16" height="6.4" x="7.2" y="16" fill="#000" rx="1" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M10.398 21.016c.329 0 .62-.057.871-.17.252-.115.448-.285.588-.51.14-.226.21-.498.21-.815v-2.335c0-.041-.014-.076-.042-.104-.028-.028-.062-.042-.103-.042H9.183c-.037 0-.07.013-.098.04-.028.025-.042.059-.042.1v.588c0 .037.014.07.042.098.028.028.06.042.098.042h1.798v1.58c0 .223-.048.394-.143.512-.095.117-.232.176-.412.176-.306 0-.489-.14-.548-.42-.02-.056-.043-.096-.073-.12-.03-.025-.071-.037-.123-.037H8.88c-.034 0-.062.012-.084.037-.023.024-.034.053-.034.086.004.273.081.507.233.703.15.196.35.344.596.443.246.099.515.148.806.148zm3.305 0c.448 0 .796-.083 1.045-.25.248-.165.372-.388.372-.668 0-.217-.083-.406-.25-.569-.165-.162-.431-.275-.797-.339-.202-.037-.352-.072-.451-.106-.099-.034-.164-.068-.196-.104-.032-.035-.048-.08-.048-.137 0-.063.027-.116.079-.157.052-.04.125-.061.218-.061.079 0 .143.012.193.036.05.024.11.059.177.104.045.033.09.061.134.084.019.015.045.022.079.022h.616c.033 0 .062-.013.086-.039.025-.026.037-.056.037-.09 0-.097-.052-.204-.157-.322-.105-.117-.257-.218-.456-.302-.2-.084-.436-.126-.709-.126-.269 0-.5.043-.691.129-.193.086-.338.199-.437.339-.1.14-.149.286-.149.44 0 .466.323.765.97.895.2.038.351.074.45.11.099.035.166.071.202.109.035.037.053.085.053.145 0 .071-.033.126-.098.165-.066.04-.149.06-.25.06-.085 0-.159-.015-.22-.043-.062-.028-.128-.068-.2-.12-.007-.008-.042-.032-.106-.073-.015-.015-.033-.022-.056-.022h-.677c-.034 0-.065.012-.093.036-.028.024-.042.055-.042.092 0 .097.05.206.149.325.099.12.25.222.456.308.205.086.461.129.767.129zm3.059 0c.47 0 .831-.11 1.083-.328.252-.218.39-.529.412-.932.007-.097.011-.181.011-.252 0-.07-.004-.155-.011-.252-.023-.396-.164-.705-.423-.927-.26-.222-.617-.333-1.072-.333-.456 0-.813.111-1.073.333-.26.222-.4.531-.423.927-.003.049-.005.133-.005.252v.083c0 .076.003.133.005.169.023.403.16.714.412.932.252.219.613.328 1.084.328zm0-.706c-.153 0-.267-.047-.342-.142-.075-.096-.118-.242-.129-.44l-.005-.224.005-.224c.011-.194.054-.34.129-.437.075-.097.189-.145.342-.145.153 0 .267.048.341.145.075.097.118.243.129.437.004.037.006.112.006.224s-.002.187-.006.224c-.011.198-.054.344-.129.44-.074.095-.188.142-.341.142zm2.683.65c.04 0 .074-.014.1-.042.027-.028.04-.06.04-.098v-1.529c0-.164.043-.292.129-.383.085-.092.203-.138.352-.138.153 0 .27.045.35.135.08.09.12.218.12.386v1.529c0 .041.015.075.043.1.028.027.062.04.103.04h.745c.041 0 .075-.014.101-.042.026-.028.04-.06.04-.098v-1.562c0-.27-.048-.499-.144-.69-.095-.19-.225-.333-.392-.43-.166-.097-.355-.146-.568-.146-.205 0-.387.037-.546.112-.159.075-.288.174-.39.297v-.213c0-.041-.012-.075-.038-.1-.027-.027-.06-.04-.101-.04H18.7c-.037 0-.07.013-.098.04-.028.025-.042.059-.042.1v2.632c0 .037.014.07.042.098.028.028.06.042.098.042h.745z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonEditorSingleObjectIcon: () => (
    <svg width="15" height="12" viewBox="0 0 15 12">
      <g fill="none" fillRule="evenodd">
        <g fill="#3751FF">
          <g>
            <g transform="translate(-163 -443) translate(151 396) translate(12 47)">
              <rect width="15" height="12" rx="2" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonEditorMultiObjectIcon: () => (
    <svg width="18" height="14" viewBox="0 0 18 14">
      <g fill="none" fillRule="evenodd">
        <g fill="#3751FF">
          <g>
            <g>
              <path
                d="M16 4.118c1.105 0 2 .895 2 2V12c0 1.105-.895 2-2 2H6.286c-1.105 0-2-.895-2-2V6.118c0-1.105.895-2 2-2H16zM11.714 0c1.105 0 2 .895 2 2v.47H4.571c-1.054 0-1.918.816-1.994 1.851l-.006.15v5.411H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0h9.714z"
                transform="translate(-233 -356) translate(161 176) translate(72 180)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonEditorArrayIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12">
      <g fill="none" fillRule="evenodd">
        <g fill="#64B30B">
          <g>
            <g transform="translate(-163 -480) translate(151 396) translate(12 84)">
              <rect width="15" height="5" rx="2" />
              <rect width="15" height="5" y="7" rx="2" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonEditorArrayItemIcon: () => (
    <svg width="15" height="12" viewBox="0 0 15 12">
      <g fill="none" fillRule="evenodd">
        <g fill="#64b30b">
          <g>
            <g transform="translate(-163 -443) translate(151 396) translate(12 47)">
              <rect width="15" height="12" rx="2" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonAddNewIcon: () => (
    <svg width="16" height="16" viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-402 -99) translate(402 99)">
            <circle cx="8" cy="8" r="7.5" stroke="#999" />
            <rect width="8" height="1" x="4" y="7.5" fill="#999" rx=".5" />
            <rect
              width="8"
              height="1"
              x="4"
              y="7.5"
              fill="#999"
              rx=".5"
              transform="rotate(90 8 8)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  jsonMoreOptionsIcon: () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g fill="#999">
          <g>
            <g>
              <path
                d="M6 10.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm6 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm6 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"
                transform="translate(-405 -385) translate(161 176) rotate(90 29.5 238.5)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  trashIcon: () => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Export" transform="translate(-64.000000, -754.000000)">
          <g id="Group" transform="translate(64.000000, 754.000000)">
            <rect
              id="Rectangle-Copy-393"
              fill="#D8D8D8"
              opacity="0"
              x="0"
              y="0"
              width="24"
              height="24"
            />
            <rect
              id="Rectangle-Copy-392"
              fill="#FFF5F5"
              opacity="0"
              x="2"
              y="2"
              width="20"
              height="20"
            />
            <path
              d="M13,5 C13.5522847,5 14,5.44771525 14,6 L14,7 L15.9132005,7 C15.9721993,7 16.0300047,7.00510931 16.0861985,7.0149096 L17.0219619,7.01615623 C17.2981043,7.01615623 17.5219619,7.24001386 17.5219619,7.51615623 C17.5219619,7.76161612 17.3450868,7.9657646 17.1118376,8.00810056 L17.0219619,8.01615623 L16.9119619,8.016 L16.9097462,8.08304548 L16.0764129,18.0830455 C16.0332219,18.6013376 15.5999558,19 15.0798671,19 L8.92013288,19 C8.40004424,19 7.96677813,18.6013376 7.92358712,18.0830455 L7.09025379,8.08304548 L7.08796194,8.016 L7.02196194,8.01615623 C6.74581957,8.01615623 6.52196194,7.79229861 6.52196194,7.51615623 C6.52196194,7.27069634 6.6988371,7.06654786 6.93208631,7.0242119 L7.02196194,7.01615623 L7.9098539,7.01571007 C7.94064191,7.01021265 7.9719621,7.00610357 8.00375407,7.00345424 L8.0452409,7.00086393 L10,7 L10,7 L10,6 C10,5.44771525 10.4477153,5 11,5 L13,5 Z M15.9119619,8.016 L8.08696194,8.016 L8.92013288,18 L15.0798671,18 L15.9119619,8.016 Z M12,9.5 C12.2454599,9.5 12.4496084,9.67687516 12.4919443,9.91012437 L12.5,10 L12.5,16 C12.5,16.2761424 12.2761424,16.5 12,16.5 C11.7545401,16.5 11.5503916,16.3231248 11.5080557,16.0898756 L11.5,16 L11.5,10 C11.5,9.72385763 11.7238576,9.5 12,9.5 Z M14.453179,9.51331856 C14.6977049,9.5347118 14.8856608,9.72870661 14.9075067,9.96475805 L14.9076985,10.0549938 L14.384764,16.032162 C14.3606967,16.3072535 14.1181804,16.5107488 13.8430888,16.4866814 C13.598563,16.4652882 13.410607,16.2712934 13.3887612,16.0352419 L13.3885694,15.9450062 L13.9115038,9.96783803 C13.9355712,9.69274646 14.1780875,9.48925116 14.453179,9.51331856 Z M9.60133333,9.49036381 C9.84619529,9.47324139 10.0621847,9.63544502 10.1206881,9.86517283 L10.1349936,9.9542676 L10.5535324,15.9396519 C10.5727952,16.2151216 10.3650984,16.4540494 10.0896286,16.4733122 C9.84476669,16.4904346 9.62877731,16.328231 9.57027384,16.0985031 L9.55596839,16.0094084 L9.13742954,10.0240241 C9.11816682,9.74855437 9.32586363,9.50962653 9.60133333,9.49036381 Z M13,6 L11,6 L11,7 L13,7 L13,6 Z"
              id="Combined-Shape"
              fill="#000000"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  timerIcon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <g>
          <path fill="#F7F8FC" d="M0 0H1367V891H0z" transform="translate(-879 -522)" />
          <g>
            <g fill="#FFF" stroke="#ECECEC" transform="translate(-879 -522) translate(114 276)">
              <rect width="1140" height="432" rx="3" />
            </g>
            <g transform="translate(-879 -522) translate(114 276) translate(762 243)">
              <circle cx="10" cy="10" r="10" fill="#417505" fillOpacity=".136" />
              <g>
                <path d="M0 0L14 0 14 14 0 14z" transform="translate(3 3)" />
                <path
                  fill="#417505"
                  fillRule="nonzero"
                  d="M8.711.933H5.29V2.09H8.71V.933zM6.43 8.448h1.14V4.98H6.43v3.468zm4.58-3.827l.81-.82c-.246-.295-.514-.573-.805-.816l-.81.821C9.321 3.09 8.21 2.662 7 2.662c-2.835 0-5.133 2.33-5.133 5.202 0 2.873 2.293 5.203 5.133 5.203s5.133-2.33 5.133-5.203c0-1.22-.422-2.347-1.123-3.243zM7 11.916c-2.207 0-3.993-1.809-3.993-4.046S4.793 3.824 7 3.824s3.993 1.809 3.993 4.046S9.207 11.916 7 11.916z"
                  transform="translate(3 3)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  eyeViewIconBlack: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-934 -1304) translate(934 1304)">
            <circle cx="12" cy="12" r="12" fill="#EFF1FF" />
            <g fill="#000000" fillRule="nonzero">
              <path
                d="M8.67 0c2.843 0 5.638 1.747 8.39 5.188l.28.35-.316.316C14.27 8.607 11.484 10 8.67 10 5.856 10 3.07 8.607.316 5.854L0 5.537l.28-.35C3.032 1.748 5.827 0 8.67 0zm0 1C6.271 1 3.828 2.472 1.346 5.462 3.816 7.83 6.256 9 8.67 9c2.414 0 4.854-1.17 7.324-3.538C13.512 2.472 11.07 1 8.67 1zm-.011 1.562c1.38 0 2.5 1.12 2.5 2.5 0 1.381-1.12 2.5-2.5 2.5-1.381 0-2.5-1.119-2.5-2.5 0-1.38 1.119-2.5 2.5-2.5zm0 1c-.829 0-1.5.672-1.5 1.5 0 .829.671 1.5 1.5 1.5.828 0 1.5-.671 1.5-1.5 0-.828-.672-1.5-1.5-1.5z"
                transform="translate(3 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  entapprove: ({ selected, disabled }) => (
    <svg version="1.1" width="24px" height="24px" viewBox="0 0 24 24">
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
        fill={selected ? '#ffffff' : '#31b793'}
        className={`${disabled ? styles.disabled : ''}`}
      >
        <g id="Export" transform="translate(-354.000000, -1319.000000)">
          <g id="Group" transform="translate(354.000000, 1319.000000)">
            <rect id="Rectangle-Copy-277" opacity="0" x="0" y="0" width="24" height="24" />
            <rect id="Rectangle-Copy-276" opacity="0" x="2" y="2" width="20" height="20" />
            <path
              d="M17.4698933,7.46944662 C17.7629098,7.17667678 18.2377835,7.17687676 18.5305534,7.4698933 C18.7967078,7.73627197 18.8207384,8.15294581 18.6027603,8.44646553 L18.5301067,8.53055338 L10.5233657,16.5305534 C10.2565623,16.7971321 9.83908787,16.8207578 9.54557301,16.6018554 L9.46151198,16.5289093 L6.46825295,13.5195908 C6.1761444,13.225915 6.17741489,12.7510429 6.47109067,12.4589344 C6.73806866,12.1933811 7.15479561,12.1702899 7.4478232,12.3889292 L7.53174705,12.4617721 L9.995,14.938 L17.4698933,7.46944662 Z"
              id="Path-18-Copy-2"
              fillRule="nonzero"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  entreject: ({ selected }) => (
    <svg version="1.1" width="24px" height="24px" viewBox="0 0 24 24">
      <g
        id="V3"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
        fill={selected ? '#ffffff' : '#F06A60'}
      >
        <g id="Export" transform="translate(-67.000000, -1275.000000)" fillRule="nonzero">
          <g id="Combined-Shape" transform="translate(67.000000, 1275.000000)">
            <path d="M17.179825,6.21966991 C17.4483105,6.48815536 17.4706843,6.909555 17.2469464,7.20352615 L17.179825,7.28033009 L12.76,11.699 L17.179825,16.1191649 C17.4727182,16.4120581 17.4727182,16.8869318 17.179825,17.179825 C16.9113396,17.4483105 16.4899399,17.4706843 16.1959688,17.2469464 L16.1191649,17.179825 L11.699,12.76 L7.28033009,17.179825 C6.98743687,17.4727182 6.51256313,17.4727182 6.21966991,17.179825 C5.95118446,16.9113396 5.92881068,16.4899399 6.15254855,16.1959688 L6.21966991,16.1191649 L10.639,11.699 L6.21966991,7.28033009 C5.9267767,6.98743687 5.9267767,6.51256313 6.21966991,6.21966991 C6.48815536,5.95118446 6.909555,5.92881068 7.20352615,6.15254855 L7.28033009,6.21966991 L11.699,10.639 L16.1191649,6.21966991 C16.4120581,5.9267767 16.8869318,5.9267767 17.179825,6.21966991 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  pamEnabled: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="16" viewBox="0 0 47 16">
      <defs>
        <linearGradient id="p0z336wnca" x1="0%" x2="105.33%" y1="38.937%" y2="55.794%">
          <stop offset="0%" stopColor="#F2E3A9" />
          <stop offset="100%" stopColor="#FFC000" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g fill="#FFF" stroke="#ECECEC" transform="translate(-308 -380) translate(114 289)">
              <rect width="1140" height="308" rx="3" />
            </g>
            <g transform="translate(-308 -380) translate(114 289) translate(194 91)">
              <rect width="47" height="16" fill="url(#p0z336wnca)" rx="8" />
              <g fill="#FFF" fillRule="nonzero">
                <g>
                  <path
                    d="M8.167 9.042c.161 0 .292.13.292.291 0 .161-.13.292-.292.292h-.583c.161 0 .292-.13.292-.292 0-.16-.131-.291-.292-.291-.161 0-.292.13-.292.291 0 .161.13.292.292.292H6.417c.161 0 .292-.13.292-.292 0-.16-.13-.291-.292-.291-.16 0-.291.13-.291.291 0 .161.13.292.291.292H5.251c.16 0 .291-.13.291-.292 0-.16-.13-.291-.291-.291-.161 0-.292.13-.292.291 0 .161.13.292.292.292h-3.5c-.161 0-.292-.13-.292-.292 0-.16.13-.291.292-.291zm-.995-4.473L5.226.174c-.107-.242-.454-.228-.542.02L3.131 4.577.485 2.25c-.213-.188-.542.009-.477.286l1.273 5.406c.031.132.149.225.284.225h6.788c.135 0 .253-.093.284-.225L9.91 2.536c.067-.288-.287-.483-.493-.27L7.172 4.568z"
                    transform="translate(5.041 3.042)"
                  />
                </g>
              </g>
              <text fill="#FFF" fontFamily="Rubik-Medium, Rubik" fontSize="11" fontWeight="400">
                <tspan x="18" y="12">
                  PAM
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  requestEntcal: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" className={styles.requestEntcal}>
      <g fill="none" data-name="requestEntcal" fillRule="evenodd" opacity=".558">
        <g fill="#000" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M14.25 3.75c.276 0 .5.187.5.417V5H15c.92 0 1.667.746 1.667 1.667v7.5c0 .92-.747 1.666-1.667 1.666H5c-.92 0-1.667-.746-1.667-1.666v-7.5C3.333 5.747 4.08 5 5 5h.417v-.833c0-.23.224-.417.5-.417s.5.187.5.417V5h7.333v-.833c0-.23.224-.417.5-.417zm1.583 4.333H4.167v6.084c0 .46.373.833.833.833h10c.46 0 .833-.373.833-.833V8.083zM7.5 9.583c.23 0 .417.224.417.5s-.187.5-.417.5H5.833c-.23 0-.416-.224-.416-.5s.186-.5.416-.5zm4.167 0c.23 0 .416.224.416.5s-.186.5-.416.5H10c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zM15 5.833H5c-.46 0-.833.373-.833.834v.416h11.666v-.416c0-.46-.373-.834-.833-.834z"
                transform="translate(-256 -533) translate(236 426) translate(20 107)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  right_arrow: () => (
    <svg width="28" height="28" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" opacity=".6">
        <g fill="#000" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M12 6.35c.145 0 .279.048.387.128l.003.002 4 3c.287.215.345.623.13.91-.194.258-.543.331-.82.186l-.09-.056-2.96-2.221V17c0 .359-.291.65-.65.65-.326 0-.597-.24-.643-.554L11.35 17V8.299L8.39 10.52c-.258.194-.614.166-.84-.05l-.07-.08c-.194-.258-.166-.614.05-.84l.08-.07 4-3 .015-.011c.018-.013.037-.025.056-.036l-.071.047c.032-.024.066-.045.101-.062.019-.01.038-.018.058-.026l.036-.012c.024-.008.049-.014.074-.019l.02-.003c.033-.005.067-.008.101-.008z"
                transform="translate(-1277 -194) translate(1271 188) rotate(90 12 18)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  entApprovelatest: () => (
    <svg>
      <g fill="none" fillRule="evenodd">
        <g>
          <g transform="translate(-1036.000000, -153.000000) translate(1036.000000, 153.000000)">
            <rect width="74" height="24" fill="#31B793" rx="12" />
            <path
              fillRule="nonzero"
              stroke="#FFF"
              strokeLinecap="round"
              strokeWidth="1.6"
              d="M7 13.234l2.425 2.726c.367.413 1 .45 1.412.083.03-.026.057-.054.083-.083L18 8h0"
            />
            <text fill="#FFF" fontFamily="Rubik-Medium, Rubik" fontSize="11" fontWeight="400">
              <tspan x="23" y="15">
                Approve
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  ),
  entRejectlatest: () => (
    <svg>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-450.000000, -610.000000) translate(236.000000, 423.000000) translate(214.000000, 187.000000)">
              <rect width="74" height="24" fill="#F06A60" rx="12" />
              <g fill="#FFF" fillRule="nonzero">
                <path
                  d="M9.737.263c.282.282.343.688.156.949l-.057.067L6.115 5l3.72 3.72c.254.254.21.709-.098 1.017-.282.282-.688.343-.949.156l-.067-.057L5 6.115l-3.72 3.72c-.254.254-.709.21-1.017-.098-.282-.282-.343-.688-.156-.949l.057-.067L3.885 5 .165 1.28C-.09 1.025-.046.57.262.262c.282-.282.688-.343.949-.156l.067.057L5 3.885 8.72.165c.254-.254.709-.21 1.017.098z"
                  transform="translate(7.000000, 7.000000)"
                />
              </g>
              <text fill="#FFF" fontFamily="Rubik-Medium, Rubik" fontSize="11" fontWeight="400">
                <tspan x="26" y="15">
                  Reject
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  entCalender: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd" opacity=".558">
        <g fill="#000" fillRule="nonzero">
          <g>
            <g>
              <path
                d="M14.25 3.75c.276 0 .5.187.5.417V5H15c.92 0 1.667.746 1.667 1.667v7.5c0 .92-.747 1.666-1.667 1.666H5c-.92 0-1.667-.746-1.667-1.666v-7.5C3.333 5.747 4.08 5 5 5h.417v-.833c0-.23.224-.417.5-.417s.5.187.5.417V5h7.333v-.833c0-.23.224-.417.5-.417zm1.583 4.333H4.167v6.084c0 .46.373.833.833.833h10c.46 0 .833-.373.833-.833V8.083zM7.5 9.583c.23 0 .417.224.417.5s-.187.5-.417.5H5.833c-.23 0-.416-.224-.416-.5s.186-.5.416-.5zm4.167 0c.23 0 .416.224.416.5s-.186.5-.416.5H10c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zM15 5.833H5c-.46 0-.833.373-.833.834v.416h11.666v-.416c0-.46-.373-.834-.833-.834z"
                transform="translate(-275 -670) translate(128 232) translate(147 438)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  approvalMenu: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd">
        <g fill="#999">
          <g>
            <g>
              <path
                d="M8 14c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm8 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm8 0c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
                transform="translate(-1140 -265) translate(128 232) rotate(90 505.5 538.5)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  undo: () => (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="V3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Export"
          transform="translate(-351.000000, -902.000000)"
          fill="#747474"
          fillRule="nonzero"
        >
          <g id="Combined-Shape" transform="translate(351.000000, 902.000000)">
            <path d="M8.3200922,10.1158894 C8.53223065,10.2926714 8.56089268,10.6079538 8.38411064,10.8200922 C8.2073286,11.0322306 7.89204625,11.0608927 7.6799078,10.8841106 L4.6799078,8.38411064 L4.61759373,8.32214364 C4.61602141,8.3202791 4.61446248,8.31840291 4.61291708,8.31651521 L4.6799078,8.38411064 C4.64545391,8.35539907 4.61594869,8.32321075 4.59139212,8.28854443 C4.58092127,8.27342983 4.57116544,8.25790241 4.56226876,8.24183325 C4.55464098,8.22839643 4.54775593,8.21441249 4.54156296,8.20019484 C4.53623185,8.1877206 4.53125629,8.17494511 4.5268028,8.16192747 C4.52080939,8.14450622 4.51584186,8.12673042 4.51187069,8.1087748 C4.50925132,8.09705141 4.50697067,8.08464085 4.505157,8.07207924 C4.50271797,8.05495502 4.50116782,8.03820801 4.50045505,8.02143141 C4.50015387,8.01444344 4.5,8.00723969 4.5,8 L4.50045505,7.97856859 C4.50116782,7.96179199 4.50271797,7.94504498 4.50510549,7.92839707 L4.5,8 C4.5,7.96245908 4.50413729,7.92588447 4.51198078,7.89070726 C4.51584186,7.87326958 4.52080939,7.85549378 4.5267733,7.83798801 C4.53125629,7.82505489 4.53623185,7.8122794 4.54170448,7.79977102 C4.54775593,7.78558751 4.55464098,7.77160357 4.5622181,7.75790557 C4.57116544,7.74209759 4.58092127,7.72657017 4.59147424,7.71164647 C4.59825323,7.70176979 4.60550066,7.69227745 4.61313441,7.68300034 C4.61446248,7.68159709 4.61602141,7.6797209 4.61759373,7.67785636 L4.6799078,7.61588936 L4.6799078,7.61588936 L7.6799078,5.11588936 C7.89204625,4.93910732 8.2073286,4.96776935 8.38411064,5.1799078 C8.56089268,5.39204625 8.53223065,5.7073286 8.3200922,5.88411064 L6.38,7.49998746 L15.5,7.5 C18.2614237,7.5 20.5,9.73857625 20.5,12.5 C20.5,15.1887547 18.3776933,17.3818181 15.7168896,17.4953805 L15.5,17.5 L5,17.5 C4.72385763,17.5 4.5,17.2761424 4.5,17 C4.5,16.7545401 4.67687516,16.5503916 4.91012437,16.5080557 L5,16.5 L15.5,16.5 C17.709139,16.5 19.5,14.709139 19.5,12.5 C19.5,10.3578046 17.8160315,8.60892112 15.6996403,8.50489531 L15.5,8.5 L6.38,8.49998746 L8.3200922,10.1158894 Z" />
          </g>
        </g>
      </g>
    </svg>
  ),
  logsSearchIcon: () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <filter id="nnaddidnha">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g
            filter="url(#nnaddidnha)"
            transform="translate(-116.000000, -223.000000) translate(116.000000, 223.000000)"
          >
            <path
              fill="#000"
              fillRule="nonzero"
              d="M16.354 15.646l4 4-.708.708-4-4 .708-.708zM10.5 3.5c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7 3.134-7 7-7zm0 1c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  logsRecordsIcon: () => (
    <svg width="22" height="22" viewBox="0 0 22 22">
      <defs>
        <filter id="6czk8hzgia">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 0 0.600000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g
            filter="url(#6czk8hzgia)"
            transform="translate(-986.000000, -226.000000) translate(986.000000, 201.000000)"
          >
            <g>
              <path
                fill="#000"
                fillRule="nonzero"
                d="M15.583 4.125c1.21 0 2.209.892 2.287 2.033l.005.144v10.313l-.005.143c-.014.212-.06.415-.134.606-.018.048-.039.096-.061.143-.04.084-.086.166-.136.244l-.007.01c-.042.064-.086.125-.134.184-.077.094-.16.182-.252.262-.055.048-.111.094-.17.137l-.072.05c-.11.074-.23.14-.354.195l-.045.02-.058.023-.088.032-.048.016-.102.03c-.052.014-.105.026-.158.036l-.144.024c-.106.014-.214.022-.324.022l.16-.006-.01.001-.15.005H6.417l-.15-.005h-.01l.16.005c-.11 0-.218-.008-.324-.022l-.144-.024c-.053-.01-.106-.022-.157-.036l-.103-.03-.048-.016-.088-.032-.059-.024-.044-.019c-.125-.055-.243-.12-.355-.195l-.071-.05c-.059-.043-.115-.089-.17-.136-.091-.081-.175-.17-.252-.263-.048-.059-.092-.12-.134-.183l-.007-.01c-.05-.079-.096-.16-.136-.245-.022-.047-.043-.095-.061-.144-.073-.19-.12-.393-.134-.605l-.005-.143V6.302l.005-.144c.078-1.141 1.078-2.033 2.287-2.033.253 0 .458.205.458.458s-.205.459-.458.459c-.766 0-1.375.57-1.375 1.26v10.313c0 .13.021.255.061.373l.043.109c.024.053.052.103.083.152.015.024.03.047.048.07l.074.091c.046.052.097.101.151.146.047.038.095.072.146.104.056.035.115.066.177.093l.057.023-.057-.023.087.035-.03-.012c.123.048.256.08.395.093l.14.006h9.166l.14-.006c.128-.012.25-.04.365-.082l.03-.01-.03.01c.03-.01.059-.022.087-.034l-.057.023c.083-.032.16-.07.234-.116.05-.032.1-.066.145-.104.055-.045.106-.094.152-.146l.074-.091c.017-.023.033-.046.048-.07.031-.049.059-.1.083-.152l.043-.109c.04-.118.061-.244.061-.373V6.302c0-.69-.609-1.26-1.375-1.26-.253 0-.458-.206-.458-.459s.205-.458.458-.458zm-2.75 11c.253 0 .459.224.459.5 0 .245-.162.45-.376.492l-.083.008H9.167c-.253 0-.459-.224-.459-.5 0-.245.162-.45.376-.492l.083-.008h3.666zm1.834-2.75c.253 0 .458.224.458.5 0 .245-.162.45-.376.492l-.082.008H7.333c-.253 0-.458-.224-.458-.5 0-.245.162-.45.376-.492l.082-.008h7.334zm0-2.75c.253 0 .458.224.458.5 0 .245-.162.45-.376.492l-.082.008H7.333c-.253 0-.458-.224-.458-.5 0-.245.162-.45.376-.492l.082-.008h7.334zM10.392 2.38c.822 0 1.518.541 1.75 1.287h.691c1.013 0 1.834.82 1.834 1.833s-.821 1.833-1.834 1.833H9.167c-1.013 0-1.834-.82-1.834-1.833 0-.821.54-1.516 1.285-1.75.204-.788.92-1.37 1.774-1.37zm0 .916c-.385 0-.723.24-.856.587l-.031.098-.128.492-.485.152c-.379.119-.642.471-.642.875 0 .47.354.858.81.91l.107.007h3.666c.507 0 .917-.41.917-.917 0-.47-.354-.858-.81-.91l-.106-.007h-1.366l-.201-.643c-.118-.38-.471-.644-.875-.644z"
                transform="translate(0.000000, 25.000000)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  emptyRecordsIcon: () => (
    <svg width="437" height="159" viewBox="0 0 437 159">
      <defs>
        <linearGradient id="amycg74vba" x1="50%" x2="50%" y1="-117.673%" y2="44.695%">
          <stop offset="0%" stopColor="#D8D8D8" />
          <stop offset="100%" stopColor="#FFF" />
        </linearGradient>
        <linearGradient id="oe24f9o4xd" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#8D9EEF" />
          <stop offset="100%" stopColor="#B3C1FE" />
        </linearGradient>
        <linearGradient id="0554byegwe" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#B3C1FE" />
          <stop offset="100%" stopColor="#8D9EEF" />
        </linearGradient>
        <linearGradient id="mzi6ssbwbf" x1="100%" x2="-13.352%" y1="28.97%" y2="88.698%">
          <stop offset="0%" stopColor="#B5C4FF" />
          <stop offset="100%" stopColor="#6678DF" />
        </linearGradient>
        <radialGradient
          id="nuhwhyxc4g"
          cx="75.717%"
          cy="43.279%"
          r="92.356%"
          fx="75.717%"
          fy="43.279%"
          gradientTransform="translate(0.757169,0.432791),scale(0.992067,1.000000),rotate(163.555749),translate(-0.757169,-0.432791)"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity=".609" />
          <stop offset="100%" stopColor="#DAECFF" stopOpacity=".559" />
        </radialGradient>
        <filter
          id="mourwgx4sb"
          width="119.7%"
          height="115.7%"
          x="-13.8%"
          y="-10.7%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="1.5"
            result="shadowSpreadOuter1"
          />
          <feOffset dx="-6" dy="-5" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            in="shadowOffsetOuter1"
            values="0 0 0 0 0.761032774 0 0 0 0 0.795170949 0 0 0 0 1 0 0 0 1 0"
          />
        </filter>
        <path
          id="qy1peumdcc"
          d="M177.51 0h64c3.314 0 6 2.686 6 6v77c0 3.314-2.686 6-6 6h-64c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6zm6 21.5h52m-52 13.75h52m-52 13.25h52m-16.5 0h16.5m-52 14h28.5"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="url(#amycg74vba)"
                d="M436 180.985C416.24 108.956 300.378 56.05 218 56.05c-82.378 0-175.93 37.608-218 113.462"
                transform="translate(-56.000000, -187.000000) translate(56.000000, 166.000000) translate(0.489796, 41.000000)"
              />
              <g transform="translate(-56.000000, -187.000000) translate(56.000000, 166.000000) translate(0.489796, 41.000000)">
                <use fill="#000" filter="url(#mourwgx4sb)" xlinkHref="#qy1peumdcc" />
                <use fill="#FFF" stroke="#EEE" strokeWidth="3" xlinkHref="#qy1peumdcc" />
              </g>
              <g transform="translate(-56.000000, -187.000000) translate(56.000000, 166.000000) translate(0.489796, 41.000000) translate(251.558199, 69.294150) rotate(-40.000000) translate(-251.558199, -69.294150) translate(218.341943, 21.258331)">
                <rect width="6" height="36" x="30.702" y="60.072" fill="url(#oe24f9o4xd)" rx="3" />
                <rect width="8" height="12" x="29.579" y="58.663" fill="url(#0554byegwe)" rx="4" />
                <ellipse
                  cx="33.216"
                  cy="33.032"
                  fill="url(#nuhwhyxc4g)"
                  stroke="url(#mzi6ssbwbf)"
                  strokeWidth="5"
                  rx="26.207"
                  ry="25.979"
                  transform="translate(33.216256, 33.031517) rotate(-10.000000) translate(-33.216256, -33.031517)"
                />
                <path
                  stroke="#352170"
                  strokeLinecap="round"
                  strokeWidth="2"
                  d="M25.752 41.735c1.945-1.333 4.278-2 7-2 2.723 0 5.056.667 7 2"
                />
                <circle cx="23.19" cy="28.796" r="2" fill="#352170" />
                <circle cx="43.037" cy="28.479" r="2" fill="#352170" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  alertInfoCursive: () => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="alert-info-filled">
  <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.7991 5.27778C8.7991 5.61528 8.5255 5.88889 8.18799 5.88889C7.85048 5.88889 7.57688 5.61528 7.57688 5.27778C7.57688 4.94027 7.85048 4.66667 8.18799 4.66667C8.5255 4.66667 8.7991 4.94027 8.7991 5.27778ZM8.69964 7.02193C8.78239 7.10777 8.81298 7.23127 8.77988 7.34581L7.839 10.6013L8.6387 10.1623C8.80008 10.0737 9.00272 10.1327 9.09131 10.2941C9.17989 10.4555 9.12088 10.6581 8.95951 10.7467L7.92533 11.3144C7.49193 11.5523 6.98701 11.1481 7.12428 10.6732L7.97869 7.71688L7.3767 7.86714C7.19809 7.91172 7.01715 7.80307 6.97257 7.62445C6.92798 7.44584 7.03664 7.2649 7.21525 7.22032L8.37893 6.92985C8.49461 6.90098 8.6169 6.93609 8.69964 7.02193Z" fill="#573BDC"/>
  </g>
  </svg>
  ),
  bulletAmber: () => (<svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle id="Badge" cx="4" cy="4.5" r="3.5" fill="#F6A91C" stroke="#A36A00"/>
  </svg>  
  ),
  alertAmber: () => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.67528 3.04619C8.3767 2.52367 7.62326 2.52367 7.32468 3.04619L2.10387 12.1826C1.80758 12.7011 2.18198 13.3463 2.77917 13.3463H13.2208C13.818 13.3463 14.1924 12.7011 13.8961 12.1826L8.67528 3.04619ZM7.35109 6.93948C7.3127 6.55557 7.61418 6.22244 8 6.22244C8.38583 6.22244 8.68731 6.55557 8.64892 6.93948L8.39616 9.467C8.37581 9.67053 8.20455 9.82553 8 9.82553C7.79546 9.82553 7.6242 9.67053 7.60384 9.467L7.35109 6.93948ZM8.55426 10.8788C8.55426 11.1849 8.30608 11.4331 7.99994 11.4331C7.6938 11.4331 7.44562 11.1849 7.44562 10.8788C7.44562 10.5726 7.6938 10.3244 7.99994 10.3244C8.30608 10.3244 8.55426 10.5726 8.55426 10.8788Z" fill="#E19701"/>
  </svg>
  ),
};

paths.accept.defaultProps = {
  disabled: false,
  tooltip: 'Approve',
};
paths.reject.defaultProps = {
  width: '20px',
  style: {},
  tooltip: 'Reject',
};
paths.attachedFile.propTypes = { fileType: PropTypes.string.isRequired };
paths.filetype.propTypes = {
  filetext: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};
paths.thumb.propTypes = {
  up: PropTypes.bool.isRequired,
};
paths.accept.propTypes = {
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
};
paths.commentsaccept.propTypes = {
  selected: PropTypes.bool.isRequired,
};
paths.reject.propTypes = {
  selected: PropTypes.bool.isRequired,
  width: PropTypes.string,
  style: PropTypes.shape({}),
  tooltip: PropTypes.string,
};
// paths.commentsreject.propTypes = {
//   selected: PropTypes.bool.isRequired,
// };
paths.comments.propTypes = {
  size: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
};
paths.arrow.propTypes = { angle: PropTypes.number.isRequired };
paths.violation.propTypes = { size: PropTypes.number };
paths.violation.defaultProps = { size: 24 };
paths.erpRolebadge.propTypes = { fillColor: PropTypes.string, title: PropTypes.string };
paths.erpRolebadge.defaultProps = {
  fillColor: null,
  title: 'Role',
};
export default paths;
